(function () {
"use strict";


if (window.__SLX_START_TRIP_V42_CONVERSION_PRESSURE_IQ__) { return; }
window.__SLX_START_TRIP_V42_CONVERSION_PRESSURE_IQ__ = true;
window.__SLX_START_TRIP_V27_NEXT_GEN__ = true;


var MAPBOX_TOKEN = String(window.SLX_MAPBOX_TOKEN || "");
var GEOAPIFY_KEY = String(window.SLX_GEOAPIFY_KEY || "");
var PRECIP_TILE_URL = String(window.SLX_PRECIP_RADAR_TILE_URL || "");
var PRECIP_POINT_FN = typeof window.SLX_GET_PRECIP_AT_LNGLAT === "function" ? window.SLX_GET_PRECIP_AT_LNGLAT : null;


var map = null;
var mapLoaded = false;
var gpsWatchId = null;
var lastFix = null;
var pendingFix = null;
var dest = null;
var stop1 = null;
var routeGeo = null;
var routeReady = false;


var loadMode = "empty_trailer";
var tripCapacity = "full";
var truckType = "dry_van";
var equipmentType = "van";
var equipmentLength = "";
var equipmentWeight = "";


var searchTarget = "dest";
var searchTimer = null;
var cueTimer = null;
var freeFlowUntil = 0;
var FREE_FLOW_MS = 14000;
var TRIP_ID = null;


var altRoutes = [];
var selectedRouteIndex = 0;
var activeChipType = "profit";


/* =========================================================
STORAGE KEYS
Centralized source of truth.
Do not scatter raw localStorage keys below this point.
========================================================= */
var LS = {
LAST_FIX: "slx_last_gps_v1",


DEST: "slx_dest",
DEST_V2: "slx_main_dest_v2",


STOPS: "slx_stops_v1",
ACTIVE_STOP: "slx_active_stop_v1",
STOP_1: "slx_stop_1_v1",


MODE: "slx_mode",
TRIP_CAPACITY: "slx_trip_capacity_v1",
TRUCK_TYPE: "slx_truck_type_v1",
EQUIPMENT_TYPE: "slx_equipment_type_v1",
EQUIPMENT_LENGTH: "slx_equipment_length_v1",
EQUIPMENT_WEIGHT: "slx_equipment_weight_v1",


ROUTE_GEO: "slx_route_geo_v1",
ROUTE_GEO_V2: "slx_route_geo_v2",
ROUTE_1: "slx_route_geojson",
ROUTE_2: "slx_route",
ROUTE_3: "slx_active_route",
ROUTE_4: "slx_trip_route",


ROUTE_STEPS: "slx_route_steps_v2",
MANEUVER_STEPS: "slx_maneuver_steps_v1",


START_PAYLOAD: "slx_start_trip_payload",
ACTIVE_TRIP_ID: "slx_active_trip_id",
NATIVE_PAYLOAD: "slx_native_trip_payload_v1",


TRIP_MODE: "slx_trip_mode_v1",
TRIP_ON: "slx_trip_on_v1",
TRIP_ON_V2: "slx_trip_on_v2",


MONEY_PREVIEW: "slx_trip_money_preview",


ALT_ROUTES: "slx_alt_routes_v1",
ALT_ROUTE_INDEX: "slx_alt_route_index_v1",
ALT_ROUTE_META: "slx_alt_route_meta_v1",
ROUTE_ETA: "slx_route_eta_v1",
ROUTE_INTEL: "slx_route_intel_v1",
CORRIDOR_VISION: "slx_corridor_vision_v1",


FREE_TRIP_MONTH: "slx_free_trip_month_v1",
FREE_TRIP_COUNT: "slx_free_trip_count_v1",
LAST_COUNTED_TRIP: "slx_last_counted_trip_id_v1",
PAYWALL_SEEN: "slx_paywall_seen_v1",
PAYWALL_EVENTS: "slx_paywall_events_v1",
PAYWALL_BYPASS: "slx_paywall_bypass_v1"
};


function $(id) { return document.getElementById(id); }
function nowMs() { return (new Date()).getTime(); }
function isFiniteNum(n) { return typeof n === "number" && isFinite(n); }


function safeJSONParse(v) {
try { return JSON.parse(String(v || "")); }
catch (e) { return null; }
}


function safeJSONStringify(v) {
try { return JSON.stringify(v); }
catch (e) { return ""; }
}


function lsGet(k) {
try { return localStorage.getItem(k); }
catch (e) { return null; }
}


function lsSet(k, v) {
try { localStorage.setItem(k, String(v)); }
catch (e) {}
}


function lsSetJSON(k, v) {
var s = safeJSONStringify(v);
if (s) { lsSet(k, s); }
}


function lsGetJSON(k) {
return safeJSONParse(lsGet(k));
}


function lsRemove(k) {
try { localStorage.removeItem(k); }
catch (e) {}
}


function genTripId() {
return String(nowMs()) + "-" + String(Math.floor(Math.random() * 1000000000));
}




/* =========================================================
SLX START TRIP - 5 FREE TRIP PAYWALL V42 + CONVERSION PRESSURE IQ
Integrated into Start Trip. ES5-safe. No bottom override.


LOCKED IN THIS RUN:
- Dev/testing unlock cannot get blocked by the 5-trip gate.
- Founding Driver free/active keys count as paid access.
- Paywall copy includes first 20 Founding Drivers / first 5 free.
- Badge renderer supports FOUNDING DRIVER #X or DEV badge.
- TEMP TEST SWITCH below can be true while Matt is testing.
========================================================= */


var SLX_FREE_TRIP_LIMIT = 5;
var SLX_CONVERSION_PRESSURE_START_AFTER = Number(window.SLX_CONVERSION_PRESSURE_START_AFTER || 2);
var SLX_CONVERSION_PRESSURE_ENABLED = window.SLX_CONVERSION_PRESSURE_ENABLED !== false;
var slxConversionPressureBypassOnce = false;


/*
TEMP TEST SWITCH:
- true  = this build will unlock Pro locally for testing.
- false = production behavior; only real entitlement/founding/dev keys unlock.
Set this back to false before a public production release.
*/
var SLX_DEV_UNLOCK_FOR_TESTING = false;


function slxCurrentMonthKey() {
  var d = new Date();
  return String(d.getFullYear()) + "-" + String(d.getMonth() + 1);
}


function slxBoolStored(key) {
  var v = "";
  try { v = String(localStorage.getItem(key) || "").toLowerCase(); }
  catch (e) { v = ""; }


  return (
    v === "1" ||
    v === "true" ||
    v === "yes" ||
    v === "active" ||
    v === "pro" ||
    v === "paid" ||
    v === "founding" ||
    v === "founder" ||
    v === "free" ||
    v === "dev"
  );
}


function slxUrlHasDevUnlock() {
  var q;
  try {
    q = String(window.location.search || "").toLowerCase();
  } catch (e) {
    q = "";
  }


  return (
    q.indexOf("slxdev=1") > -1 ||
    q.indexOf("devpro=1") > -1 ||
    q.indexOf("mattdev=1") > -1
  );
}


function slxApplyDevUnlockIfNeeded() {
  if (!SLX_DEV_UNLOCK_FOR_TESTING && !slxUrlHasDevUnlock() && !slxBoolStored("slx_dev_pro_unlocked_v1")) {
    return false;
  }


  try {
    localStorage.setItem("slx_dev_pro_unlocked_v1", "1");
    localStorage.setItem("slx_paywall_bypass_v1", "1");
    localStorage.setItem("slx_pro_unlocked_v1", "1");
    localStorage.setItem("slx_subscription_active_v1", "1");
    localStorage.setItem("slx_entitlement_pro_v1", "1");


    if (!localStorage.getItem("slx_founding_driver_number_v1")) {
      localStorage.setItem("slx_founding_driver_number_v1", "DEV");
    }
  } catch (e) {}


  return true;
}


function slxHasPaidAccess() {
  slxApplyDevUnlockIfNeeded();


  /* DEV / TESTING BYPASS */
  if (slxBoolStored("slx_dev_pro_unlocked_v1")) { return true; }


  /* FOUNDING DRIVER / EARLY ACCESS */
  if (slxBoolStored("slx_founding_driver_free_v1")) { return true; }
  if (slxBoolStored("slx_founding_driver_active_v1")) { return true; }
  if (slxBoolStored("slx_founder_access_v1")) { return true; }
  if (slxBoolStored("slx_founder_driver_v1")) { return true; }


  /* ADMIN / MANUAL BYPASS */
  if (slxBoolStored(LS.PAYWALL_BYPASS)) { return true; }
  if (slxBoolStored("slx_admin_bypass_v1")) { return true; }


  /* REAL PRO / SUBSCRIPTION ENTITLEMENTS */
  if (slxBoolStored("slx_pro_unlocked_v1")) { return true; }
  if (slxBoolStored("slx_entitlement_pro_v1")) { return true; }
  if (slxBoolStored("slx_subscription_active_v1")) { return true; }
  if (slxBoolStored("slx_web_paid_v1")) { return true; }


  return false;
}


function slxResetTripCounterIfNeeded() {
  var month = slxCurrentMonthKey();
  var stored = String(lsGet(LS.FREE_TRIP_MONTH) || "");


  if (stored !== month) {
    lsSet(LS.FREE_TRIP_MONTH, month);
    lsSet(LS.FREE_TRIP_COUNT, "0");
    lsRemove(LS.LAST_COUNTED_TRIP);
  }
}


function slxGetFreeTripCount() {
  var n;


  slxResetTripCounterIfNeeded();


  n = Number(lsGet(LS.FREE_TRIP_COUNT) || 0);


  if (!isFiniteNum(n) || n < 0) { n = 0; }


  return Math.floor(n);
}


function slxLogPaywallEvent(name, extra) {
  var arr = [];
  var raw = lsGet(LS.PAYWALL_EVENTS);
  var parsed = safeJSONParse(raw);
  if (parsed && parsed.length) { arr = parsed; }


  arr.push({
    event: String(name || "event"),
    trip_id: String(TRIP_ID || ""),
    count: slxGetFreeTripCount(),
    extra: extra || null,
    at: new Date().toISOString()
  });


  while (arr.length > 25) { arr.shift(); }
  lsSet(LS.PAYWALL_EVENTS, JSON.stringify(arr));
}


function slxUpgradeUrl() {
  return "https://semilocator.com/pages/subscriptions";
}


var SLX_NATIVE_DRIVER_MONTHLY_PRODUCT_ID = "com.semiloctor.driver.monthly";


function slxNativeBillingPost(payload) {
  var ok = false;


  try {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.slx) {
      window.webkit.messageHandlers.slx.postMessage(payload);
      ok = true;
    }
  } catch (e1) {}


  try {
    if (!ok && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.purchase) {
      window.webkit.messageHandlers.purchase.postMessage(payload);
      ok = true;
    }
  } catch (e2) {}


  return ok;
}


function slxPurchaseDriverMonthlyPro() {
  var payload = {
    action: "purchase",
    productId: SLX_NATIVE_DRIVER_MONTHLY_PRODUCT_ID,
    product_id: SLX_NATIVE_DRIVER_MONTHLY_PRODUCT_ID,
    role: "driver",
    plan: "monthly",
    source: "start_trip_pro_sheet",
    ts: new Date().toISOString()
  };


  slxLogPaywallEvent("native_purchase_click", {
    product_id: SLX_NATIVE_DRIVER_MONTHLY_PRODUCT_ID
  });


  if (slxNativeBillingPost(payload)) {
    toast("Opening Apple purchase");
    return true;
  }


  window.location.href = slxUpgradeUrl();
  return false;
}


function slxRestoreDriverPurchases() {
  var payload = {
    action: "restore",
    role: "driver",
    source: "start_trip_pro_sheet",
    ts: new Date().toISOString()
  };


  slxLogPaywallEvent("restore_click", { source: "start_trip_pro_sheet" });


  try {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.restorePurchases) {
      window.webkit.messageHandlers.restorePurchases.postMessage(payload);
      toast("Checking purchases");
      return true;
    }
  } catch (e1) {}


  if (slxNativeBillingPost(payload)) {
    toast("Checking purchases");
    return true;
  }


  window.location.href = slxUpgradeUrl();
  return false;
}


function slxHidePaywallOverlay() {
  var overlay = $("slxPaywallOverlay");


  if (overlay) {
    overlay.style.display = "none";
    overlay.style.visibility = "hidden";
    overlay.style.pointerEvents = "none";
  }
}


function slxRenderFoundingDriverBadge() {
  var num = "";
  var text = "";
  var badge;


  try { num = String(localStorage.getItem("slx_founding_driver_number_v1") || ""); }
  catch (e) { num = ""; }


  if (!num && !slxHasPaidAccess()) { return; }


  if (!num && slxBoolStored("slx_dev_pro_unlocked_v1")) { num = "DEV"; }


  if (!num) { return; }


  text = num === "DEV" ? "FOUNDING DRIVER DEV" : "FOUNDING DRIVER #" + String(num).replace("#", "");


  badge = $("slxFoundingDriverBadge");


  if (!badge) {
    badge = document.createElement("div");
    badge.id = "slxFoundingDriverBadge";
    badge.style.cssText = [
      "position:fixed",
      "left:22px",
      "bottom:calc(92px + env(safe-area-inset-bottom,0px))",
      "z-index:9000",
      "padding:9px 12px",
      "border-radius:999px",
      "background:rgba(7,16,25,.88)",
      "border:1px solid rgba(0,255,176,.34)",
      "box-shadow:0 12px 30px rgba(0,0,0,.42),0 0 24px rgba(0,255,176,.16)",
      "color:#baffdf",
      "font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif",
      "font-size:10px",
      "font-weight:1000",
      "letter-spacing:1.3px",
      "pointer-events:none",
      "backdrop-filter:blur(12px)",
      "-webkit-backdrop-filter:blur(12px)"
    ].join(";");
    document.body.appendChild(badge);
  }


  badge.textContent = text;
}



/* =========================================================
SLX V42 — CONVERSION PRESSURE IQ

Rules:
- Trips 1–2 prove value without interruption.
- Before free trips 3–5, Start Trip is a high-intent upgrade moment.
- Show Pro every time the driver taps Start Trip during that window.
- A remaining free trip can still be continued with one clear tap.
- Trip 6+ keeps the existing hard gate.
- No automatic paywall on page load.
- Paid/founding/dev access always bypasses pressure.
========================================================= */

/* SEMI V43A: First confirmed arrival -> one-time Pro introduction on next Start Trip page.
   Keeps the existing five free STARTS/month rule unchanged. */
var SLX_V43_FIRST_ARRIVAL_KEY = "slx_v43_first_confirmed_arrival_v1";
var SLX_V43_INTRO_SEEN_KEY = "slx_v43_first_trip_intro_seen_v1";
function slxV43ShowFirstTripIntro() {
  var overlay, card;
  if (slxHasPaidAccess()) { return false; }
  if (lsGet(SLX_V43_INTRO_SEEN_KEY) === "1") { return false; }
  if (lsGet(SLX_V43_FIRST_ARRIVAL_KEY) !== "1") { return false; }
  if (slxGetFreeTripCount() < 1) { return false; }
  if ($("slxPaywallOverlay") && $("slxPaywallOverlay").style.display === "flex") { return false; }
  overlay = document.createElement("div");
  overlay.id = "slxV43IntroOverlay";
  overlay.style.cssText = "position:fixed;inset:0;z-index:12000;display:flex;align-items:flex-end;justify-content:center;padding:18px;background:rgba(0,0,0,.64);font-family:system-ui,-apple-system,sans-serif";
  card = document.createElement("div");
  card.style.cssText = "width:100%;max-width:430px;padding:22px 18px;border-radius:24px;border:1px solid rgba(0,255,176,.36);background:#0c141c;color:white;box-shadow:0 24px 75px rgba(0,0,0,.56)";
  card.innerHTML = '<div style="font-size:11px;letter-spacing:2px;color:#adffe2;font-weight:800">SEMI LOCATOR PRO</div>' +
    '<div style="font-size:25px;line-height:1.13;margin-top:10px;font-weight:900">Your first trip is in the books.</div>' +
    '<p style="font-size:14px;line-height:1.5;color:#d2dedb">Keep your freight tools close: route intelligence, parking insights, weather outlook and driver workflow. Explore Pro or keep using your remaining free starts this month.</p>' +
    '<button type="button" id="slxV43Buy" style="width:100%;min-height:53px;border:0;border-radius:15px;font-size:14px;font-weight:900;background:#30efb3;color:#071a15">EXPLORE DRIVER MONTHLY PRO</button>' +
    '<button type="button" id="slxV43Free" style="width:100%;min-height:48px;margin-top:10px;border:1px solid #65706d;border-radius:15px;font-size:13px;font-weight:800;background:#17242a;color:white">CONTINUE FREE</button>' +
    '<button type="button" id="slxV43Restore" style="width:100%;min-height:36px;margin-top:7px;border:0;background:transparent;color:#b0c4be">Restore purchases</button>';
  overlay.appendChild(card);
  document.body.appendChild(overlay);
  lsSet(SLX_V43_INTRO_SEEN_KEY, "1");
  slxLogPaywallEvent("first_trip_intro_shown", { source: "confirmed_arrival", remaining: Math.max(0, SLX_FREE_TRIP_LIMIT-slxGetFreeTripCount()) });
  $("slxV43Free").onclick = function () {
    slxLogPaywallEvent("first_trip_intro_continue_free", {});
    if (overlay.parentNode) { overlay.parentNode.removeChild(overlay); }
  };
  $("slxV43Buy").onclick = function () {
    slxLogPaywallEvent("first_trip_intro_upgrade_tapped", {});
    slxPurchaseDriverMonthlyPro();
  };
  $("slxV43Restore").onclick = function () { slxRestoreDriverPurchases(); };
  return true;
}
function slxV43ScheduleFirstTripIntro() {
  setTimeout(function () {
    if (!document.body) { return; }
    if (lsGet("slx_trip_on_v2") === "1") { return; }
    slxV43ShowFirstTripIntro();
  }, 1000);
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", slxV43ScheduleFirstTripIntro);
} else { slxV43ScheduleFirstTripIntro(); }

function slxConversionPressureThreshold() {
  var n = Number(SLX_CONVERSION_PRESSURE_START_AFTER);
  if (!isFiniteNum(n) || n < 0) { n = 2; }
  return Math.floor(n);
}


function slxShouldShowStartTripPressure() {
  var count;

  if (!SLX_CONVERSION_PRESSURE_ENABLED) { return false; }
  if (slxHasPaidAccess()) { return false; }
  if (slxConversionPressureBypassOnce) { return false; }

  count = slxGetFreeTripCount();

  return (
    count >= slxConversionPressureThreshold() &&
    count < SLX_FREE_TRIP_LIMIT
  );
}


function slxHidePressureOverlay() {
  var overlay = $("slxPressureOverlay");

  if (overlay && overlay.parentNode) {
    overlay.parentNode.removeChild(overlay);
  }
}


function slxContinueRemainingFreeTrip() {
  var count = slxGetFreeTripCount();
  var remaining = Math.max(0, SLX_FREE_TRIP_LIMIT - count);
  var btn;

  slxConversionPressureBypassOnce = true;
  slxHidePressureOverlay();

  slxLogPaywallEvent("conversion_pressure_continue_free", {
    trigger: "start_trip_high_intent",
    count: count,
    remaining: remaining
  });

  setStatus("Starting free trip", "green");
  toast("Starting free trip");

  btn = $("btnStartTrip");
  if (btn && typeof btn.click === "function") {
    setTimeout(function () {
      btn.click();
    }, 120);
  }
}


function slxShowStartTripPressure() {
  var overlay, card, count, remaining, nextTrip;

  if (slxHasPaidAccess()) { return false; }

  slxHidePressureOverlay();

  count = slxGetFreeTripCount();
  remaining = Math.max(0, SLX_FREE_TRIP_LIMIT - count);
  nextTrip = count + 1;

  overlay = document.createElement("div");
  overlay.id = "slxPressureOverlay";
  overlay.style.cssText = [
    "position:fixed",
    "inset:0",
    "z-index:10000",
    "display:flex",
    "align-items:flex-end",
    "justify-content:center",
    "padding:18px",
    "background:rgba(0,0,0,.54)",
    "backdrop-filter:blur(11px)",
    "-webkit-backdrop-filter:blur(11px)"
  ].join(";");

  card = document.createElement("div");
  card.id = "slxPressureCard";
  card.style.cssText = [
    "width:100%",
    "max-width:430px",
    "border-radius:26px",
    "border:1px solid rgba(0,255,176,.32)",
    "background:radial-gradient(circle at 85% 0%,rgba(0,255,176,.16),transparent 34%),rgba(8,14,22,.97)",
    "box-shadow:0 28px 80px rgba(0,0,0,.58),0 0 42px rgba(0,255,176,.14)",
    "color:#fff",
    "padding:20px 18px 17px",
    "font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif"
  ].join(";");

  card.innerHTML =
    '<div style="font-size:11px;font-weight:1000;letter-spacing:1.2px;color:#9bffd7;margin-bottom:8px;">SEMI LOCATOR PRO</div>' +
    '<div style="font-size:27px;font-weight:1000;line-height:1.02;margin-bottom:9px;">Keep the road tools working for you</div>' +
    '<div style="font-size:13px;font-weight:760;line-height:1.42;opacity:.82;margin-bottom:14px;">You\'re starting trip ' + String(nextTrip) + '. Pro keeps route intelligence, Real ETA, parking confidence, weather risk, and driver tools available without the monthly trip limit.</div>' +
    '<button id="slxPressureUpgrade" type="button" style="width:100%;min-height:58px;padding:9px 12px;border-radius:17px;border:1px solid rgba(0,255,176,.55);background:linear-gradient(180deg,rgba(40,255,200,1),rgba(0,230,155,1));color:#041712;text-align:left;font-size:14px;font-weight:1000;">UNLOCK SEMI LOCATOR PRO<div style="font-size:11px;margin-top:5px;opacity:.80;">Price confirmed in Apple purchase sheet</div></button>' +
    '<button id="slxPressureContinue" type="button" style="width:100%;min-height:48px;margin-top:10px;border-radius:15px;border:1px solid rgba(155,255,215,.22);background:rgba(0,255,176,.07);color:#baffdf;font-size:11px;font-weight:1000;letter-spacing:.45px;">CONTINUE FREE • ' + String(remaining) + (remaining === 1 ? ' TRIP LEFT' : ' TRIPS LEFT') + '</button>' +
    '<button id="slxPressureRestore" type="button" style="width:100%;height:36px;margin-top:8px;border-radius:13px;border:1px solid rgba(255,255,255,.12);background:rgba(255,255,255,.05);color:#dffef4;font-size:10px;font-weight:1000;">RESTORE PURCHASES</button>' +
    '<div id="slxPressureStatus" style="min-height:16px;margin-top:7px;text-align:center;font-size:10px;font-weight:800;opacity:.68;"></div>';

  overlay.appendChild(card);
  document.body.appendChild(overlay);

  $("slxPressureUpgrade").onclick = function () {
    slxLogPaywallEvent("conversion_pressure_upgrade_tapped", {
      trigger: "start_trip_high_intent",
      plan: "monthly",
      count: count,
      remaining: remaining
    });

    if ($("slxPressureStatus")) {
      $("slxPressureStatus").textContent = "Opening Apple purchase...";
    }

    slxPurchaseDriverMonthlyPro();
  };

  $("slxPressureContinue").onclick = function () {
    slxContinueRemainingFreeTrip();
  };

  $("slxPressureRestore").onclick = function () {
    slxLogPaywallEvent("conversion_pressure_restore_tapped", {
      trigger: "start_trip_high_intent",
      count: count,
      remaining: remaining
    });

    if ($("slxPressureStatus")) {
      $("slxPressureStatus").textContent = "Checking purchases...";
    }

    slxRestoreDriverPurchases();
  };

  slxLogPaywallEvent("conversion_pressure_shown", {
    trigger: "start_trip_high_intent",
    count: count,
    remaining: remaining,
    next_trip: nextTrip,
    route_type: String(activeChipType || "profit"),
    destination: dest ? String(dest.label || dest.full || "") : ""
  });

  setStatus("Pro available", "gold");

  return true;
}


function slxShowPaywall(gate) {
  var overlay, card, left;


  if (slxHasPaidAccess()) {
    slxHidePaywallOverlay();
    setStatus("Pro unlocked", "green");
    toast("Pro unlocked");
    slxRenderFoundingDriverBadge();
    slxLogPaywallEvent("blocked_but_bypass_allowed", gate || {});
    return;
  }


  lsSet(LS.PAYWALL_SEEN, "1");
  slxLogPaywallEvent("blocked", gate || {});


  overlay = $("slxPaywallOverlay");


  if (!overlay) {
    overlay = document.createElement("div");
    overlay.id = "slxPaywallOverlay";
    overlay.style.cssText = [
      "position:fixed",
      "inset:0",
      "z-index:9999",
      "display:flex",
      "align-items:flex-end",
      "justify-content:center",
      "padding:18px",
      "background:rgba(0,0,0,.46)",
      "backdrop-filter:blur(10px)",
      "-webkit-backdrop-filter:blur(10px)"
    ].join(";");


    card = document.createElement("div");
    card.id = "slxPaywallCard";
    card.style.cssText = [
      "width:100%",
      "max-width:430px",
      "border-radius:24px",
      "border:1px solid rgba(0,255,176,.25)",
      "background:rgba(8,14,22,.94)",
      "box-shadow:0 24px 70px rgba(0,0,0,.50),0 0 38px rgba(0,255,176,.18)",
      "color:#fff",
      "padding:18px",
      "font-family:system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif"
    ].join(";");


    card.innerHTML =
      '<div style="display:flex;align-items:flex-start;justify-content:space-between;gap:12px;margin-bottom:8px;">' +
        '<div>' +
          '<div style="font-size:11px;font-weight:1000;letter-spacing:1px;color:#9bffd7;margin-bottom:8px;">SEMI LOCATOR PRO</div>' +
          '<div id="slxPaywallTitle" style="font-size:22px;font-weight:1000;line-height:1.05;">Drive smarter. Park earlier.</div>' +
        '</div>' +
        '<button id="slxPaywallClose" type="button" style="width:36px;height:36px;flex:0 0 auto;border-radius:14px;border:1px solid rgba(255,255,255,.14);background:rgba(255,255,255,.08);color:#fff;font-size:18px;font-weight:1000;">X</button>' +
      '</div>' +
      '<div id="slxPaywallText" style="font-size:12px;font-weight:800;line-height:1.35;opacity:.90;margin-bottom:12px;">Unlock parking confidence, route intelligence, and premium driver tools.</div>' +
      '<div id="slxFoundingPaywallText" style="font-size:11px;font-weight:900;line-height:1.35;color:#baffdf;background:rgba(0,255,176,.08);border:1px solid rgba(0,255,176,.16);border-radius:16px;padding:10px 11px;margin-bottom:14px;">Founding Driver access includes early features and priority feedback.</div>' +
      '<button id="slxPaywallUpgrade" type="button" style="width:100%;min-height:58px;padding:9px 12px;border-radius:16px;border:1px solid rgba(0,255,176,.55);background:linear-gradient(180deg,rgba(40,255,200,1),rgba(0,230,155,1));color:#041712;text-align:left;font-size:14px;font-weight:1000;">DRIVER MONTHLY PRO<div style="font-size:11px;margin-top:5px;opacity:.80;">Price confirmed in Apple purchase sheet</div></button>' +
      '<div style="font-size:9px;font-weight:700;line-height:1.35;opacity:.62;margin-top:10px;">Auto-renewable subscription. Payment is charged to your Apple ID after confirmation. Manage or cancel in App Store settings.</div>' +
      '<button id="slxPaywallRestore" type="button" style="width:100%;height:36px;margin-top:9px;border-radius:13px;border:1px solid rgba(255,255,255,.12);background:rgba(255,255,255,.05);color:#dffef4;font-size:10px;font-weight:1000;">RESTORE PURCHASES</button>' +
      '<button id="slxPaywallLater" type="button" style="width:100%;height:38px;margin-top:7px;border-radius:13px;border:1px solid rgba(255,255,255,.12);background:rgba(255,255,255,.08);color:#fff;font-size:11px;font-weight:1000;">MAYBE LATER</button>';


    overlay.appendChild(card);
    document.body.appendChild(overlay);


    $("slxPaywallUpgrade").onclick = function () {
      slxPurchaseDriverMonthlyPro();
    };


    $("slxPaywallRestore").onclick = function () {
      slxRestoreDriverPurchases();
    };


    $("slxPaywallClose").onclick = function () {
      overlay.style.display = "none";
    };


    $("slxPaywallLater").onclick = function () {
      overlay.style.display = "none";
    };
  }


  left = Math.max(0, SLX_FREE_TRIP_LIMIT - slxGetFreeTripCount());
  if ($("slxPaywallTitle") && gate && gate.auto_open) {
    $("slxPaywallTitle").textContent = "Drive smarter. Park earlier.";
  }
  if ($("slxPaywallText")) {
    if (gate && gate.auto_open) {
      $("slxPaywallText").textContent =
        "Unlock parking confidence, route intelligence, and premium driver tools built for the road ahead.";
    } else {
      $("slxPaywallText").textContent =
        "You have used all " + String(SLX_FREE_TRIP_LIMIT) +
        " free Start Trip runs this month. Upgrade to keep using route intelligence, Real ETA, parking confidence, weather risk, and trip planning.";
    }
  }


  overlay.style.visibility = "visible";
  overlay.style.pointerEvents = "auto";
  overlay.style.display = "flex";


  if (gate && gate.auto_open) {
    slxLogPaywallEvent("auto_sheet_shown", { source: "start_trip" });
    setStatus("Pro available", "gold");
  } else {
    setStatus("Upgrade required", "gold");
    toast("Free trip limit reached");
  }
}


function slxRegisterStartTripPaywall(tripId) {
  var count, last, remaining;


  slxApplyDevUnlockIfNeeded();


  if (slxHasPaidAccess()) {
    slxHidePaywallOverlay();
    slxRenderFoundingDriverBadge();
    slxLogPaywallEvent("bypass_allowed", { reason: "paid_founder_or_dev" });
    return { allowed: true, count: slxGetFreeTripCount(), remaining: 999, bypass: true, message: "" };
  }


  slxResetTripCounterIfNeeded();


  count = slxGetFreeTripCount();
  last = String(lsGet(LS.LAST_COUNTED_TRIP) || "");


  if (last && String(tripId || "") === last) {
    remaining = Math.max(0, SLX_FREE_TRIP_LIMIT - count);
    return { allowed: true, count: count, remaining: remaining, duplicate: true, message: "" };
  }


  if (count >= SLX_FREE_TRIP_LIMIT) {
    return { allowed: false, count: count, remaining: 0, message: "Free trip limit reached" };
  }


  count += 1;
  remaining = Math.max(0, SLX_FREE_TRIP_LIMIT - count);


  lsSet(LS.FREE_TRIP_COUNT, String(count));
  lsSet(LS.LAST_COUNTED_TRIP, String(tripId || ""));
  slxLogPaywallEvent("trip_counted", { count: count, remaining: remaining });


  if (count === 4) {
    return { allowed: true, count: count, remaining: remaining, message: "Heads up: 1 free trip left after this one" };
  }


  if (count === 5) {
    return { allowed: true, count: count, remaining: remaining, message: "Final free trip this month" };
  }


  return { allowed: true, count: count, remaining: remaining, message: "" };
}


function slxSyncPaywallStatusPill() {
  var count, remaining;


  slxApplyDevUnlockIfNeeded();


  if (slxHasPaidAccess()) {
    slxHidePaywallOverlay();
    slxRenderFoundingDriverBadge();
    setStatus("Pro unlocked", "green");
    return;
  }


  count = slxGetFreeTripCount();
  remaining = Math.max(0, SLX_FREE_TRIP_LIMIT - count);


  if (remaining <= 0) {
    setStatus("Pro required", "gold");
  } else if (remaining <= 2) {
    setStatus(String(remaining) + " free trips left", "gold");
  }
}


slxApplyDevUnlockIfNeeded();
setTimeout(function () {
  slxApplyDevUnlockIfNeeded();
  if (slxHasPaidAccess()) {
    slxRenderFoundingDriverBadge();
    slxHidePaywallOverlay();
  }
}, 250);
setTimeout(function () {
  slxApplyDevUnlockIfNeeded();
  if (slxHasPaidAccess()) {
    slxRenderFoundingDriverBadge();
    slxHidePaywallOverlay();
  }
}, 1200);


function toast(msg) {
var el = $("toast");
if (!el) { return; }
el.textContent = String(msg || "Ready");
el.className = "toast on";
setTimeout(function () {
el.className = "toast";
}, 1100);
}


function setStatus(text, kind) {
var el = $("pillStatus");
if (!el) { return; }
el.className = "pill";
if (kind === "green") { el.className = "pill green"; }
if (kind === "red") { el.className = "pill red"; }
if (kind === "gold") { el.className = "pill gold"; }
if (kind === "blue") { el.className = "pill blue"; }
el.textContent = text || "Ready";
}


function setGpsPill(text) {
var el = $("pillGps");
if (!el) { return; }
el.textContent = text || "GPS: --";
}


function syncMoneyPreviewPill(money) {
var pill = $("pillMoney");
if (!pill) { return; }
if (!money) {
pill.textContent = "$ --";
return;
}
pill.textContent = "$ " + String(Math.round(Number(money.net || 0)));
}


function distanceMiles(lat1, lng1, lat2, lng2) {
var R = 3958.8;
var dLat = (lat2 - lat1) * Math.PI / 180;
var dLng = (lng2 - lng1) * Math.PI / 180;
var a1 = lat1 * Math.PI / 180;
var a2 = lat2 * Math.PI / 180;
var x =
Math.sin(dLat / 2) * Math.sin(dLat / 2) +
Math.sin(dLng / 2) * Math.sin(dLng / 2) *
Math.cos(a1) * Math.cos(a2);
return R * (2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x)));
}


/* =========================================================
SLX START TRIP — DISPATCH PAYLOAD HYDRATION V1
Must run early before old localStorage route wins.
ES5 safe.
========================================================= */
(function(){
"use strict";


if(window.__SLX_START_TRIP_DISPATCH_HYDRATION_V1__){return;}
window.__SLX_START_TRIP_DISPATCH_HYDRATION_V1__=true;


function getParam(name){
var q, parts, i, kv;


q = String(window.location.search || "");
if(q.charAt(0) === "?"){ q = q.substring(1); }


parts = q.split("&");


for(i=0;i<parts.length;i++){
kv = parts[i].split("=");
if(decodeURIComponent(kv[0] || "") === name){
return decodeURIComponent((kv.slice(1).join("=") || "").replace(/\+/g," "));
}
}


return "";
}


function safeParse(raw){
try{
return JSON.parse(raw);
}catch(e){}
return null;
}


function decodePayload(raw){
var txt, parsed;


if(!raw){return null;}


try{
txt = decodeURIComponent(raw);
}catch(e0){
txt = raw;
}


parsed = safeParse(txt);
if(parsed){return parsed;}


try{
txt = decodeURIComponent(escape(atob(raw)));
parsed = safeParse(txt);
if(parsed){return parsed;}
}catch(e1){}


try{
txt = atob(raw);
parsed = safeParse(txt);
if(parsed){return parsed;}
}catch(e2){}


return null;
}


function lsSet(k,v){
try{localStorage.setItem(k,v);}catch(e){}
}


function normalizePoint(p,fallbackName){
if(!p){return null;}


if(isFinite(Number(p.lng)) && isFinite(Number(p.lat))){
return {
name:String(p.name || fallbackName || "Location"),
title:String(p.name || fallbackName || "Location"),
label:String(p.name || fallbackName || "Location"),
full:String(p.full || p.name || fallbackName || "Location"),
lng:Number(p.lng),
lat:Number(p.lat)
};
}


return null;
}


function makeRouteFC(payload){
var coords = [];
var i, o, d, s;


o = normalizePoint(payload.origin,"Dispatch Origin");
d = normalizePoint(payload.destination,"Dispatch Destination");


if(!o || !d){return null;}


coords.push([Number(o.lng),Number(o.lat)]);


if(payload.stops && payload.stops.length){
for(i=0;i<payload.stops.length;i++){
s = normalizePoint(payload.stops[i],"Dispatch Stop");
if(s){coords.push([Number(s.lng),Number(s.lat)]);}
}
}


coords.push([Number(d.lng),Number(d.lat)]);


return {
type:"FeatureCollection",
features:[{
type:"Feature",
geometry:{
type:"LineString",
coordinates:coords
},
properties:{
source:"dispatch_cockpit",
dispatch:1,
created_at:String(payload.created_at || new Date().toISOString()),
routeMode:String(payload.routeMode || "fastest"),
stops:payload.stops && payload.stops.length ? payload.stops.length : 0
}
}]
};
}


function hydrateDispatch(){
var isDispatch, rawPayload, payload, dest, origin, routeFC, stops, notes, tripId;


isDispatch = getParam("dispatch");
rawPayload = getParam("payload");


if(String(isDispatch) !== "1" || !rawPayload){return false;}


payload = decodePayload(rawPayload);


if(!payload){return false;}


origin = normalizePoint(payload.origin,"Dispatch Origin");
dest = normalizePoint(payload.destination,"Dispatch Destination");
stops = payload.stops && payload.stops.length ? payload.stops : [];
notes = String(payload.notes || "");
routeFC =
  payload.route && payload.route.features ? payload.route :
  payload.routeGeo && payload.routeGeo.features ? payload.routeGeo :
  payload.route_geo && payload.route_geo.features ? payload.route_geo :
  payload.routeGeoJSON && payload.routeGeoJSON.features ? payload.routeGeoJSON :
  payload.route_geojson && payload.route_geojson.features ? payload.route_geojson :
  payload.activeRoute && payload.activeRoute.features ? payload.activeRoute :
  payload.tripRoute && payload.tripRoute.features ? payload.tripRoute :
  payload.driverRoute && payload.driverRoute.features ? payload.driverRoute :
  payload.handoff && payload.handoff.route && payload.handoff.route.features ? payload.handoff.route :
  payload.handoff && payload.handoff.routeGeo && payload.handoff.routeGeo.features ? payload.handoff.routeGeo :
  makeRouteFC(payload);
tripId = "dispatch_" + String(Date.now());


if(!dest || !routeFC){return false;}


/* Clear stale route dominance */
lsSet("slx_dispatch_payload_v1", JSON.stringify(payload));
lsSet("slx_active_trip_id", tripId);
lsSet("slx_trip_source_v1", "dispatch_cockpit");
lsSet("slx_trip_on_v1", "0");
lsSet("slx_trip_on_v2", "0");


/* Destination keys Start Trip commonly reads */
lsSet("slx_dest", JSON.stringify(dest));
lsSet("slx_main_dest_v2", JSON.stringify(dest));
lsSet("slx_route_target", JSON.stringify(dest));


/* Origin/current dispatch origin */
if(origin){
lsSet("slx_dispatch_origin_v1", JSON.stringify(origin));
lsSet("slx_origin_v1", JSON.stringify(origin));
lsSet("slx_last_gps_v1", JSON.stringify({
lng:Number(origin.lng),
lat:Number(origin.lat),
heading:0,
speed:0,
source:"dispatch_origin"
}));
}


/* Stop keys */
lsSet("slx_stops_v1", JSON.stringify(stops));
lsSet("slx_dispatch_stops_v1", JSON.stringify(stops));


if(stops.length){
lsSet("slx_active_stop_v1", JSON.stringify(stops[0]));
}else{
try{localStorage.removeItem("slx_active_stop_v1");}catch(e0){}
}


/* Route keys — overwrite old route everywhere */
lsSet("slx_route_geo_v2", JSON.stringify(routeFC));
lsSet("slx_route_geo_v1", JSON.stringify(routeFC));
lsSet("slx_route_geojson", JSON.stringify(routeFC));
lsSet("slx_active_route", JSON.stringify(routeFC));
lsSet("slx_trip_route", JSON.stringify(routeFC));
lsSet("slx_route_has_dispatch_v1", "1");


/* Driver handoff payload */
lsSet("slx_start_trip_payload", JSON.stringify({
source:"dispatch_cockpit",
tripId:tripId,
origin:origin,
destination:dest,
dest:dest,
stops:stops,
route:routeFC,
routeGeo:routeFC,
route_geo:routeFC,
routeGeoJSON:routeFC,
route_geojson:routeFC,
activeRoute:routeFC,
tripRoute:routeFC,
driverRoute:routeFC,
notes:notes,
company:String(payload.company || ""),
unit:String(payload.unit || ""),
status:String(payload.status || ""),
role:String(payload.role || "driver"),
routeMode:String(payload.routeMode || "fastest"),
created_at:String(payload.created_at || new Date().toISOString())
}));


/* Optional UI flags */
lsSet("slx_dispatch_ready_v1", "1");
lsSet("slx_dispatch_notes_v1", notes);


try{
window.SLX_DISPATCH_PAYLOAD = payload;
window.SLX_DISPATCH_ROUTE = routeFC;
window.SLX_DISPATCH_DEST = dest;
}catch(e1){}


return true;
}


if(hydrateDispatch()){
try{
window.__SLX_DISPATCH_HYDRATED_NOW__ = true;
}catch(e){}
}


})();


/* =========================================================
STOP NORMALIZATION HELPERS V1
One stop shape for Search, Scan Stops, and Driver Mode later.
Safe: does not route, draw, or change camera.
========================================================= */


function normalizeStop(item, source) {
var lat, lng, label, full, type;


if (!item) { return null; }


lat = Number(item.lat);
lng = Number(item.lng);


if (!isFiniteNum(lat) || !isFiniteNum(lng)) {
return null;
}


label = String(
item.label ||
item.main ||
item.name ||
item.title ||
item.place_name ||
"Stop"
);


full = String(
item.full ||
item.sub ||
item.address ||
item.place_name ||
""
);


type = String(
item.type ||
item.category ||
item.kind ||
source ||
"stop"
);


return {
lat: lat,
lng: lng,
label: label,
full: full,
type: type,
source: String(source || "unknown"),
addedAt: nowMs()
};
}


function saveActiveStop(stop) {
if (!stop) { return; }


stop1 = stop;


lsSetJSON(LS.ACTIVE_STOP, stop);
lsSetJSON(LS.STOP_1, stop);
lsSetJSON(LS.STOPS, [stop]);
}


function getActiveStop() {
var stop;


if (stop1 && isFiniteNum(Number(stop1.lat)) && isFiniteNum(Number(stop1.lng))) {
return stop1;
}


stop = lsGetJSON(LS.ACTIVE_STOP);
if (stop && isFiniteNum(Number(stop.lat)) && isFiniteNum(Number(stop.lng))) {
stop1 = stop;
return stop;
}


stop = lsGetJSON(LS.STOP_1);
if (stop && isFiniteNum(Number(stop.lat)) && isFiniteNum(Number(stop.lng))) {
stop1 = stop;
return stop;
}


return null;
}


function clearActiveStop() {
stop1 = null;
lsRemove(LS.ACTIVE_STOP);
lsRemove(LS.STOP_1);
lsRemove(LS.STOPS);
}


function minutesDelta(a, b) {
  return Math.round((Number(a || 0) - Number(b || 0)) / 60);
}


function moneyDelta(a, b) {
  return Math.round(Number(a || 0) - Number(b || 0));
}


function getRpmValue() {
  var raw = lsGet("slx_money_rpm_v1") || "";
  var num = Number(raw);
  if (!isFiniteNum(num) || num <= 0) { num = 2.20; }
  return num;
}


function calcTripMoney(distanceMeters, durationSeconds) {
  var miles = Number(distanceMeters || 0) * 0.000621371;
  var rpm = getRpmValue();
  var fuelCostPerMile = 0.72;
  var gross, fuel, net;


  if (loadMode === "loaded") { fuelCostPerMile = 0.82; }
  else if (loadMode === "bobtail") { fuelCostPerMile = 0.58; }


  gross = miles * rpm;
  fuel = miles * fuelCostPerMile;
  net = gross - fuel;


  return {
    miles: miles,
    rpm: rpm,
    gross: gross,
    fuel: fuel,
    net: net,
    durationSeconds: Number(durationSeconds || 0)
  };
}




/* =========================================================
SLX START TRIP - REAL ETA + TRIP INTELLIGENCE V28
Integrated into route selection. No wrapper overrides.
ES5-safe. ASCII-only.
========================================================= */


function slxMinutesLabel(totalMinutes) {
  var m = Math.max(0, Math.round(Number(totalMinutes || 0)));
  var h = Math.floor(m / 60);
  var r = m % 60;
  if (h <= 0) { return String(r) + "m"; }
  if (r <= 0) { return String(h) + "h"; }
  return String(h) + "h " + String(r) + "m";
}


function slxIsMetroLabel(label) {
  var d = String(label || "").toLowerCase();
  return (
    d.indexOf("atlanta") > -1 ||
    d.indexOf("dallas") > -1 ||
    d.indexOf("chicago") > -1 ||
    d.indexOf("houston") > -1 ||
    d.indexOf("memphis") > -1 ||
    d.indexOf("nashville") > -1 ||
    d.indexOf("orlando") > -1 ||
    d.indexOf("miami") > -1 ||
    d.indexOf("los angeles") > -1 ||
    d.indexOf("new york") > -1 ||
    d.indexOf("new jersey") > -1 ||
    d.indexOf("philadelphia") > -1
  );
}


function slxMetroDelayMinutes(label) {
  var hour = (new Date()).getHours();
  if (!slxIsMetroLabel(label)) { return 0; }
  if ((hour >= 7 && hour <= 9) || (hour >= 16 && hour <= 19)) { return 32; }
  return 18;
}


function slxFacilityArrivalBufferMinutes(label) {
  var d = String(label || "").toLowerCase();
  if (
    d.indexOf("warehouse") > -1 ||
    d.indexOf("distribution") > -1 ||
    d.indexOf("logistics") > -1 ||
    d.indexOf("terminal") > -1 ||
    d.indexOf("fulfillment") > -1 ||
    d.indexOf("walmart") > -1 ||
    d.indexOf("amazon") > -1 ||
    d.indexOf("target") > -1 ||
    d.indexOf("costco") > -1
  ) {
    return 24;
  }
  return 10;
}


function slxFuelStopBufferMinutes(miles) {
  miles = Number(miles || 0);
  if (miles >= 650) { return 52; }
  if (miles >= 300) { return 28; }
  if (miles >= 180) { return 18; }
  return 0;
}


function slxFoodRestBufferMinutes(miles) {
  miles = Number(miles || 0);
  if (miles >= 750) { return 46; }
  if (miles >= 420) { return 28; }
  if (miles >= 250) { return 16; }
  return 0;
}


function slxParkingSearchBufferMinutes(parkingScore, miles) {
  parkingScore = Number(parkingScore || 0);
  miles = Number(miles || 0);
  if (parkingScore < 45) { return miles >= 250 ? 42 : 24; }
  if (parkingScore < 60) { return miles >= 250 ? 28 : 16; }
  if (parkingScore < 75) { return 12; }
  return 0;
}


function slxWeatherDelayBufferMinutes(weatherScore) {
  weatherScore = Number(weatherScore || 0);
  if (weatherScore < 40) { return 48; }
  if (weatherScore < 60) { return 26; }
  if (weatherScore < 75) { return 12; }
  return 0;
}


function slxBuildRealEta(route, money, parkingScore, weatherScore) {
  var miles, baseSeconds, fuel, rest, parking, weather, metro, arrival, buffer, realSeconds;
  var label = dest ? String(dest.label || dest.full || "") : "";
  var reasons = [];


  if (!route) { return null; }


  money = money || calcTripMoney(route.distanceMeters, route.durationSeconds);
  miles = Number(money.miles || (Number(route.distanceMeters || 0) * 0.000621371));
  baseSeconds = Number(route.durationSeconds || 0);


  fuel = slxFuelStopBufferMinutes(miles);
  rest = slxFoodRestBufferMinutes(miles);
  parking = slxParkingSearchBufferMinutes(parkingScore, miles);
  weather = slxWeatherDelayBufferMinutes(weatherScore);
  metro = slxMetroDelayMinutes(label);
  arrival = slxFacilityArrivalBufferMinutes(label);


  buffer = fuel + rest + parking + weather + metro + arrival;
  realSeconds = baseSeconds + (buffer * 60);


  if (fuel > 0) { reasons.push("Fuel stop likely +" + fuel + "m"); }
  if (rest > 0) { reasons.push("Food/rest buffer +" + rest + "m"); }
  if (parking > 0) { reasons.push("Parking search buffer +" + parking + "m"); }
  if (weather > 0) { reasons.push("Weather delay risk +" + weather + "m"); }
  if (metro > 0) { reasons.push("Metro slowdown risk +" + metro + "m"); }
  if (arrival > 0) { reasons.push("Arrival/check-in +" + arrival + "m"); }


  while (reasons.length > 3) { reasons.pop(); }


  return {
    base_seconds: baseSeconds,
    real_seconds: realSeconds,
    base_minutes: Math.round(baseSeconds / 60),
    real_minutes: Math.round(realSeconds / 60),
    buffer_minutes: buffer,
    fuel_stop_minutes: fuel,
    food_rest_minutes: rest,
    parking_search_minutes: parking,
    weather_delay_minutes: weather,
    metro_delay_minutes: metro,
    facility_arrival_minutes: arrival,
    label: "REAL ETA " + slxMinutesLabel(realSeconds / 60),
    base_label: slxMinutesLabel(baseSeconds / 60),
    buffer_label: "+" + String(buffer) + "m buffer",
    reasons: reasons
  };
}


function slxBuildTripIntel(route, money, eta, routeType, scores) {
  var reasons = [];
  var weatherSaving = 0;
  var confidence = 0;
  var park = scores ? Number(scores.parking || 0) : 0;
  var weather = scores ? Number(scores.weather || 0) : 0;
  var wind = scores ? Number(scores.crosswind || 0) : 0;
  var toll = scores ? Number(scores.toll || 0) : 0;
  var load = scores ? Number(scores.loadShift || 0) : 0;


  if (routeType === "profit") { reasons.push("Higher estimated profit"); }
  if (routeType === "parking") { reasons.push("Better parking outlook"); }
  if (routeType === "weather") { reasons.push("Lower weather exposure"); }
  if (routeType === "fastest") { reasons.push("Fastest base drive time"); }
  if (routeType === "tolls") { reasons.push("Lower toll pressure"); }
  if (routeType === "loadshift") { reasons.push("Better load stability"); }
  if (routeType === "crosswind") { reasons.push("Lower crosswind exposure"); }


  if (park >= 80) { reasons.push("Strong parking corridor"); }
  else if (park < 60) { reasons.push("Parking may tighten later"); }


  if (weather >= 80) { reasons.push("Cleaner weather corridor"); }
  else if (weather < 60) { reasons.push("Weather could affect timing"); }


  if (wind < 60) { reasons.push("Crosswind exposure elevated"); }
  if (toll >= 80) { reasons.push("Low toll risk"); }
  if (load >= 80) { reasons.push("Load stability looks good"); }


  while (reasons.length > 3) { reasons.pop(); }
  while (reasons.length < 3) { reasons.push("Trip intelligence active"); }


  if (eta && eta.weather_delay_minutes > 0) {
    weatherSaving = eta.weather_delay_minutes;
  }


  confidence = Math.round(((park || 70) * 0.32) + ((weather || 70) * 0.28) + ((wind || 70) * 0.16) + ((toll || 70) * 0.12) + ((load || 70) * 0.12));
  if (confidence < 0) { confidence = 0; }
  if (confidence > 100) { confidence = 100; }


  return {
    updated_at: new Date().toISOString(),
    route_type: String(routeType || "profit"),
    confidence: confidence,
    reasons: reasons,
    weather_savings_minutes: weatherSaving,
    money_net: Math.round(Number(money && money.net || 0)),
    miles: Math.round(Number(money && money.miles || 0)),
    parking_score: park,
    weather_score: weather,
    toll_score: toll,
    load_shift_score: load,
    crosswind_score: wind,
    eta: eta
  };
}


function slxPersistRoutePlanningIntel(route, money, eta, intel) {
  try {
    if (eta) { lsSet(LS.ROUTE_ETA, JSON.stringify(eta)); }
    if (intel) { lsSet(LS.ROUTE_INTEL, JSON.stringify(intel)); }
    if (intel) {
      lsSet(LS.CORRIDOR_VISION, JSON.stringify({
        updated_at: new Date().toISOString(),
        mode: "planning_only",
        summary: intel.weather_savings_minutes > 0 ? "Weather may affect timing on this corridor" : "Corridor intelligence ready",
        driver_mode_behavior: "condensed_alerts_only",
        route_type: intel.route_type,
        confidence: intel.confidence
      }));
    }
  } catch (e) {}
}


/* ===== next-gen intelligence ===== */


function estimateParkingConfidenceScore(routeMeters) {
  var miles = Number(routeMeters || 0) * 0.000621371;
  var hour = (new Date()).getHours();
  var score = 100;
  var metroPenaltyCities, i, label;


  if (hour >= 18 && hour <= 23) { score -= 22; }
  if (hour >= 0 && hour <= 4) { score -= 10; }
  if (miles > 250) { score -= 8; }
  if (miles > 600) { score -= 12; }
  if (miles > 900) { score -= 12; }


  metroPenaltyCities = [
    "atlanta", "dallas", "chicago", "los angeles",
    "houston", "memphis", "nashville", "newark",
    "jersey", "philadelphia", "miami", "orlando"
  ];


  if (dest && dest.label) {
    label = String(dest.label || "").toLowerCase();
    for (i = 0; i < metroPenaltyCities.length; i++) {
      if (label.indexOf(metroPenaltyCities[i]) > -1) { score -= 14; }
    }
  }


  if (stop1 && stop1.label) {
    label = String(stop1.label || "").toLowerCase();
    for (i = 0; i < metroPenaltyCities.length; i++) {
      if (label.indexOf(metroPenaltyCities[i]) > -1) { score -= 8; }
    }
  }


  if (score < 0) { score = 0; }
  if (score > 100) { score = 100; }
  return score;
}


function parkingConfidenceLabel(score) {
  if (score >= 80) { return "HIGH"; }
  if (score >= 60) { return "MEDIUM"; }
  if (score >= 40) { return "LOW"; }
  return "TIGHT";
}


function tollRiskScore(routeMeters) {
  var miles = Number(routeMeters || 0) * 0.000621371;
  var score = 100;
  var t = "";


  if (miles > 150) { score -= 8; }
  if (miles > 400) { score -= 10; }
  if (miles > 800) { score -= 12; }


  if (dest && dest.label) {
    t = String(dest.label || "").toLowerCase();
    if (t.indexOf("new york") > -1) { score -= 18; }
    if (t.indexOf("new jersey") > -1) { score -= 16; }
    if (t.indexOf("chicago") > -1) { score -= 12; }
    if (t.indexOf("philadelphia") > -1) { score -= 10; }
    if (t.indexOf("florida") > -1) { score -= 6; }
  }


  if (score < 0) { score = 0; }
  if (score > 100) { score = 100; }
  return score;
}


function tollRiskLabel(score) {
  if (score >= 80) { return "LOW"; }
  if (score >= 60) { return "MED"; }
  return "HIGH";
}


function signalRiskScore(routeMeters) {
  var miles = Number(routeMeters || 0) * 0.000621371;
  var score = 100;
  if (miles > 250) { score -= 6; }
  if (miles > 600) { score -= 10; }
  if (miles > 900) { score -= 14; }
  return Math.max(0, Math.min(100, score));
}


function signalRiskLabel(score) {
  if (score >= 80) { return "STRONG"; }
  if (score >= 60) { return "GOOD"; }
  if (score >= 40) { return "PATCHY"; }
  return "LOW";
}


/* Optional precip layer support.
   To make this truly live, set:
   window.SLX_PRECIP_RADAR_TILE_URL = "https://.../{z}/{x}/{y}.png"
   OR
   window.SLX_GET_PRECIP_AT_LNGLAT = function(lng,lat){ return 0..100; };
*/
function addPrecipitationLayer() {
  if (!mapLoaded || !map) { return; }
  if (!PRECIP_TILE_URL) { return; }


  try {
    if (!map.getSource("slxPrecip")) {
      map.addSource("slxPrecip", {
        type: "raster",
        tiles: [PRECIP_TILE_URL],
        tileSize: 256
      });
    }


    if (!map.getLayer("slxPrecipLayer")) {
      map.addLayer({
        id: "slxPrecipLayer",
        type: "raster",
        source: "slxPrecip",
        paint: { "raster-opacity": 0.40 }
      });
    }
  } catch (e) {}
}


function adjustRadarOpacity() {
  var z;
  if (!mapLoaded || !map) { return; }
  if (!map.getLayer || !map.getLayer("slxPrecipLayer")) { return; }
  try {
    z = map.getZoom();
    if (z >= 10) { map.setPaintProperty("slxPrecipLayer", "raster-opacity", 0.62); }
    else if (z >= 7) { map.setPaintProperty("slxPrecipLayer", "raster-opacity", 0.48); }
    else { map.setPaintProperty("slxPrecipLayer", "raster-opacity", 0.34); }
  } catch (e) {}
}


function getPrecipPointScore(lng, lat) {
  var v = 0;
  if (PRECIP_POINT_FN) {
    try {
      v = Number(PRECIP_POINT_FN(lng, lat) || 0);
      if (!isFiniteNum(v)) { v = 0; }
      if (v < 0) { v = 0; }
      if (v > 100) { v = 100; }
      return v;
    } catch (e) {}
  }


  if (map && map.getLayer && map.getLayer("slxPrecipLayer")) {
    return 18;
  }


  return 0;
}


function sampleRouteWeatherOverlap(routeGeometry) {
  var coords, sampleStep, i, pt, total, sum, avg;
  if (!routeGeometry || !routeGeometry.coordinates || !routeGeometry.coordinates.length) { return 0; }


  coords = routeGeometry.coordinates;
  sampleStep = Math.max(1, Math.floor(coords.length / 18));
  total = 0;
  sum = 0;


  for (i = 0; i < coords.length; i += sampleStep) {
    pt = coords[i];
    if (!pt || pt.length < 2) { continue; }
    sum += getPrecipPointScore(Number(pt[0]), Number(pt[1]));
    total += 1;
  }


  if (!total) { return 0; }
  avg = Math.round(sum / total);
  if (avg < 0) { avg = 0; }
  if (avg > 100) { avg = 100; }
  return avg;
}


function weatherImpactScore(routeMeters, routeGeometry) {
  var miles = Number(routeMeters || 0) * 0.000621371;
  var score = 100;
  var overlap = sampleRouteWeatherOverlap(routeGeometry);


  if (miles > 250) { score -= 6; }
  if (miles > 600) { score -= 10; }
  if (miles > 900) { score -= 16; }


  score -= Math.round(overlap * 0.45);


  return Math.max(0, Math.min(100, score));
}


function weatherImpactLabel(score) {
  if (score >= 80) { return "CLEAR"; }
  if (score >= 60) { return "LIGHT"; }
  if (score >= 40) { return "MODERATE"; }
  return "HEAVY";
}


function loadShiftRiskScore(routeMeters) {
  var miles = Number(routeMeters || 0) * 0.000621371;
  var score = 100;
  var d = "";


  if (loadMode === "empty_trailer") { score -= 18; }
  if (loadMode === "bobtail") { score -= 28; }


  if (equipmentType === "flatbed") { score -= 22; }
  if (equipmentType === "step_deck") { score -= 18; }
  if (equipmentType === "car_hauler") { score -= 16; }
  if (equipmentType === "conestoga") { score -= 10; }


  if (miles > 300) { score -= 6; }
  if (miles > 700) { score -= 12; }
  if (miles > 1000) { score -= 16; }


  if (dest && dest.label) {
    d = String(dest.label || "").toLowerCase();
    if (d.indexOf("wyoming") > -1) { score -= 18; }
    if (d.indexOf("montana") > -1) { score -= 16; }
    if (d.indexOf("colorado") > -1) { score -= 14; }
    if (d.indexOf("utah") > -1) { score -= 10; }
    if (d.indexOf("new mexico") > -1) { score -= 8; }
  }


  score -= Math.round(sampleRouteWeatherOverlap(routeGeo && routeGeo.features && routeGeo.features[0] ? routeGeo.features[0].geometry : null) * 0.12);


  return Math.max(0, Math.min(100, score));
}


function loadShiftRiskLabel(score) {
  if (score >= 80) { return "LOW"; }
  if (score >= 60) { return "MODERATE"; }
  if (score >= 40) { return "HIGH"; }
  return "CRITICAL";
}


function crosswindExposureScore(routeMeters) {
  var miles = Number(routeMeters || 0) * 0.000621371;
  var hour = (new Date()).getHours();
  var score = 100;
  var d = "";


  if (loadMode === "empty_trailer") { score -= 20; }
  if (loadMode === "bobtail") { score -= 26; }


  if (equipmentType === "flatbed") { score -= 18; }
  if (equipmentType === "step_deck") { score -= 15; }
  if (equipmentType === "car_hauler") { score -= 14; }
  if (equipmentType === "conestoga") { score -= 8; }
  if (equipmentType === "van") { score -= 2; }
  if (equipmentType === "reefer") { score -= 3; }


  if (miles > 250) { score -= 6; }
  if (miles > 600) { score -= 10; }
  if (miles > 1000) { score -= 14; }


  if (hour >= 11 && hour <= 19) { score -= 6; }


  if (dest && dest.label) {
    d = String(dest.label || "").toLowerCase();
    if (d.indexOf("wyoming") > -1) { score -= 20; }
    if (d.indexOf("montana") > -1) { score -= 18; }
    if (d.indexOf("colorado") > -1) { score -= 14; }
    if (d.indexOf("new mexico") > -1) { score -= 12; }
    if (d.indexOf("texas") > -1) { score -= 8; }
    if (d.indexOf("oklahoma") > -1) { score -= 10; }
    if (d.indexOf("kansas") > -1) { score -= 12; }
    if (d.indexOf("nebraska") > -1) { score -= 10; }
    if (d.indexOf("south dakota") > -1) { score -= 12; }
    if (d.indexOf("north dakota") > -1) { score -= 14; }
  }


  score -= Math.round(sampleRouteWeatherOverlap(routeGeo && routeGeo.features && routeGeo.features[0] ? routeGeo.features[0].geometry : null) * 0.08);


  return Math.max(0, Math.min(100, score));
}


function crosswindExposureLabel(score) {
  if (score >= 80) { return "LOW"; }
  if (score >= 60) { return "MODERATE"; }
  if (score >= 40) { return "HIGH"; }
  return "SEVERE";
}


function weatherDeltaAgainstCurrent(candidateRoute) {
  var currentScore, candidateScore;
  if (!candidateRoute) { return null; }
  if (!routeGeo || !routeGeo.features || !routeGeo.features.length) { return null; }


  currentScore = weatherImpactScore(
    Number(routeGeo.features[0].properties && routeGeo.features[0].properties.distanceMeters || 0),
    routeGeo.features[0].geometry
  );


  candidateScore = weatherImpactScore(
    Number(candidateRoute.distanceMeters || 0),
    candidateRoute.geometry
  );


  return {
    currentScore: currentScore,
    candidateScore: candidateScore,
    improvement: candidateScore - currentScore
  };
}


function persistAltRoutes() {
  if (altRoutes && altRoutes.length) {
    lsSet(LS.ALT_ROUTES, JSON.stringify(altRoutes));
    lsSet(LS.ALT_ROUTE_INDEX, String(selectedRouteIndex || 0));
  } else {
    lsRemove(LS.ALT_ROUTES);
    lsRemove(LS.ALT_ROUTE_INDEX);
  }
}


function clearAltRouteStorage() {
  lsRemove(LS.ALT_ROUTES);
  lsRemove(LS.ALT_ROUTE_INDEX);
  lsRemove(LS.ALT_ROUTE_META);
}


function clearChipActiveStyles() {
  var ids = [
    "chipBestProfit",
    "chipFastest",
    "chipLowTolls",
    "chipBestParking",
    "chipLowWeather",
    "chipLoadShiftSafe",
    "chipCrosswindSafe"
  ];
  var i, el;
  for (i = 0; i < ids.length; i++) {
    el = $(ids[i]);
    if (!el) { continue; }
    el.classList.remove("active");
    el.style.boxShadow = "";
    el.style.transform = "";
  }
}


function highlightChip(type) {
  var target = null;
  clearChipActiveStyles();


  if (type === "profit") { target = $("chipBestProfit"); }
  if (type === "fastest") { target = $("chipFastest"); }
  if (type === "tolls") { target = $("chipLowTolls"); }
  if (type === "parking") { target = $("chipBestParking"); }
  if (type === "weather") { target = $("chipLowWeather"); }
  if (type === "loadshift") { target = $("chipLoadShiftSafe"); }
  if (type === "crosswind") { target = $("chipCrosswindSafe"); }


  if (target) {
    target.classList.add("active");
    target.style.boxShadow = "0 0 28px rgba(255,255,255,.18), 0 0 34px rgba(0,255,176,.16)";
    target.style.transform = "translateY(-1px)";
  }
}


function renderChipLabels(meta) {
  var bestProfitEl = $("chipBestProfit");
  var fastestEl = $("chipFastest");
  var tollEl = $("chipLowTolls");
  var parkingEl = $("chipBestParking");
  var weatherEl = $("chipLowWeather");
  var loadShiftEl = $("chipLoadShiftSafe");
  var crosswindEl = $("chipCrosswindSafe");


  if (!meta) { return; }


  if (bestProfitEl) {
    bestProfitEl.textContent = "BEST PROFIT • " + (meta.profitDelta >= 0 ? "+$" + meta.profitDelta : "-$" + Math.abs(meta.profitDelta));
  }


  if (fastestEl) {
    fastestEl.textContent = "FASTEST • " + (meta.etaDelta > 0 ? "−" + meta.etaDelta + " MIN" : "BASE");
  }


  if (tollEl) {
    tollEl.textContent = "LOW TOLLS • " + tollRiskLabel(meta.tollScore) + " RISK";
  }


  if (parkingEl) {
    parkingEl.textContent = "BEST PARKING • " + parkingConfidenceLabel(meta.parkingScore);
  }


  if (weatherEl) {
    if (meta.weatherImprovement >= 12) {
      weatherEl.textContent = "LOW WEATHER IMPACT • +" + String(meta.weatherImprovement) + " SAFER";
    } else {
      weatherEl.textContent = "LOW WEATHER IMPACT • " + weatherImpactLabel(meta.weatherScore);
    }
  }


  if (loadShiftEl) {
    loadShiftEl.textContent = "LOAD SHIFT RISK • " + loadShiftRiskLabel(meta.loadShiftScore);
  }


  if (crosswindEl) {
    crosswindEl.textContent = "CROSSWIND EXPOSURE • " + crosswindExposureLabel(meta.crosswindScore);
  }
}


function selectAltRoute(index, label) {
  var alt;
  var money;
  var parkingScore;
  var tollScore;
  var weatherScore;
  var loadShiftScore;
  var crosswindScore;
  var precipOverlap;
  var routeFeature;
  var realEta;
  var tripIntel;
  var intelScores;


  if (!altRoutes || !altRoutes.length) { return; }
  if (!isFiniteNum(index) || index < 0 || index >= altRoutes.length) { return; }


  selectedRouteIndex = index;
  activeChipType = String(label || "profit");
  alt = altRoutes[index];


  if (!alt || !alt.geometry) { return; }


  money = calcTripMoney(alt.distanceMeters, alt.durationSeconds);
  parkingScore = estimateParkingConfidenceScore(alt.distanceMeters);
  tollScore = tollRiskScore(alt.distanceMeters);
  weatherScore = weatherImpactScore(alt.distanceMeters, alt.geometry);
  loadShiftScore = loadShiftRiskScore(alt.distanceMeters);
  crosswindScore = crosswindExposureScore(alt.distanceMeters);
  precipOverlap = sampleRouteWeatherOverlap(alt.geometry);


  intelScores = {
    parking: parkingScore,
    toll: tollScore,
    weather: weatherScore,
    loadShift: loadShiftScore,
    crosswind: crosswindScore
  };


  realEta = slxBuildRealEta(alt, money, parkingScore, weatherScore);
  tripIntel = slxBuildTripIntel(alt, money, realEta, activeChipType, intelScores);


  routeFeature = {
    type: "Feature",
    geometry: alt.geometry,
    properties: {
      distanceMeters: Number(alt.distanceMeters || 0),
      durationSeconds: Number(alt.durationSeconds || 0),
      miles: Number(money.miles || 0),
      rpm: Number(money.rpm || 0),
      gross: Number(money.gross || 0),
      fuel: Number(money.fuel || 0),
      net: Number(money.net || 0),


      parkingConfidence: parkingConfidenceLabel(parkingScore),
      parkingScore: parkingScore,


      tollScore: tollScore,
      tollRisk: tollRiskLabel(tollScore),


      weatherScore: weatherScore,
      weatherImpact: weatherImpactLabel(weatherScore),


      loadShiftScore: loadShiftScore,
      loadShiftRisk: loadShiftRiskLabel(loadShiftScore),


      crosswindScore: crosswindScore,
      crosswindExposure: crosswindExposureLabel(crosswindScore),


      signalScore: signalRiskScore(alt.distanceMeters),
      signalRisk: signalRiskLabel(signalRiskScore(alt.distanceMeters)),


      precipOverlapPercent: precipOverlap,
      selectedRouteLabel: activeChipType,
      altRouteIndex: index,


      realEtaMinutes: realEta ? realEta.real_minutes : 0,
      baseEtaMinutes: realEta ? realEta.base_minutes : 0,
      etaBufferMinutes: realEta ? realEta.buffer_minutes : 0,
      etaReasons: realEta && realEta.reasons ? realEta.reasons.join(" | ") : "",
      tripIntelConfidence: tripIntel ? tripIntel.confidence : 0,
      tripIntelReasons: tripIntel && tripIntel.reasons ? tripIntel.reasons.join(" | ") : "",
      weatherSavingsMinutes: tripIntel ? tripIntel.weather_savings_minutes : 0
    }
  };


  routeGeo = {
    type: "FeatureCollection",
    features: [routeFeature]
  };


  routeReady = true;

  /*
    V29 SELECTED ROUTE MANEUVER AUTHORITY:
    Save the exact selected alternative's provider steps. Driver Mode already
    reads these keys; this is the missing Start Trip -> Drive Mode handoff.
  */
  try {
    var selectedStepsV29 = alt && alt.steps && alt.steps.length ? alt.steps :
      (alt && alt.maneuverSteps && alt.maneuverSteps.length ? alt.maneuverSteps : []);

    if (selectedStepsV29 && selectedStepsV29.length) {
      lsSet(LS.ROUTE_STEPS, JSON.stringify(selectedStepsV29));
      lsSet(LS.MANEUVER_STEPS, JSON.stringify(selectedStepsV29));

      /* Compatibility with older/newer Driver Mode readers. */
      lsSet("slx_route_steps_v1", JSON.stringify(selectedStepsV29));
      lsSet("slx_trip_steps_v1", JSON.stringify(selectedStepsV29));
      lsSet("slx_nav_steps_v1", JSON.stringify(selectedStepsV29));

      routeFeature.properties.stepCount = selectedStepsV29.length;
      routeFeature.properties.hasManeuverSteps = 1;
    } else {
      lsRemove(LS.ROUTE_STEPS);
      lsRemove(LS.MANEUVER_STEPS);
      lsRemove("slx_route_steps_v1");
      lsRemove("slx_trip_steps_v1");
      lsRemove("slx_nav_steps_v1");

      routeFeature.properties.stepCount = 0;
      routeFeature.properties.hasManeuverSteps = 0;
    }
  } catch (eV29Steps) {}


  lsSet(LS.MONEY_PREVIEW, JSON.stringify(money));
  slxPersistRoutePlanningIntel(alt, money, realEta, tripIntel);
  persistAltRoutes();
  syncMoneyPreviewPill(money);
  drawRouteLine(routeGeo);
  saveDriverHandoffPayload();
  syncUiFromState();
  highlightChip(activeChipType);
  fitToRouteTopView();
}


var SIGNAL_ENDPOINT = String(
  window.SLX_SIGNAL_ENDPOINT ||
  (
    String(
      window.SLX_WORKER_BASE ||
      "https://similocator.loveforlocals.workers.dev"
    ).replace(/\/+$/,"") +
    "/signals"
  )
);


function publishDriverPresence() {
  var gps = getGPS();
  var payload;
  var endpoint = SIGNAL_ENDPOINT;


  console.log("[SLX PRESENCE FIRED]");
  console.log("[SLX GPS]", gps);
  console.log("[SLX ENDPOINT]", endpoint);


  if (!gps) {
    console.log("[SLX PRESENCE ABORT] Missing GPS");
    return false;
  }


  if (!TRIP_ID) {
    TRIP_ID = genTripId();
  }


  payload = {
    trip_id: TRIP_ID,


    lat: Number(gps.lat),
    lng: Number(gps.lng),
    heading: Number(gps.heading || 0),
    speed: Number(gps.speed || 0),


    type: "driver",
    status: "active",
    signal_type: "driver",
    pin_type: "driver",
    role: "driver",


    mode: String(loadMode || "empty_trailer"),
    load_mode: String(loadMode || "empty_trailer"),
    truck_type: String(truckType || "dry_van"),
    equipment_type: String(equipmentType || "van"),


    source: "start_trip",
    confidence: "live",
    details: "Driver trip started from Start Trip",
    title: "Live Driver",


    expires_in_minutes: 90,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  };


  try {
    localStorage.setItem(
      "slx_driver_runtime_state_v1",
      JSON.stringify(payload)
    );
  } catch (e) {}


  try {
    console.log("[SLX POST PAYLOAD]", payload);


    fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    })
    .then(function (res) {
      console.log("[SLX PRESENCE POST STATUS]", res.status);
      return res.text();
    })
    .then(function (txt) {
      console.log("[SLX PRESENCE POST RESPONSE]", txt);
    })
    .catch(function (err) {
      console.log("[SLX PRESENCE POST ERROR]", err);
    });


  } catch (e2) {
    console.log("[SLX PRESENCE POST FAIL]", e2);
  }


  return true;
}


function startPresenceHeartbeat(){


  if(window.__SLX_PRESENCE_HEARTBEAT_V28__){
    return;
  }


  window.__SLX_PRESENCE_HEARTBEAT_V28__=true;


  setInterval(function(){


    var on =
      lsGet(LS.TRIP_ON_V2) ||
      lsGet(LS.TRIP_ON);


    if(String(on)==="1"){
      publishDriverPresence();
    }


  },30000);
}


function buildRouteMeta() {
  var bestProfitIndex = 0;
  var fastestIndex = 0;
  var lowestTollIndex = 0;
  var bestParkingIndex = 0;
  var bestWeatherIndex = 0;
  var safestLoadIndex = 0;
  var bestCrosswindIndex = 0;
  var bestProfit = -999999;
  var bestDuration = 999999999;
  var bestParking = -999999;
  var bestToll = -999999;
  var bestWeather = -999999;
  var bestLoad = -999999;
  var bestCrosswind = -999999;
  var i, route, money, parkScore, tollScore, weatherScore, loadShiftScore, crosswindScore;
  var base, baseMoney, profitMoney, weatherDelta;


  if (!altRoutes || !altRoutes.length) { return null; }


  for (i = 0; i < altRoutes.length; i++) {
    route = altRoutes[i];
    money = calcTripMoney(route.distanceMeters, route.durationSeconds);
    parkScore = estimateParkingConfidenceScore(route.distanceMeters);
    tollScore = tollRiskScore(route.distanceMeters);
    weatherScore = weatherImpactScore(route.distanceMeters, route.geometry);
    loadShiftScore = loadShiftRiskScore(route.distanceMeters);
    crosswindScore = crosswindExposureScore(route.distanceMeters);


    route.money = money;
    route.parkingScore = parkScore;
    route.tollScore = tollScore;
    route.weatherScore = weatherScore;
    route.loadShiftScore = loadShiftScore;
    route.crosswindScore = crosswindScore;


    if (money.net > bestProfit) { bestProfit = money.net; bestProfitIndex = i; }
    if (route.durationSeconds < bestDuration) { bestDuration = route.durationSeconds; fastestIndex = i; }
    if (parkScore > bestParking) { bestParking = parkScore; bestParkingIndex = i; }
    if (tollScore > bestToll) { bestToll = tollScore; lowestTollIndex = i; }
    if (weatherScore > bestWeather) { bestWeather = weatherScore; bestWeatherIndex = i; }
    if (loadShiftScore > bestLoad) { bestLoad = loadShiftScore; safestLoadIndex = i; }
    if (crosswindScore > bestCrosswind) { bestCrosswind = crosswindScore; bestCrosswindIndex = i; }
  }


  base = altRoutes[0];
  baseMoney = calcTripMoney(base.distanceMeters, base.durationSeconds);
  profitMoney = calcTripMoney(altRoutes[bestProfitIndex].distanceMeters, altRoutes[bestProfitIndex].durationSeconds);
  weatherDelta = weatherDeltaAgainstCurrent(altRoutes[bestWeatherIndex]);
  if (!weatherDelta) { weatherDelta = { improvement: 0 }; }


  return {
    bestProfitIndex: bestProfitIndex,
    fastestIndex: fastestIndex,
    lowestTollIndex: lowestTollIndex,
    bestParkingIndex: bestParkingIndex,
    bestWeatherIndex: bestWeatherIndex,
    safestLoadIndex: safestLoadIndex,
    bestCrosswindIndex: bestCrosswindIndex,
    profitDelta: moneyDelta(profitMoney.net, baseMoney.net),
    etaDelta: minutesDelta(base.durationSeconds, altRoutes[fastestIndex].durationSeconds),
    parkingScore: estimateParkingConfidenceScore(altRoutes[bestParkingIndex].distanceMeters),
    tollScore: tollRiskScore(altRoutes[lowestTollIndex].distanceMeters),
    weatherScore: weatherImpactScore(altRoutes[bestWeatherIndex].distanceMeters, altRoutes[bestWeatherIndex].geometry),
    loadShiftScore: loadShiftRiskScore(altRoutes[safestLoadIndex].distanceMeters),
    crosswindScore: crosswindExposureScore(altRoutes[bestCrosswindIndex].distanceMeters),
    weatherImprovement: weatherDelta.improvement
  };
}


function evaluateBestRoutes() {
  var meta = buildRouteMeta();
  if (!meta) { return; }


  lsSet(LS.ALT_ROUTE_META, JSON.stringify(meta));
  renderChipLabels(meta);


  if (meta.weatherImprovement >= 18 && $("subline")) {
    $("subline").textContent = "Storm-aware alt route available • weather exposure reduced";
  }


  selectAltRoute(meta.bestProfitIndex, "profit");
}


function bindSmartRouteChips() {
  var profitChip = $("chipBestProfit");
  var fastestChip = $("chipFastest");
  var tollChip = $("chipLowTolls");
  var parkingChip = $("chipBestParking");
  var weatherChip = $("chipLowWeather");
  var loadShiftChip = $("chipLoadShiftSafe");
  var crosswindChip = $("chipCrosswindSafe");
  var meta = buildRouteMeta();


  if (!meta) { return; }


  if (profitChip) {
    profitChip.onclick = function () {
      selectAltRoute(meta.bestProfitIndex, "profit");
      toast("Best profit route selected");
    };
  }


  if (fastestChip) {
    fastestChip.onclick = function () {
      selectAltRoute(meta.fastestIndex, "fastest");
      toast("Fastest route selected");
    };
  }


  if (tollChip) {
    tollChip.onclick = function () {
      selectAltRoute(meta.lowestTollIndex, "tolls");
      toast("Low toll route selected");
    };
  }


  if (parkingChip) {
    parkingChip.onclick = function () {
      selectAltRoute(meta.bestParkingIndex, "parking");
      toast("Best parking route selected");
    };
  }


  if (weatherChip) {
    weatherChip.onclick = function () {
      selectAltRoute(meta.bestWeatherIndex, "weather");
      toast(meta.weatherImprovement >= 12 ? "Weather-safer route selected" : "Low weather route selected");
    };
  }


  if (loadShiftChip) {
    loadShiftChip.onclick = function () {
      selectAltRoute(meta.safestLoadIndex, "loadshift");
      toast("Load-stability route selected");
    };
  }


  if (crosswindChip) {
    crosswindChip.onclick = function () {
      selectAltRoute(meta.bestCrosswindIndex, "crosswind");
      toast("Crosswind-safer route selected");
    };
  }
}


function persistLastFix() {
  var gps = getGPS();
  if (!gps) { return; }


  gps.ts = gps.ts || nowMs();
  lsSet(LS.LAST_FIX, JSON.stringify(gps));
}


function slxGpsAgeMs() {
  if (!lastFix || !lastFix.ts) { return 999999999; }
  return nowMs() - Number(lastFix.ts || 0);
}


function slxGpsIsStale() {
  return slxGpsAgeMs() > 120000;
}


function restorePersistedGPS(shouldRecenter) {
  var saved = lsGetJSON(LS.LAST_FIX);
  var stale = false;


  if (!saved || !isFiniteNum(Number(saved.lat)) || !isFiniteNum(Number(saved.lng))) {
    updateGpsUI();
    requestFreshGPS(false);
    return false;
  }


  lastFix = {
    lat: Number(saved.lat),
    lng: Number(saved.lng),
    acc: Number(saved.acc || 0),
    ts: Number(saved.ts || 0),
    heading: isFiniteNum(Number(saved.heading)) ? Number(saved.heading) : null,
    speed: isFiniteNum(Number(saved.speed)) ? Number(saved.speed) : null
  };


  if (!lastFix.ts || !isFiniteNum(lastFix.ts)) {
    lastFix.ts = nowMs() - 999999999;
  }


  stale = slxGpsIsStale();


  pendingFix = { lng: lastFix.lng, lat: lastFix.lat };
  updateGpsUI();


  if (mapLoaded && map) {
    ensureMapSources();
    setYouPoint(lastFix.lng, lastFix.lat);
    pendingFix = null;


    if (shouldRecenter) {
      recenterToGPS();
    }
  }


  if (stale) {
    setStatus("Refreshing GPS...", "blue");
    requestFreshGPS(!!shouldRecenter);
  }


  return true;
}


function acceptLiveGPSFix(pos, shouldRecenter) {
  var c = pos && pos.coords ? pos.coords : {};
  var lat = Number(c.latitude);
  var lng = Number(c.longitude);
  var acc = Number(c.accuracy || 9999);
  var heading = isFiniteNum(Number(c.heading)) ? Number(c.heading) : null;
  var speed = isFiniteNum(Number(c.speed)) ? Number(c.speed) : null;


  if (!isFiniteNum(lat) || !isFiniteNum(lng)) { return false; }


  lastFix = {
    lat: lat,
    lng: lng,
    acc: acc,
    ts: nowMs(),
    heading: heading,
    speed: speed
  };


  persistLastFix();
  updateGpsUI();


  if (mapLoaded && map) {
    ensureMapSources();
    setYouPoint(lastFix.lng, lastFix.lat);


    if (shouldRecenter) {
      clearFreeFlow();


      try {
        map.easeTo({
          center: [lastFix.lng, lastFix.lat],
          zoom: 16.0,
          pitch: 0,
          bearing: 0,
          duration: 700,
          essential: true
        });
      } catch (e0) {}


    } else if (nowMs() > freeFlowUntil) {


      try {
        map.easeTo({
          center: [lastFix.lng, lastFix.lat],
          duration: 850,
          essential: true
        });
      } catch (e1) {}


    }


  } else {
    pendingFix = { lng: lastFix.lng, lat: lastFix.lat };
  }


  saveDriverHandoffPayload();
  setStatus(shouldRecenter ? "GPS centered" : "GPS refreshed", "green");
  return true;
}


function requestFreshGPS(shouldRecenter) {
  if (!navigator || !navigator.geolocation) {
    return false;
  }


  try {
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        acceptLiveGPSFix(pos, !!shouldRecenter);
      },
      function () {
        if (!lastFix) {
          setStatus("GPS blocked", "red");
          setGpsPill("GPS blocked");
          toast("Enable location permissions");
        }
      },
      { enableHighAccuracy: true, timeout: 20000, maximumAge: 0 }
    );
  } catch (e) {
    return false;
  }


  return true;
}


function recenterToGPS() {
  if (!lastFix) {
    restorePersistedGPS(false);
  }


  if (!lastFix || !isFiniteNum(Number(lastFix.lat)) || !isFiniteNum(Number(lastFix.lng))) {
    toast("Tap LOCK GPS first");
    setStatus("Need GPS", "red");
    updateGpsUI();
    requestFreshGPS(true);
    return false;
  }


  if(slxGpsIsStale()){
   requestFreshGPS(false);
}


  clearFreeFlow();
  updateGpsUI();


  if (mapLoaded && map) {
    ensureMapSources();
    setYouPoint(lastFix.lng, lastFix.lat);


    try {
      map.easeTo({
        center: [lastFix.lng, lastFix.lat],
        zoom: 16.0,
        pitch: 0,
        bearing: 0,
        duration: 700,
        essential: true
      });
    } catch (e) {}
  } else {
    pendingFix = { lng: lastFix.lng, lat: lastFix.lat };
  }


  if (slxGpsIsStale()) {
    setStatus("Refreshing GPS...", "blue");
    toast("Refreshing GPS");
    requestFreshGPS(true);
  } else {
    setStatus("GPS centered", "green");
    toast("GPS recentered");
  }


  return true;
}


function isLoadedMode() {
  return loadMode === "loaded";
}


function labelTripMode(v) {
  if (v === "loaded") { return "LOADED"; }
  if (v === "bobtail") { return "BOBTAIL"; }
  return "EMPTY TRAILER";
}


function labelTruckType(v) {
  var mapLabel = {
    dry_van: "DRY VAN",
    reefer: "REEFER",
    flatbed: "FLATBED",
    hotshot: "HOTSHOT",
    box_truck: "BOX TRUCK",
    car_hauler: "CAR HAULER",
    power_only: "POWER ONLY"
  };
  return mapLabel[v] || "TRUCK";
}


function labelEquipmentType(v) {
  var mapLabel = {
    van: "VAN",
    reefer: "REEFER",
    flatbed: "FLATBED",
    step_deck: "STEP DECK",
    lowboy: "LOWBOY",
    conestoga: "CONESTOGA",
    car_hauler: "CAR HAULER",
    container_chassis: "CHASSIS",
    power_only: "POWER ONLY",
    box_truck: "BOX TRUCK",
    hopper: "HOPPER",
    tanker: "TANKER"
  };
  return mapLabel[v] || "EQUIPMENT";
}


function labelWeight(v) {
  if (!v) { return ""; }
  if (v === "light") { return "LIGHT"; }
  if (v === "oversize") { return "OVERSIZE"; }
  return String(v) + " LB";
}


function labelCapacity(v) {
  return v === "partial" ? "PARTIAL" : "FULL";
}


function setLoadUI() {
  var emptyTrailer = $("chipEmptyTrailer");
  var loaded = $("chipLoaded");
  var bobtail = $("chipBobtail");
  var start = $("btnStartTrip");


  if (emptyTrailer) { emptyTrailer.className = loadMode === "empty_trailer" ? "chip on btn" : "chip btn"; }
  if (loaded) { loaded.className = loadMode === "loaded" ? "chip gold btn on" : "chip gold btn"; }
  if (bobtail) { bobtail.className = loadMode === "bobtail" ? "chip blue btn on" : "chip blue btn"; }
  if (start) { start.className = "ctaBig btn"; }
}


function setCapacityUI() {
  var full = $("chipCapacityFull");
  var partial = $("chipCapacityPartial");
  if (full) { full.className = tripCapacity === "full" ? "chip on blue btn" : "chip blue btn"; }
  if (partial) { partial.className = tripCapacity === "partial" ? "chip on orange btn" : "chip orange btn"; }
}


function updateEquipmentSelects() {
  if ($("truckTypeSelect")) { $("truckTypeSelect").value = truckType; }
  if ($("equipmentTypeSelect")) { $("equipmentTypeSelect").value = equipmentType; }
  if ($("lengthSelect")) { $("lengthSelect").value = equipmentLength; }
  if ($("weightSelect")) { $("weightSelect").value = equipmentWeight; }
}


function renderEquipmentSummary() {
  var wrap = $("equipmentSummary");
  var html = [];
  if (!wrap) { return; }


  html.push('<div class="summaryPill">' + labelTripMode(loadMode) + '</div>');
  html.push('<div class="summaryPill">' + labelTruckType(truckType) + '</div>');
  html.push('<div class="summaryPill">' + labelEquipmentType(equipmentType) + '</div>');
  html.push('<div class="summaryPill">' + labelCapacity(tripCapacity) + '</div>');


  if (equipmentLength) { html.push('<div class="summaryPill">' + String(equipmentLength) + ' FT</div>'); }
  if (equipmentWeight) { html.push('<div class="summaryPill">' + labelWeight(equipmentWeight) + '</div>'); }


  wrap.innerHTML = html.join("");
}


function setSearchTargetUI() {
  var input = $("destInput");
  var btn = $("btnAddStop");
  var sub = $("subline");


  if (input) {
    input.placeholder = searchTarget === "stop" ?
      "Search stop address, truck stop, customer, city" :
      "Search destination, address, truck stop, customer, city";
  }


  if (btn) { btn.textContent = searchTarget === "stop" ? "ADDING STOP..." : "+ ADD STOP"; }


  if (sub) {
    if (searchTarget === "stop") { sub.textContent = "Pick a stop, then route and start"; }
    else if (stop1) { sub.textContent = "Destination + 1 stop ready for route"; }
    else if (dest) { sub.textContent = "Destination selected • Route when ready"; }
    else { sub.textContent = "Lock GPS, set destination, add stop, route, start"; }
  }
}


function setStopUI() {
  var card = $("stopCard");
  var main = $("stopMain");
  var sub = $("stopSub");


  if (!card || !main || !sub) { return; }


  if (stop1) {
    card.className = "stopCard on";
    main.textContent = stop1.label || "Stop";
    sub.textContent = stop1.full || "Selected stop";
  } else {
    card.className = "stopCard";
    main.textContent = "Stop";
    sub.textContent = "Address";
  }


  setSearchTargetUI();
}


function setRouteNowCue(on) {
  var btn = $("btnRouteNow");
  if (!btn) { return; }
  btn.className = "edgeBtn gold btn";
  btn.style.boxShadow = on ?
    "0 14px 28px rgba(0,0,0,.24), 0 0 28px rgba(255,205,105,.42), 0 0 70px rgba(255,205,105,.22), inset 0 0 0 1px rgba(255,255,255,.22)" :
    "0 12px 24px rgba(0,0,0,.22), 0 0 24px rgba(255,205,105,.35), 0 0 60px rgba(255,205,105,.18), inset 0 0 0 1px rgba(255,255,255,.18)";
}


function updateRouteNowCue() {
  setRouteNowCue(!!dest && !routeReady);
}


function highlightRouteNow() {
  if (cueTimer) { clearTimeout(cueTimer); }
  setRouteNowCue(true);
  cueTimer = setTimeout(function () { updateRouteNowCue(); }, 2600);
}


function enterFreeFlow() { freeFlowUntil = nowMs() + FREE_FLOW_MS; }
function clearFreeFlow() { freeFlowUntil = 0; }


function getTopHeight() {
  var el = document.querySelector(".topBar");
  return el ? (el.offsetHeight || 84) : 84;
}


function emptyFC() {
  return { type: "FeatureCollection", features: [] };
}


function pointFC(lng, lat) {
  return {
    type: "FeatureCollection",
    features: [{
      type: "Feature",
      geometry: { type: "Point", coordinates: [lng, lat] },
      properties: {}
    }]
  };
}


function getGPS() {
  if (!lastFix) { return null; }
  if (!isFiniteNum(lastFix.lat) || !isFiniteNum(lastFix.lng)) { return null; }
  return {
    lat: lastFix.lat,
    lng: lastFix.lng,
    acc: lastFix.acc || 0,
    ts: lastFix.ts || nowMs(),
    heading: isFiniteNum(lastFix.heading) ? lastFix.heading : null,
    speed: isFiniteNum(lastFix.speed) ? lastFix.speed : null
  };
}


function updateGpsButtonLabel() {
  var btn = $("btnLockGps");
  if (!btn) { return; }
  btn.textContent = lastFix ? "RECENTER GPS" : "LOCK GPS";
}


function updateGpsUI() {
  if (!lastFix) {
    setGpsPill("GPS: --");
    updateGpsButtonLabel();
    return;
  }
  setGpsPill("GPS locked");
  updateGpsButtonLabel();
}


function inputMatchesDest() {
  var typed = getInputText().toLowerCase();
  var a = dest && dest.label ? String(dest.label).toLowerCase() : "";
  var b = dest && dest.full ? String(dest.full).toLowerCase() : "";


  if (!typed) { return !!dest; }
  if (!dest) { return false; }
  if (typed === a || typed === b) { return true; }
  if (a && typed.indexOf(a) > -1) { return true; }
  if (b && typed.indexOf(b) > -1) { return true; }
  return false;
}


function clearStoredRouteKeys() {
  lsRemove(LS.ROUTE_GEO);
  lsRemove(LS.ROUTE_GEO_V2);
  lsRemove(LS.ROUTE_1);
  lsRemove(LS.ROUTE_2);
  lsRemove(LS.ROUTE_3);
  lsRemove(LS.ROUTE_4);

  /* V29: route geometry and maneuver truth must clear together. */
  lsRemove(LS.ROUTE_STEPS);
  lsRemove(LS.MANEUVER_STEPS);
  lsRemove("slx_route_steps_v1");
  lsRemove("slx_trip_steps_v1");
  lsRemove("slx_nav_steps_v1");

  lsRemove(LS.NATIVE_PAYLOAD);
  lsRemove(LS.MONEY_PREVIEW);
  lsRemove(LS.ROUTE_ETA);
  lsRemove(LS.ROUTE_INTEL);
  lsRemove(LS.CORRIDOR_VISION);
  clearAltRouteStorage();
  lsSet(LS.TRIP_ON, "0");
  lsSet(LS.TRIP_ON_V2, "0");
}


function removeRouteLayers() {
  try { if (map && map.getLayer("slxRouteCore")) { map.removeLayer("slxRouteCore"); } } catch (e1) {}
  try { if (map && map.getLayer("slxRouteGlow")) { map.removeLayer("slxRouteGlow"); } } catch (e2) {}
  try { if (map && map.getSource("slxRoute")) { map.removeSource("slxRoute"); } } catch (e3) {}
}


function clearPoiLayers() {
  try { if (map && map.getLayer("slxPoiGlow")) { map.removeLayer("slxPoiGlow"); } } catch (e) {}
  try { if (map && map.getLayer("slxPoiDots")) { map.removeLayer("slxPoiDots"); } } catch (e2) {}
  try { if (map && map.getSource("slxPois")) { map.removeSource("slxPois"); } } catch (e3) {}
}


function clearRouteStateOnly() {
  routeGeo = null;
  routeReady = false;
  altRoutes = [];
  selectedRouteIndex = 0;
  activeChipType = "profit";
  removeRouteLayers();
  clearStoredRouteKeys();
  clearChipActiveStyles();
}


function ensureMapSources() {
  if (!mapLoaded || !map) { return; }


  try {
    if (!map.getSource("slxYou")) { map.addSource("slxYou", { type: "geojson", data: emptyFC() }); }
    if (!map.getSource("slxDest")) { map.addSource("slxDest", { type: "geojson", data: emptyFC() }); }
  } catch (e) {}


  try {
    if (!map.getLayer("slxYouGlow")) {
      map.addLayer({
        id: "slxYouGlow",
        type: "circle",
        source: "slxYou",
        paint: { "circle-radius": 14, "circle-color": "rgba(0,255,176,0.24)" }
      });
    }
    if (!map.getLayer("slxYouDot")) {
      map.addLayer({
        id: "slxYouDot",
        type: "circle",
        source: "slxYou",
        paint: {
          "circle-radius": 6,
          "circle-color": "rgba(0,255,176,1)",
          "circle-stroke-width": 2,
          "circle-stroke-color": "rgba(0,0,0,0.72)"
        }
      });
    }
    if (!map.getLayer("slxDestGlow")) {
      map.addLayer({
        id: "slxDestGlow",
        type: "circle",
        source: "slxDest",
        paint: { "circle-radius": 14, "circle-color": "rgba(255,205,105,0.24)" }
      });
    }
    if (!map.getLayer("slxDestDot")) {
      map.addLayer({
        id: "slxDestDot",
        type: "circle",
        source: "slxDest",
        paint: {
          "circle-radius": 6,
          "circle-color": "rgba(255,205,105,1)",
          "circle-stroke-width": 2,
          "circle-stroke-color": "rgba(0,0,0,0.72)"
        }
      });
    }
  } catch (e2) {}
}


function setYouPoint(lng, lat) {
  if (!mapLoaded || !map) { return; }
  try { if (map.getSource("slxYou")) { map.getSource("slxYou").setData(pointFC(lng, lat)); } } catch (e) {}
}


function setDestPoint(lng, lat) {
  if (!mapLoaded || !map) { return; }
  try { if (map.getSource("slxDest")) { map.getSource("slxDest").setData(pointFC(lng, lat)); } } catch (e) {}
}


function clearDestPoint() {
  if (!mapLoaded || !map) { return; }
  try { if (map.getSource("slxDest")) { map.getSource("slxDest").setData(emptyFC()); } } catch (e) {}
}


function buildBoundsFromCoords(coords) {
  var bounds, i;
  if (!coords || coords.length < 2) { return null; }
  bounds = new mapboxgl.LngLatBounds([coords[0][0], coords[0][1]], [coords[0][0], coords[0][1]]);
  for (i = 1; i < coords.length; i++) {
    bounds.extend([coords[i][0], coords[i][1]]);
  }
  return bounds;
}


function drawRouteLine(geojson) {
  if (!mapLoaded || !map || !geojson) { return; }


  try {
    if (map.getSource("slxRoute")) {
      map.getSource("slxRoute").setData(geojson);
    } else {
      map.addSource("slxRoute", { type: "geojson", data: geojson });
      map.addLayer({
        id: "slxRouteGlow",
        type: "line",
        source: "slxRoute",
        layout: { "line-join": "round", "line-cap": "round" },
        paint: {
          "line-color": isLoadedMode() ? "rgba(255,205,105,0.40)" : "rgba(0,255,176,0.34)",
          "line-width": 18
        }
      });
      map.addLayer({
        id: "slxRouteCore",
        type: "line",
        source: "slxRoute",
        layout: { "line-join": "round", "line-cap": "round" },
        paint: {
          "line-color": isLoadedMode() ? "rgba(255,205,105,1)" : "rgba(0,255,176,1)",
          "line-width": 7
        }
      });
    }
  } catch (e) {}
}


function fitToRouteTopView() {
  var feature, coords, bounds, padTop, padBottom, sidePad, vh, topH, cam;
  if (!mapLoaded || !map || !routeGeo || !routeGeo.features || !routeGeo.features.length) { return; }


  try {
    feature = routeGeo.features[0];
    if (!feature || !feature.geometry || !feature.geometry.coordinates) { return; }
    coords = feature.geometry.coordinates;
    bounds = buildBoundsFromCoords(coords);
    if (!bounds) { return; }


    vh = window.innerHeight || 844;
    topH = getTopHeight();
    padTop = topH + 22;
    padBottom = Math.round(vh * 0.26);
    sidePad = 18;


    try { map.stop(); } catch (e1) {}
    try { map.jumpTo({ bearing: 0, pitch: 0 }); } catch (e2) {}


    cam = map.cameraForBounds(bounds, {
      padding: { top: padTop, right: sidePad, bottom: padBottom, left: sidePad },
      bearing: 0,
      pitch: 0,
      maxZoom: 10.5
    });


    if (cam && cam.center) {
      map.easeTo({
        center: cam.center,
        zoom: cam.zoom,
        bearing: 0,
        pitch: 0,
        duration: 900,
        essential: true
      });
    }
  } catch (e) {}
}


function updateLayout() {
  var results = $("results");
  var vh = window.innerHeight || document.documentElement.clientHeight || 844;
  var resultsMax;


  if (results) {
    resultsMax = vh > 760 ? 220 : 140;
    results.style.maxHeight = String(resultsMax) + "px";
  }
}


function syncUiFromState() {
  var input = $("destInput");


  if (input) {
    if (searchTarget === "stop" && stop1) {
      input.value = stop1.label || stop1.full || "";
    } else {
      input.value = dest ? (dest.label || dest.full || "") : "";
    }
    if (String(input.value || "").toLowerCase() === "pinned destination") { input.value = ""; }
    input.placeholder = "Search destination, address, truck stop, customer, city";
  }


  updateGpsUI();
  setLoadUI();
  setCapacityUI();
  updateEquipmentSelects();
  renderEquipmentSummary();
  setStopUI();
  updateRouteNowCue();
  updateLayout();


  if (!mapLoaded || !map) { return; }


  ensureMapSources();
  if (lastFix) { setYouPoint(lastFix.lng, lastFix.lat); }
  if (dest) { setDestPoint(dest.lng, dest.lat); }
  else { clearDestPoint(); }


  if (routeReady && routeGeo) { drawRouteLine(routeGeo); }
  else { removeRouteLayers(); }
}


function saveDriverHandoffPayload() {
  var gps = getGPS();
  var stops = stop1 ? [{
    lat: stop1.lat,
    lng: stop1.lng,
    label: stop1.label || "",
    full: stop1.full || ""
  }] : [];
  var payload;


  if (!TRIP_ID) { TRIP_ID = genTripId(); }


  payload = {
    trip_id: TRIP_ID,
    saved_at: (new Date()).toISOString(),
    gps: gps,
    dest: dest ? { lat: dest.lat, lng: dest.lng, label: dest.label || "", full: dest.full || "" } : null,
    stops: stops,
    money_preview: safeJSONParse(lsGet(LS.MONEY_PREVIEW)),
    route_eta: safeJSONParse(lsGet(LS.ROUTE_ETA)),
    route_intel: safeJSONParse(lsGet(LS.ROUTE_INTEL)),
    corridor_vision: safeJSONParse(lsGet(LS.CORRIDOR_VISION)),
    mode: loadMode,
    trip_capacity: tripCapacity,
    truck_type: truckType,
    equipment_type: equipmentType,
    equipment_length_ft: equipmentLength || "",
    equipment_weight_lb: equipmentWeight || "",
    route_ready: routeReady ? 1 : 0,
    route: routeGeo || null,

    /*
      V29: Driver Mode gets the maneuver package directly in the handoff too,
      not only through localStorage aliases.
    */
    route_steps:
      (altRoutes && altRoutes[selectedRouteIndex] && altRoutes[selectedRouteIndex].steps) ?
      altRoutes[selectedRouteIndex].steps :
      (safeJSONParse(lsGet(LS.ROUTE_STEPS)) || []),
    maneuver_steps:
      (altRoutes && altRoutes[selectedRouteIndex] && altRoutes[selectedRouteIndex].steps) ?
      altRoutes[selectedRouteIndex].steps :
      (safeJSONParse(lsGet(LS.MANEUVER_STEPS)) || []),

    alt_routes: altRoutes || [],
    selected_route_index: selectedRouteIndex || 0,
    selected_route_type: activeChipType
  };


  lsSet(LS.ACTIVE_TRIP_ID, TRIP_ID);
  lsSet(LS.START_PAYLOAD, JSON.stringify(payload));
  lsSet(LS.MODE, String(loadMode || "empty_trailer"));
  lsSet(LS.TRIP_MODE, String(loadMode || "empty_trailer"));
  lsSet(LS.TRIP_CAPACITY, String(tripCapacity || "full"));
  lsSet(LS.TRUCK_TYPE, String(truckType || "dry_van"));
  lsSet(LS.EQUIPMENT_TYPE, String(equipmentType || "van"));
  lsSet(LS.EQUIPMENT_LENGTH, String(equipmentLength || ""));
  lsSet(LS.EQUIPMENT_WEIGHT, String(equipmentWeight || ""));


  if (gps) { lsSet(LS.LAST_FIX, JSON.stringify(gps)); }


  if (dest) {
    lsSet(LS.DEST, JSON.stringify({ lat: dest.lat, lng: dest.lng, label: dest.label || "", full: dest.full || "" }));
    lsSet(LS.DEST_V2, JSON.stringify({ lat: dest.lat, lng: dest.lng, label: dest.label || "", full: dest.full || "" }));
  } else {
    lsRemove(LS.DEST);
    lsRemove(LS.DEST_V2);
  }


  if (stop1) { lsSet(LS.STOPS, JSON.stringify(stops)); }
  else { lsRemove(LS.STOPS); }


  if (routeGeo && dest) {
    lsSet(LS.ROUTE_GEO, JSON.stringify(routeGeo));
    lsSet(LS.ROUTE_GEO_V2, JSON.stringify(routeGeo));
    lsSet(LS.ROUTE_1, JSON.stringify(routeGeo));
    lsSet(LS.ROUTE_2, JSON.stringify(routeGeo));
    lsSet(LS.ROUTE_3, JSON.stringify(routeGeo));
    lsSet(LS.ROUTE_4, JSON.stringify(routeGeo));
    lsSet(LS.TRIP_ON, "1");
    lsSet(LS.TRIP_ON_V2, "1");

    /* V29: route selection + maneuver selection are one atomic handoff. */
    try {
      var handoffStepsV29 =
        (altRoutes && altRoutes[selectedRouteIndex] && altRoutes[selectedRouteIndex].steps) ?
        altRoutes[selectedRouteIndex].steps :
        (safeJSONParse(lsGet(LS.ROUTE_STEPS)) || []);

      if (handoffStepsV29 && handoffStepsV29.length) {
        lsSet(LS.ROUTE_STEPS, JSON.stringify(handoffStepsV29));
        lsSet(LS.MANEUVER_STEPS, JSON.stringify(handoffStepsV29));
        lsSet("slx_route_steps_v1", JSON.stringify(handoffStepsV29));
        lsSet("slx_trip_steps_v1", JSON.stringify(handoffStepsV29));
        lsSet("slx_nav_steps_v1", JSON.stringify(handoffStepsV29));
      }
    } catch (eV29Handoff) {}

    persistAltRoutes();
  } else {
    clearStoredRouteKeys();
  }
}


function restoreState() {
  var fix = safeJSONParse(lsGet(LS.LAST_FIX));
  var d = safeJSONParse(lsGet(LS.DEST_V2)) || safeJSONParse(lsGet(LS.DEST));
  var stopsStored = safeJSONParse(lsGet(LS.STOPS));
  var r = safeJSONParse(lsGet(LS.ROUTE_GEO_V2)) ||
    safeJSONParse(lsGet(LS.ROUTE_GEO)) ||
    safeJSONParse(lsGet(LS.ROUTE_1)) ||
    safeJSONParse(lsGet(LS.ROUTE_2)) ||
    safeJSONParse(lsGet(LS.ROUTE_3)) ||
    safeJSONParse(lsGet(LS.ROUTE_4));
  var restoredAltRoutes = safeJSONParse(lsGet(LS.ALT_ROUTES));
  var restoredRouteIndex = parseInt(lsGet(LS.ALT_ROUTE_INDEX) || "0", 10);
  var m = lsGet(LS.MODE);
  var cap = lsGet(LS.TRIP_CAPACITY);
  var tt = lsGet(LS.TRUCK_TYPE);
  var et = lsGet(LS.EQUIPMENT_TYPE);
  var el = lsGet(LS.EQUIPMENT_LENGTH);
  var ew = lsGet(LS.EQUIPMENT_WEIGHT);
  var tripOn = lsGet(LS.TRIP_ON_V2) || lsGet(LS.TRIP_ON);


  if (fix && isFiniteNum(Number(fix.lat)) && isFiniteNum(Number(fix.lng))) {
    lastFix = {
      lat: Number(fix.lat),
      lng: Number(fix.lng),
      acc: Number(fix.acc || 0),
      ts: Number(fix.ts || 0),
      heading: isFiniteNum(Number(fix.heading)) ? Number(fix.heading) : null,
      speed: isFiniteNum(Number(fix.speed)) ? Number(fix.speed) : null
    };
    pendingFix = { lng: lastFix.lng, lat: lastFix.lat };
  }


  if (d && isFiniteNum(Number(d.lat)) && isFiniteNum(Number(d.lng))) {
    dest = {
      lat: Number(d.lat),
      lng: Number(d.lng),
      label: String(d.label || ""),
      full: String(d.full || d.label || "")
    };
  }


  if (stopsStored && stopsStored.length && stopsStored[0]) {
    stop1 = {
      lat: Number(stopsStored[0].lat),
      lng: Number(stopsStored[0].lng),
      label: String(stopsStored[0].label || ""),
      full: String(stopsStored[0].full || stopsStored[0].label || "")
    };
  }


  if (tripOn === "1" && r && r.type === "FeatureCollection" && r.features && r.features.length) {
    routeGeo = r;
    routeReady = true;
  }


  if (restoredAltRoutes && restoredAltRoutes.length) {
    altRoutes = restoredAltRoutes;
    selectedRouteIndex = isFiniteNum(restoredRouteIndex) ? restoredRouteIndex : 0;
  }


  if (m === "loaded" || m === "empty_trailer" || m === "bobtail") { loadMode = m; }
  if (cap === "partial" || cap === "full") { tripCapacity = cap; }
  if (tt) { truckType = tt; }
  if (et) { equipmentType = et; }
  if (el) { equipmentLength = el; }
  if (ew) { equipmentWeight = ew; }


  if (routeGeo && routeGeo.features && routeGeo.features[0] && routeGeo.features[0].properties && routeGeo.features[0].properties.selectedRouteLabel) {
    activeChipType = String(routeGeo.features[0].properties.selectedRouteLabel);
    highlightChip(activeChipType);
  }
}


function getInputText() {
  var el = $("destInput");
  if (!el) { return ""; }
  return String(el.value || "").replace(/^\s+|\s+$/g, "");
}


/* =========================================================
SLX START TRIP — TRUCKING SEARCH CORE V2
Universal address search first; trucking intent remains available separately.
Route-aware + GPS-aware + ES5 safe.
========================================================= */


function slxSearchText(v) {
  return String(v || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, " ")
    .replace(/^\s+|\s+$/g, "");
}


function slxLooksLikeStreetNumberQuery(query) {
  var raw = String(query || "").replace(/^\s+|\s+$/g, "");
  var q = slxSearchText(query);


  if (!raw || !q) { return false; }


  if (/^\d{1,7}\s+/.test(raw)) { return true; }


  if (/\b\d{1,7}\s+[a-z0-9]+\s+(st|street|rd|road|ave|avenue|blvd|boulevard|dr|drive|ln|lane|hwy|highway|pkwy|parkway|ct|court|cir|circle|way|pl|place|ter|terrace)\b/i.test(raw)) {
    return true;
  }


  if (/\b(st|street|rd|road|ave|avenue|blvd|boulevard|dr|drive|ln|lane|hwy|highway|pkwy|parkway|ct|court|cir|circle|way|pl|place|ter|terrace)\b/i.test(raw) && /\d/.test(raw)) {
    return true;
  }


  return false;
}


function slxLooksLikeFacilityDestination(query) {
  var q = slxSearchText(query);


  if (!q) { return false; }
  if (slxLooksLikeTruckSearch(query)) { return false; }


  return (
    q.indexOf("warehouse") > -1 ||
    q.indexOf("distribution") > -1 ||
    q.indexOf("distribution center") > -1 ||
    q.indexOf("dc ") > -1 ||
    q.indexOf(" dc") > -1 ||
    q.indexOf("logistics") > -1 ||
    q.indexOf("terminal") > -1 ||
    q.indexOf("fulfillment") > -1 ||
    q.indexOf("plant") > -1 ||
    q.indexOf("mill") > -1 ||
    q.indexOf("receiver") > -1 ||
    q.indexOf("shipper") > -1 ||
    q.indexOf("walmart") > -1 ||
    q.indexOf("amazon") > -1 ||
    q.indexOf("target") > -1 ||
    q.indexOf("costco") > -1 ||
    q.indexOf("fedex") > -1 ||
    q.indexOf("ups") > -1
  );
}


function slxSearchIntent(query) {
  var q = slxSearchText(query);


  if (!q) { return { type: "normal", query: query }; }


  /* Address-first guardrail: street-number searches must not get buried by truck POI logic. */
  if (slxLooksLikeStreetNumberQuery(query)) {
    return { type: "address", query: query, addressFirst: true };
  }


  if (slxLooksLikeFacilityDestination(query)) {
    return { type: "facility", query: query, addressFirst: true };
  }


  if (q.indexOf("love") > -1 || q.indexOf("loves") > -1) {
    return { type: "fuel_brand", query: "Love's Travel Stop" };
  }


  if (q.indexOf("pilot") > -1) {
    return { type: "fuel_brand", query: "Pilot Travel Center" };
  }


  if (q.indexOf("flying j") > -1) {
    return { type: "fuel_brand", query: "Flying J Travel Center" };
  }


  if (q === "ta" || q.indexOf("travel center") > -1 || q.indexOf("travelcenters") > -1) {
    return { type: "fuel_brand", query: "TravelCenters of America" };
  }


  if (q.indexOf("petro") > -1) {
    return { type: "fuel_brand", query: "Petro Stopping Center" };
  }


  if (q.indexOf("cat scale") > -1 || q.indexOf("scale") > -1 || q.indexOf("weigh") > -1) {
    return { type: "scale", query: "CAT Scale" };
  }


  if (q.indexOf("parking") > -1 || q.indexOf("park") > -1 || q.indexOf("overnight") > -1) {
    return { type: "parking", query: "truck parking" };
  }


  if (q.indexOf("truck stop") > -1 || q.indexOf("truckstop") > -1) {
    return { type: "truck_stop", query: "truck stop" };
  }


  if (q.indexOf("diesel") > -1 || q.indexOf("fuel") > -1 || q.indexOf("gas") > -1) {
    return { type: "fuel", query: "truck stop diesel" };
  }


  if (q.indexOf("repair") > -1 || q.indexOf("tire") > -1 || q.indexOf("service") > -1 || q.indexOf("mechanic") > -1) {
    return { type: "repair", query: "diesel truck repair" };
  }


  if (q.indexOf("rest area") > -1 || q === "rest" || q.indexOf("rest stop") > -1) {
    return { type: "rest", query: "rest area" };
  }


  if (q.indexOf("shower") > -1) {
    return { type: "shower", query: "truck stop shower" };
  }


  if (q.indexOf("food") > -1 || q.indexOf("restaurant") > -1 || q.indexOf("eat") > -1) {
    return { type: "food", query: "truck stop food" };
  }


  return { type: "normal", query: query };
}
function slxSearchProximity() {
  var gps;


  try {
    gps = getGPS();
    if (gps && isFiniteNum(Number(gps.lng)) && isFiniteNum(Number(gps.lat))) {
      return String(gps.lng) + "," + String(gps.lat);
    }
  } catch (e1) {}


  try {
    if (lastFix && isFiniteNum(Number(lastFix.lng)) && isFiniteNum(Number(lastFix.lat))) {
      return String(lastFix.lng) + "," + String(lastFix.lat);
    }
  } catch (e2) {}


  return "";
}


function slxGetRouteCoordsForSearch() {
  var geo, f, c;


  try {
    if (typeof routeGeo !== "undefined" && routeGeo) {
      geo = routeGeo;
    }
  } catch (e) {}


  if (!geo) {
    geo =
      lsGetJSON(LS.ROUTE_GEO_V2) ||
      lsGetJSON(LS.ROUTE_GEO) ||
      lsGetJSON(LS.ROUTE_1) ||
      lsGetJSON(LS.ROUTE_2) ||
      lsGetJSON(LS.ROUTE_3) ||
      lsGetJSON(LS.ROUTE_4);
  }


  if (!geo || !geo.features || !geo.features.length) { return null; }


  f = geo.features[0];
  if (!f || !f.geometry) { return null; }


  if (f.geometry.type === "LineString") {
    c = f.geometry.coordinates;
    if (c && c.length > 1) { return c; }
  }


  if (f.geometry.type === "MultiLineString") {
    c = f.geometry.coordinates && f.geometry.coordinates[0];
    if (c && c.length > 1) { return c; }
  }


  return null;
}


function slxDistanceToRouteMiles(lat, lng) {
  var coords = slxGetRouteCoordsForSearch();
  var i, step, best, d;


  if (!coords || !coords.length) { return 999999; }


  step = Math.max(1, Math.floor(coords.length / 220));
  best = 999999;


  for (i = 0; i < coords.length; i += step) {
    if (!coords[i] || coords[i].length < 2) { continue; }


    d = distanceMiles(
      Number(lat),
      Number(lng),
      Number(coords[i][1]),
      Number(coords[i][0])
    );


    if (d < best) { best = d; }
  }


  return best;
}


function slxScoreSearchItem(item, intent) {
  var s = 0;
  var text = String((item.main || "") + " " + (item.sub || "")).toLowerCase();
  var main = String(item.main || "").toLowerCase();
  var src = String(item.source || "").toLowerCase();
  var routeMiles = 999999;


  if (item.distanceMiles) {
    s += Math.max(0, 120 - Number(item.distanceMiles || 0));
  }


  if (item.lat && item.lng) {
    routeMiles = slxDistanceToRouteMiles(Number(item.lat), Number(item.lng));
    item.routeDistanceMiles = routeMiles;


    if (routeMiles <= 1) { s += 90; }
    else if (routeMiles <= 3) { s += 65; }
    else if (routeMiles <= 8) { s += 35; }
    else if (routeMiles <= 15) { s += 15; }
  }


  if (src === "operational_poi") { s += 40; }
  /* Never demote a valid street address simply because its name contains Road, Drive, etc. */
  if (intent && intent.type === "address") { return s + 300; }
  if (item.truckRelevant) { s += 35; }


  if (text.indexOf("truck stop") > -1) { s += 80; }
  if (text.indexOf("travel center") > -1) { s += 75; }
  if (text.indexOf("diesel") > -1) { s += 55; }
  if (text.indexOf("truck") > -1) { s += 45; }
  if (text.indexOf("fuel") > -1) { s += 35; }
  if (text.indexOf("parking") > -1) { s += 30; }
  if (text.indexOf("rest area") > -1) { s += 28; }
  if (text.indexOf("repair") > -1 || text.indexOf("service") > -1) { s += 25; }


  if (main.indexOf("love") === 0 || text.indexOf("love's") > -1 || text.indexOf("loves travel") > -1 || text.indexOf("love’s") > -1) { s += 120; }
  if (main.indexOf("pilot") === 0 || text.indexOf("pilot travel") > -1) { s += 115; }
  if (text.indexOf("flying j") > -1) { s += 115; }
  if (main.indexOf("ta ") === 0 || text.indexOf("ta travel") > -1 || text.indexOf("petro") > -1) { s += 100; }


  if (intent && intent.type === "fuel_brand") {
    if (text.indexOf("travel stop") > -1) { s += 90; }
    if (text.indexOf("travel center") > -1) { s += 90; }
    if (text.indexOf("truck stop") > -1) { s += 80; }
    if (text.indexOf("diesel") > -1) { s += 60; }
    if (text.indexOf("gas station") > -1) { s += 25; }
  }


  if (
    text.indexOf(" cove") > -1 ||
    text.indexOf(" cv") > -1 ||
    text.indexOf(" lane") > -1 ||
    text.indexOf(" drive") > -1 ||
    text.indexOf(" dr") > -1 ||
    text.indexOf(" road") > -1 ||
    text.indexOf(" rd") > -1 ||
    text.indexOf(" avenue") > -1 ||
    text.indexOf(" ave") > -1 ||
    text.indexOf(" corner") > -1 ||
    text.indexOf(" mountain") > -1 ||
    text.indexOf(" grove") > -1 ||
    text.indexOf(" place") > -1
  ) {
    if (
      text.indexOf("truck stop") === -1 &&
      text.indexOf("travel center") === -1 &&
      text.indexOf("travel stop") === -1 &&
      text.indexOf("diesel") === -1
    ) {
      s -= 160;
    }
  }


  if (intent && intent.type === "fuel") {
    if (text.indexOf("diesel") > -1) { s += 45; }
    if (text.indexOf("fuel") > -1) { s += 35; }
  }


  if (intent && intent.type === "parking" && text.indexOf("parking") > -1) { s += 55; }
  if (intent && intent.type === "repair" && (text.indexOf("repair") > -1 || text.indexOf("service") > -1)) { s += 55; }
  if (intent && intent.type === "scale" && (text.indexOf("scale") > -1 || text.indexOf("weigh") > -1)) { s += 55; }


  return s;
}


function slxBuildSearchItem(f, intent, source) {
  var lng, lat, gps, miles;


  if (!f || !f.center || f.center.length < 2) { return null; }


  lng = Number(f.center[0]);
  lat = Number(f.center[1]);


  if (!isFiniteNum(lng) || !isFiniteNum(lat)) { return null; }


  miles = 0;


  try {
    gps = getGPS();
    if (gps && isFiniteNum(Number(gps.lat)) && isFiniteNum(Number(gps.lng))) {
      miles = distanceMiles(Number(gps.lat), Number(gps.lng), lat, lng);
    }
  } catch (e) {}


  return {
    lng: lng,
    lat: lat,
    main: String(f.text || f.place_name || "Result"),
    sub: String(f.place_name || ""),
    type: intent && intent.type !== "normal" ? intent.type : "destination",
    source: source || "autocomplete",
    searchIntent: intent ? intent.type : "normal",
    truckRelevant: !!(intent && intent.type !== "normal"),
    distanceMiles: miles,
    routeDistanceMiles: slxDistanceToRouteMiles(lat, lng),
    score: 0
  };
}


/* =========================================================
SLX CORRIDOR SEARCH ENGINE V1
Route-aware operational POI filtering
========================================================= */


function slxPointNearRouteMiles(lat, lng, routeGeo, thresholdMiles) {


  var coords, i;
  var best = 999999;
  var d;


  if (
    !routeGeo ||
    !routeGeo.coordinates ||
    !routeGeo.coordinates.length
  ) {
    return false;
  }


  coords = routeGeo.coordinates;


  for (i = 0; i < coords.length; i += 1) {


    d = calcMiles(
      lat,
      lng,
      Number(coords[i][1]),
      Number(coords[i][0])
    );


    if (d < best) {
      best = d;
    }


    if (best <= thresholdMiles) {
      return true;
    }
  }


  return false;
}




/* =========================================================
ONLY SHOW POIs THAT ARE ALONG ROUTE
========================================================= */


function slxFilterPoisAlongRoute(items) {


  var out = [];


  if (
    !window.routeGeo ||
    !window.routeGeo.coordinates ||
    !window.routeGeo.coordinates.length
  ) {
    return items || [];
  }


  (items || []).forEach(function(item){


    if (
      slxPointNearRouteMiles(
        Number(item.lat),
        Number(item.lng),
        window.routeGeo,
        8
      )
    ) {
      out.push(item);
    }


  });


  return out;
}


function slxOperationalPoiSearch(query) {
  var raw = String(query || "");
  var q = raw.toLowerCase().trim();
  var out = [];
  var prox = slxSearchProximity();
  var proxParts, proxLng, proxLat;


  q = q.replace(/'/g, "");
  q = q.replace(/’/g, "");


  if (!q) { return []; }
  if (!window.SLX_OPERATIONAL_POIS || !window.SLX_OPERATIONAL_POIS.length) { return []; }


  if (prox && prox.indexOf(",") > -1) {
    proxParts = prox.split(",");
    proxLng = Number(proxParts[0]);
    proxLat = Number(proxParts[1]);
  }


  window.SLX_OPERATIONAL_POIS.forEach(function (poi) {
    var matched = false;
    var dist = 999999;
    var routeDist = 999999;
var score = 0;
    var aliases = poi.aliases || [];
    var i, alias;


    for (i = 0; i < aliases.length; i += 1) {
      alias = String(aliases[i] || "").toLowerCase().trim();
      alias = alias.replace(/'/g, "");
      alias = alias.replace(/’/g, "");


      if (
        q === alias ||
        alias.indexOf(q) === 0 ||
        q.indexOf(alias) > -1
      ) {
        matched = true;
        break;
      }
    }


    if (!matched) { return; }


    if (isFiniteNum(proxLng) && isFiniteNum(proxLat)) {
      dist = distanceMiles(proxLat, proxLng, Number(poi.lat), Number(poi.lng));
      routeDist = slxDistanceToRouteMiles(
  Number(poi.lat),
  Number(poi.lng)
);
    }


    out.push({
      main: String(poi.name || "Truck stop"),
      sub: "Truck fuel" + (dist < 999999 ? " • " + String(Math.round(dist * 10) / 10) + " mi" : "") + " • " + String(poi.city || "") + ", " + String(poi.state || ""),
      label: String(poi.name || "Truck stop"),
      full: String(poi.name || "Truck stop") + ", " + String(poi.city || "") + ", " + String(poi.state || ""),
      lat: Number(poi.lat),
      lng: Number(poi.lng),
      truckRelevant: true,
      operationalPoi: true,
      distanceMiles: dist,
      source: "slx_operational_registry",
      category: "Truck fuel",
      score: (100000 - (dist * 25)) - (routeDist * 100)
    });
  });


  out = slxFilterPoisAlongRoute(out);
  out.sort(function (a, b) {
    return Number(b.score || 0) - Number(a.score || 0);
  });


  return out.slice(0, 10);
}


/* =========================================================
SLX OPERATIONAL POI REGISTRY V1
========================================================= */


window.SLX_OPERATIONAL_POIS = [


  {
    brand: "Love's",
    aliases: ["loves", "love's", "love", "truck fuel", "diesel", "fuel", "truck stop"],
    type: "truck_fuel",
    category: "truck_stop",
    name: "Love's Travel Stop",
    lat: 35.1328,
    lng: -90.0626,
    city: "Memphis",
    state: "TN"
  },


  {
    brand: "Pilot",
    aliases: ["pilot", "pilot flying j", "flying pilot", "truck fuel", "diesel", "fuel", "truck stop"],
    type: "truck_fuel",
    category: "truck_stop",
    name: "Pilot Travel Center",
    lat: 35.1820,
    lng: -90.1850,
    city: "West Memphis",
    state: "AR"
  },


  {
    brand: "Flying J",
    aliases: ["flying j", "flyingj", "pilot flying j", "truck fuel", "diesel", "fuel", "truck stop"],
    type: "truck_fuel",
    category: "truck_stop",
    name: "Flying J Travel Center",
    lat: 35.1506,
    lng: -90.0518,
    city: "Memphis",
    state: "TN"
  },


  {
    brand: "TA",
    aliases: ["ta", "travelcenters", "travel centers", "truck fuel", "diesel", "fuel", "truck stop"],
    type: "truck_fuel",
    category: "truck_stop",
    name: "TA Travel Center",
    lat: 35.1118,
    lng: -90.0531,
    city: "Memphis",
    state: "TN"
  },


  {
    brand: "Rest Area",
    aliases: ["rest area", "rest stop", "parking", "truck parking", "break area"],
    type: "rest_area",
    category: "rest_area",
    name: "I-40 Rest Area",
    lat: 35.1520,
    lng: -90.1720,
    city: "West Memphis",
    state: "AR"
  },


  {
    brand: "Petro",
    aliases: ["petro", "truck fuel", "diesel", "fuel", "truck stop"],
    type: "truck_fuel",
    category: "truck_stop",
    name: "Petro Stopping Center",
    lat: 35.1980,
    lng: -90.2010,
    city: "West Memphis",
    state: "AR"
  }


];


function geocodeSearch(query, opts, cb) {
  var intent, searchQuery, prox;
  var operationalResults;


  opts = opts || {};


  if (!MAPBOX_TOKEN) {
    cb([]);
    return;
  }


  intent = slxSearchIntent(query);


  /* Address/facility searches get first priority over operational POI shortcuts. */
  if (!intent.addressFirst) {
    operationalResults = slxOperationalPoiSearch(query);


    if (operationalResults && operationalResults.length) {
      cb(operationalResults);
      return;
    }
  }


  searchQuery = intent.query || query;
  prox = slxSearchProximity();


  function runMapboxSearch(q, types, limit, source, done) {
    var params = [];
    var url, xhr;

    /* Geocoding v5 supports 1–10 results and no longer supports POI types.
       Keep address search reliable; true POI search needs Search Box API. */
    limit = Math.max(1, Math.min(10, Number(limit) || 10));
    types = String(types || "address,place,postcode,region,district,locality,neighborhood")
      .split(",").filter(function (type) { return type !== "poi"; }).join(",");
    if (!types) { types = "address,place,postcode,region,district,locality,neighborhood"; }


    params.push("access_token=" + encodeURIComponent(MAPBOX_TOKEN));
    params.push("autocomplete=true");
    params.push("limit=" + encodeURIComponent(String(limit || 10)));
    params.push("country=us");
    params.push("language=en");
    params.push("types=" + encodeURIComponent(types));


    if (prox) {
      params.push("proximity=" + encodeURIComponent(prox));
    }


    url = "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
      encodeURIComponent(q) + ".json?" + params.join("&");


    xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);


    xhr.onreadystatechange = function () {
      var data, feats, out, i, item;


      if (xhr.readyState !== 4) { return; }


      try {
        if (xhr.status >= 200 && xhr.status < 300) {
          data = JSON.parse(xhr.responseText || "{}");
          feats = data.features || [];
          out = [];


          for (i = 0; i < feats.length; i += 1) {
            item = slxBuildSearchItem(feats[i], intent, source);
            if (!item) { continue; }
            item.score = slxScoreSearchItem(item, intent);
            out.push(item);
          }


          done(out);
          return;
        }
      } catch (e) {}


      done([]);
    };


    xhr.send(null);
  }


  function runAddressFirstSearch(done) {
    var all = [];
    var seen = {};


    function addItems(items, boost, tag) {
      var i, it, key;
      if (!items || !items.length) { return; }


      for (i = 0; i < items.length; i += 1) {
        it = items[i];
        if (!it) { continue; }


        key = String(Math.round(Number(it.lat || 0) * 10000)) + "," + String(Math.round(Number(it.lng || 0) * 10000));
        if (seen[key]) { continue; }
        seen[key] = true;


        it.searchIntent = tag || intent.type;
        it.type = tag || intent.type;
        it.truckRelevant = false;
        it.score = Number(it.score || 0) + Number(boost || 0);
        all.push(it);
      }
    }


    runMapboxSearch(query, "address,poi,place,postcode,region,district,locality,neighborhood", opts.limit || 10, "address_first", function (addressItems) {
      addItems(addressItems, 260, intent.type === "facility" ? "facility" : "address");


      runMapboxSearch(query, "poi,address", 8, "facility_blend", function (poiItems) {
        addItems(poiItems, intent.type === "facility" ? 180 : 40, intent.type === "facility" ? "facility" : "address");


        all.sort(function (a, b) {
          var as = Number(a.score || 0);
          var bs = Number(b.score || 0);
          var ad = Number(a.distanceMiles || 999999);
          var bd = Number(b.distanceMiles || 999999);


          if (bs !== as) { return bs - as; }
          return ad - bd;
        });


        done(all.slice(0, 12));
      });
    });
  }


  function runTruckSearchBundle(done) {
    var queries = [];
    var all = [];
    var seen = {};
    var idx = 0;


    if (intent.type === "fuel_brand") {
      queries = [
        searchQuery,
        query,
        searchQuery + " truck stop",
        searchQuery + " travel center",
        searchQuery + " diesel",
        "truck stop",
        "diesel fuel"
      ];
    } else if (intent.type === "fuel") {
      queries = [
        searchQuery,
        "diesel fuel",
        "truck stop",
        "travel center",
        "Pilot Flying J",
        "Love's Travel Stop",
        "TA Petro"
      ];
    } else if (intent.type === "truck_stop") {
      queries = [
        "truck stop",
        "travel center",
        "diesel fuel",
        "Pilot Flying J",
        "Love's Travel Stop",
        "TA Petro"
      ];
    } else if (intent.type === "parking") {
      queries = [
        "truck parking",
        "truck stop",
        "travel center",
        "rest area"
      ];
    } else if (intent.type === "scale") {
      queries = [
        "CAT scale",
        "weigh station",
        "truck scale"
      ];
    } else if (intent.type === "repair") {
      queries = [
        "truck repair",
        "truck service",
        "tire repair",
        "diesel repair"
      ];
    } else {
      queries = [
        searchQuery,
        query
      ];
    }


    function addItems(items) {
      var i, it, key;


      if (!items || !items.length) { return; }


      for (i = 0; i < items.length; i += 1) {
        it = items[i];


        key =
          String(Math.round(Number(it.lat || 0) * 10000)) + "," +
          String(Math.round(Number(it.lng || 0) * 10000));


        if (!seen[key]) {
          seen[key] = true;
          all.push(it);
        }
      }
    }


    function next() {
      var q;


      if (idx >= queries.length) {
        all.sort(function (a, b) {
          var da = Number(a.distanceMiles || 999999);
          var db = Number(b.distanceMiles || 999999);
          var sa = Number(a.score || 0);
          var sb = Number(b.score || 0);


          if (Math.abs(sb - sa) > 18) {
            return sb - sa;
          }


          return da - db;
        });


        done(all.slice(0, 12));
        return;
      }


      q = queries[idx];
      idx += 1;


      if (!q) {
        next();
        return;
      }


      runMapboxSearch(q, "poi", 10, "truck_bundle", function (items) {
        addItems(items);
        next();
      });
    }


    next();
  }


  if (intent && intent.addressFirst) {
    runAddressFirstSearch(function (addressItems) {
      if (addressItems && addressItems.length) {
        cb(addressItems);
        return;
      }


      runMapboxSearch(query, "poi,address,place,postcode,region,district,locality,neighborhood", opts.limit || 10, "address_fallback", function (fallbackItems) {
        cb(fallbackItems);
      });
    });


    return;
  }


  if (intent && intent.type !== "normal") {
    runTruckSearchBundle(function (truckItems) {
      if (truckItems && truckItems.length) {
        cb(truckItems);
        return;
      }


      runMapboxSearch(query, "poi,address,place,postcode,region,district,locality,neighborhood", opts.limit || 10, "geocode_fallback", function (fallbackItems) {
        fallbackItems.sort(function (a, b) {
          return Number(b.score || 0) - Number(a.score || 0);
        });
        cb(fallbackItems);
      });
    });


    return;
  }


  runMapboxSearch(searchQuery, "poi,address,place,postcode,region,district,locality,neighborhood", opts.limit || 10, "autocomplete", function (items) {
    cb(items);
  });
}
/* =========================================================
SLX TRUCK SEARCH KEYWORD ENGINE V1
Detects trucking intent before geocoding
========================================================= */


function slxLooksLikeTruckSearch(q){


  q = String(q || "").toLowerCase();


  return (
    q.indexOf("pilot") !== -1 ||
    q.indexOf("love") !== -1 ||
    q.indexOf("loves") !== -1 ||
    q.indexOf("flying j") !== -1 ||
    q.indexOf("ta") !== -1 ||
    q.indexOf("petro") !== -1 ||
    q.indexOf("truck stop") !== -1 ||
    q.indexOf("diesel") !== -1 ||
    q.indexOf("parking") !== -1 ||
    q.indexOf("cat scale") !== -1 ||
    q.indexOf("weigh station") !== -1 ||
    q.indexOf("rest area") !== -1 ||
    q.indexOf("truck wash") !== -1
  );


}


/* =========================================================
SLX START TRIP — SEARCH RESULTS RENDER V1
Sorts by truck relevance + distance + score.
Safe replacement for buildResultsHtml() + showResults().
========================================================= */


function slxResultBadge(item) {
  var intent = String(item.searchIntent || item.type || "normal");
  var src = String(item.source || "");


  if (intent === "address") { return "ADDRESS MATCH"; }
  if (intent === "facility") { return "FACILITY / CUSTOMER"; }
  if (intent === "fuel_brand") { return "TRUCK FUEL"; }
  if (intent === "fuel") { return "DIESEL / FUEL"; }
  if (intent === "truck_stop") { return "TRUCK STOP"; }
  if (intent === "parking") { return "TRUCK PARKING"; }
  if (intent === "repair") { return "TRUCK SERVICE"; }
  if (intent === "scale") { return "SCALE / WEIGH"; }
  if (intent === "rest") { return "REST AREA"; }
  if (intent === "shower") { return "SHOWERS"; }
  if (intent === "food") { return "FOOD STOP"; }
  if (src === "address_first") { return "ADDRESS MATCH"; }


  return "DESTINATION";
}


function slxResultCleanMain(item) {
  var main = String(item.main || "Result");


  if (main.length > 52) {
    main = main.substring(0, 50) + "...";
  }


  return main;
}


function slxResultDistanceLabel(item) {
  var miles = Number(item.distanceMiles || 0);
  if (miles > 0 && miles < 9999) {
    return String(Math.round(miles * 10) / 10) + " mi from you";
  }
  return "";
}


function slxResultUtilityLine(item) {
  var intent = String(item.searchIntent || item.type || "normal");
  var text = String((item.main || "") + " " + (item.sub || "")).toLowerCase();
  var parts = [];


  if (intent === "address") { return "Route-ready address destination"; }
  if (intent === "facility") { return "Customer / facility style destination"; }


  if (intent === "fuel_brand" || intent === "fuel" || intent === "truck_stop") {
    parts.push("Diesel");
    parts.push("Truck access");
    if (text.indexOf("parking") > -1 || text.indexOf("travel") > -1 || text.indexOf("truck stop") > -1) { parts.push("Parking possible"); }
    if (text.indexOf("shower") > -1 || text.indexOf("travel") > -1) { parts.push("Driver services"); }
    return parts.join(" / ");
  }


  if (intent === "parking") { return "Parking candidate - verify availability on arrival"; }
  if (intent === "repair") { return "Service / repair candidate"; }
  if (intent === "scale") { return "Scale or weigh station candidate"; }
  if (intent === "rest") { return "Rest area / break option"; }
  if (intent === "food") { return "Food stop near your search"; }


  return "Tap to set destination";
}


function slxResultWhyLine(item) {
  var intent = String(item.searchIntent || item.type || "normal");
  var routeMiles = Number(item.routeDistanceMiles || 999999);
  var line = "";


  if (intent === "address") { line = "Best match for street address"; }
  else if (intent === "facility") { line = "Facility/customer match"; }
  else if (item.truckRelevant) { line = "Truck-relevant result"; }
  else { line = "General destination match"; }


  if (routeMiles <= 1) { line += " - on route corridor"; }
  else if (routeMiles <= 5) { line += " - near route corridor"; }


  return line;
}


function slxResultCleanSub(item) {
  var sub = String(item.sub || "");
  var badge = slxResultBadge(item);
  var dist = slxResultDistanceLabel(item);
  var parts = [];


  if (badge) { parts.push(badge); }
  if (dist) { parts.push(dist); }
  if (sub) { parts.push(sub); }


  return parts.join(" - ");
}


function slxSortResultsForDisplay(items) {
  var out = [];
  var i;


  if (!items || !items.length) { return out; }


  for (i = 0; i < items.length; i += 1) {
    if (!items[i]) { continue; }
    out.push(items[i]);
  }


  out.sort(function (a, b) {
    var as = Number(a.score || 0);
    var bs = Number(b.score || 0);
    var ad = Number(a.distanceMiles || 999999);
    var bd = Number(b.distanceMiles || 999999);


    if (bs !== as) { return bs - as; }
    return ad - bd;
  });


  return out;
}


function slxStyleResultRow(row, item) {
  var isAddress = String(item.searchIntent || item.type || "") === "address";
  var isFacility = String(item.searchIntent || item.type || "") === "facility";


  row.style.borderTop = "1px solid rgba(255,255,255,.08)";
  row.style.padding = "11px 12px";
  row.style.background = "rgba(0,0,0,.10)";


  if (item.truckRelevant) {
    row.style.background = "linear-gradient(180deg,rgba(0,255,176,.08),rgba(0,0,0,.10))";
  }


  if (isAddress || isFacility) {
    row.style.background = "linear-gradient(180deg,rgba(90,160,255,.10),rgba(0,0,0,.10))";
  }
}


function buildResultsHtml(items, targetId) {
  var box = $(targetId || "results");
  var sorted, i, row, main, sub, item, badge, intel, why;


  if (!box) { return; }


  box.innerHTML = "";


  sorted = slxSortResultsForDisplay(items);


  if (!sorted.length) {
    box.style.display = "none";
    updateLayout();
    return;
  }


  for (i = 0; i < sorted.length && i < 12; i += 1) {
    item = sorted[i];


    row = document.createElement("div");
    row.className = item.truckRelevant ? "resItem btn truckResult" : "resItem btn";
    slxStyleResultRow(row, item);


    main = document.createElement("div");
    main.className = "resMain";
    main.textContent = slxResultCleanMain(item);
    main.style.fontSize = "13px";
    main.style.fontWeight = "1000";
    main.style.lineHeight = "1.12";


    sub = document.createElement("div");
    sub.className = "resSub";
    sub.textContent = slxResultCleanSub(item);
    sub.style.marginTop = "3px";
    sub.style.fontSize = "9.5px";
    sub.style.fontWeight = "850";
    sub.style.opacity = ".86";
    sub.style.lineHeight = "1.18";


    intel = document.createElement("div");
    intel.className = "resIntel";
    intel.textContent = slxResultUtilityLine(item);
    intel.style.marginTop = "5px";
    intel.style.fontSize = "9.5px";
    intel.style.fontWeight = "950";
    intel.style.color = "#baffdf";
    intel.style.letterSpacing = ".15px";


    why = document.createElement("div");
    why.className = "resWhy";
    why.textContent = slxResultWhyLine(item);
    why.style.marginTop = "3px";
    why.style.fontSize = "8.5px";
    why.style.fontWeight = "900";
    why.style.opacity = ".66";


    row.appendChild(main);
    row.appendChild(sub);
    row.appendChild(intel);
    row.appendChild(why);


    badge = document.createElement("div");
    badge.className = "resBadge";
    badge.textContent = slxResultBadge(item);
    badge.style.display = "inline-flex";
    badge.style.marginTop = "7px";
    badge.style.padding = "4px 8px";
    badge.style.borderRadius = "999px";
    badge.style.border = item.truckRelevant ? "1px solid rgba(0,255,176,.30)" : "1px solid rgba(90,160,255,.25)";
    badge.style.color = item.truckRelevant ? "#9bffd7" : "#c9ddff";
    badge.style.background = item.truckRelevant ? "rgba(0,255,176,.07)" : "rgba(90,160,255,.07)";
    badge.style.fontSize = "8.5px";
    badge.style.fontWeight = "1000";
    badge.style.letterSpacing = ".12em";
    row.appendChild(badge);


    row.onclick = (function (it) {
      return function () {
        chooseSearchResult(it);
        clearResults();
      };
    })(item);


    box.appendChild(row);
  }


  box.style.display = "block";
  updateLayout();
}
function slxEnhanceTruckSearchResults(results, query) {


  var out = [];
  var i, r, text, score, q;


  q = String(query || "").toLowerCase();


  for (i = 0; i < results.length; i += 1) {


    r = results[i] || {};


    text = (
      String(r.main || "") + " " +
      String(r.sub || "") + " " +
      String(r.name || "")
    ).toLowerCase();


    score = Number(r.score || 0);


    r.truckRelevant = false;
    r.searchIntent = "normal";


    /* =====================================================
       TRUCK STOP / FUEL BRAND BOOST
    ===================================================== */


    if (
      text.indexOf("love's") !== -1 ||
      text.indexOf("loves travel") !== -1 ||
      text.indexOf("pilot") !== -1 ||
      text.indexOf("flying j") !== -1 ||
      text.indexOf("travel center") !== -1 ||
      text.indexOf("ta truck stop") !== -1 ||
      text.indexOf("petro") !== -1 ||
      text.indexOf("buc-ee") !== -1 ||
      text.indexOf("truck stop") !== -1
    ) {


      r.truckRelevant = true;
      r.searchIntent = "truck_stop";


      score += 220;


      /* local proximity bonus */
      if (Number(r.distanceMiles || 999) <= 25) {
        score += 90;
      }


      if (Number(r.distanceMiles || 999) <= 10) {
        score += 140;
      }
    }


    /* =====================================================
       DIESEL / FUEL
    ===================================================== */


    if (
      text.indexOf("diesel") !== -1 ||
      text.indexOf("fuel") !== -1 ||
      text.indexOf("truck fuel") !== -1
    ) {


      r.truckRelevant = true;


      if (r.searchIntent === "normal") {
        r.searchIntent = "fuel";
      }


      score += 80;
    }


    /* =====================================================
       PARKING
    ===================================================== */


    if (
      text.indexOf("truck parking") !== -1 ||
      text.indexOf("parking") !== -1 ||
      text.indexOf("rest area") !== -1
    ) {


      r.truckRelevant = true;


      if (r.searchIntent === "normal") {
        r.searchIntent = "parking";
      }


      score += 70;
    }


    /* =====================================================
       REPAIR / SERVICE
    ===================================================== */


    if (
      text.indexOf("tire") !== -1 ||
      text.indexOf("repair") !== -1 ||
      text.indexOf("service") !== -1
    ) {


      r.truckRelevant = true;


      if (r.searchIntent === "normal") {
        r.searchIntent = "repair";
      }


      score += 50;
    }


    /* =====================================================
       PENALIZE RANDOM STREETS / COVES / NEIGHBORHOODS
    ===================================================== */


    if (
      text.indexOf("cove") !== -1 ||
      text.indexOf("drive") !== -1 ||
      text.indexOf("lane") !== -1 ||
      text.indexOf("court") !== -1 ||
      text.indexOf("circle") !== -1 ||
      text.indexOf("way") !== -1
    ) {


      if (!r.truckRelevant) {
        score -= 140;
      }
    }


    /* =====================================================
       EXACT QUERY MATCH BOOST
    ===================================================== */


    if (q && text.indexOf(q) !== -1) {
      score += 35;
    }


    r.score = score;


    out.push(r);
  }


  out.sort(function(a, b) {
    return Number(b.score || 0) - Number(a.score || 0);
  });


  return out;
}


function showResults(items) {
  buildResultsHtml(items, "results");
}


function clearResults() {
  var box = $("results");
  if (box) {
    box.innerHTML = "";
    box.style.display = "none";
  }
  updateLayout();
}


function chooseDestination(item) {
  if (!item) { return; }


  dest = {
    lat: Number(item.lat),
    lng: Number(item.lng),
    label: String(item.main || item.sub || "Destination"),
    full: String(item.sub || item.main || "")
  };


  searchTarget = "dest";
  clearRouteStateOnly();
  syncUiFromState();
  clearResults();
  saveDriverHandoffPayload();
  highlightRouteNow();
  setStatus("Destination set", "green");
  toast("Destination set - tap ROUTE NOW");
}


function chooseStop(item) {
var stop = normalizeStop(item, "search");


if (!stop) {
toast("Stop not valid");
setStatus("Stop error", "red");
return;
}


saveActiveStop(stop);


searchTarget = "dest";
clearRouteStateOnly();
syncUiFromState();
clearResults();
saveDriverHandoffPayload();
highlightRouteNow();
setStatus("Stop added", "gold");
toast("Stop added - tap ROUTE NOW");
}


function chooseSearchResult(item) {
  if (searchTarget === "stop") { chooseStop(item); }
  else { chooseDestination(item); }
}


function routeWithGeoapify(fromLng, fromLat, toLng, toLat, cb) {
  var gps = getGPS();
  var profile = "truck";
  var url;
  var xhr;
  var waypointStr;


  if (!GEOAPIFY_KEY) { cb(null); return; }


  if (truckType === "box_truck" || truckType === "hotshot" || truckType === "car_hauler" || truckType === "power_only" || loadMode === "bobtail") {
    profile = "drive";
  }


  if (stop1 && isFiniteNum(Number(stop1.lng)) && isFiniteNum(Number(stop1.lat))) {
    waypointStr = fromLat + "," + fromLng + "|" + stop1.lat + "," + stop1.lng + "|" + toLat + "," + toLng;
  } else {
    waypointStr = fromLat + "," + fromLng + "|" + toLat + "," + toLng;
  }


  url = "https://api.geoapify.com/v1/routing?waypoints=" + encodeURIComponent(waypointStr) + "&mode=" + profile + "&details=route_details";
  if (gps && isFiniteNum(gps.heading)) { url += "&heading=" + encodeURIComponent(String(gps.heading)); }
  url += "&apiKey=" + encodeURIComponent(GEOAPIFY_KEY);


  xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.onreadystatechange = function () {
    var data, feature;
    if (xhr.readyState !== 4) { return; }
    try {
      if (xhr.status >= 200 && xhr.status < 300) {
        data = JSON.parse(xhr.responseText || "{}");
        feature = (data.features && data.features[0]) ? data.features[0] : null;
        cb(feature);
        return;
      }
    } catch (e) {}
    cb(null);
  };
  xhr.send(null);
}


/* =========================================================
SAFE MAP GUARDS V28
Prevents blocker loops from exploding if map not ready
========================================================= */


if(typeof map==="undefined"){
   var map=null;
}


if(typeof mapLoaded==="undefined"){
   var mapLoaded=false;
}


function slxMapReady(){
   return !!(
      map &&
      mapLoaded &&
      typeof map.getSource==="function"
   );
}


function slxExtractDirectionsSteps(route) {
  var out = [];
  var legs = route && route.legs ? route.legs : [];
  var i, j, steps;

  for (i = 0; i < legs.length; i++) {
    steps = legs[i] && legs[i].steps ? legs[i].steps : [];
    for (j = 0; j < steps.length; j++) {
      if (steps[j]) { out.push(steps[j]); }
    }
  }

  return out;
}


function slxExtractGeoapifyRouteSteps(feature) {
  var out = [];
  var props = feature && feature.properties ? feature.properties : {};
  var legs = props.legs || [];
  var i, j, steps;

  for (i = 0; i < legs.length; i++) {
    steps = legs[i] && legs[i].steps ? legs[i].steps : [];
    for (j = 0; j < steps.length; j++) {
      if (steps[j]) { out.push(steps[j]); }
    }
  }

  return out;
}


function normalizeDirectionsRoutes(data) {
  var routes = [];
  var i, r, steps;
  if (!data || !data.routes || !data.routes.length) { return routes; }


  for (i = 0; i < data.routes.length; i++) {
    r = data.routes[i];
    if (!r || !r.geometry || !r.geometry.coordinates || !r.geometry.coordinates.length) { continue; }

    /*
      V29 MANEUVER HANDOFF:
      Geometry is not navigation truth by itself. Preserve the provider's
      real legs[].steps[] so Driver Mode receives maneuver + street metadata.
    */
    steps = slxExtractDirectionsSteps(r);

    routes.push({
      geometry: r.geometry,
      distanceMeters: Number(r.distance || 0),
      durationSeconds: Number(r.duration || 0),
      label: i === 0 ? "Primary" : "Alt " + String(i + 1),
      steps: steps,
      maneuverSteps: steps,
      stepCount: steps.length
    });
  }


  return routes;
}


function routeWithMapboxAlternatives(fromLng, fromLat, toLng, toLat, cb) {
  var url, xhr, coords, profile;


  if (!MAPBOX_TOKEN) { cb([]); return; }
  profile = "driving-traffic";


  if (stop1 && isFiniteNum(Number(stop1.lng)) && isFiniteNum(Number(stop1.lat))) {
    coords = fromLng + "," + fromLat + ";" + stop1.lng + "," + stop1.lat + ";" + toLng + "," + toLat;
  } else {
    coords = fromLng + "," + fromLat + ";" + toLng + "," + toLat;
  }


  url = "https://api.mapbox.com/directions/v5/mapbox/" + profile + "/" +
    encodeURIComponent(coords) +
    "?access_token=" + encodeURIComponent(MAPBOX_TOKEN) +
    "&geometries=geojson" +
    "&overview=full" +
    "&steps=true" +
    "&banner_instructions=true" +
    "&voice_instructions=true" +
    "&voice_units=imperial" +
    "&alternatives=true";


  xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.onreadystatechange = function () {
    var data;
    if (xhr.readyState !== 4) { return; }
    try {
      if (xhr.status >= 200 && xhr.status < 300) {
        data = JSON.parse(xhr.responseText || "{}");
        cb(normalizeDirectionsRoutes(data));
        return;
      }
    } catch (e) {}
    cb([]);
  };
  xhr.send(null);
}


function finalizeRouteFromAlternatives(routes) {
  if (!routes || !routes.length) {
    setRouteNowCue(true);
    setStatus("Route failed", "red");
    toast("Route failed");
    return;
  }


  altRoutes = routes.slice(0, 3);
  selectedRouteIndex = 0;
  evaluateBestRoutes();
  bindSmartRouteChips();
  setStatus(stop1 ? "Route ready with stop" : "Route ready", "green");
  toast(stop1 ? "Route ready with stop" : "Route ready");
}


function runFastestRoute(gps) {
  routeWithMapboxAlternatives(gps.lng, gps.lat, dest.lng, dest.lat, function (routes) {
    if (routes && routes.length) {
      finalizeRouteFromAlternatives(routes);
      return;
    }


    routeWithGeoapify(gps.lng, gps.lat, dest.lng, dest.lat, function (feature2) {
      if (!feature2 || !feature2.geometry) {
        finalizeRouteFromAlternatives([]);
        return;
      }


      finalizeRouteFromAlternatives([{
        geometry: feature2.geometry,
        distanceMeters: Number(
          feature2 && feature2.properties &&
          (feature2.properties.distance || feature2.properties.distanceMeters || 0)
        ),
        durationSeconds: Number(
          feature2 && feature2.properties &&
          (feature2.properties.time || feature2.properties.duration || feature2.properties.durationSeconds || 0)
        ),
        label: "Primary",
        steps: slxExtractGeoapifyRouteSteps(feature2),
        maneuverSteps: slxExtractGeoapifyRouteSteps(feature2),
        stepCount: slxExtractGeoapifyRouteSteps(feature2).length
      }]);
    });
  });
}


function routeNow() {
  var gps = getGPS();
  var typed = getInputText();


  function runRoute() {
    if (!dest) {
      toast("Pick a destination");
      setStatus("Need destination", "red");
      return;
    }


    setRouteNowCue(false);
    setStatus(stop1 ? "Routing stop + destination..." : "Routing...", "blue");
    clearResults();
    clearFreeFlow();
    runFastestRoute(gps);
  }


  if (!gps) {
    toast("Tap LOCK GPS first");
    setStatus("Need GPS", "red");
    return;
  }


  if (typed && (!dest || !inputMatchesDest())) {
    geocodeSearch(typed, { limit: 1 }, function (items) {
      if (items && items.length) {
        chooseDestination(items[0]);
        setTimeout(function () { runRoute(); }, 60);
      } else {
        toast("Destination not found");
        setStatus("No results", "red");
      }
    });
    return;
  }


  if (!dest) {
    toast("Pick a destination");
    setStatus("Need destination", "red");
    return;
  }


  runRoute();
}


function lockGPS() {
  var hadFix = !!lastFix;


  if (!navigator || !navigator.geolocation) {
    toast("GPS not available");
    setStatus("No GPS", "red");
    return;
  }


  if (hadFix) {
    recenterToGPS();
    requestFreshGPS(true);
  } else {
    setStatus("Locking GPS...", "blue");
    setGpsPill("GPS locking...");
    requestFreshGPS(true);
  }


  try {
    if (gpsWatchId !== null) { navigator.geolocation.clearWatch(gpsWatchId); }
  } catch (e) {}


  try {
    gpsWatchId = navigator.geolocation.watchPosition(
      function (pos) { acceptLiveGPSFix(pos, false); },
      function () {
        if (!lastFix) {
          setStatus("GPS issue", "red");
          setGpsPill("GPS issue");
        }
      },
      { enableHighAccuracy: true, timeout: 20000, maximumAge: 0 }
    );
  } catch (e2) {}
}


function initMap() {
  if (!MAPBOX_TOKEN || !window.mapboxgl) {
    setStatus("Map failed", "red");
    toast("Mapbox failed");
    return;
  }


  mapboxgl.accessToken = MAPBOX_TOKEN;


  try {
    map = new mapboxgl.Map({
      container: "slxMap",
      style: "mapbox://styles/mapbox/satellite-streets-v12",
      center: [-90.05, 34.97],
      zoom: 11.6,
      pitch: 0,
      bearing: 0,
      attributionControl: false
    });


    try {
      window.__SLX_START_TRIP_MAP__ = map;
      window.slxMap = map;
      window.SLX_MAP = map;
      window.map = map;


      window.__SLX_START_TRIP_MAP_LOADED__ = false;
      window.slxMapLoaded = false;
      window.SLX_MAP_LOADED = false;


      window.slxMapReady = function () {
        return !!(
          window.__SLX_START_TRIP_MAP__ &&
          window.__SLX_START_TRIP_MAP_LOADED__ &&
          typeof window.__SLX_START_TRIP_MAP__.getSource === "function"
        );
      };
    } catch (bridgeErr1) {}


  } catch (e1) {
    setStatus("Map failed", "red");
    toast("Map init failed");
    return;
  }


  map.on("load", function () {
    mapLoaded = true;


    try {
      window.__SLX_START_TRIP_MAP__ = map;
      window.slxMap = map;
      window.SLX_MAP = map;
      window.map = map;


      window.__SLX_START_TRIP_MAP_LOADED__ = true;
      window.slxMapLoaded = true;
      window.SLX_MAP_LOADED = true;
      window.mapLoaded = true;
    } catch (bridgeErr2) {}


    ensureMapSources();
    addPrecipitationLayer();
    adjustRadarOpacity();
    updateLayout();
    restorePersistedGPS(false);


    if (pendingFix && isFiniteNum(pendingFix.lng) && isFiniteNum(pendingFix.lat)) {
      setYouPoint(pendingFix.lng, pendingFix.lat);
      pendingFix = null;
    } else if (lastFix) {
      setYouPoint(lastFix.lng, lastFix.lat);
    }


    if (dest) {
      setDestPoint(dest.lng, dest.lat);
    }


    if (routeReady && routeGeo) {
      drawRouteLine(routeGeo);
      fitToRouteTopView();
      bindSmartRouteChips();
    }


    map.on("dragstart", function () {
      enterFreeFlow();
    });


    map.on("zoomstart", function () {
      enterFreeFlow();
    });


    map.on("rotatestart", function () {
      enterFreeFlow();
    });


    map.on("pitchstart", function () {
      enterFreeFlow();
    });


    map.on("touchstart", function () {
      enterFreeFlow();
    });


    map.on("mousedown", function () {
      enterFreeFlow();
    });


    map.on("zoomend", function () {
      adjustRadarOpacity();
    });


    map.on("moveend", function () {
      adjustRadarOpacity();
    });


    map.on("click", function (ev) {
      var lng = Number(ev.lngLat.lng);
      var lat = Number(ev.lngLat.lat);


      if (!isFiniteNum(lng) || !isFiniteNum(lat)) {
        return;
      }


      chooseSearchResult({
        lng: lng,
        lat: lat,
        main: searchTarget === "stop" ? "Selected stop" : "Selected destination",
        sub: "Map selection"
      });
    });
  });


  map.on("error", function () {
    try {
      console.log("[SLX MAP ERROR]");
    } catch (e2) {}
  });
}


function goDriverDashboard() {
  var base = "https://semilocator.com/pages/driver-dashboard";
  var q = [];


  if (!TRIP_ID) { TRIP_ID = genTripId(); }


  saveDriverHandoffPayload();


  q.push("trip=" + encodeURIComponent(TRIP_ID));
  q.push("mode=" + encodeURIComponent(loadMode));
  q.push("trip_capacity=" + encodeURIComponent(tripCapacity));
  q.push("truck_type=" + encodeURIComponent(truckType));
  q.push("equipment_type=" + encodeURIComponent(equipmentType));
  q.push("equipment_length_ft=" + encodeURIComponent(equipmentLength || ""));
  q.push("equipment_weight_lb=" + encodeURIComponent(equipmentWeight || ""));
  q.push("from=start-trip");
  q.push("r=" + encodeURIComponent(routeReady ? "1" : "0"));
  q.push("route_index=" + encodeURIComponent(String(selectedRouteIndex || 0)));
  q.push("route_type=" + encodeURIComponent(String(activeChipType || "profit")));


  if (dest && isFiniteNum(dest.lat) && isFiniteNum(dest.lng)) {
    q.push("to=" + encodeURIComponent(dest.lat + "," + dest.lng));
    q.push("label=" + encodeURIComponent(dest.label || ""));
  }


  window.location.href = base + "?" + q.join("&");
}


function bindEquipmentSelectors() {
  if ($("truckTypeSelect")) {
    $("truckTypeSelect").onchange = function () {
      truckType = String(this.value || "dry_van");
      lsSet(LS.TRUCK_TYPE, truckType);
      renderEquipmentSummary();
      saveDriverHandoffPayload();
      toast("Truck updated");
    };
  }


  if ($("equipmentTypeSelect")) {
    $("equipmentTypeSelect").onchange = function () {
      equipmentType = String(this.value || "van");
      lsSet(LS.EQUIPMENT_TYPE, equipmentType);
      renderEquipmentSummary();
      saveDriverHandoffPayload();
      toast("Equipment updated");
    };
  }


  if ($("lengthSelect")) {
    $("lengthSelect").onchange = function () {
      equipmentLength = String(this.value || "");
      lsSet(LS.EQUIPMENT_LENGTH, equipmentLength);
      renderEquipmentSummary();
      saveDriverHandoffPayload();
      toast("Length updated");
    };
  }


  if ($("weightSelect")) {
    $("weightSelect").onchange = function () {
      equipmentWeight = String(this.value || "");
      lsSet(LS.EQUIPMENT_WEIGHT, equipmentWeight);
      renderEquipmentSummary();
      saveDriverHandoffPayload();
      toast("Weight updated");
    };
  }
}


function bindUI() {
  var input = $("destInput");


  if ($("btnBack")) {
    $("btnBack").onclick = function () { window.location.href = "https://semilocator.com"; };
  }


  if ($("btnZoomIn")) {
    $("btnZoomIn").onclick = function () {
      enterFreeFlow();
      try { if (map) { map.zoomTo((map.getZoom() || 12) + 1, { duration: 220 }); } } catch (e) {}
    };
  }


  if ($("btnZoomOut")) {
    $("btnZoomOut").onclick = function () {
      enterFreeFlow();
      try { if (map) { map.zoomTo((map.getZoom() || 12) - 1, { duration: 220 }); } } catch (e) {}
    };
  }


  if ($("btnLockGps")) {
    $("btnLockGps").onclick = function () {
      clearFreeFlow();
      lockGPS();
    };
  }


  if ($("btnRouteNow")) {
    $("btnRouteNow").onclick = function () {
      routeNow();
    };
  }


  if ($("btnClear")) {
    $("btnClear").onclick = function () {
      resetTripAll();
    };
  }


  if ($("btnDash")) {
    $("btnDash").onclick = function () {
      goDriverDashboard();
    };
  }


   if ($("btnStartTrip")) {
    $("btnStartTrip").onclick = function () {


      var gps = getGPS();


      if (!gps) {
        toast("Tap LOCK GPS first");
        setStatus("Need GPS", "red");
        return;
      }


      if (!dest) {
        toast("Pick a destination");
        setStatus("Need destination", "red");
        return;
      }


      if (!routeReady || !routeGeo) {
        highlightRouteNow();
        toast("Route it first");
        setStatus("Need route", "red");
        return;
      }


      if (typeof TRIP_ID === "undefined" || !TRIP_ID) {
        TRIP_ID = "trip_" + Date.now();
      }


      var paywallGate;


      if (slxHasPaidAccess()) {
        slxHidePaywallOverlay();
        slxHidePressureOverlay();
        slxRenderFoundingDriverBadge();
        paywallGate = { allowed: true, count: slxGetFreeTripCount(), remaining: 999, bypass: true, message: "" };
      } else {

        /*
          V42: consume the one-shot Continue Free decision before rechecking.
          Otherwise, pressure appears on every Start Trip tap from trips 3–5.
        */
        if (slxConversionPressureBypassOnce) {
          slxConversionPressureBypassOnce = false;
        } else if (slxShouldShowStartTripPressure()) {
          slxShowStartTripPressure();
          return;
        }

        paywallGate = slxRegisterStartTripPaywall(TRIP_ID);
      }


      if (!paywallGate || !paywallGate.allowed) {
        slxShowPaywall(paywallGate || {});
        return;
      }


      if (paywallGate.message) {
        toast(paywallGate.message);
        setStatus(paywallGate.message, "gold");
      } else if (paywallGate.bypass) {
        setStatus("Pro unlocked", "green");
      }


      try {
        lsSet("slx_trip_on_v1", "1");
        lsSet("slx_trip_on_v2", "1");


        lsSet("slx_active_trip_id", TRIP_ID);
      } catch (e) {}


      try {
        if (typeof saveDriverHandoffPayload === "function") {
          saveDriverHandoffPayload();
        }
      } catch (e2) {}


      try {
        lsSet("slx_last_gps_v1", JSON.stringify({
          lat: Number(gps.lat),
          lng: Number(gps.lng),
          heading: Number(gps.heading || 0),
          speed: Number(gps.speed || 0),
          updated_at: (new Date()).toISOString()
        }));
      } catch (e3) {}


      toast("Starting trip...");
      setStatus("Trip active", "green");


      try {
        publishDriverPresence();
        startPresenceHeartbeat();
      } catch (e4) {
        console.log("[SLX START TRIP PRESENCE FAIL]", e4);
      }


      setTimeout(function () {
        goDriverDashboard();
      }, 250);


    };
  }


  if ($("chipEmptyTrailer")) {
    $("chipEmptyTrailer").onclick = function () {
      loadMode = "empty_trailer";
      lsSet(LS.MODE, loadMode);
      setLoadUI();
      if (routeGeo) { drawRouteLine(routeGeo); }
      renderEquipmentSummary();
      saveDriverHandoffPayload();
      toast("Empty trailer mode");
    };
  }


  if ($("chipLoaded")) {
    $("chipLoaded").onclick = function () {
      loadMode = "loaded";
      lsSet(LS.MODE, loadMode);
      setLoadUI();
      if (routeGeo) { drawRouteLine(routeGeo); }
      renderEquipmentSummary();
      saveDriverHandoffPayload();
      toast("Loaded mode");
    };
  }


  if ($("chipBobtail")) {
    $("chipBobtail").onclick = function () {
      loadMode = "bobtail";
      lsSet(LS.MODE, loadMode);
      setLoadUI();
      if (routeGeo) { drawRouteLine(routeGeo); }
      renderEquipmentSummary();
      saveDriverHandoffPayload();
      toast("Bobtail mode");
    };
  }


  if ($("chipCapacityFull")) {
    $("chipCapacityFull").onclick = function () {
      tripCapacity = "full";
      lsSet(LS.TRIP_CAPACITY, tripCapacity);
      setCapacityUI();
      renderEquipmentSummary();
      saveDriverHandoffPayload();
      toast("Capacity full");
    };
  }


  if ($("chipCapacityPartial")) {
    $("chipCapacityPartial").onclick = function () {
      tripCapacity = "partial";
      lsSet(LS.TRIP_CAPACITY, tripCapacity);
      setCapacityUI();
      renderEquipmentSummary();
      saveDriverHandoffPayload();
      toast("Capacity partial");
    };
  }


  bindEquipmentSelectors();


  if ($("btnAddStop")) {
    $("btnAddStop").onclick = function () {
      searchTarget = "stop";
      clearResults();
      setSearchTargetUI();
      if (input) { input.focus(); }
      setStatus("Search stop", "gold");
      toast("Add stop");
    };
  }


  if ($("btnRemoveStop")) {
    $("btnRemoveStop").onclick = function () {
      stop1 = null;
      searchTarget = "dest";
      lsRemove(LS.STOPS);
      clearRouteStateOnly();
      syncUiFromState();
      saveDriverHandoffPayload();
      setStatus("Stop removed", "green");
      toast("Stop removed");
    };
  }


  if (input) {
    input.oninput = function () {
      var v = String(this.value || "").replace(/^\s+|\s+$/g, "");


      if (searchTimer) { clearTimeout(searchTimer); }


      if (v.length < 2) {
        clearResults();
        return;
      }


      searchTimer = setTimeout(function () {
        geocodeSearch(v, { limit: 10 }, function (items) {
          /* Ignore late responses for earlier input, including after the user clears it. */
          if (!input || String(input.value || "").replace(/^\s+|\s+$/g, "") !== v) { return; }
          if (items && items.length) {
            showResults(items);
            setStatus(searchTarget === "stop" ? "Pick a stop" : "Pick a result", searchTarget === "stop" ? "gold" : "green");
          } else {
            clearResults();
            setStatus("No results", "red");
          }
        });
      }, 160);
    };


    input.onfocus = function () {
      if (searchTarget !== "stop") { searchTarget = "dest"; }
      setSearchTargetUI();
    };
  }


  bindSmartRouteChips();


  document.addEventListener("click", function (ev) {
    var results = $("results");
    var destInput = $("destInput");


    if (!results || results.style.display === "none") { return; }


    try {
      if (ev && ev.target) {
        if (ev.target === results || results.contains(ev.target) || ev.target === destInput) { return; }
      }
      clearResults();
    } catch (e) {}
  }, false);
}


function resetTripAll() {
  clearRouteStateOnly();
  dest = null;
  stop1 = null;
  searchTarget = "dest";
  TRIP_ID = genTripId();


  lsRemove(LS.DEST);
  lsRemove(LS.DEST_V2);
  lsRemove(LS.STOPS);
  lsRemove(LS.START_PAYLOAD);
  lsRemove(LS.ACTIVE_TRIP_ID);
  lsRemove(LS.MONEY_PREVIEW);
  lsSet(LS.TRIP_ON, "0");
  lsSet(LS.TRIP_ON_V2, "0");
  lsSet(LS.MODE, "empty_trailer");
  lsSet(LS.TRIP_MODE, "empty_trailer");


  loadMode = "empty_trailer";


  clearPoiLayers();
  syncUiFromState();
  saveDriverHandoffPayload();
  setStatus("Ready", "green");
  syncMoneyPreviewPill(null);
  toast("Trip cleared");
}


function boot() {
  var panel = $("panel");
  var panelToggle = $("btnPanelToggle");


  TRIP_ID = lsGet(LS.ACTIVE_TRIP_ID) || genTripId();
  restoreState();
  restorePersistedGPS(false);
  setLoadUI();
  setCapacityUI();
  updateEquipmentSelects();
  renderEquipmentSummary();
  updateGpsUI();
  setStopUI();
  updateRouteNowCue();
  bindUI();
  slxSyncPaywallStatusPill();


  /*
    V42 Conversion Pressure IQ:
    Do not interrupt a free driver simply for opening Start Trip.
    Monetization pressure happens when the driver taps Start Trip.
  */


  if (panel) { panel.className = "panel collapsed"; }
  if (panelToggle) { panelToggle.textContent = "LOADOUT"; }


  initMap();
  saveDriverHandoffPayload();
  updateLayout();


  if ($("destInput")) {
    $("destInput").value = dest ? (dest.label || dest.full || "") : "";
    if (String($("destInput").value || "").toLowerCase() === "pinned destination") {
      $("destInput").value = "";
    }
  }


  if (routeReady && altRoutes && altRoutes.length) {
    bindSmartRouteChips();
  }


  if (routeGeo && routeGeo.features && routeGeo.features[0] && routeGeo.features[0].properties) {
    syncMoneyPreviewPill({ net: Number(routeGeo.features[0].properties.net || 0) });
  } else {
    syncMoneyPreviewPill(safeJSONParse(lsGet(LS.MONEY_PREVIEW)));
  }
}


window.addEventListener("resize", function () {
  try { if (map) { map.resize(); } } catch (e) {}
  updateLayout();
}, false);


window.addEventListener("orientationchange", function () {
  try { if (map) { map.resize(); } } catch (e) {}
  setTimeout(function () {
    clearFreeFlow();
    updateLayout();
    if (routeReady && routeGeo) { fitToRouteTopView(); }
  }, 120);
}, false);


window.addEventListener("pagehide", function () {
  persistLastFix();
  saveDriverHandoffPayload();
}, false);


window.addEventListener("pageshow", function () {
  restoreState();
  restorePersistedGPS(false);
  syncUiFromState();
  if (routeReady && altRoutes && altRoutes.length) {
    bindSmartRouteChips();
  }
}, false);


document.addEventListener("visibilitychange", function () {
  if (document.hidden) {
    persistLastFix();
    saveDriverHandoffPayload();
  } else {
    restoreState();
    restorePersistedGPS(false);
    syncUiFromState();
    if (routeReady && altRoutes && altRoutes.length) {
      bindSmartRouteChips();
    }
  }
}, false);


window.addEventListener("load", function () {
  boot();
}, false);


/* =========================================================
SLX START TRIP — MAP FIRST / MONEY / ROUTE LOCK PATCH V1
Place INSIDE this Start Trip IIFE, right before final })();


Locks:
- Route chips stay compact and pinned
- Money preview stays compact
- Route calculator refreshes after route selection
- Start Trip payload gets money + dock intelligence
- Map fit gets more long-haul breathing room
========================================================= */


function slxInstallStartTripLayoutLock(){
  var st = $("slxStartTripLayoutLockV1");
  if(st){return;}


  st = document.createElement("style");
  st.id = "slxStartTripLayoutLockV1";
  st.textContent =
    ".routeChips,.smartRouteChips,#routeChips,#smartRouteChips{position:fixed!important;left:12px!important;right:12px!important;bottom:calc(86px + env(safe-area-inset-bottom,0px))!important;z-index:120!important;display:flex!important;gap:6px!important;overflow-x:auto!important;overflow-y:hidden!important;padding:4px 2px!important;max-height:42px!important;-webkit-overflow-scrolling:touch!important;}"+
    ".routeChips .chip,.smartRouteChips .chip,#routeChips .chip,#smartRouteChips .chip{flex:0 0 auto!important;min-height:32px!important;padding:7px 10px!important;border-radius:999px!important;font-size:10px!important;white-space:nowrap!important;}"+
    "#panel,.panel{max-height:38vh!important;overflow:hidden!important;}"+
    "#panel.collapsed,.panel.collapsed{max-height:116px!important;overflow:hidden!important;}"+
    "#results{max-height:42vh!important;overflow:auto!important;z-index:180!important;}"+
    "#pillMoney{min-width:auto!important;padding:6px 9px!important;font-size:11px!important;}"+
    ".moneyCard,#moneyCard,.tripMoney,#tripMoney{max-height:82px!important;overflow:hidden!important;padding:8px 10px!important;}"+
    ".moneyCard select,.moneyCard .scroll,#moneyCard select,#moneyCard .scroll{max-height:34px!important;}";


  document.head.appendChild(st);
}


function slxUpdateCompactMoneyCard(){
  var money = null;
  var feature = routeGeo && routeGeo.features && routeGeo.features[0] ? routeGeo.features[0] : null;
  var props = feature && feature.properties ? feature.properties : null;
  var el = $("moneyCard") || $("tripMoney") || $("moneyPreview") || $("moneyBox");


  if(props){
    money = {
      miles: Number(props.miles || 0),
      rpm: Number(props.rpm || getRpmValue()),
      gross: Number(props.gross || 0),
      fuel: Number(props.fuel || 0),
      net: Number(props.net || 0)
    };
  }else{
    money = safeJSONParse(lsGet(LS.MONEY_PREVIEW));
  }


  syncMoneyPreviewPill(money);


  if(!el || !money){return;}


  el.innerHTML =
    '<div style="display:flex;align-items:center;justify-content:space-between;gap:8px;">'+
      '<div style="font-size:10px;font-weight:900;opacity:.78;">TRIP MONEY</div>'+
      '<div style="font-size:15px;font-weight:950;">$'+String(Math.round(Number(money.net||0)))+'</div>'+
    '</div>'+
    '<div style="display:flex;gap:6px;margin-top:5px;overflow:hidden;">'+
      '<span class="summaryPill">'+String(Math.round(Number(money.miles||0)))+' MI</span>'+
      '<span class="summaryPill">$'+String(Number(money.rpm||0).toFixed(2))+'/MI</span>'+
      '<span class="summaryPill">FUEL $'+String(Math.round(Number(money.fuel||0)))+'</span>'+
    '</div>';
}


function slxFitRouteMapFirst(){
  var feature, coords, bounds, vh, padTop, padBottom, cam;


  if(!mapLoaded || !map || !routeGeo || !routeGeo.features || !routeGeo.features.length){return;}


  try{
    feature = routeGeo.features[0];
    coords = feature.geometry.coordinates;
    bounds = buildBoundsFromCoords(coords);
    if(!bounds){return;}


    vh = window.innerHeight || 844;


    padTop = 118;
    padBottom = Math.round(vh * 0.22);


    try{map.stop();}catch(e0){}
    try{map.jumpTo({bearing:0,pitch:0});}catch(e1){}


    cam = map.cameraForBounds(bounds,{
      padding:{top:padTop,right:26,bottom:padBottom,left:26},
      bearing:0,
      pitch:0,
      maxZoom:9.8
    });


    if(cam && cam.center){
      map.easeTo({
        center:cam.center,
        zoom:cam.zoom,
        bearing:0,
        pitch:0,
        duration:650,
        essential:true
      });
    }
  }catch(e){}
}


function slxRouteReadyPolish(){
  slxInstallStartTripLayoutLock();
  slxUpdateCompactMoneyCard();


  if(routeReady && routeGeo){
    window.setTimeout(slxFitRouteMapFirst,120);
    window.setTimeout(slxFitRouteMapFirst,650);
  }
}


/* wrap existing route selection so calculator/layout update every time */
var __oldSelectAltRoute = selectAltRoute;
selectAltRoute = function(index,label){
  __oldSelectAltRoute(index,label);
  slxRouteReadyPolish();
};


/* wrap existing finalize so chips stay stable after async route response */
var __oldFinalizeRouteFromAlternatives = finalizeRouteFromAlternatives;
finalizeRouteFromAlternatives = function(routes){
  __oldFinalizeRouteFromAlternatives(routes);
  slxRouteReadyPolish();
};


/* make layout deterministic */
var __oldUpdateLayout = updateLayout;
updateLayout = function(){
  __oldUpdateLayout();


  var results = $("results");
  var vh = window.innerHeight || 844;


  if(results){
    results.style.maxHeight = String(Math.max(180, Math.round(vh * 0.42))) + "px";
  }


  slxInstallStartTripLayoutLock();
};


/* strengthen handoff payload for Driver Mode / Dock Intelligence */
var __oldSaveDriverHandoffPayload = saveDriverHandoffPayload;
saveDriverHandoffPayload = function(){
  __oldSaveDriverHandoffPayload();


  try{
    localStorage.setItem("slx_dock_intelligence_v1",JSON.stringify({
      trip_id:TRIP_ID,
      mode:loadMode,
      capacity:tripCapacity,
      truck_type:truckType,
      equipment_type:equipmentType,
      equipment_length_ft:equipmentLength || "",
      equipment_weight_lb:equipmentWeight || "",
      selected_route_index:selectedRouteIndex || 0,
      selected_route_type:activeChipType || "profit",
      money_preview:safeJSONParse(lsGet(LS.MONEY_PREVIEW)),
      route_ready:routeReady ? 1 : 0,
      updated_at:new Date().toISOString()
    }));
  }catch(e){}
};


window.setTimeout(slxRouteReadyPolish,600);
window.setTimeout(slxRouteReadyPolish,1800);


/* =========================================================
SLX START TRIP — SAFE TRIP MONEY AUTO CALC V1
Uses existing Trip Money panel only.
No new buttons. No new floating cards. No layout changes.
========================================================= */


if(!window.__SLX_SAFE_TRIP_MONEY_AUTO_CALC_V1__){
window.__SLX_SAFE_TRIP_MONEY_AUTO_CALC_V1__=true;


function slxSafeMoneyNumber(v){
  v=Number(v);
  return isFinite(v)?v:0;
}


function slxSafeMoneyFormat(n){
  n=Number(n||0);
  if(!isFinite(n)||n<=0){return "$ --";}
  return "$ "+Math.round(n).toLocaleString();
}


function slxGetSafeRpm(){
  var rpm=0;
  var mini=$("rpmInputMini");
  var full=$("rpmInput");


  if(mini&&mini.value){rpm=Number(mini.value);}
  if((!rpm||!isFinite(rpm))&&full&&full.value){rpm=Number(full.value);}
  if(!rpm||!isFinite(rpm)||rpm<=0){rpm=Number(lsGet("slx_money_rpm_v1")||0);}
  if(!rpm||!isFinite(rpm)||rpm<=0){rpm=2.20;}


  return rpm;
}


function slxGetCurrentRouteMiles(){


  var miles=0;


  try{


    if(routeGeo && routeGeo.features && routeGeo.features.length){


      var props=routeGeo.features[0].properties || {};


      if(props.miles && isFinite(props.miles)){
        return Number(props.miles);
      }


      if(props.distanceMiles && isFinite(props.distanceMiles)){
        return Number(props.distanceMiles);
      }


      if(props.distance && isFinite(props.distance)){
        return Number(props.distance)*0.000621371;
      }


      if(props.distanceMeters && isFinite(props.distanceMeters)){
        return Number(props.distanceMeters)*0.000621371;
      }


    }


  }catch(e){}


  /* fallback to step-based estimate */


  try{


    if(window.routeSteps && routeSteps.length){


      var totalMeters=0;


      for(var i=0;i<routeSteps.length;i++){


        if(routeSteps[i].distanceMeters){
          totalMeters+=Number(routeSteps[i].distanceMeters);
        }


      }


      if(totalMeters>0){
        return totalMeters*0.000621371;
      }


    }


  }catch(e){}


  return 0;
}


function slxBuildSafeTripMoney(){
  var miles=slxGetCurrentRouteMiles();
  var rpm=slxGetSafeRpm();
  var fuelCostPerMile=0.72;
  var gross,fuel,net;


  if(!miles||miles<=0){return null;}


  if(loadMode==="loaded"){fuelCostPerMile=0.82;}
  else if(loadMode==="bobtail"){fuelCostPerMile=0.58;}


  gross=miles*rpm;
  fuel=miles*fuelCostPerMile;
  net=gross-fuel;


  return {
    miles:miles,
    rpm:rpm,
    gross:gross,
    fuel:fuel,
    net:net,
    fuel_cost_per_mile:fuelCostPerMile,
    updated_at:new Date().toISOString()
  };
}


function slxRenderSafeTripMoney(){
  var money=slxBuildSafeTripMoney();
  var mini=$("moneyPreviewMini");
  var pill=$("pillMoney");
  var rpmMini=$("rpmInputMini");
  var rpmFull=$("rpmInput");


  if(!money){return;}


  try{
    localStorage.setItem(LS.MONEY_PREVIEW,JSON.stringify(money));
    localStorage.setItem("slx_trip_money_preview",JSON.stringify(money));
    localStorage.setItem("slx_money_rpm_v1",String(money.rpm));
  }catch(e){}


  if(mini){mini.textContent=slxSafeMoneyFormat(money.net);}
  if(pill){pill.textContent=slxSafeMoneyFormat(money.net);}


  if(rpmMini&&!rpmMini.value){rpmMini.value=String(money.rpm.toFixed(2));}
  if(rpmFull&&!rpmFull.value){rpmFull.value=String(money.rpm.toFixed(2));}


  try{
    if(routeGeo&&routeGeo.features&&routeGeo.features[0]){
      routeGeo.features[0].properties=routeGeo.features[0].properties||{};
      routeGeo.features[0].properties.miles=money.miles;
      routeGeo.features[0].properties.rpm=money.rpm;
      routeGeo.features[0].properties.gross=money.gross;
      routeGeo.features[0].properties.fuel=money.fuel;
      routeGeo.features[0].properties.net=money.net;
    }
  }catch(e){}
}


function slxBindSafeMoneyInputs(){
  var mini=$("rpmInputMini");
  var full=$("rpmInput");


  if(mini&&!mini.__slxMoneyAutoBound){
    mini.__slxMoneyAutoBound=true;
    mini.addEventListener("input",function(){
      try{localStorage.setItem("slx_money_rpm_v1",String(this.value||""));}catch(e){}
      if(full){full.value=this.value;}
      slxRenderSafeTripMoney();
      saveDriverHandoffPayload();
    },false);
  }


  if(full&&!full.__slxMoneyAutoBound){
    full.__slxMoneyAutoBound=true;
    full.addEventListener("input",function(){
      try{localStorage.setItem("slx_money_rpm_v1",String(this.value||""));}catch(e){}
      if(mini){mini.value=this.value;}
      slxRenderSafeTripMoney();
      saveDriverHandoffPayload();
    },false);
  }
}


/* Recalculate after route selection without touching layout */
var __oldSelectAltRouteMoneyAutoV1=selectAltRoute;
selectAltRoute=function(index,label){
  __oldSelectAltRouteMoneyAutoV1(index,label);
  slxRenderSafeTripMoney();
  saveDriverHandoffPayload();
};


var __oldFinalizeRouteMoneyAutoV1=finalizeRouteFromAlternatives;
finalizeRouteFromAlternatives=function(routes){
  __oldFinalizeRouteMoneyAutoV1(routes);
  setTimeout(slxRenderSafeTripMoney,80);
  setTimeout(slxRenderSafeTripMoney,450);
};


setTimeout(slxBindSafeMoneyInputs,400);
setTimeout(slxRenderSafeTripMoney,700);
setTimeout(slxRenderSafeTripMoney,1500);
setInterval(function(){
  slxBindSafeMoneyInputs();
  slxRenderSafeTripMoney();
},2500);


}


/* =========================================================
SLX START TRIP ROUTE CHIP INTEL RESTORE V1
Keeps route chips intelligent after route build / reload
========================================================= */


function slxRestoreRouteChipIntel(){
  var meta = safeJSONParse(lsGet(LS.ALT_ROUTE_META));
  if(!meta){ return; }


  try{
    renderChipLabels(meta);
    highlightChip(activeChipType || "profit");
  }catch(e){}
}


setTimeout(slxRestoreRouteChipIntel,500);
setTimeout(slxRestoreRouteChipIntel,1200);
setTimeout(slxRestoreRouteChipIntel,2400);


var __oldSyncUiFromState = syncUiFromState;
syncUiFromState = function(){
  __oldSyncUiFromState();
  slxRestoreRouteChipIntel();
};


var __oldEvaluateBestRoutes = evaluateBestRoutes;
evaluateBestRoutes = function(){
  __oldEvaluateBestRoutes();
  slxRestoreRouteChipIntel();
};


/* =========================================================
SLX SAFE LOADOUT SHEET + MAP RECOVERY V4
Place before final })();
========================================================= */


if(!window.__SLX_SAFE_LOADOUT_V4__){
window.__SLX_SAFE_LOADOUT_V4__=true;


function slxMapRecoverV4(){
  var mapEl=$("slxMap");
  if(mapEl){
    mapEl.style.display="block";
    mapEl.style.visibility="visible";
    mapEl.style.opacity="1";
    mapEl.style.background="#081018";
    mapEl.style.zIndex="1";
  }


  try{
    if(map){
      map.resize();
      if(!mapLoaded && map.loaded && map.loaded()){
        mapLoaded=true;
      }
    }
  }catch(e){}
}


function slxInstallLoadoutV4(){
  var st,sheet;


  if(!$("slxLoadoutStyleV4")){
    st=document.createElement("style");
    st.id="slxLoadoutStyleV4";
    st.textContent=
      "#slxLoadoutSheet{position:fixed;left:12px;right:12px;bottom:calc(88px + env(safe-area-inset-bottom,0px));z-index:220;display:none;border-radius:24px;background:rgba(8,14,22,.94);border:1px solid rgba(255,255,255,.14);box-shadow:0 24px 60px rgba(0,0,0,.50);backdrop-filter:blur(18px);-webkit-backdrop-filter:blur(18px);padding:12px;color:#fff;}"+
      "#slxLoadoutSheet.on{display:block;}"+
      ".slxLoadoutHead{display:flex;align-items:center;justify-content:space-between;margin-bottom:10px;}"+
      ".slxLoadoutTitle{font-size:13px;font-weight:1000;letter-spacing:.8px;color:#dffff5;}"+
      ".slxLoadoutClose{width:34px;height:34px;border-radius:999px;border:1px solid rgba(255,255,255,.14);background:rgba(255,255,255,.08);color:#fff;font-weight:1000;}"+
      ".slxLoadoutGrid{display:grid;grid-template-columns:1fr 1fr;gap:8px;}"+
      ".slxLoadoutBlock{border-radius:16px;border:1px solid rgba(255,255,255,.10);background:rgba(0,0,0,.18);padding:9px;}"+
      ".slxLoadoutLabel{font-size:9px;font-weight:1000;letter-spacing:.8px;opacity:.72;margin-bottom:7px;}"+
      ".slxLoadoutChips{display:flex;flex-wrap:wrap;gap:6px;}"+
      ".slxLoadoutChip{min-height:28px;padding:0 9px;border-radius:999px;border:1px solid rgba(255,255,255,.13);background:rgba(0,0,0,.20);font-size:9px;font-weight:1000;color:#fff;}"+
      ".slxLoadoutChip.on{border-color:rgba(0,255,176,.45);color:#9bffd7;}"+
      ".slxLoadoutSelect{width:100%;height:36px;border-radius:12px;border:1px solid rgba(255,255,255,.12);background:rgba(0,0,0,.24);color:#fff;padding:0 9px;font-size:10px;font-weight:1000;}"+
      "#slxSaveLoadout{width:100%;height:44px;margin-top:10px;border-radius:16px;border:1px solid rgba(0,255,176,.50);background:linear-gradient(180deg,rgba(40,255,200,1),rgba(0,230,155,1));color:#041712;font-size:13px;font-weight:1000;letter-spacing:.5px;}";
    document.head.appendChild(st);
  }


  if(!$("slxLoadoutSheet")){
    sheet=document.createElement("div");
    sheet.id="slxLoadoutSheet";
    sheet.innerHTML=
      '<div class="slxLoadoutHead"><div class="slxLoadoutTitle">TRIP LOADOUT</div><button id="slxLoadoutClose" class="slxLoadoutClose" type="button">×</button></div>'+
      '<div class="slxLoadoutGrid">'+
      '<div class="slxLoadoutBlock"><div class="slxLoadoutLabel">LOAD STATE</div><div class="slxLoadoutChips"><button class="slxLoadoutChip" data-mode="empty_trailer">EMPTY</button><button class="slxLoadoutChip" data-mode="loaded">LOADED</button><button class="slxLoadoutChip" data-mode="bobtail">BOBTAIL</button></div></div>'+
      '<div class="slxLoadoutBlock"><div class="slxLoadoutLabel">CAPACITY</div><div class="slxLoadoutChips"><button class="slxLoadoutChip" data-cap="full">FULL</button><button class="slxLoadoutChip" data-cap="partial">PARTIAL</button></div></div>'+
      '<div class="slxLoadoutBlock"><div class="slxLoadoutLabel">TRUCK TYPE</div><select id="slxLoadoutTruck" class="slxLoadoutSelect"><option value="dry_van">DRY VAN</option><option value="reefer">REEFER</option><option value="flatbed">FLATBED</option><option value="hotshot">HOTSHOT</option><option value="box_truck">BOX TRUCK</option><option value="car_hauler">CAR HAULER</option><option value="power_only">POWER ONLY</option></select></div>'+
      '<div class="slxLoadoutBlock"><div class="slxLoadoutLabel">EQUIPMENT</div><select id="slxLoadoutEquip" class="slxLoadoutSelect"><option value="van">VAN</option><option value="reefer">REEFER</option><option value="flatbed">FLATBED</option><option value="step_deck">STEP DECK</option><option value="lowboy">LOWBOY</option><option value="conestoga">CONESTOGA</option><option value="car_hauler">CAR HAULER</option><option value="container_chassis">CHASSIS</option><option value="power_only">POWER ONLY</option><option value="box_truck">BOX TRUCK</option><option value="hopper">HOPPER</option><option value="tanker">TANKER</option></select></div>'+
      '<div class="slxLoadoutBlock"><div class="slxLoadoutLabel">LENGTH</div><select id="slxLoadoutLength" class="slxLoadoutSelect"><option value="">--</option><option value="20">20 FT</option><option value="24">24 FT</option><option value="26">26 FT</option><option value="28">28 FT</option><option value="40">40 FT</option><option value="45">45 FT</option><option value="48">48 FT</option><option value="53">53 FT</option></select></div>'+
      '<div class="slxLoadoutBlock"><div class="slxLoadoutLabel">WEIGHT</div><select id="slxLoadoutWeight" class="slxLoadoutSelect"><option value="">--</option><option value="light">LIGHT</option><option value="10000">10K LB</option><option value="20000">20K LB</option><option value="30000">30K LB</option><option value="40000">40K LB</option><option value="45000">45K LB</option><option value="oversize">OVERSIZE</option></select></div>'+
      '</div><button id="slxSaveLoadout" type="button">SAVE LOADOUT</button>';
    document.body.appendChild(sheet);
  }
}


function slxSyncLoadoutV4(){
  var chips=document.querySelectorAll(".slxLoadoutChip");
  var i,c;


  for(i=0;i<chips.length;i++){
    c=chips[i];
    c.classList.remove("on");
    if(c.getAttribute("data-mode")===loadMode){c.classList.add("on");}
    if(c.getAttribute("data-cap")===tripCapacity){c.classList.add("on");}
  }


  if($("slxLoadoutTruck")){$("slxLoadoutTruck").value=truckType;}
  if($("slxLoadoutEquip")){$("slxLoadoutEquip").value=equipmentType;}
  if($("slxLoadoutLength")){$("slxLoadoutLength").value=equipmentLength||"";}
  if($("slxLoadoutWeight")){$("slxLoadoutWeight").value=equipmentWeight||"";}
}


function slxOpenLoadoutV4(){
  slxInstallLoadoutV4();
  slxSyncLoadoutV4();
  if($("slxLoadoutSheet")){$("slxLoadoutSheet").classList.add("on");}
  slxMapRecoverV4();
}


function slxCloseLoadoutV4(){
  if($("slxLoadoutSheet")){$("slxLoadoutSheet").classList.remove("on");}
  slxMapRecoverV4();
}


function slxSaveLoadoutV4(){
  if($("slxLoadoutTruck")){truckType=$("slxLoadoutTruck").value||"dry_van";}
  if($("slxLoadoutEquip")){equipmentType=$("slxLoadoutEquip").value||"van";}
  if($("slxLoadoutLength")){equipmentLength=$("slxLoadoutLength").value||"";}
  if($("slxLoadoutWeight")){equipmentWeight=$("slxLoadoutWeight").value||"";}


  lsSet(LS.MODE,loadMode);
  lsSet(LS.TRIP_CAPACITY,tripCapacity);
  lsSet(LS.TRUCK_TYPE,truckType);
  lsSet(LS.EQUIPMENT_TYPE,equipmentType);
  lsSet(LS.EQUIPMENT_LENGTH,equipmentLength);
  lsSet(LS.EQUIPMENT_WEIGHT,equipmentWeight);


  setLoadUI();
  setCapacityUI();
  updateEquipmentSelects();
  renderEquipmentSummary();
  saveDriverHandoffPayload();


  slxCloseLoadoutV4();
  toast("Loadout saved");
}


function slxBindLoadoutV4(){
  var btn=$("btnPanelToggle");


  slxInstallLoadoutV4();


  if(btn){
    btn.textContent="LOADOUT";
    btn.onclick=function(e){
      if(e&&e.preventDefault){e.preventDefault();}
      slxOpenLoadoutV4();
      return false;
    };
  }


  document.addEventListener("click",function(e){
    var t=e.target;
    var mode,cap;


    if(!t){return;}


    if(t.id==="slxLoadoutClose"){slxCloseLoadoutV4();return;}
    if(t.id==="slxSaveLoadout"){slxSaveLoadoutV4();return;}


    mode=t.getAttribute?t.getAttribute("data-mode"):null;
    cap=t.getAttribute?t.getAttribute("data-cap"):null;


    if(mode){
      loadMode=mode;
      slxSyncLoadoutV4();
      setLoadUI();
      saveDriverHandoffPayload();
    }


    if(cap){
      tripCapacity=cap;
      slxSyncLoadoutV4();
      setCapacityUI();
      saveDriverHandoffPayload();
    }
  },false);
}


setTimeout(slxBindLoadoutV4,300);
setTimeout(slxBindLoadoutV4,1000);
setTimeout(slxMapRecoverV4,700);
setTimeout(slxMapRecoverV4,1600);
}


/* =========================================================
SLX MONEY PILL HARD SYNC (AUTHORITATIVE ROUTE SOURCE)
Locks top-right $ pill to alt-route chip math
========================================================= */


if(!window.__SLX_MONEY_PILL_SYNC_V5__){
window.__SLX_MONEY_PILL_SYNC_V5__=true;


function slxFormatMoney(n){
  n=Number(n||0);
  if(!isFinite(n)||n<=0) return "$ --";
  return "$ "+Math.round(n).toLocaleString();
}


function slxGetRouteMoney(){


  try{


    if(routeGeo &&
       routeGeo.features &&
       routeGeo.features[0] &&
       routeGeo.features[0].properties){


      var p=routeGeo.features[0].properties;


      if(Number(p.net)>0){
        return Number(p.net);
      }


      if(Number(p.distanceMeters)>0){


        var calc=calcTripMoney(
          Number(p.distanceMeters||0),
          Number(p.durationSeconds||0)
        );


        if(calc && calc.net>0){
          return Number(calc.net);
        }
      }
    }


  }catch(e){}


  try{


    var saved = JSON.parse(
      localStorage.getItem(LS.MONEY_PREVIEW)||"null"
    );


    if(saved && saved.net>0){
      return Number(saved.net);
    }


  }catch(e){}


  return 0;
}


function slxUpdateMoneyPill(){


  var pill=$("pillMoney");
  if(!pill) return;


  var net=slxGetRouteMoney();


  pill.textContent=slxFormatMoney(net);


}


setTimeout(slxUpdateMoneyPill,200);
setTimeout(slxUpdateMoneyPill,700);
setTimeout(slxUpdateMoneyPill,1500);
setInterval(slxUpdateMoneyPill,1200);


}


/* =========================================================
SLX MONEY PILL DISPLAY LOCK V6
Stops $ -- flicker after valid money appears
========================================================= */


if(!window.__SLX_MONEY_PILL_DISPLAY_LOCK_V6__){
window.__SLX_MONEY_PILL_DISPLAY_LOCK_V6__=true;


var slxLockedMoneyTextV6="";


function slxLockMoneyTextV6(){
  var pill=$("pillMoney");
  var txt="";


  if(!pill){return;}


  txt=String(pill.textContent||"").replace(/\s+/g," ").replace(/^\s+|\s+$/g,"");


  if(txt && txt !== "$ --" && txt !== "$--"){
    slxLockedMoneyTextV6=txt;
    try{localStorage.setItem("slx_money_pill_locked_text_v1",txt);}catch(e){}
  }


  if(!slxLockedMoneyTextV6){
    try{slxLockedMoneyTextV6=localStorage.getItem("slx_money_pill_locked_text_v1")||"";}catch(e2){}
  }


  if(slxLockedMoneyTextV6 && (txt === "$ --" || txt === "$--" || txt === "")){
    pill.textContent=slxLockedMoneyTextV6;
  }
}


function slxForcePaintLockedMoneyV6(){
  var pill=$("pillMoney");
  if(!pill){return;}


  slxLockMoneyTextV6();


  if(slxLockedMoneyTextV6){
    pill.textContent=slxLockedMoneyTextV6;
  }
}


/* watch the pill and immediately undo $ -- */
setTimeout(function(){
  var pill=$("pillMoney");
  if(!pill){return;}


  try{
    var obs=new MutationObserver(function(){
      slxLockMoneyTextV6();
    });


    obs.observe(pill,{
      childList:true,
      characterData:true,
      subtree:true
    });
  }catch(e){}
},300);


setTimeout(slxForcePaintLockedMoneyV6,500);
setTimeout(slxForcePaintLockedMoneyV6,1200);
setTimeout(slxForcePaintLockedMoneyV6,2500);
setInterval(slxForcePaintLockedMoneyV6,350);


}


/* =========================================================
SLX START TRIP — CORRIDOR STOP PREVIEW V4.1
Smart filtered POIs + intentional tap cards + ADD STOP
Replaces V4.0
========================================================= */


if(!window.__SLX_CORRIDOR_STOP_PREVIEW_V41__){
window.__SLX_CORRIDOR_STOP_PREVIEW_V41__=true;


var slxPoiLastTapV41=0;
var slxPoiActiveIdV41="";


function slxStopToast(msg){
var old=document.getElementById("slxStopToastV41"),el;
if(old&&old.parentNode){old.parentNode.removeChild(old);}
el=document.createElement("div");
el.id="slxStopToastV41";
el.textContent=msg;
el.style.position="fixed";
el.style.left="28px";
el.style.right="28px";
el.style.top="132px";
el.style.zIndex="999999";
el.style.padding="11px 14px";
el.style.borderRadius="999px";
el.style.background="rgba(4,28,23,.92)";
el.style.border="1px solid rgba(0,255,190,.45)";
el.style.color="#9dffe8";
el.style.fontSize="12px";
el.style.fontWeight="900";
el.style.letterSpacing=".07em";
el.style.textAlign="center";
el.style.pointerEvents="none";
el.style.boxShadow="0 0 26px rgba(0,255,200,.26)";
document.body.appendChild(el);
setTimeout(function(){el.style.transition="opacity .35s ease";el.style.opacity="0";},1400);
setTimeout(function(){if(el&&el.parentNode){el.parentNode.removeChild(el);}},1900);
}


function slxStopColorExpr(alpha){
return [
"case",
["==",["get","type"],"parking"],"rgba(41,223,255,"+alpha+")",
["==",["get","type"],"fuel"],"rgba(46,134,255,"+alpha+")",
["==",["get","type"],"food"],"rgba(39,240,138,"+alpha+")",
["==",["get","type"],"service"],"rgba(255,139,47,"+alpha+")",
["==",["get","type"],"shopping"],"rgba(141,85,255,"+alpha+")",
["==",["get","type"],"showers"],"rgba(255,80,135,"+alpha+")",
["==",["get","type"],"rest"],"rgba(80,230,255,"+alpha+")",
"rgba(150,255,214,"+alpha+")"
];
}


function slxEnsureStopLayersV41(){
if(!mapLoaded||!map){return false;}
try{
if(!map.getSource("slxCorridorStops")){
map.addSource("slxCorridorStops",{type:"geojson",data:{type:"FeatureCollection",features:[]}});
}


if(!map.getLayer("slxCorridorStopsGlow")){
map.addLayer({
id:"slxCorridorStopsGlow",
type:"circle",
source:"slxCorridorStops",
paint:{
"circle-radius":["interpolate",["linear"],["zoom"],4,13,8,20,12,28],
"circle-color":slxStopColorExpr(".34"),
"circle-blur":0.65
}
});
}


if(!map.getLayer("slxCorridorStopsDot")){
map.addLayer({
id:"slxCorridorStopsDot",
type:"circle",
source:"slxCorridorStops",
paint:{
"circle-radius":["interpolate",["linear"],["zoom"],4,9,8,12,12,15],
"circle-color":"rgba(8,14,22,.96)",
"circle-stroke-width":3.25,
"circle-stroke-color":slxStopColorExpr("1")
}
});
}


if(!map.getLayer("slxCorridorStopsText")){
map.addLayer({
id:"slxCorridorStopsText",
type:"symbol",
source:"slxCorridorStops",
layout:{
"text-field":["get","label"],
"text-size":["interpolate",["linear"],["zoom"],4,10,8,13,12,15],
"text-font":["Open Sans Bold","Arial Unicode MS Bold"],
"text-allow-overlap":true,
"text-ignore-placement":true
},
paint:{
"text-color":"#ffffff",
"text-halo-color":"rgba(0,0,0,.88)",
"text-halo-width":1.8
}
});
}
return true;
}catch(e){return false;}
}


function slxMilesV41(a,b){
var R=3959,dLat,dLon,lat1,lat2,x;
if(!a||!b){return 0;}
dLat=(b[1]-a[1])*Math.PI/180;
dLon=(b[0]-a[0])*Math.PI/180;
lat1=a[1]*Math.PI/180;
lat2=b[1]*Math.PI/180;
x=Math.sin(dLat/2)*Math.sin(dLat/2)+Math.sin(dLon/2)*Math.sin(dLon/2)*Math.cos(lat1)*Math.cos(lat2);
return R*2*Math.atan2(Math.sqrt(x),Math.sqrt(1-x));
}


function slxRouteMilesV41(){
var coords,i,total=0;
try{
coords=routeGeo.features[0].geometry.coordinates;
for(i=1;i<coords.length;i++){total+=slxMilesV41(coords[i-1],coords[i]);}
}catch(e){}
return total;
}


function slxRouteModeV41(){
var mi=slxRouteMilesV41();
if(mi<25){return "LOCAL";}
if(mi<150){return "REGIONAL";}
return "LONG";
}


function slxSamplesV41(){
var out=[],coords,len,i,idx,count,mode;
if(!routeGeo||!routeGeo.features||!routeGeo.features[0]){return out;}
if(!routeGeo.features[0].geometry||!routeGeo.features[0].geometry.coordinates){return out;}
coords=routeGeo.features[0].geometry.coordinates;
len=coords.length;
if(len<2){return out;}
mode=slxRouteModeV41();
count=mode==="LOCAL"?5:(mode==="REGIONAL"?10:16);
for(i=1;i<=count;i++){
idx=Math.floor((len-1)*(i/(count+1)));
if(coords[idx]){
out.push({lng:Number(coords[idx][0]),lat:Number(coords[idx][1]),index:i,zone:i<=2?"start":i>=count-1?"dest":"mid"});
}
}
return out;
}


function slxCfgV41(){
var mode=slxRouteModeV41();
if(mode==="LOCAL"){
return [
{type:"parking",label:"P",dx:.026,dy:.012,max:4},
{type:"fuel",label:"F",dx:-.024,dy:.012,max:3}
];
}
if(mode==="REGIONAL"){
return [
{type:"parking",label:"P",dx:.036,dy:.016,max:6},
{type:"fuel",label:"F",dx:-.034,dy:.016,max:5},
{type:"rest",label:"R",dx:.018,dy:.040,max:3},
{type:"service",label:"S",dx:-.030,dy:-.020,max:3}
];
}
return [
{type:"parking",label:"P",dx:.045,dy:.018,max:8},
{type:"fuel",label:"F",dx:-.040,dy:.018,max:7},
{type:"rest",label:"R",dx:.018,dy:.050,max:5},
{type:"service",label:"S",dx:-.032,dy:-.022,max:4},
{type:"food",label:"E",dx:.032,dy:-.024,max:4},
{type:"showers",label:"W",dx:-.052,dy:.028,max:3},
{type:"shopping",label:"M",dx:.058,dy:-.010,max:3}
];
}


function slxStopTypeNameV41(type){
var m={parking:"Parking",fuel:"Fuel",food:"Food",service:"Service",shopping:"Store",showers:"Shower",rest:"Rest Area"};
return m[type]||"Stop";
}


function slxZoneNameV41(zone){
if(zone==="start"){return "Early route";}
if(zone==="dest"){return "Near destination";}
return "Mid corridor";
}


function slxBuildPinsV41(samples){
var out=[],cfg=slxCfgV41(),counts={},i,j,s,c,wave,name;
for(i=0;i<samples.length;i++){
s=samples[i];
wave=i%2===0?1:-1;
for(j=0;j<cfg.length;j++){
c=cfg[j];
counts[c.type]=counts[c.type]||0;
if(counts[c.type]>=c.max){continue;}


name=slxStopTypeNameV41(c.type)+" • "+slxZoneNameV41(s.zone);


out.push({
type:"Feature",
geometry:{type:"Point",coordinates:[s.lng+(c.dx*wave),s.lat+c.dy]},
properties:{
id:c.type+"_"+s.index+"_"+counts[c.type],
type:c.type,
label:c.label,
zone:s.zone,
name:name,
title:slxStopTypeNameV41(c.type),
subtitle:slxZoneNameV41(s.zone),
lat:s.lat+c.dy,
lng:s.lng+(c.dx*wave)
}
});
counts[c.type]++;
}
}
return out;
}


function slxSetStopsV41(pins){
try{
if(map&&map.getSource("slxCorridorStops")){
map.getSource("slxCorridorStops").setData({type:"FeatureCollection",features:pins||[]});
}
localStorage.setItem("slx_corridor_stop_preview_v1",JSON.stringify({
updated_at:new Date().toISOString(),
mode:slxRouteModeV41(),
features:pins||[]
}));
}catch(e){}
}


function slxClosePoiCardV41(){
var el=document.getElementById("slxPoiCardV41");
if(el&&el.parentNode){el.parentNode.removeChild(el);}
slxPoiActiveIdV41="";
}


function slxAddStopFromPoiV41(feature){
var p=feature&&feature.properties?feature.properties:{};
var coords=feature&&feature.geometry&&feature.geometry.coordinates?feature.geometry.coordinates:null;
var stop,raw,arr;


if(!coords){return;}


stop={
name:String(p.name||p.title||p.type||"Route stop"),
type:String(p.type||"stop"),
label:String(p.label||"S"),
zone:String(p.zone||"mid"),
lng:Number(coords[0]),
lat:Number(coords[1]),
source:"corridor_poi_v41",
added_at:new Date().toISOString()
};


try{
raw=localStorage.getItem("slx_selected_stops_v1");
arr=raw?JSON.parse(raw):[];
if(!arr||!arr.length){arr=[];}
arr.push(stop);
localStorage.setItem("slx_selected_stops_v1",JSON.stringify(arr));
localStorage.setItem("slx_active_stop_v1",JSON.stringify(stop));
}catch(e){}


slxStopToast("STOP ADDED • "+stop.name);
slxClosePoiCardV41();
}


function slxRenderPoiCardV41(feature){
var old=document.getElementById("slxPoiCardV41");
var p=feature&&feature.properties?feature.properties:{};
var type=String(p.type||"stop");
var title=String(p.title||slxStopTypeNameV41(type));
var sub=String(p.subtitle||slxZoneNameV41(p.zone||"mid"));
var note="";
var card,close,add;


if(old&&old.parentNode){old.parentNode.removeChild(old);}


if(type==="fuel"){note="Fuel option";}
else if(type==="parking"){note="Parking option";}
else if(type==="service"){note="Repair / support";}
else if(type==="rest"){note="Break / rest area";}
else if(type==="showers"){note="Driver comfort stop";}
else if(type==="food"){note="Food stop";}
else {note="Route stop";}


card=document.createElement("div");
card.id="slxPoiCardV41";
card.innerHTML=
'<button id="slxPoiCloseV41" type="button">×</button>'+
'<div style="font-size:22px;font-weight:1000;line-height:1.05;margin-bottom:7px;">'+title+'</div>'+
'<div style="font-size:10px;font-weight:1000;letter-spacing:.18em;color:#9bffd7;text-transform:uppercase;margin-bottom:8px;">'+type+'</div>'+
'<div style="font-size:13px;font-weight:900;color:rgba(255,255,255,.78);line-height:1.25;margin-bottom:12px;">'+sub+' • '+note+'</div>'+
'<button id="slxPoiAddStopV41" type="button">ADD STOP</button>';


card.style.position="fixed";
card.style.left="18px";
card.style.right="150px";
card.style.bottom="calc(220px + env(safe-area-inset-bottom,0px))";
card.style.zIndex="99998";
card.style.padding="16px 18px";
card.style.borderRadius="22px";
card.style.background="rgba(7,13,20,.94)";
card.style.border="1px solid rgba(80,230,255,.28)";
card.style.boxShadow="0 20px 46px rgba(0,0,0,.46),0 0 28px rgba(80,230,255,.12)";
card.style.backdropFilter="blur(18px)";
card.style.webkitBackdropFilter="blur(18px)";
card.style.color="#fff";


document.body.appendChild(card);


close=document.getElementById("slxPoiCloseV41");
if(close){
close.style.position="absolute";
close.style.right="14px";
close.style.top="14px";
close.style.width="38px";
close.style.height="38px";
close.style.borderRadius="999px";
close.style.border="1px solid rgba(255,255,255,.16)";
close.style.background="rgba(255,255,255,.10)";
close.style.color="#fff";
close.style.fontSize="28px";
close.style.fontWeight="1000";
close.onclick=function(e){
if(e&&e.preventDefault){e.preventDefault();}
slxClosePoiCardV41();
return false;
};
}


add=document.getElementById("slxPoiAddStopV41");
if(add){
add.style.width="100%";
add.style.border="0";
add.style.borderRadius="17px";
add.style.padding="13px 12px";
add.style.background="linear-gradient(180deg,#78ffd2,#45eaa7)";
add.style.color="#061713";
add.style.fontSize="13px";
add.style.fontWeight="1000";
add.style.letterSpacing=".14em";
add.onclick=function(e){
if(e&&e.preventDefault){e.preventDefault();}
if(e&&e.stopPropagation){e.stopPropagation();}
slxAddStopFromPoiV41(feature);
return false;
};
}
}


function slxHandlePoiTapV41(e){
var now=Date.now(),features,feature,id;


if(now-slxPoiLastTapV41<350){return;}
slxPoiLastTapV41=now;


if(!map||!map.getLayer("slxCorridorStopsDot")){return;}


try{
features=map.queryRenderedFeatures(e.point,{layers:["slxCorridorStopsDot","slxCorridorStopsText"]});
}catch(err){features=[];}


if(!features||!features.length){return;}


feature=features[0];
id=String(feature.properties&&feature.properties.id||feature.properties&&feature.properties.name||"poi");


if(slxPoiActiveIdV41===id){return;}
slxPoiActiveIdV41=id;


slxRenderPoiCardV41(feature);
}


function slxInstallPoiTapV41(){
if(!mapLoaded||!map||map.__slxPoiTapV41){return;}
map.__slxPoiTapV41=true;


map.on("click",function(e){
slxHandlePoiTapV41(e);
});


try{
map.on("dragstart",function(){});
}catch(e){}
}


function slxRunScanStopsV41(){
var samples,pins,mode;


if(!routeReady||!routeGeo){slxStopToast("ROUTE FIRST TO SCAN STOPS");return false;}
if(!mapLoaded||!map){slxStopToast("MAP NOT READY");return false;}
if(!slxEnsureStopLayersV41()){slxStopToast("PIN LAYERS NOT READY");return false;}


samples=slxSamplesV41();
if(!samples.length){slxStopToast("ROUTE NOT READY");return false;}


pins=slxBuildPinsV41(samples);
slxSetStopsV41(pins);


mode=slxRouteModeV41();


if(mode==="LOCAL"){slxStopToast("SMART LOCAL STOPS • "+pins.length+" BEST PINS");}
else if(mode==="REGIONAL"){slxStopToast("REGIONAL STOPS READY • "+pins.length+" PINS");}
else{slxStopToast("LONG HAUL STOPS READY • "+pins.length+" PINS");}


return false;
}


function slxWireScanButtonV41(){
var btn=document.getElementById("btnScanStops");
var rail=document.querySelector(".rightRailBottom");


if(!btn&&rail){
btn=document.createElement("button");
btn.id="btnScanStops";
btn.className="edgeBtn btn";
btn.type="button";
btn.textContent="SCAN STOPS";
rail.insertBefore(btn,rail.firstChild);
}


if(!btn){return;}


btn.textContent="SCAN STOPS";
btn.style.display="block";
btn.style.visibility="visible";
btn.style.pointerEvents="auto";
btn.style.borderColor="rgba(0,255,176,.34)";
btn.style.color="#9bffd7";
btn.style.boxShadow="0 0 18px rgba(0,255,176,.10)";


btn.onclick=function(e){
if(e&&e.preventDefault){e.preventDefault();}
if(e&&e.stopPropagation){e.stopPropagation();}
return slxRunScanStopsV41();
};
}


var __oldDrawRouteLineStopsV41=drawRouteLine;
drawRouteLine=function(geojson){
__oldDrawRouteLineStopsV41(geojson);
slxEnsureStopLayersV41();
setTimeout(slxInstallPoiTapV41,250);
};


setTimeout(slxWireScanButtonV41,300);
setTimeout(slxWireScanButtonV41,1000);
setTimeout(slxEnsureStopLayersV41,1400);
setTimeout(slxInstallPoiTapV41,1600);
setInterval(slxWireScanButtonV41,1800);


window.slxScanCorridorStops=slxRunScanStopsV41;
window.slxRunScanStopsV41=slxRunScanStopsV41;
window.slxClosePoiCardV41=slxClosePoiCardV41;


}


/* =========================================================
SLX START TRIP — SELECTED STOPS BAR V1
Shows stops added from POI cards. Safe UI only.
========================================================= */


(function(){
"use strict";


if(window.__SLX_SELECTED_STOPS_BAR_V1__) return;
window.__SLX_SELECTED_STOPS_BAR_V1__=true;


function slxStopsReadV1(){
try{return JSON.parse(localStorage.getItem("slx_selected_stops_v1")||"[]");}
catch(e){}
return [];
}


function slxStopsWriteV1(arr){
try{localStorage.setItem("slx_selected_stops_v1",JSON.stringify(arr||[]));}
catch(e){}
}


function slxShortStopNameV1(s){
var name=String(s&&s.name||s&&s.type||"Stop");
name=name.replace(/\s+•\s+.*/,"");
if(name.length>16){name=name.substring(0,14)+"…";}
return name;
}


function slxEnsureStopsBarV1(){
var bar=document.getElementById("slxSelectedStopsBarV1");


if(bar) return bar;


bar=document.createElement("div");
bar.id="slxSelectedStopsBarV1";


bar.style.position="fixed";
bar.style.left="14px";
bar.style.right="150px";
bar.style.bottom="calc(154px + env(safe-area-inset-bottom,0px))";
bar.style.zIndex="99970";
bar.style.display="none";
bar.style.alignItems="center";
bar.style.gap="7px";
bar.style.padding="8px 9px";
bar.style.borderRadius="18px";
bar.style.background="rgba(7,13,20,.88)";
bar.style.border="1px solid rgba(0,255,176,.22)";
bar.style.boxShadow="0 14px 34px rgba(0,0,0,.34),0 0 20px rgba(0,255,176,.10)";
bar.style.backdropFilter="blur(16px)";
bar.style.webkitBackdropFilter="blur(16px)";
bar.style.color="#fff";
bar.style.overflowX="auto";
bar.style.webkitOverflowScrolling="touch";


document.body.appendChild(bar);
return bar;
}


function slxRenderStopsBarV1(){
var bar=slxEnsureStopsBarV1();
var stops=slxStopsReadV1();
var html="";
var i,s,label,type;


if(!stops.length){
bar.style.display="none";
bar.innerHTML="";
return;
}


html+='<div style="flex:0 0 auto;font-size:9px;font-weight:1000;letter-spacing:.14em;color:#9bffd7;">STOPS</div>';


for(i=0;i<stops.length;i++){
s=stops[i];
type=String(s.type||"stop").toUpperCase();
label=slxShortStopNameV1(s);


html+=
'<button data-slx-stop-index="'+i+'" class="slxStopChipV1" type="button" '+
'style="flex:0 0 auto;display:inline-flex;align-items:center;gap:6px;min-height:30px;padding:0 9px;border-radius:999px;border:1px solid rgba(255,255,255,.14);background:rgba(0,0,0,.24);color:#fff;font-size:10px;font-weight:1000;">'+
'<span style="color:#9bffd7;">'+type.substring(0,1)+'</span>'+
'<span>'+label+'</span>'+
'<span style="opacity:.65;">×</span>'+
'</button>';
}


bar.innerHTML=html;
bar.style.display="flex";


Array.prototype.forEach.call(bar.querySelectorAll(".slxStopChipV1"),function(btn){
btn.onclick=function(e){
var idx,arr;


if(e&&e.preventDefault){e.preventDefault();}
if(e&&e.stopPropagation){e.stopPropagation();}


idx=Number(btn.getAttribute("data-slx-stop-index"));
arr=slxStopsReadV1();


if(idx>=0&&idx<arr.length){
arr.splice(idx,1);
slxStopsWriteV1(arr);


try{
if(arr.length){localStorage.setItem("slx_active_stop_v1",JSON.stringify(arr[arr.length-1]));}
else{localStorage.removeItem("slx_active_stop_v1");}
}catch(x){}


slxRenderStopsBarV1();


if(typeof slxStopToast==="function"){slxStopToast("STOP REMOVED");}
else if(typeof toast==="function"){toast("Stop removed");}
}


return false;
};
});
}


/* Hook into existing ADD STOP if V4.1 is present */
if(typeof window.slxClosePoiCardV41==="function"){
setInterval(slxRenderStopsBarV1,1200);
}else{
setInterval(slxRenderStopsBarV1,1800);
}


setTimeout(slxRenderStopsBarV1,400);
setTimeout(slxRenderStopsBarV1,1200);


window.slxRenderStopsBarV1=slxRenderStopsBarV1;


})();


/* =========================================================
SLX CORRIDOR READOUT + COOL STOPS RESTORE V1
- Intelligent legend above Trip Money
- Shows only pin types actually present
- Restores COOL STOPS button if missing
========================================================= */


if(!window.__SLX_CORRIDOR_READOUT_COOL_RESTORE_V1__){
window.__SLX_CORRIDOR_READOUT_COOL_RESTORE_V1__=true;


function slxReadoutParse(){
  try{
    return JSON.parse(localStorage.getItem("slx_corridor_stop_preview_v1")||"null");
  }catch(e){}
  return null;
}


function slxTypeMetaV1(type){
  var map={
    parking:{label:"P",name:"Parking",color:"#29dfff"},
    fuel:{label:"F",name:"Fuel",color:"#2e86ff"},
    food:{label:"E",name:"Food",color:"#27f08a"},
    service:{label:"S",name:"Service",color:"#ff8b2f"},
    shopping:{label:"M",name:"Store",color:"#8d55ff"},
    showers:{label:"W",name:"Shower",color:"#ff5087"},
    rest:{label:"R",name:"Rest",color:"#50e6ff"}
  };
  return map[type]||null;
}


function slxInstallCorridorReadoutV1(){
  var box=document.getElementById("slxCorridorReadoutV1");


  if(!box){
    box=document.createElement("div");
    box.id="slxCorridorReadoutV1";
    document.body.appendChild(box);
  }


  box.style.position="fixed";
  box.style.left="14px";
  box.style.right="150px";
  box.style.bottom="calc(206px + env(safe-area-inset-bottom,0px))";
  box.style.zIndex="280";
  box.style.display="none";
  box.style.padding="9px 11px";
  box.style.borderRadius="18px";
  box.style.background="rgba(8,14,22,.88)";
  box.style.border="1px solid rgba(0,255,176,.26)";
  box.style.boxShadow="0 18px 42px rgba(0,0,0,.38),0 0 26px rgba(0,255,176,.12)";
  box.style.backdropFilter="blur(16px)";
  box.style.webkitBackdropFilter="blur(16px)";
  box.style.color="#dfffff";
  box.style.pointerEvents="none";
  box.style.fontWeight="900";
}


function slxUpdateCorridorReadoutV1(){


  var box=document.getElementById("slxCorridorReadoutV1");
  var data=slxReadoutParse();
  var counts={}, order=["parking","fuel","food","service","shopping","showers","rest"];
  var i,f,t,meta,items=[],summary;


  if(!box){slxInstallCorridorReadoutV1();box=document.getElementById("slxCorridorReadoutV1");}
  if(!box){return;}


  if(!data||!data.features||!data.features.length){
    box.style.display="none";
    return;
  }


  for(i=0;i<data.features.length;i++){
    f=data.features[i];
    t=String(f.properties&&f.properties.type||"parking").toLowerCase();
    counts[t]=(counts[t]||0)+1;
  }


  for(i=0;i<order.length;i++){
    t=order[i];
    if(!counts[t]){continue;}


    meta=slxTypeMetaV1(t);
    if(!meta){continue;}


    items.push(
      '<div style="display:flex;align-items:center;margin-right:10px;margin-bottom:4px;">'+
      '<span style="color:'+meta.color+';font-weight:1000;margin-right:4px;">'+meta.label+'</span>'+
      '<span>'+meta.name+'</span>'+
      '</div>'
    );
  }


  summary="Parking + fuel visible";


  if((counts.food||0)+(counts.service||0)+(counts.shopping||0)>4){
    summary="Stops, food + service visible";
  }


  if((counts.showers||0)>0 || (counts.rest||0)>0){
    summary="Break options visible";
  }


  box.innerHTML =
    '<div style="font-size:10px;letter-spacing:.12em;color:#9bffd7;margin-bottom:5px;">CORRIDOR READOUT • '+summary+'</div>'+
    '<div style="display:flex;flex-wrap:wrap;font-size:10px;line-height:1.45;">'+
    items.join("")+
    '</div>';


  box.style.display="block";
}


function slxRestoreCoolStopsButtonV1(){
  var rail=document.querySelector(".rightRailBottom");
  var btn=document.getElementById("btnCoolStops");


  if(btn){
    btn.style.display="block";
    btn.style.visibility="visible";
    btn.style.pointerEvents="auto";
    return;
  }


  if(!rail){return;}


  btn=document.createElement("button");
  btn.id="btnCoolStops";
  btn.className="edgeBtn btn";
  btn.type="button";
  btn.textContent="COOL STOPS";
  btn.style.borderColor="rgba(80,230,255,.34)";
  btn.style.color="#bdf7ff";
  btn.style.boxShadow="0 0 18px rgba(80,230,255,.12)";


  rail.insertBefore(btn,rail.firstChild);


  btn.onclick=function(e){
    if(e&&e.preventDefault){e.preventDefault();}
    if(typeof slxShowCoolStops==="function"){
      slxShowCoolStops();
    }else{
      toast("Cool Stops not loaded");
    }
    return false;
  };
}


/* update readout right after scan writes pins */
if(typeof slxSetCorridorStopPins==="function" && !slxSetCorridorStopPins.__slxReadoutWrappedV1){
  var __oldSetCorridorStopPinsReadoutV1=slxSetCorridorStopPins;


  slxSetCorridorStopPins=function(features){
    __oldSetCorridorStopPinsReadoutV1(features);
    setTimeout(slxUpdateCorridorReadoutV1,120);
    setTimeout(slxUpdateCorridorReadoutV1,600);
  };


  slxSetCorridorStopPins.__slxReadoutWrappedV1=true;
}


setTimeout(slxInstallCorridorReadoutV1,300);
setTimeout(slxRestoreCoolStopsButtonV1,500);
setTimeout(slxUpdateCorridorReadoutV1,900);


setInterval(function(){
  slxRestoreCoolStopsButtonV1();
  slxUpdateCorridorReadoutV1();
},2200);


window.slxUpdateCorridorReadoutV1=slxUpdateCorridorReadoutV1;
window.slxRestoreCoolStopsButtonV1=slxRestoreCoolStopsButtonV1;


}


/* =========================================================
SLX CORRIDOR READOUT — HARD AUTO-HIDE FOR LOADOUT V2
Works with slxCorridorReadoutV1 and Trip Money / Loadout sheet
========================================================= */


(function(){
"use strict";


if(window.__SLX_CORRIDOR_READOUT_LOADOUT_HIDE_V2__) return;
window.__SLX_CORRIDOR_READOUT_LOADOUT_HIDE_V2__=true;


function slxVisible(el){
  if(!el) return false;
  try{
    var cs=window.getComputedStyle(el);
    if(cs.display==="none"||cs.visibility==="hidden"||Number(cs.opacity)===0){return false;}
  }catch(e){}
  return !!(el.offsetWidth||el.offsetHeight||el.getClientRects().length);
}


function slxLoadoutIsOpenV2(){
  var sheet=document.getElementById("slxLoadoutSheet");
  var panel=document.getElementById("slxLoadoutPanel") ||
            document.getElementById("tripLoadoutPanel") ||
            document.querySelector(".tripLoadoutPanel") ||
            document.querySelector(".slxTripLoadout");


  try{
    if(document.body.classList.contains("slx-loadout-open")) return true;
  }catch(e){}


  if(sheet && sheet.classList && sheet.classList.contains("on")) return true;
  if(sheet && slxVisible(sheet)) return true;
  if(panel && slxVisible(panel)) return true;


  return false;
}


function slxGetReadoutV2(){
  return document.getElementById("slxCorridorReadoutV1") ||
         document.getElementById("slxCorridorReadout") ||
         document.querySelector(".slxCorridorReadout");
}


function slxHideReadoutForLoadoutV2(){
  var box=slxGetReadoutV2();


  if(!box) return;


  if(slxLoadoutIsOpenV2()){
    box.setAttribute("data-slx-hidden-by-loadout","1");
    box.style.setProperty("display","none","important");
    box.style.setProperty("opacity","0","important");
    box.style.setProperty("visibility","hidden","important");
    box.style.setProperty("pointer-events","none","important");
    return;
  }


  if(box.getAttribute("data-slx-hidden-by-loadout")==="1"){
    box.removeAttribute("data-slx-hidden-by-loadout");
    box.style.removeProperty("display");
    box.style.removeProperty("opacity");
    box.style.removeProperty("visibility");
    box.style.removeProperty("pointer-events");


    if(typeof window.slxUpdateCorridorReadoutV1==="function"){
      setTimeout(window.slxUpdateCorridorReadoutV1,80);
    }
  }
}


function slxPatchReadoutUpdaterV2(){
  if(typeof window.slxUpdateCorridorReadoutV1!=="function") return;
  if(window.slxUpdateCorridorReadoutV1.__slxLoadoutGuardV2) return;


  var old=window.slxUpdateCorridorReadoutV1;


  window.slxUpdateCorridorReadoutV1=function(){
    if(slxLoadoutIsOpenV2()){
      slxHideReadoutForLoadoutV2();
      return;
    }


    old.apply(this,arguments);
    slxHideReadoutForLoadoutV2();
  };


  window.slxUpdateCorridorReadoutV1.__slxLoadoutGuardV2=true;
}


function slxBindLoadoutButtonsV2(){
  var openBtn=document.getElementById("btnPanelToggle");
  var closeBtn=document.getElementById("slxLoadoutClose");
  var saveBtn=document.getElementById("slxSaveLoadout");


  if(openBtn&&!openBtn.__slxReadoutHideV2){
    openBtn.__slxReadoutHideV2=true;
    openBtn.addEventListener("click",function(){
      try{document.body.classList.add("slx-loadout-open");}catch(e){}
      setTimeout(slxHideReadoutForLoadoutV2,0);
      setTimeout(slxHideReadoutForLoadoutV2,80);
      setTimeout(slxHideReadoutForLoadoutV2,220);
    },true);
  }


  if(closeBtn&&!closeBtn.__slxReadoutHideV2){
    closeBtn.__slxReadoutHideV2=true;
    closeBtn.addEventListener("click",function(){
      setTimeout(function(){
        try{document.body.classList.remove("slx-loadout-open");}catch(e){}
        slxHideReadoutForLoadoutV2();
      },160);
    },true);
  }


  if(saveBtn&&!saveBtn.__slxReadoutHideV2){
    saveBtn.__slxReadoutHideV2=true;
    saveBtn.addEventListener("click",function(){
      setTimeout(function(){
        try{document.body.classList.remove("slx-loadout-open");}catch(e){}
        slxHideReadoutForLoadoutV2();
      },180);
    },true);
  }
}


setTimeout(slxPatchReadoutUpdaterV2,150);
setTimeout(slxBindLoadoutButtonsV2,200);
setTimeout(slxHideReadoutForLoadoutV2,300);


setInterval(function(){
  slxPatchReadoutUpdaterV2();
  slxBindLoadoutButtonsV2();
  slxHideReadoutForLoadoutV2();
},250);


window.slxHideReadoutForLoadoutV2=slxHideReadoutForLoadoutV2;


})();


/* =========================================================
SLX COOL STOPS HARD RESTORE V1
Self-contained. Restores COOL STOPS pins when button is tapped.
Paste at VERY BOTTOM before final })();
========================================================= */


if(!window.__SLX_COOL_STOPS_HARD_RESTORE_V1__){
window.__SLX_COOL_STOPS_HARD_RESTORE_V1__=true;


var SLX_COOL_STOPS_HARD=[
  {name:"Grand Canyon",lat:36.1069,lng:-112.1129,tier:"legendary"},
  {name:"Zion",lat:37.2982,lng:-113.0263,tier:"legendary"},
  {name:"Monument Valley",lat:36.9980,lng:-110.0985,tier:"legendary"},
  {name:"Meteor Crater",lat:35.0272,lng:-111.0225,tier:"major"},
  {name:"White Sands",lat:32.7872,lng:-106.3257,tier:"major"},
  {name:"Carlsbad Caverns",lat:32.1479,lng:-104.5567,tier:"major"},
  {name:"Big Bend",lat:29.1275,lng:-103.2425,tier:"major"},
  {name:"Gateway Arch",lat:38.6247,lng:-90.1848,tier:"major"},
  {name:"Joshua Tree",lat:33.8734,lng:-115.9010,tier:"major"},
  {name:"Hoover Dam",lat:36.0161,lng:-114.7377,tier:"major"},
  {name:"Petrified Forest",lat:35.0659,lng:-109.7810,tier:"major"}
];


function slxMilesV1(a,b){
  return distanceMiles(Number(a[1]),Number(a[0]),Number(b[1]),Number(b[0]));
}


function slxCoolDistToRouteV1(lng,lat){
  var best=999999, coords, step, i, d;


  if(!routeGeo||!routeGeo.features||!routeGeo.features[0]){return best;}
  if(!routeGeo.features[0].geometry||!routeGeo.features[0].geometry.coordinates){return best;}


  coords=routeGeo.features[0].geometry.coordinates;
  step=Math.max(1,Math.floor(coords.length/120));


  for(i=0;i<coords.length;i+=step){
    d=slxMilesV1([lng,lat],coords[i]);
    if(d<best){best=d;}
  }


  return best;
}


function slxEnsureCoolHardLayersV1(){
  if(!mapLoaded||!map){return false;}


  try{
    if(!map.getSource("slxCoolStops")){
      map.addSource("slxCoolStops",{
        type:"geojson",
        data:{type:"FeatureCollection",features:[]}
      });
    }


    if(!map.getLayer("slxCoolStopsGlow")){
      map.addLayer({
        id:"slxCoolStopsGlow",
        type:"circle",
        source:"slxCoolStops",
        paint:{
          "circle-radius":["case",["==",["get","tier"],"legendary"],30,24],
          "circle-color":["case",["==",["get","tier"],"legendary"],"rgba(80,230,255,.38)","rgba(80,230,255,.26)"],
          "circle-blur":0.68
        }
      });
    }


    if(!map.getLayer("slxCoolStopsDot")){
      map.addLayer({
        id:"slxCoolStopsDot",
        type:"circle",
        source:"slxCoolStops",
        paint:{
          "circle-radius":["case",["==",["get","tier"],"legendary"],15,13],
          "circle-color":"rgba(8,14,22,.96)",
          "circle-stroke-width":3,
          "circle-stroke-color":["case",["==",["get","tier"],"legendary"],"rgba(80,230,255,1)","rgba(120,230,255,.95)"]
        }
      });
    }


    if(!map.getLayer("slxCoolStopsText")){
      map.addLayer({
        id:"slxCoolStopsText",
        type:"symbol",
        source:"slxCoolStops",
        layout:{
          "text-field":"★",
          "text-size":["case",["==",["get","tier"],"legendary"],16,14],
          "text-font":["Open Sans Bold","Arial Unicode MS Bold"],
          "text-allow-overlap":true,
          "text-ignore-placement":true
        },
        paint:{
          "text-color":"#ffffff",
          "text-halo-color":"rgba(0,0,0,.82)",
          "text-halo-width":1.7
        }
      });
    }


    return true;
  }catch(e){
    return false;
  }
}


function slxRunCoolStopsHardV1(){
  var out=[], scored=[], i, s, d, score;


  if(!routeReady||!routeGeo){
    toast("Route first for Cool Stops");
    return false;
  }


  if(!slxEnsureCoolHardLayersV1()){
    toast("Cool Stops map not ready");
    return false;
  }


  for(i=0;i<SLX_COOL_STOPS_HARD.length;i++){
    s=SLX_COOL_STOPS_HARD[i];
    d=slxCoolDistToRouteV1(s.lng,s.lat);


    if(d<=120){
      score=120-d;
      if(s.tier==="legendary"){score+=40;}
      if(s.tier==="major"){score+=20;}
      scored.push({stop:s,miles:d,score:score});
    }
  }


  scored.sort(function(a,b){return b.score-a.score;});


  for(i=0;i<scored.length&&out.length<8;i++){
    s=scored[i].stop;


    out.push({
      type:"Feature",
      geometry:{type:"Point",coordinates:[s.lng,s.lat]},
      properties:{
        label:"★",
        name:s.name,
        tier:s.tier,
        miles_off_route:Math.round(scored[i].miles)
      }
    });
  }


  map.getSource("slxCoolStops").setData({
    type:"FeatureCollection",
    features:out
  });


  try{
    localStorage.setItem("slx_journey_pins_v1",JSON.stringify({
      updated_at:new Date().toISOString(),
      features:out
    }));
  }catch(e){}


  toast(out.length ? String(out.length)+" Cool Stops added" : "No Cool Stops near this route");
  return false;
}


function slxWireCoolStopsHardV1(){
  var btn=document.getElementById("btnCoolStops");
  var rail=document.querySelector(".rightRailBottom");


  if(!btn&&rail){
    btn=document.createElement("button");
    btn.id="btnCoolStops";
    btn.className="edgeBtn btn";
    btn.type="button";
    btn.textContent="COOL STOPS";
    rail.insertBefore(btn,rail.firstChild);
  }


  if(!btn){return;}


  btn.textContent="COOL STOPS";
  btn.style.display="block";
  btn.style.visibility="visible";
  btn.style.pointerEvents="auto";
  btn.style.borderColor="rgba(80,230,255,.34)";
  btn.style.color="#bdf7ff";
  btn.style.boxShadow="0 0 18px rgba(80,230,255,.12)";


  btn.onclick=function(e){
    if(e&&e.preventDefault){e.preventDefault();}
    if(e&&e.stopPropagation){e.stopPropagation();}
    return slxRunCoolStopsHardV1();
  };
}


setTimeout(slxWireCoolStopsHardV1,300);
setTimeout(slxWireCoolStopsHardV1,1000);
setTimeout(slxEnsureCoolHardLayersV1,1600);
setInterval(slxWireCoolStopsHardV1,2200);


window.slxShowCoolStops=slxRunCoolStopsHardV1;
window.slxRunCoolStopsHardV1=slxRunCoolStopsHardV1;


}


/* =========================================================
SLX POI INFO CARD V1
Tap any corridor POI or Cool Stop to show info card
Fuel price-ready
========================================================= */


if(!window.__SLX_POI_INFO_CARD_V1__){
window.__SLX_POI_INFO_CARD_V1__=true;


function slxInstallPoiInfoCardV1(){
  var card=document.getElementById("slxPoiInfoCardV1");
  var st;


  if(!document.getElementById("slxPoiInfoCardStyleV1")){
    st=document.createElement("style");
    st.id="slxPoiInfoCardStyleV1";
    st.textContent=
      "#slxPoiInfoCardV1{position:fixed;left:16px;right:154px;bottom:calc(206px + env(safe-area-inset-bottom,0px));z-index:420;display:none;border-radius:20px;background:rgba(8,14,22,.94);border:1px solid rgba(0,255,176,.30);box-shadow:0 20px 46px rgba(0,0,0,.48),0 0 28px rgba(0,255,176,.14);backdrop-filter:blur(18px);-webkit-backdrop-filter:blur(18px);padding:13px;color:#fff;}"+
      "#slxPoiInfoCardV1.on{display:block;}"+
      ".slxPoiInfoTop{display:flex;align-items:center;justify-content:space-between;gap:8px;}"+
      ".slxPoiInfoTitle{font-size:15px;font-weight:1000;letter-spacing:.2px;color:#dffff5;}"+
      ".slxPoiInfoType{margin-top:5px;font-size:10px;font-weight:1000;letter-spacing:.12em;color:#9bffd7;}"+
      ".slxPoiInfoSub{margin-top:7px;font-size:11px;font-weight:850;line-height:1.35;color:rgba(255,255,255,.78);}"+
      ".slxPoiInfoPrice{margin-top:9px;display:inline-flex;min-height:28px;align-items:center;padding:0 10px;border-radius:999px;border:1px solid rgba(255,205,105,.32);background:rgba(255,205,105,.10);color:#ffe2a2;font-size:11px;font-weight:1000;}"+
      ".slxPoiInfoClose{width:30px;height:30px;border-radius:999px;border:1px solid rgba(255,255,255,.18);background:rgba(255,255,255,.08);color:#fff;font-size:18px;font-weight:1000;}"+
      "@media(max-width:420px){#slxPoiInfoCardV1{left:14px;right:150px;bottom:calc(205px + env(safe-area-inset-bottom,0px));padding:11px}.slxPoiInfoTitle{font-size:13px}.slxPoiInfoSub{font-size:10px}}";
    document.head.appendChild(st);
  }


  if(!card){
    card=document.createElement("div");
    card.id="slxPoiInfoCardV1";
    card.innerHTML=
      '<div class="slxPoiInfoTop">'+
        '<div>'+
          '<div class="slxPoiInfoTitle" id="slxPoiInfoTitleV1">Stop</div>'+
          '<div class="slxPoiInfoType" id="slxPoiInfoTypeV1">CORRIDOR POI</div>'+
        '</div>'+
        '<button class="slxPoiInfoClose" id="slxPoiInfoCloseV1" type="button">×</button>'+
      '</div>'+
      '<div class="slxPoiInfoSub" id="slxPoiInfoSubV1">Route-adjacent stop.</div>'+
      '<div class="slxPoiInfoPrice" id="slxPoiInfoPriceV1" style="display:none;"></div>';
    document.body.appendChild(card);
  }


  if(document.getElementById("slxPoiInfoCloseV1")){
    document.getElementById("slxPoiInfoCloseV1").onclick=function(e){
      if(e&&e.stopPropagation){e.stopPropagation();}
      card.classList.remove("on");
      return false;
    };
  }
}


function slxPoiTypeNameV1(type){
  type=String(type||"").toLowerCase();


  if(type==="parking"){return "Truck Parking";}
  if(type==="fuel"){return "Fuel Stop";}
  if(type==="food"){return "Food";}
  if(type==="service"){return "Service / Repair";}
  if(type==="shopping"){return "Store / Supplies";}
  if(type==="showers"){return "Showers";}
  if(type==="rest"){return "Rest Area";}
  if(type==="national_park"){return "Cool Stop";}
  if(type==="landmark"){return "Cool Stop";}


  return "Corridor Stop";
}


function slxShowPoiInfoCardV1(props){
  var card,title,type,sub,price;
  var poiType,name,zone,miles,fuelPrice;


  slxInstallPoiInfoCardV1();


  card=document.getElementById("slxPoiInfoCardV1");
  title=document.getElementById("slxPoiInfoTitleV1");
  type=document.getElementById("slxPoiInfoTypeV1");
  sub=document.getElementById("slxPoiInfoSubV1");
  price=document.getElementById("slxPoiInfoPriceV1");


  if(!card||!title||!type||!sub||!price){return;}


  props=props||{};
  poiType=String(props.type||"parking").toLowerCase();
  name=String(props.name||slxPoiTypeNameV1(poiType));
  zone=String(props.zone||"corridor").toUpperCase();
  miles=props.miles_off_route||props.miles||"";
  fuelPrice=props.fuel_price||props.fuelPrice||props.price||"";


  title.textContent=name;
  type.textContent=slxPoiTypeNameV1(poiType).toUpperCase();


  if(poiType==="national_park"||poiType==="landmark"){
    sub.textContent=(miles ? String(miles)+" mi off route • " : "")+"Scenic corridor marker worth knowing about.";
  }else{
    sub.textContent=zone+" corridor window • Tap-ready stop intelligence.";
  }


  if(poiType==="fuel"){
    price.style.display="inline-flex";
    price.textContent=fuelPrice ? "Diesel: $"+String(fuelPrice) : "Diesel price: checking soon";
  }else{
    price.style.display="none";
  }


  card.classList.add("on");


  clearTimeout(window.__slxPoiInfoTimerV1);
  window.__slxPoiInfoTimerV1=setTimeout(function(){
    if(card){card.classList.remove("on");}
  },6500);
}


function slxBindPoiInfoMapTapsV1(){
  if(!map||!map.on||map.__slxPoiInfoBoundV1){return;}
  map.__slxPoiInfoBoundV1=true;


  function handleTap(e){
    var f,props;


    if(e&&e.preventDefault){e.preventDefault();}
    if(e&&e.originalEvent&&e.originalEvent.stopPropagation){
      e.originalEvent.stopPropagation();
      e.originalEvent.cancelBubble=true;
    }


    if(!e||!e.features||!e.features.length){return false;}


    f=e.features[0];
    props=f.properties||{};


    slxShowPoiInfoCardV1(props);
    return false;
  }


  try{map.on("click","slxCorridorStopsDot",handleTap);}catch(e1){}
  try{map.on("click","slxCorridorStopsText",handleTap);}catch(e2){}
  try{map.on("touchstart","slxCorridorStopsDot",handleTap);}catch(e3){}
  try{map.on("touchstart","slxCorridorStopsText",handleTap);}catch(e4){}


  try{map.on("click","slxCoolStopsDot",handleTap);}catch(e5){}
  try{map.on("click","slxCoolStopsText",handleTap);}catch(e6){}
  try{map.on("touchstart","slxCoolStopsDot",handleTap);}catch(e7){}
  try{map.on("touchstart","slxCoolStopsText",handleTap);}catch(e8){}
}


setTimeout(slxInstallPoiInfoCardV1,400);
setTimeout(slxBindPoiInfoMapTapsV1,900);
setTimeout(slxBindPoiInfoMapTapsV1,1800);
setInterval(slxBindPoiInfoMapTapsV1,2500);


window.slxShowPoiInfoCardV1=slxShowPoiInfoCardV1;


}


/* =========================================================
SLX POI TAP HITBOX FIX V1
Makes corridor POI taps open info card instead of map/add-stop logic
========================================================= */


if(!window.__SLX_POI_TAP_HITBOX_FIX_V1__){
window.__SLX_POI_TAP_HITBOX_FIX_V1__=true;


function slxEnsurePoiHitLayersV1(){
  if(!mapLoaded||!map){return;}


  try{
    if(map.getSource("slxCorridorStops") && !map.getLayer("slxCorridorStopsHit")){
      map.addLayer({
        id:"slxCorridorStopsHit",
        type:"circle",
        source:"slxCorridorStops",
        paint:{
          "circle-radius":34,
          "circle-color":"rgba(0,0,0,0)"
        }
      });
    }


    if(map.getSource("slxCoolStops") && !map.getLayer("slxCoolStopsHit")){
      map.addLayer({
        id:"slxCoolStopsHit",
        type:"circle",
        source:"slxCoolStops",
        paint:{
          "circle-radius":36,
          "circle-color":"rgba(0,0,0,0)"
        }
      });
    }


    try{ if(map.getLayer("slxCorridorStopsHit")){ map.moveLayer("slxCorridorStopsHit"); } }catch(e1){}
    try{ if(map.getLayer("slxCorridorStopsText")){ map.moveLayer("slxCorridorStopsText"); } }catch(e2){}
    try{ if(map.getLayer("slxCoolStopsHit")){ map.moveLayer("slxCoolStopsHit"); } }catch(e3){}
    try{ if(map.getLayer("slxCoolStopsText")){ map.moveLayer("slxCoolStopsText"); } }catch(e4){}


  }catch(e){}
}


function slxBindPoiHitTapsV1(){
  if(!map||!map.on||map.__slxPoiHitTapBoundV1){return;}
  map.__slxPoiHitTapBoundV1=true;


  function openPoi(e){
    var f,props;


    if(e&&e.preventDefault){e.preventDefault();}
    if(e&&e.originalEvent){
      if(e.originalEvent.stopPropagation){e.originalEvent.stopPropagation();}
      if(e.originalEvent.preventDefault){e.originalEvent.preventDefault();}
      e.originalEvent.cancelBubble=true;
      window.__SLX_BLOCK_NEXT_MAP_PICK__=Date.now()+900;
    }


    if(!e||!e.features||!e.features.length){return false;}


    f=e.features[0];
    props=f.properties||{};


    if(typeof slxShowPoiInfoCardV1==="function"){
      slxShowPoiInfoCardV1(props);
    }else{
      toast(String(props.name||props.type||"Stop"));
    }


    return false;
  }


  try{map.on("click","slxCorridorStopsHit",openPoi);}catch(e1){}
  try{map.on("touchstart","slxCorridorStopsHit",openPoi);}catch(e2){}
  try{map.on("click","slxCorridorStopsDot",openPoi);}catch(e3){}
  try{map.on("touchstart","slxCorridorStopsDot",openPoi);}catch(e4){}
  try{map.on("click","slxCorridorStopsText",openPoi);}catch(e5){}
  try{map.on("touchstart","slxCorridorStopsText",openPoi);}catch(e6){}


  try{map.on("click","slxCoolStopsHit",openPoi);}catch(e7){}
  try{map.on("touchstart","slxCoolStopsHit",openPoi);}catch(e8){}
  try{map.on("click","slxCoolStopsDot",openPoi);}catch(e9){}
  try{map.on("touchstart","slxCoolStopsDot",openPoi);}catch(e10){}
  try{map.on("click","slxCoolStopsText",openPoi);}catch(e11){}
  try{map.on("touchstart","slxCoolStopsText",openPoi);}catch(e12){}
}


/* Block the next blank map-tap destination/add-stop pick after POI tap */
if(typeof chooseSearchResult==="function" && !chooseSearchResult.__slxPoiTapProtectedV1){
  var __oldChooseSearchResultPoiTapV1=chooseSearchResult;


  chooseSearchResult=function(item){
    if(window.__SLX_BLOCK_NEXT_MAP_PICK__ && Date.now()<window.__SLX_BLOCK_NEXT_MAP_PICK__){
      return false;
    }
    return __oldChooseSearchResultPoiTapV1(item);
  };


  chooseSearchResult.__slxPoiTapProtectedV1=true;
}


setTimeout(slxEnsurePoiHitLayersV1,300);
setTimeout(slxEnsurePoiHitLayersV1,900);
setTimeout(slxBindPoiHitTapsV1,1000);
setTimeout(slxEnsurePoiHitLayersV1,1800);


setInterval(function(){
  slxEnsurePoiHitLayersV1();
  slxBindPoiHitTapsV1();
},2200);


window.slxEnsurePoiHitLayersV1=slxEnsurePoiHitLayersV1;


}


/* =========================================================
SLX POI CARD INTELLIGENCE UPGRADE V2
Smarter tap cards for Fuel / Parking / Rest / Food / Service
Fuel price-ready
========================================================= */


if(!window.__SLX_POI_CARD_INTEL_UPGRADE_V2__){
window.__SLX_POI_CARD_INTEL_UPGRADE_V2__=true;


function slxPoiCleanNameV2(props,type){
  var name=String(props.name||"").trim();


  if(name && name.toLowerCase() !== type){
    return name;
  }


  if(type==="fuel"){return "Fuel Stop";}
  if(type==="parking"){return "Truck Parking";}
  if(type==="food"){return "Food Stop";}
  if(type==="service"){return "Service / Repair";}
  if(type==="shopping"){return "Store / Supplies";}
  if(type==="showers"){return "Shower Stop";}
  if(type==="rest"){return "Rest Area";}
  if(type==="national_park"||type==="landmark"){return name||"Cool Stop";}


  return "Corridor Stop";
}


function slxParkingConfidenceCopyV2(zone,risk){
  zone=String(zone||"mid").toLowerCase();
  risk=String(risk||"green").toLowerCase();


  if(risk==="red"){return "Parking pressure high • plan backup stop";}
  if(risk==="amber"){return "Parking may tighten • good planning window";}
  if(zone==="dest"){return "Destination-side parking window";}
  if(zone==="start"){return "Early-route parking option";}
  return "Mid-corridor parking option";
}


function slxFuelPriceTextV2(props){
  var p=props||{};
  var price=p.fuel_price||p.fuelPrice||p.diesel||p.diesel_price||p.price||"";


  if(price){
    return "Diesel: $"+String(price);
  }


  return "Diesel price: pending live feed";
}


function slxPoiIntelSubV2(props,type){
  var zone=String(props.zone||"mid").toUpperCase();
  var risk=String(props.risk||"green").toLowerCase();
  var miles=props.miles_off_route||props.miles||"";


  if(type==="fuel"){
    return zone+" corridor fuel window • Good candidate for route-cost planning.";
  }


  if(type==="parking"){
    return zone+" corridor parking • "+slxParkingConfidenceCopyV2(props.zone,risk)+".";
  }


  if(type==="food"){
    return zone+" corridor food option • Useful break window without leaving route flow.";
  }


  if(type==="service"){
    return zone+" corridor service option • Repair/support marker near the active route.";
  }


  if(type==="shopping"){
    return zone+" corridor supply stop • Store/supplies marker near the route.";
  }


  if(type==="showers"){
    return zone+" corridor shower option • Driver comfort stop marker.";
  }


  if(type==="rest"){
    return zone+" corridor rest area • Good break candidate.";
  }


  if(type==="national_park"||type==="landmark"){
    return (miles ? String(miles)+" mi off route • " : "")+"Scenic corridor marker worth knowing about.";
  }


  return zone+" corridor window • Tap-ready stop intelligence.";
}


/* Override the previous POI card renderer with smarter copy */
window.slxShowPoiInfoCardV1=function(props){
  var card,title,typeEl,sub,price;
  var poiType,name,typeName;


  if(typeof slxInstallPoiInfoCardV1==="function"){
    slxInstallPoiInfoCardV1();
  }


  card=document.getElementById("slxPoiInfoCardV1");
  title=document.getElementById("slxPoiInfoTitleV1");
  typeEl=document.getElementById("slxPoiInfoTypeV1");
  sub=document.getElementById("slxPoiInfoSubV1");
  price=document.getElementById("slxPoiInfoPriceV1");


  if(!card||!title||!typeEl||!sub||!price){return;}


  props=props||{};
  poiType=String(props.type||"parking").toLowerCase();
  name=slxPoiCleanNameV2(props,poiType);


  if(typeof slxPoiTypeNameV1==="function"){
    typeName=slxPoiTypeNameV1(poiType);
  }else{
    typeName=poiType.toUpperCase();
  }


  title.textContent=name;
  typeEl.textContent=String(typeName).toUpperCase();
  sub.textContent=slxPoiIntelSubV2(props,poiType);


  if(poiType==="fuel"){
    price.style.display="inline-flex";
    price.textContent=slxFuelPriceTextV2(props);
  }else if(poiType==="parking"){
    price.style.display="inline-flex";
    price.textContent="Parking confidence: "+String(props.risk||"green").toUpperCase();
  }else{
    price.style.display="none";
  }


  card.classList.add("on");


  clearTimeout(window.__slxPoiInfoTimerV1);
  window.__slxPoiInfoTimerV1=setTimeout(function(){
    if(card){card.classList.remove("on");}
  },7500);
};


}


})();


/* =========================================================
SLX START TRIP — TOAST VISIBILITY LIFT V1
Keeps toast above money panel, under route horizon
========================================================= */


(function(){
"use strict";


if(window.__SLX_START_TRIP_TOAST_LIFT_V1__) return;
window.__SLX_START_TRIP_TOAST_LIFT_V1__=true;


function slxLiftToastV1(){
  var el=document.getElementById("toast");
  if(!el) return;


  el.style.position="fixed";
  el.style.left="28px";
  el.style.right="350px";
  el.style.top="calc(var(--topbar-h) + var(--search-h) + 118px)";
  el.style.bottom="auto";
  el.style.zIndex="99999";
  el.style.pointerEvents="none";
}


var oldToast=window.toast;


if(typeof oldToast==="function" && !oldToast.__slxLiftedV1){
  window.toast=function(msg){
    oldToast(msg);
    setTimeout(slxLiftToastV1,10);
    setTimeout(slxLiftToastV1,80);
  };
  window.toast.__slxLiftedV1=true;
}


setTimeout(slxLiftToastV1,200);
setTimeout(slxLiftToastV1,900);
setInterval(slxLiftToastV1,1200);


})();


/* =========================================================
SLX START TRIP — LAST GOOD GPS ROUTE ORIGIN V1
Uses last successful GPS lock as route origin if fresh enough.
Prevents routing from wrong/default map position.
========================================================= */


(function(){
"use strict";


if(window.__SLX_LAST_GOOD_GPS_ROUTE_ORIGIN_V1__) return;
window.__SLX_LAST_GOOD_GPS_ROUTE_ORIGIN_V1__=true;


var LAST_GOOD_KEY="slx_last_good_gps_route_origin_v1";
var FRESH_MS=2*60*1000;
var USABLE_MS=20*60*1000;


function slxNow(){
  return Date.now?Date.now():(new Date()).getTime();
}


function slxFinite(v){
  v=Number(v);
  return isFinite(v);
}


function slxReadLastGoodGps(){
  try{
    return JSON.parse(localStorage.getItem(LAST_GOOD_KEY)||"null");
  }catch(e){}
  return null;
}


function slxWriteLastGoodGps(fix){
  if(!fix) return;


  var lat=Number(fix.lat||fix.latitude);
  var lng=Number(fix.lng||fix.lon||fix.longitude);


  if(!slxFinite(lat)||!slxFinite(lng)) return;


  try{
    localStorage.setItem(LAST_GOOD_KEY,JSON.stringify({
      lat:lat,
      lng:lng,
      acc:Number(fix.acc||fix.accuracy||0),
      heading:slxFinite(fix.heading)?Number(fix.heading):null,
      speed:slxFinite(fix.speed)?Number(fix.speed):null,
      ts:slxNow()
    }));
  }catch(e){}
}


function slxAgeLabel(ms){
  var min=Math.round(ms/60000);
  if(min<1) return "fresh";
  return String(min)+" min old";
}


function slxGetBestGpsOrigin(){
  var live=null;
  var saved=null;
  var age=999999999;


  try{
    if(typeof getGPS==="function"){
      live=getGPS();
    }
  }catch(e){}


  if(live&&slxFinite(live.lat)&&slxFinite(live.lng)){
    slxWriteLastGoodGps(live);
    return {
      gps:live,
      source:"fresh",
      label:"GPS locked"
    };
  }


  saved=slxReadLastGoodGps();


  if(saved&&slxFinite(saved.lat)&&slxFinite(saved.lng)&&saved.ts){
    age=slxNow()-Number(saved.ts);


    if(age<=USABLE_MS){
      return {
        gps:saved,
        source:age<=FRESH_MS?"fresh_saved":"last_known",
        label:age<=FRESH_MS?"GPS recently locked":"Last known GPS • "+slxAgeLabel(age)
      };
    }
  }


  return null;
}


/* capture successful GPS locks automatically */
if(typeof lockGPS==="function"&&!lockGPS.__slxLastGoodWrappedV1){
  var __oldLockGPSLastGoodV1=lockGPS;


  lockGPS=function(){
    var r=__oldLockGPSLastGoodV1();


    setTimeout(function(){
      try{
        if(typeof getGPS==="function"){
          slxWriteLastGoodGps(getGPS());
        }else if(typeof lastFix!=="undefined"&&lastFix){
          slxWriteLastGoodGps(lastFix);
        }
      }catch(e){}
    },700);


    setTimeout(function(){
      try{
        if(typeof getGPS==="function"){
          slxWriteLastGoodGps(getGPS());
        }else if(typeof lastFix!=="undefined"&&lastFix){
          slxWriteLastGoodGps(lastFix);
        }
      }catch(e){}
    },1800);


    return r;
  };


  lockGPS.__slxLastGoodWrappedV1=true;
}


/* make getGPS fallback to last good GPS */
if(typeof getGPS==="function"&&!getGPS.__slxLastGoodFallbackV1){
  var __oldGetGPSLastGoodV1=getGPS;


  getGPS=function(){
    var gps=__oldGetGPSLastGoodV1();
    var saved,age;


    if(gps&&slxFinite(gps.lat)&&slxFinite(gps.lng)){
      slxWriteLastGoodGps(gps);
      return gps;
    }


    saved=slxReadLastGoodGps();


    if(saved&&slxFinite(saved.lat)&&slxFinite(saved.lng)&&saved.ts){
      age=slxNow()-Number(saved.ts);


      if(age<=USABLE_MS){
        saved.lastKnown=1;
        saved.ageMs=age;
        return saved;
      }
    }


    return gps;
  };


  getGPS.__slxLastGoodFallbackV1=true;
}


/* soften Route Now behavior: use last-known GPS, require relock only if stale */
if(typeof routeNow==="function"&&!routeNow.__slxLastGoodRouteNowV1){
  var __oldRouteNowLastGoodV1=routeNow;


  routeNow=function(){
    var best=slxGetBestGpsOrigin();


    if(!best){
      toast("Tap LOCK GPS first");
      setStatus("Need GPS", "red");
      return false;
    }


    try{
      if(typeof lastFix!=="undefined"){
        lastFix={
          lat:Number(best.gps.lat),
          lng:Number(best.gps.lng),
          acc:Number(best.gps.acc||0),
          ts:Number(best.gps.ts||slxNow()),
          heading:slxFinite(best.gps.heading)?Number(best.gps.heading):null,
          speed:slxFinite(best.gps.speed)?Number(best.gps.speed):null
        };
      }
    }catch(e){}


    if(best.source==="last_known"){
      setStatus(best.label, "gold");
      toast(best.label);
    }


    return __oldRouteNowLastGoodV1();
  };


  routeNow.__slxLastGoodRouteNowV1=true;
}


/* add small saved-GPS cue on boot */
setTimeout(function(){
  var best=slxGetBestGpsOrigin();
  if(best&&best.source==="last_known"){
    try{ setGpsPill(best.label); }catch(e){}
  }
},900);


window.slxGetBestGpsOriginV1=slxGetBestGpsOrigin;
window.slxWriteLastGoodGpsV1=slxWriteLastGoodGps;


})();


/* =========================================================
SLX START TRIP — RECENT TRIPS + DOCK INTELLIGENCE V1
Local-first destination memory + dock notes
========================================================= */


(function(){
"use strict";


if(window.__SLX_RECENT_TRIPS_DOCK_INTEL_V1__) return;
window.__SLX_RECENT_TRIPS_DOCK_INTEL_V1__=true;


var RECENT_KEY="slx_recent_destinations_v1";
var DOCK_KEY="slx_dock_intelligence_notes_v1";


function slxRTParse(v){
  try{return JSON.parse(String(v||""));}catch(e){}
  return null;
}


function slxRTFinite(v){
  v=Number(v);
  return isFinite(v);
}


function slxRTNorm(s){
  return String(s||"").toLowerCase().replace(/[^a-z0-9]+/g," ").replace(/^\s+|\s+$/g,"");
}


function slxRTDestKey(d){
  var label=slxRTNorm(d&&d.label||d&&d.full||"");
  var lat=d&&slxRTFinite(d.lat)?Number(d.lat).toFixed(3):"";
  var lng=d&&slxRTFinite(d.lng)?Number(d.lng).toFixed(3):"";
  return label+"_"+lat+"_"+lng;
}


function slxGetRecentTrips(){
  return slxRTParse(localStorage.getItem(RECENT_KEY))||[];
}


function slxSaveRecentTrip(d){
  var list,key,out,i,item;


  if(!d||!slxRTFinite(d.lat)||!slxRTFinite(d.lng)) return;


  key=slxRTDestKey(d);
  list=slxGetRecentTrips();
  out=[{
    key:key,
    lat:Number(d.lat),
    lng:Number(d.lng),
    label:String(d.label||"Destination"),
    full:String(d.full||d.label||""),
    saved_at:new Date().toISOString()
  }];


  for(i=0;i<list.length;i++){
    item=list[i];
    if(item&&item.key!==key){out.push(item);}
    if(out.length>=5) break;
  }


  try{localStorage.setItem(RECENT_KEY,JSON.stringify(out));}catch(e){}
}


function slxGetDockNotes(){
  return slxRTParse(localStorage.getItem(DOCK_KEY))||{};
}


function slxSaveDockNoteForDest(d,note){
  var all,key;


  if(!d||!note) return;


  all=slxGetDockNotes();
  key=slxRTDestKey(d);


  all[key]={
    key:key,
    label:String(d.label||"Destination"),
    full:String(d.full||d.label||""),
    lat:Number(d.lat),
    lng:Number(d.lng),
    note:String(note||""),
    updated_at:new Date().toISOString()
  };


  try{localStorage.setItem(DOCK_KEY,JSON.stringify(all));}catch(e){}
}


function slxGetDockNoteForDest(d){
  var all,key;


  if(!d) return null;


  all=slxGetDockNotes();
  key=slxRTDestKey(d);


  return all[key]||null;
}


function slxInstallRecentDockUI(){
  var box, dock, input;


  input=$("destInput");
  if(!input) return;


  if(!document.getElementById("slxRecentDockStyleV1")){
    var st=document.createElement("style");
    st.id="slxRecentDockStyleV1";
    st.textContent=
      "#slxRecentTripsV1{position:fixed;left:12px;right:74px;top:calc(var(--topbar-h) + var(--search-h) + 112px);z-index:210;display:none;border-radius:18px;background:rgba(8,14,22,.92);border:1px solid rgba(0,255,176,.22);box-shadow:0 18px 42px rgba(0,0,0,.42);backdrop-filter:blur(16px);-webkit-backdrop-filter:blur(16px);padding:10px;color:#fff;}"+
      "#slxRecentTripsV1.on{display:block;}"+
      ".slxRecentTitle{font-size:10px;font-weight:1000;letter-spacing:.12em;color:#9bffd7;margin-bottom:7px;}"+
      ".slxRecentRow{min-height:38px;display:flex;align-items:center;justify-content:space-between;gap:8px;border-radius:13px;padding:7px 9px;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.08);margin-bottom:6px;}"+
      ".slxRecentMain{font-size:12px;font-weight:950;color:#fff;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"+
      ".slxRecentSub{font-size:10px;font-weight:750;color:rgba(255,255,255,.62);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"+
      ".slxRecentDockBadge{font-size:9px;font-weight:1000;color:#ffe2a2;border:1px solid rgba(255,205,105,.28);border-radius:999px;padding:4px 7px;white-space:nowrap;}"+
      "#slxDockIntelV1{position:fixed;left:14px;right:150px;bottom:calc(252px + env(safe-area-inset-bottom,0px));z-index:310;display:none;border-radius:18px;background:rgba(8,14,22,.93);border:1px solid rgba(255,205,105,.30);box-shadow:0 18px 42px rgba(0,0,0,.42),0 0 24px rgba(255,205,105,.10);padding:11px;color:#fff;}"+
      "#slxDockIntelV1.on{display:block;}"+
      ".slxDockTitle{font-size:10px;font-weight:1000;letter-spacing:.12em;color:#ffe2a2;margin-bottom:6px;}"+
      ".slxDockNote{font-size:11px;font-weight:850;line-height:1.35;color:rgba(255,255,255,.82);margin-bottom:8px;}"+
      ".slxDockBtn{height:30px;border-radius:999px;border:1px solid rgba(0,255,176,.30);background:rgba(0,255,176,.10);color:#9bffd7;font-size:10px;font-weight:1000;padding:0 10px;margin-right:6px;}";
    document.head.appendChild(st);
  }


  box=document.getElementById("slxRecentTripsV1");
  if(!box){
    box=document.createElement("div");
    box.id="slxRecentTripsV1";
    document.body.appendChild(box);
  }


  dock=document.getElementById("slxDockIntelV1");
  if(!dock){
    dock=document.createElement("div");
    dock.id="slxDockIntelV1";
    document.body.appendChild(dock);
  }
}


function slxRenderRecentTrips(){
  var box=document.getElementById("slxRecentTripsV1");
  var list=slxGetRecentTrips();
  var notes=slxGetDockNotes();
  var html=[],i,item,hasDock;


  if(!box) return;


  if(!list.length){
    box.classList.remove("on");
    return;
  }


  html.push('<div class="slxRecentTitle">RECENT DESTINATIONS</div>');


  for(i=0;i<list.length;i++){
    item=list[i];
    hasDock=!!notes[item.key];


    html.push(
      '<div class="slxRecentRow" data-slx-recent-index="'+i+'">'+
        '<div style="min-width:0;">'+
          '<div class="slxRecentMain">'+String(item.label||"Destination")+'</div>'+
          '<div class="slxRecentSub">'+String(item.full||"Tap to reuse")+'</div>'+
        '</div>'+
        (hasDock?'<div class="slxRecentDockBadge">DOCK</div>':'')+
      '</div>'
    );
  }


  box.innerHTML=html.join("");
  box.classList.add("on");


  setTimeout(slxBindRecentRows,50);
}


function slxBindRecentRows(){
  var rows=document.querySelectorAll("#slxRecentTripsV1 .slxRecentRow");
  var list=slxGetRecentTrips();


  for(var i=0;i<rows.length;i++){
    if(rows[i].__slxRecentBound) continue;
    rows[i].__slxRecentBound=true;


    rows[i].onclick=(function(idx){
      return function(e){
        var item=list[idx];
        if(e&&e.preventDefault){e.preventDefault();}
        if(!item) return false;


        dest={
          lat:Number(item.lat),
          lng:Number(item.lng),
          label:String(item.label||"Destination"),
          full:String(item.full||item.label||"")
        };


        searchTarget="dest";
        clearRouteStateOnly();
        syncUiFromState();
        clearResults();
        saveDriverHandoffPayload();
        highlightRouteNow();
        setStatus("Recent destination set","green");
        toast("Recent destination set");


        var box=document.getElementById("slxRecentTripsV1");
        if(box){box.classList.remove("on");}


        slxShowDockIntelForDest(dest);
        return false;
      };
    })(i);
  }
}


function slxShowDockIntelForDest(d){
  var dock=document.getElementById("slxDockIntelV1");
  var note=slxGetDockNoteForDest(d);


  if(!dock) return;


  if(!d){
    dock.classList.remove("on");
    return;
  }


  dock.innerHTML =
    '<div class="slxDockTitle">DOCK INTELLIGENCE</div>'+
    '<div class="slxDockNote">'+
      (note&&note.note ? String(note.note) : 'No dock note saved yet for this destination.')+
    '</div>'+
    '<button id="slxAddDockNoteBtnV1" class="slxDockBtn" type="button">'+(note&&note.note?'EDIT DOCK NOTE':'ADD DOCK NOTE')+'</button>'+
    '<button id="slxHideDockNoteBtnV1" class="slxDockBtn" type="button">HIDE</button>';


  dock.classList.add("on");


  setTimeout(function(){
    var add=$("slxAddDockNoteBtnV1");
    var hide=$("slxHideDockNoteBtnV1");


    if(add){
      add.onclick=function(e){
        var current=slxGetDockNoteForDest(dest);
        var val=prompt("Dock / entrance note for this destination:", current&&current.note?current.note:"Truck entrance / dock / guard shack notes");
        if(val&&String(val).replace(/\s+/g,"")){
          slxSaveDockNoteForDest(dest,val);
          slxShowDockIntelForDest(dest);
          saveDriverHandoffPayload();
          toast("Dock note saved");
        }
        return false;
      };
    }


    if(hide){
      hide.onclick=function(){
        dock.classList.remove("on");
        return false;
      };
    }
  },50);
}


/* save destination whenever one is picked */
if(typeof chooseDestination==="function"&&!chooseDestination.__slxRecentDockWrappedV1){
  var __oldChooseDestinationRecentDockV1=chooseDestination;


  chooseDestination=function(item){
    __oldChooseDestinationRecentDockV1(item);


    try{
      if(dest){
        slxSaveRecentTrip(dest);
        slxShowDockIntelForDest(dest);
      }
    }catch(e){}
  };


  chooseDestination.__slxRecentDockWrappedV1=true;
}


/* also save when route becomes ready, in case dest was restored */
if(typeof saveDriverHandoffPayload==="function"&&!saveDriverHandoffPayload.__slxDockIntelWrappedV1){
  var __oldSavePayloadDockIntelV1=saveDriverHandoffPayload;


  saveDriverHandoffPayload=function(){
    try{
      if(dest){slxSaveRecentTrip(dest);}


      var note=dest?slxGetDockNoteForDest(dest):null;
      if(note){
        var payload=slxRTParse(localStorage.getItem(LS.START_PAYLOAD))||{};
        payload.dock_intelligence=note;
        payload.dock_note=note.note;
        localStorage.setItem(LS.START_PAYLOAD,JSON.stringify(payload));
      }
    }catch(e){}


    __oldSavePayloadDockIntelV1();
  };


  saveDriverHandoffPayload.__slxDockIntelWrappedV1=true;
}


function slxBindRecentSearchFocus(){
  var input=$("destInput");
  if(!input||input.__slxRecentFocusBoundV1) return;


  input.__slxRecentFocusBoundV1=true;


  input.addEventListener("focus",function(){
    if(String(input.value||"").replace(/\s+/g,"").length<2){
      slxRenderRecentTrips();
    }
  },false);


  input.addEventListener("input",function(){
    var box=document.getElementById("slxRecentTripsV1");
    if(!box) return;


    if(String(input.value||"").replace(/\s+/g,"").length>=2){
      box.classList.remove("on");
    }else{
      slxRenderRecentTrips();
    }
  },false);
}


document.addEventListener("click",function(e){
  var box=document.getElementById("slxRecentTripsV1");
  var input=$("destInput");


  if(!box||!box.classList.contains("on")) return;
  if(e.target===box||box.contains(e.target)||e.target===input) return;


  box.classList.remove("on");
},false);


setTimeout(slxInstallRecentDockUI,300);
setTimeout(slxBindRecentSearchFocus,500);
setTimeout(function(){
  if(dest){slxShowDockIntelForDest(dest);}
},1300);


window.slxRenderRecentTripsV1=slxRenderRecentTrips;
window.slxShowDockIntelForDestV1=slxShowDockIntelForDest;
window.slxSaveDockNoteForDestV1=slxSaveDockNoteForDest;


})();


/* =========================================================
SLX START TRIP — DOCK INTELLIGENCE PANEL V2
Manual dock / entrance / guard shack notes for destinations
========================================================= */


(function(){
"use strict";


if(window.__SLX_DOCK_INTELLIGENCE_PANEL_V2__) return;
window.__SLX_DOCK_INTELLIGENCE_PANEL_V2__=true;


var DOCK_KEY="slx_dock_intelligence_notes_v2";


function slxDockParse(v){
  try{return JSON.parse(String(v||""));}catch(e){}
  return null;
}


function slxDockNorm(s){
  return String(s||"").toLowerCase().replace(/[^a-z0-9]+/g," ").replace(/^\s+|\s+$/g,"");
}


function slxDockDestKey(d){
  if(!d) return "";
  return slxDockNorm(d.label||d.full||"destination")+"_"+Number(d.lat||0).toFixed(3)+"_"+Number(d.lng||0).toFixed(3);
}


function slxDockAll(){
  return slxDockParse(localStorage.getItem(DOCK_KEY))||{};
}


function slxDockGet(d){
  var all=slxDockAll();
  return all[slxDockDestKey(d)]||null;
}


function slxDockSave(d,note){
  var all,key;


  if(!d||!note) return;


  key=slxDockDestKey(d);
  all=slxDockAll();


  all[key]={
    key:key,
    label:String(d.label||"Destination"),
    full:String(d.full||d.label||""),
    lat:Number(d.lat),
    lng:Number(d.lng),
    note:String(note),
    updated_at:new Date().toISOString()
  };


  localStorage.setItem(DOCK_KEY,JSON.stringify(all));
}


function slxDockInstall(){
  var st,card;


  if(!document.getElementById("slxDockIntelStyleV2")){
    st=document.createElement("style");
    st.id="slxDockIntelStyleV2";
    st.textContent=
      "#slxDockIntelCardV2{position:fixed;left:14px;right:150px;bottom:calc(252px + env(safe-area-inset-bottom,0px));z-index:335;display:none;border-radius:18px;background:rgba(8,14,22,.94);border:1px solid rgba(255,205,105,.32);box-shadow:0 18px 42px rgba(0,0,0,.44),0 0 26px rgba(255,205,105,.12);backdrop-filter:blur(16px);-webkit-backdrop-filter:blur(16px);padding:11px;color:#fff;}"+
      "#slxDockIntelCardV2.on{display:block;}"+
      ".slxDockHeadV2{font-size:10px;font-weight:1000;letter-spacing:.12em;color:#ffe2a2;margin-bottom:6px;}"+
      ".slxDockBodyV2{font-size:11px;font-weight:850;line-height:1.35;color:rgba(255,255,255,.84);margin-bottom:9px;}"+
      ".slxDockBtnV2{height:30px;border-radius:999px;border:1px solid rgba(0,255,176,.30);background:rgba(0,255,176,.10);color:#9bffd7;font-size:10px;font-weight:1000;padding:0 10px;margin-right:6px;}";
    document.head.appendChild(st);
  }


  if(!document.getElementById("slxDockIntelCardV2")){
    card=document.createElement("div");
    card.id="slxDockIntelCardV2";
    document.body.appendChild(card);
  }
}


function slxDockRender(){
  var card,note,body;


  slxDockInstall();


  card=document.getElementById("slxDockIntelCardV2");
  if(!card) return;


  if(!dest){
    card.classList.remove("on");
    return;
  }


  note=slxDockGet(dest);


  body=note&&note.note ?
    note.note :
    "No dock note saved yet. Add truck entrance, guard shack, gate, dock, or approach notes.";


  card.innerHTML=
    '<div class="slxDockHeadV2">DOCK INTELLIGENCE</div>'+
    '<div class="slxDockBodyV2">'+body+'</div>'+
    '<button id="slxDockAddBtnV2" class="slxDockBtnV2" type="button">'+(note&&note.note?'EDIT NOTE':'ADD NOTE')+'</button>'+
    '<button id="slxDockHideBtnV2" class="slxDockBtnV2" type="button">HIDE</button>';


  card.classList.add("on");


  setTimeout(function(){
    var add=document.getElementById("slxDockAddBtnV2");
    var hide=document.getElementById("slxDockHideBtnV2");


    if(add){
      add.onclick=function(e){
        var current=slxDockGet(dest);
        var val;


        if(e&&e.preventDefault){e.preventDefault();}


        val=prompt(
          "Dock / entrance note:",
          current&&current.note ? current.note : "Truck entrance, guard shack, dock number, approach side..."
        );


        if(val&&String(val).replace(/\s+/g,"")){
          slxDockSave(dest,val);
          slxDockRender();
          try{saveDriverHandoffPayload();}catch(x){}
          toast("Dock note saved");
        }


        return false;
      };
    }


    if(hide){
      hide.onclick=function(){
        card.classList.remove("on");
        return false;
      };
    }
  },50);
}


if(typeof chooseDestination==="function"&&!chooseDestination.__slxDockV2Wrapped){
  var oldChooseDestinationDockV2=chooseDestination;


  chooseDestination=function(item){
    oldChooseDestinationDockV2(item);
    setTimeout(slxDockRender,120);
  };


  chooseDestination.__slxDockV2Wrapped=true;
}


if(typeof saveDriverHandoffPayload==="function"&&!saveDriverHandoffPayload.__slxDockV2Payload){
  var oldSaveDockPayloadV2=saveDriverHandoffPayload;


  saveDriverHandoffPayload=function(){
    var note;


    oldSaveDockPayloadV2();


    try{
      note=dest?slxDockGet(dest):null;


      if(note){
        var payload=slxDockParse(localStorage.getItem(LS.START_PAYLOAD))||{};
        payload.dock_intelligence=note;
        payload.dock_note=note.note;
        localStorage.setItem(LS.START_PAYLOAD,JSON.stringify(payload));
      }
    }catch(e){}
  };


  saveDriverHandoffPayload.__slxDockV2Payload=true;
}


setTimeout(slxDockInstall,300);
setTimeout(function(){
  if(dest){slxDockRender();}
},1200);


window.slxDockRenderV2=slxDockRender;
window.slxDockSaveV2=slxDockSave;


})();


/* =========================================================
SLX START TRIP — DOCK INTEL HANDOFF LOCK V3
Ensures saved dock notes are stored into Start Trip payload
so Driver Mode can read them during arrival.
========================================================= */


(function(){
"use strict";


if(window.__SLX_START_TRIP_DOCK_HANDOFF_LOCK_V3__) return;
window.__SLX_START_TRIP_DOCK_HANDOFF_LOCK_V3__=true;


var DOCK_KEYS=[
  "slx_dock_intelligence_notes_v1",
  "slx_dock_intelligence_notes_v2"
];


function slxDockParse(v){
  try{return JSON.parse(String(v||""));}catch(e){}
  return null;
}


function slxDockNorm(s){
  return String(s||"").toLowerCase().replace(/[^a-z0-9]+/g," ").replace(/^\s+|\s+$/g,"");
}


function slxDockDestKey(d){
  if(!d) return "";
  return slxDockNorm(d.label||d.full||"destination")+"_"+Number(d.lat||0).toFixed(3)+"_"+Number(d.lng||0).toFixed(3);
}


function slxFindDockNoteForDest(d){
  var key=slxDockDestKey(d);
  var i,all,note,k;


  if(!d||!key) return null;


  for(i=0;i<DOCK_KEYS.length;i++){
    all=slxDockParse(localStorage.getItem(DOCK_KEYS[i]));
    if(!all) continue;


    if(all[key]&&all[key].note){
      return all[key];
    }


    for(k in all){
      if(all.hasOwnProperty(k)&&all[k]&&all[k].note){
        if(String(k)===key){return all[k];}
      }
    }
  }


  return null;
}


function slxApplyDockIntelToPayload(){
  var note,payload;


  try{
    if(!dest){return;}


    note=slxFindDockNoteForDest(dest);


    payload=slxDockParse(localStorage.getItem(LS.START_PAYLOAD))||{};


    if(note&&note.note){
      payload.dock_intelligence=note;
      payload.dock_note=String(note.note);
      payload.dock_note_available=1;
      localStorage.setItem("slx_active_dock_note_v1",String(note.note));
    }else{
      payload.dock_note_available=0;
    }


    localStorage.setItem(LS.START_PAYLOAD,JSON.stringify(payload));
    localStorage.setItem("slx_start_trip_payload",JSON.stringify(payload));
  }catch(e){}
}


if(typeof saveDriverHandoffPayload==="function"&&!saveDriverHandoffPayload.__slxDockHandoffV3){
  var oldSaveDockHandoffV3=saveDriverHandoffPayload;


  saveDriverHandoffPayload=function(){
    oldSaveDockHandoffV3();
    slxApplyDockIntelToPayload();
  };


  saveDriverHandoffPayload.__slxDockHandoffV3=true;
}


if(typeof chooseDestination==="function"&&!chooseDestination.__slxDockHandoffChooseV3){
  var oldChooseDockHandoffV3=chooseDestination;


  chooseDestination=function(item){
    oldChooseDockHandoffV3(item);
    setTimeout(slxApplyDockIntelToPayload,100);
    setTimeout(slxApplyDockIntelToPayload,600);
  };


  chooseDestination.__slxDockHandoffChooseV3=true;
}


if(typeof routeNow==="function"&&!routeNow.__slxDockHandoffRouteV3){
  var oldRouteDockHandoffV3=routeNow;


  routeNow=function(){
    slxApplyDockIntelToPayload();
    return oldRouteDockHandoffV3();
  };


  routeNow.__slxDockHandoffRouteV3=true;
}


setTimeout(slxApplyDockIntelToPayload,700);
setTimeout(slxApplyDockIntelToPayload,1800);


window.slxApplyDockIntelToPayloadV3=slxApplyDockIntelToPayload;


})();


/* =========================================================
SLX START TRIP — SCAN STOPS ENGINE RECOVERY V1
Restores Scan Stops button + fallback POI pins if scanner got overwritten
========================================================= */


(function(){
"use strict";


if(window.__SLX_SCAN_STOPS_ENGINE_RECOVERY_V1__) return;
window.__SLX_SCAN_STOPS_ENGINE_RECOVERY_V1__=true;


function slxScanToast(msg){
  try{
    if(typeof toast==="function"){toast(msg);return;}
  }catch(e){}


  var el=document.createElement("div");
  el.textContent=msg;
  el.style.position="fixed";
  el.style.left="86px";
  el.style.top="48%";
  el.style.zIndex="99999";
  el.style.padding="10px 12px";
  el.style.borderRadius="18px";
  el.style.background="rgba(0,0,0,.72)";
  el.style.color="#fff";
  el.style.fontSize="13px";
  el.style.fontWeight="900";
  el.style.pointerEvents="none";
  document.body.appendChild(el);


  setTimeout(function(){
    if(el&&el.parentNode){el.parentNode.removeChild(el);}
  },1500);
}


function slxGetRouteCoords(){
  try{
    if(routeGeo && routeGeo.features && routeGeo.features[0] &&
       routeGeo.features[0].geometry && routeGeo.features[0].geometry.coordinates){
      return routeGeo.features[0].geometry.coordinates;
    }
  }catch(e){}
  return null;
}


function slxEnsureFallbackPoiSource(){
  if(!mapLoaded||!map){return;}


  try{
    if(!map.getSource("slxCorridorStops")){
      map.addSource("slxCorridorStops",{
        type:"geojson",
        data:{type:"FeatureCollection",features:[]}
      });
    }


    if(!map.getLayer("slxCorridorStopsGlow")){
      map.addLayer({
        id:"slxCorridorStopsGlow",
        type:"circle",
        source:"slxCorridorStops",
        paint:{
          "circle-radius":24,
          "circle-color":["case",
            ["==",["get","type"],"parking"],"rgba(41,223,255,.36)",
            ["==",["get","type"],"fuel"],"rgba(46,134,255,.36)",
            ["==",["get","type"],"food"],"rgba(39,240,138,.36)",
            ["==",["get","type"],"service"],"rgba(255,139,47,.38)",
            ["==",["get","type"],"store"],"rgba(141,85,255,.38)",
            ["==",["get","type"],"shower"],"rgba(255,80,135,.40)",
            ["==",["get","type"],"rest"],"rgba(80,230,255,.38)",
            "rgba(41,223,255,.34)"
          ],
          "circle-blur":0.64
        }
      });
    }


    if(!map.getLayer("slxCorridorStopsDot")){
      map.addLayer({
        id:"slxCorridorStopsDot",
        type:"circle",
        source:"slxCorridorStops",
        paint:{
          "circle-radius":14,
          "circle-color":"rgba(8,14,22,.96)",
          "circle-stroke-width":3.25,
          "circle-stroke-color":["case",
            ["==",["get","type"],"parking"],"rgba(41,223,255,1)",
            ["==",["get","type"],"fuel"],"rgba(46,134,255,1)",
            ["==",["get","type"],"food"],"rgba(39,240,138,1)",
            ["==",["get","type"],"service"],"rgba(255,139,47,1)",
            ["==",["get","type"],"store"],"rgba(141,85,255,1)",
            ["==",["get","type"],"shower"],"rgba(255,80,135,1)",
            ["==",["get","type"],"rest"],"rgba(80,230,255,1)",
            "rgba(150,255,214,1)"
          ]
        }
      });
    }


    if(!map.getLayer("slxCorridorStopsText")){
      map.addLayer({
        id:"slxCorridorStopsText",
        type:"symbol",
        source:"slxCorridorStops",
        layout:{
          "text-field":["get","label"],
          "text-size":14,
          "text-font":["Open Sans Bold","Arial Unicode MS Bold"],
          "text-allow-overlap":true,
          "text-ignore-placement":true
        },
        paint:{
          "text-color":"#ffffff",
          "text-halo-color":"rgba(0,0,0,.90)",
          "text-halo-width":1.8
        }
      });
    }
  }catch(e){}
}


function slxFallbackScanStops(){
  var coords=slxGetRouteCoords();
  var features=[];
  var types=[
    ["parking","P",0.030,0.014],
    ["fuel","F",-0.028,0.013],
    ["food","E",0.022,-0.018],
    ["service","S",-0.022,-0.016],
    ["store","M",0.038,-0.010],
    ["shower","W",-0.036,0.022],
    ["rest","R",0.014,0.032]
  ];
  var i,j,idx,pt,t,wave;


  if(!coords||coords.length<3){
    slxScanToast("Route not ready");
    return;
  }


  for(i=1;i<=14;i++){
    idx=Math.floor((coords.length-1)*(i/15));
    pt=coords[idx];
    if(!pt){continue;}


    wave=i%2===0?1:-1;


    for(j=0;j<types.length;j++){
      t=types[j];


      if(t[0]==="store" && i%3===0){continue;}
      if(t[0]==="food" && i%4===1){continue;}
      if(t[0]==="shower" && i%4===0){continue;}


      features.push({
        type:"Feature",
        geometry:{
          type:"Point",
          coordinates:[
            Number(pt[0]) + (t[2]*wave),
            Number(pt[1]) + t[3]
          ]
        },
        properties:{
type:t[0],
label:t[1],
zone:i<5?"start":i>10?"dest":"mid",
name:t[0]+" window",
main:t[0]+" stop",
sub:"Corridor stop preview",
source:"scan_stops",
risk:"green"
}
      });
    }
  }


  features=features.slice(0,64);


  slxEnsureFallbackPoiSource();


  try{
    if(map&&map.getSource("slxCorridorStops")){
      map.getSource("slxCorridorStops").setData({
        type:"FeatureCollection",
        features:features
      });
    }


    localStorage.setItem("slx_corridor_stop_preview_v1",JSON.stringify({
      updated_at:new Date().toISOString(),
      features:features
    }));


    slxScanToast("Corridor stops ready");
  }catch(e){
    slxScanToast("Scan failed");
  }
}


function slxHardRebindScanButton(){
  var btn=document.getElementById("btnScanStops");
  var rail=document.querySelector(".rightRailBottom");


  if(!btn&&rail){
    btn=document.createElement("button");
    btn.id="btnScanStops";
    btn.className="edgeBtn btn";
    btn.type="button";
    btn.textContent="SCAN STOPS";
    btn.style.borderColor="rgba(0,255,176,.28)";
    btn.style.color="#9bffd7";
    rail.insertBefore(btn,rail.firstChild);
  }


  if(!btn){return;}


  btn.onclick=function(e){
    if(e&&e.preventDefault){e.preventDefault();}
    if(e&&e.stopPropagation){e.stopPropagation();}


    if(typeof window.slxScanCorridorStops==="function"){
      try{
        window.slxScanCorridorStops();
        return false;
      }catch(err){}
    }


    slxFallbackScanStops();
    return false;
  };
}


setTimeout(slxHardRebindScanButton,200);
setTimeout(slxHardRebindScanButton,800);
setTimeout(slxHardRebindScanButton,1600);
setInterval(slxHardRebindScanButton,2500);


window.slxFallbackScanStopsV1=slxFallbackScanStops;
window.slxHardRebindScanButtonV1=slxHardRebindScanButton;


function slxInstallScanStopTapTester(){
if(!mapLoaded || !map){ return; }


try{
if(window.__SLX_SCAN_STOP_TAP_TESTER_V1__){ return; }
window.__SLX_SCAN_STOP_TAP_TESTER_V1__ = true;


map.on("click", "slxCorridorStopsDot", function(e){
var f = e && e.features && e.features[0] ? e.features[0] : null;
var p = f && f.properties ? f.properties : null;


if(!p){ return; }


slxScanToast("Tapped " + String(p.main || p.name || p.type || "stop"));
console.log("[SLX SCAN STOP TAP]", p);
});


map.on("mouseenter", "slxCorridorStopsDot", function(){
try{ map.getCanvas().style.cursor = "pointer"; }catch(e1){}
});


map.on("mouseleave", "slxCorridorStopsDot", function(){
try{ map.getCanvas().style.cursor = ""; }catch(e2){}
});


}catch(e){}
}


setTimeout(slxInstallScanStopTapTester,1200);
setTimeout(slxInstallScanStopTapTester,2400);
setInterval(slxInstallScanStopTapTester,4000);


window.slxInstallScanStopTapTesterV1 = slxInstallScanStopTapTester;


})();


/* =========================================================
SLX SCAN ENGINE AUTO-GUARD
Ensures corridor pins always appear even if scan engine delays
========================================================= */


(function(){


if(window.__SLX_SCAN_ENGINE_GUARD__) return;
window.__SLX_SCAN_ENGINE_GUARD__=true;


setTimeout(function(){


  if(typeof window.slxScanCorridorStops!=="function"){
    if(typeof window.slxFallbackScanStopsV1==="function"){
      window.slxFallbackScanStopsV1();
    }
  }


},900);


})();


/* =========================================================
SLX POI INFO CARD — STRICT PIN ONLY GUARD V2
Cards can only open after a verified POI-layer tap.
Blocks accidental map/zoom/pan card popups.
========================================================= */


(function(){
"use strict";


if(window.__SLX_POI_STRICT_PIN_ONLY_GUARD_V2__) return;
window.__SLX_POI_STRICT_PIN_ONLY_GUARD_V2__=true;


var allowCardUntil=0;
var blockCardUntil=0;
var lastX=0;
var lastY=0;
var downX=0;
var downY=0;
var downAt=0;


function now(){
  return Date.now?Date.now():(new Date()).getTime();
}


function pointFromEvent(e){
  var oe=e&&e.originalEvent?e.originalEvent:e;
  var t;


  if(oe&&oe.touches&&oe.touches.length){t=oe.touches[0];}
  else if(oe&&oe.changedTouches&&oe.changedTouches.length){t=oe.changedTouches[0];}
  else{t=oe;}


  return {
    x:Number(t&&t.clientX||0),
    y:Number(t&&t.clientY||0)
  };
}


function hidePoiCards(){
  var cards=document.querySelectorAll(
    "#slxPoiInfoCard,#slxStopInfoCard,#slxCorridorInfoCard,#slxCoolStopInfo,"+
    ".slxPoiInfoCard,.slxStopInfoCard,.slxCorridorInfoCard,.slxCoolStopInfo"
  );
  var i;


  for(i=0;i<cards.length;i++){
    cards[i].classList.remove("on");
    cards[i].style.display="none";
    cards[i].style.pointerEvents="none";
  }
}


function blockCards(ms){
  blockCardUntil=now()+Number(ms||800);
  hidePoiCards();
}


function allowCards(ms){
  allowCardUntil=now()+Number(ms||500);
}


function cardAllowed(){
  return now()<allowCardUntil && now()>blockCardUntil;
}


function installMapBlockers(){
  if(!map||map.__slxStrictPoiBlockersV2) return;
  map.__slxStrictPoiBlockersV2=true;


  try{map.on("dragstart",function(){blockCards(1200);});}catch(e){}
  try{map.on("zoomstart",function(){blockCards(1200);});}catch(e1){}
  try{map.on("movestart",function(){blockCards(900);});}catch(e2){}
  try{map.on("rotatestart",function(){blockCards(1200);});}catch(e3){}
  try{map.on("pitchstart",function(){blockCards(1200);});}catch(e4){}
  try{map.on("touchmove",function(){blockCards(1200);});}catch(e5){}
  try{map.on("wheel",function(){blockCards(1200);});}catch(e6){}


  try{
    map.on("click",function(e){
      if(!cardAllowed()){
        hidePoiCards();
      }
    });
  }catch(e7){}
}


function installPinAllowList(){
  if(!map||map.__slxStrictPoiAllowV2) return;
  map.__slxStrictPoiAllowV2=true;


  var layers=[
    "slxCorridorStopsDot",
    "slxCorridorStopsText",
    "slxCoolStopsDot",
    "slxCoolStopsText"
  ];


  function bind(layer){
    try{
      map.on("mousedown",layer,function(e){
        var p=pointFromEvent(e);
        downX=p.x;
        downY=p.y;
        downAt=now();
      });
    }catch(e1){}


    try{
      map.on("touchstart",layer,function(e){
        var p=pointFromEvent(e);
        downX=p.x;
        downY=p.y;
        downAt=now();
      });
    }catch(e2){}


    try{
      map.on("click",layer,function(e){
        var p=pointFromEvent(e);
        var dx=Math.abs(p.x-downX);
        var dy=Math.abs(p.y-downY);
        var dt=now()-downAt;


        if(dx<=6 && dy<=6 && dt<=450 && now()>blockCardUntil){
          allowCards(700);
        }else{
          blockCards(1000);
          if(e&&e.preventDefault){e.preventDefault();}
          if(e&&e.originalEvent&&e.originalEvent.stopPropagation){
            e.originalEvent.stopPropagation();
          }
          return false;
        }
      });
    }catch(e3){}
  }


  for(var i=0;i<layers.length;i++){
    bind(layers[i]);
  }
}


/* Mutation watcher: if a card appears without permission, kill it instantly */
function installCardWatchdog(){
  if(window.__slxPoiCardWatchdogV2) return;
  window.__slxPoiCardWatchdogV2=true;


  try{
    var obs=new MutationObserver(function(){
      if(!cardAllowed()){
        hidePoiCards();
      }
    });


    obs.observe(document.body,{
      childList:true,
      subtree:true,
      attributes:true,
      attributeFilter:["class","style"]
    });
  }catch(e){}
}


setTimeout(installMapBlockers,300);
setTimeout(installPinAllowList,600);
setTimeout(installCardWatchdog,800);


setInterval(function(){
  installMapBlockers();
  installPinAllowList();


  if(!cardAllowed() && now()<blockCardUntil){
    hidePoiCards();
  }
},300);


window.slxPoiCardsAllowV2=allowCards;
window.slxPoiCardsBlockV2=blockCards;
window.slxPoiCardsHideV2=hidePoiCards;


})();


/* =========================================================
SLX START TRIP — FACILITY INTEL V2.2
Unified + warehouse aware + memory + stable button + arrival badge
========================================================= */
(function(){
"use strict";


if(window.__SLX_FACILITY_INTEL_V22__) return;
window.__SLX_FACILITY_INTEL_V22__=true;


var facilityFeatures=[];
var selectedFacilityId=null;
var facilityLastCameraV28=null;
var facilityZoomedInV28=false;
var facilityLastTapV28=0;


function FI(id){return document.getElementById(id);}


function fiToast(msg){
try{ if(typeof toast==="function"){toast(msg);return;} }catch(e){}
}


function fiGetMap(){
try{ if(window.__SLX_START_TRIP_MAP__) return window.__SLX_START_TRIP_MAP__; }catch(e){}
try{ if(window.slxMap) return window.slxMap; }catch(e1){}
try{ if(window.SLX_MAP) return window.SLX_MAP; }catch(e2){}
try{ if(window.map) return window.map; }catch(e3){}
try{ if(typeof map!=="undefined") return map; }catch(e4){}
return null;
}


function fiMapReady(m){
if(!m) return false;
try{ if(m.loaded && m.loaded()) return true; }catch(e){}
try{ if(m.isStyleLoaded && m.isStyleLoaded()) return true; }catch(e1){}
try{ if(m.getStyle && m.getStyle()) return true; }catch(e2){}
return false;
}




function fiSaveCameraV28(m){
try{
facilityLastCameraV28={
center:m.getCenter ? m.getCenter() : null,
zoom:m.getZoom ? m.getZoom() : 0,
pitch:m.getPitch ? m.getPitch() : 0,
bearing:m.getBearing ? m.getBearing() : 0
};
}catch(e){}
}


function fiRestoreCameraV28(m){
if(!m || !facilityLastCameraV28){return false;}
try{
m.easeTo({
center:facilityLastCameraV28.center,
zoom:facilityLastCameraV28.zoom,
pitch:facilityLastCameraV28.pitch,
bearing:facilityLastCameraV28.bearing,
duration:850,
essential:true
});
facilityZoomedInV28=false;
fiToast("Returned to route view");
setTimeout(fiWireButton,100);
return false;
}catch(e){}
return false;
}


function fiGetDest(){
var keys=["slx_main_dest_v2","slx_dest","slx_start_trip_dest_v1","slx_selected_dest_v1","slx_main_dest_v1"];
var i,p,label;


try{
if(typeof dest!=="undefined" && dest && isFinite(Number(dest.lng)) && isFinite(Number(dest.lat))){
label=String(dest.name||dest.label||dest.full||dest.title||"Destination");
return {lng:Number(dest.lng),lat:Number(dest.lat),name:label,label:label,full:String(dest.full||label)};
}
}catch(e){}


for(i=0;i<keys.length;i++){
try{
p=JSON.parse(localStorage.getItem(keys[i])||"null");
if(p && isFinite(Number(p.lng)) && isFinite(Number(p.lat))){
label=String(p.name||p.label||p.full||p.title||"Destination");
return {lng:Number(p.lng),lat:Number(p.lat),name:label,label:label,full:String(p.full||label)};
}
}catch(e2){}
}


return null;
}


/* ---------- MEMORY ---------- */


function fiMemoryKey(d){
if(!d) return "";
return Math.round(Number(d.lat)*10000)+"_"+Math.round(Number(d.lng)*10000);
}


function fiReadMemory(){
try{return JSON.parse(localStorage.getItem("slx_facility_memory_v1")||"{}");}
catch(e){}
return {};
}


function fiWriteMemory(db){
try{localStorage.setItem("slx_facility_memory_v1",JSON.stringify(db||{}));}
catch(e){}
}


function fiRemember(d,choice){
var db,key;
if(!d||!choice) return;


db=fiReadMemory();
key=fiMemoryKey(d);
if(!key) return;


db[key]={
facility_name:String(d.name||d.label||"Destination"),
choice_name:String(choice.name||"Facility Point"),
choice_type:String(choice.type||""),
score:Number(choice.score||0),
coordinates:choice.coordinates||null,
updated_at:new Date().toISOString()
};


fiWriteMemory(db);
}


function fiGetMemory(d){
var db,key;
if(!d) return null;
db=fiReadMemory();
key=fiMemoryKey(d);
return key&&db[key]?db[key]:null;
}


/* ---------- FACILITY LOGIC ---------- */


function fiIsWarehouse(name){
name=String(name||"").toLowerCase();
return (
name.indexOf("warehouse")>-1 ||
name.indexOf("distribution")>-1 ||
name.indexOf("logistics")>-1 ||
name.indexOf("fulfillment")>-1 ||
name.indexOf("freight")>-1 ||
name.indexOf("terminal")>-1 ||
name.indexOf("dc")>-1 ||
name.indexOf("aldis")>-1 ||
name.indexOf("aldi")>-1 ||
name.indexOf("walmart")>-1 ||
name.indexOf("amazon")>-1 ||
name.indexOf("target")>-1 ||
name.indexOf("costco")>-1
);
}


function fiFeature(d,dx,dy,id,label,name,type,score){
var lng=Number(d.lng)+dx;
var lat=Number(d.lat)+dy;


return {
type:"Feature",
geometry:{type:"Point",coordinates:[lng,lat]},
properties:{
id:id,
label:label,
name:name,
type:type,
score:score,
lng:lng,
lat:lat,
selected:selectedFacilityId===id?1:0
}
};
}


function fiBuildFeatures(d){
if(fiIsWarehouse(d.name)){
return [
fiFeature(d, 0.0045, 0.0028,"gate","G","Guard / Truck Gate","gate",95),
fiFeature(d,-0.0042, 0.0018,"dock","D","Receiving Dock","dock",92),
fiFeature(d, 0.0025,-0.0045,"ship","S","Shipping Dock","shipping",88),
fiFeature(d, 0.0032,-0.0032,"yard","Y","Trailer Yard","yard",85),
fiFeature(d, 0.0028,-0.0038,"rear","R","Rear Access","rear",78),
fiFeature(d,-0.0036,-0.0028,"office","E","Office / Avoid","avoid",40)
];
}


return [
fiFeature(d, 0.0045, 0.0028,"main","M","Main Entrance","main",90),
fiFeature(d,-0.0042, 0.0018,"alt","A","Alternate Entrance","alt",75)
];
}


/* ---------- MAP LAYERS ---------- */


function fiEnsureLayers(m){
if(!m) return false;


try{
if(!m.getSource("slxFacility")){
m.addSource("slxFacility",{type:"geojson",data:{type:"FeatureCollection",features:[]}});
}


if(!m.getLayer("slxFacilityHalo")){
m.addLayer({
id:"slxFacilityHalo",
type:"circle",
source:"slxFacility",
paint:{
"circle-radius":["case",["==",["get","selected"],1],30,22],
"circle-color":["case",["==",["get","selected"],1],"rgba(0,255,176,.34)","rgba(80,230,255,.24)"],
"circle-blur":0.62
}
});
}


if(!m.getLayer("slxFacilityDot")){
m.addLayer({
id:"slxFacilityDot",
type:"circle",
source:"slxFacility",
paint:{
"circle-radius":["case",["==",["get","selected"],1],15,13],
"circle-color":"rgba(8,14,22,.96)",
"circle-stroke-width":3,
"circle-stroke-color":["case",["==",["get","selected"],1],"#00ffb0","#50e6ff"]
}
});
}


if(!m.getLayer("slxFacilityText")){
m.addLayer({
id:"slxFacilityText",
type:"symbol",
source:"slxFacility",
layout:{
"text-field":["get","label"],
"text-size":14,
"text-font":["Open Sans Bold","Arial Unicode MS Bold"],
"text-allow-overlap":true,
"text-ignore-placement":true
},
paint:{
"text-color":"#ffffff",
"text-halo-color":"rgba(0,0,0,.88)",
"text-halo-width":1.7
}
});
}


return true;
}catch(e){
return false;
}
}


function fiDraw(m,data){
try{
if(m&&m.getSource("slxFacility")){
m.getSource("slxFacility").setData({
type:"FeatureCollection",
features:data||[]
});
}
}catch(e){}
}


/* ---------- CARD ---------- */


function fiGuidance(type){
type=String(type||"");
if(type==="gate") return "Best truck entry candidate. Verify signage before entering.";
if(type==="dock") return "Likely receiving dock. Check appointment and receiving instructions.";
if(type==="shipping") return "Likely shipping / outbound dock. Verify load assignment.";
if(type==="yard") return "Trailer yard / staging candidate. Watch for gate instructions.";
if(type==="rear") return "Possible rear or service access. Use caution.";
if(type==="avoid") return "Likely office / employee side. Avoid unless instructed.";
return "Entrance candidate. Verify facility signage.";
}


function fiUpdateArrivalBadge(){
var selected,badge,out,color;


selected=null;
try{selected=JSON.parse(localStorage.getItem("slx_selected_entrance_v1")||"null");}catch(e){}
if(!selected){try{selected=JSON.parse(localStorage.getItem("slx_driver_arrival_intel_v1")||"null");}catch(e2){}}


badge=FI("slxArrivalConfidenceBadge");
if(!selected){
if(badge){badge.style.display="none";}
return;
}


if(!badge){
badge=document.createElement("div");
badge.id="slxArrivalConfidenceBadge";
document.body.appendChild(badge);
}


out="MEDIUM";
color="#ffe2a2";


if(String(selected.type||"")==="avoid"){
out="LOW";
color="#ffb4b4";
}else if(Number(selected.score||0)>=90){
out="HIGH";
color="#9bffd7";
}


badge.style.position="fixed";
badge.style.left="14px";
badge.style.right="150px";
badge.style.bottom="calc(305px + env(safe-area-inset-bottom,0px))";
badge.style.right="220px";
badge.style.padding="8px 10px";
badge.style.zIndex="96";
badge.style.borderRadius="18px";
badge.style.padding="10px 12px";
badge.style.background="rgba(8,14,22,.90)";
badge.style.border="1px solid rgba(80,230,255,.30)";
badge.style.boxShadow="0 16px 36px rgba(0,0,0,.36),0 0 24px rgba(80,230,255,.12)";
badge.style.pointerEvents="none";
badge.style.display="block";


badge.innerHTML=
'<div style="font-size:10px;font-weight:1000;letter-spacing:.16em;color:#baffea;margin-bottom:5px;">ARRIVAL CONFIDENCE</div>'+
'<div style="display:flex;align-items:center;justify-content:space-between;gap:10px;">'+
'<div style="font-size:18px;font-weight:1000;color:'+color+';">'+out+'</div>'+
'<div style="font-size:11px;font-weight:900;color:rgba(255,255,255,.78);text-align:right;line-height:1.25;">'+(
  selected.type==="gate" ? "Truck gate likely ahead" :
  selected.type==="dock" ? "Receiving dock approach detected" :
  selected.type==="shipping" ? "Outbound dock candidate" :
  selected.type==="yard" ? "Trailer yard staging area" :
  selected.type==="rear" ? "Rear access road — verify signage" :
  selected.type==="avoid" ? "Office side — avoid for trucks" :
  "Verify entrance on arrival"
)+'</div>'+
'</div>';
}


function fiShowCard(props){
var card=FI("slxDockIntelCard")||FI("slxPoiInfoCard")||FI("slxPoiInfoCardV1");
var type=String(props.type||"");
var score=Number(props.score||0);
var coords=[Number(props.lng),Number(props.lat)];


if(!card) return;


card.innerHTML=
'<div style="display:flex;justify-content:space-between;gap:10px;align-items:flex-start;">'+
'<div style="min-width:0;flex:1;">'+
'<div style="font-weight:1000;font-size:20px;line-height:1.05;margin-bottom:6px;">'+String(props.name||"Facility Point")+'</div>'+
'<div style="font-size:10px;font-weight:1000;letter-spacing:.18em;color:#9bffd7;margin-bottom:9px;">FACILITY INTEL</div>'+
'<div style="font-size:13px;font-weight:850;line-height:1.28;color:rgba(255,255,255,.82);margin-bottom:10px;">'+fiGuidance(type)+'</div>'+
'<div style="display:inline-flex;border:1px solid rgba(0,255,176,.28);border-radius:999px;padding:6px 10px;color:#baffea;font-size:11px;font-weight:1000;margin-bottom:12px;">Confidence '+score+'</div>'+
'<button id="slxRouteFacilityBtnV22" type="button" style="width:100%;padding:12px;border-radius:15px;border:0;background:linear-gradient(180deg,#78ffd2,#45eaa7);color:#061713;font-size:13px;font-weight:1000;letter-spacing:.12em;">SAVE POINT</button>'+
'</div>'+
'<button id="slxCloseFacilityCardV22" type="button" style="width:36px;height:36px;border-radius:999px;border:1px solid rgba(255,255,255,.14);background:rgba(255,255,255,.09);color:#fff;font-size:24px;font-weight:1000;">×</button>'+
'</div>';


card.classList.add("on");
card.style.display="block";


setTimeout(function(){
var close=FI("slxCloseFacilityCardV22");
var route=FI("slxRouteFacilityBtnV22");


if(close){
close.onclick=function(e){
if(e&&e.preventDefault){e.preventDefault();}
card.classList.remove("on");
card.style.display="none";
return false;
};
}


if(route){
route.onclick=function(e){
var d=fiGetDest();
var save;


if(e&&e.preventDefault){e.preventDefault();}
if(e&&e.stopPropagation){e.stopPropagation();}


save={
updated_at:new Date().toISOString(),
label:String(props.label||""),
name:String(props.name||"Facility Point"),
type:String(props.type||""),
score:Number(props.score||0),
coordinates:coords
};


try{localStorage.setItem("slx_selected_entrance_v1",JSON.stringify(save));}catch(x){}
try{localStorage.setItem("slx_driver_arrival_intel_v1",JSON.stringify(save));}catch(x2){}
try{fiRemember(d,save);}catch(x3){}


fiUpdateArrivalBadge();
fiToast("Facility point saved");
return false;
};
}
},50);
}


/* ---------- TAP ---------- */


function fiBind(m){
if(!m||m.__slxFacilityBoundV22) return;
m.__slxFacilityBoundV22=true;


function handle(e){
var f,p,i;


if(!e||!e.features||!e.features.length) return;


if(e.originalEvent){
try{e.originalEvent.stopPropagation();}catch(x){}
try{e.originalEvent.preventDefault();}catch(x2){}
window.__SLX_BLOCK_NEXT_MAP_PICK__=Date.now()+900;
}


f=e.features[0];
p=f.properties||{};


selectedFacilityId=String(p.id||"");


for(i=0;i<facilityFeatures.length;i++){
facilityFeatures[i].properties.selected=
String(facilityFeatures[i].properties.id||"")===selectedFacilityId?1:0;
}


fiDraw(m,facilityFeatures);
fiShowCard(p);
fiToast("Selected: "+String(p.name||"Facility Point"));


return false;
}


try{m.on("click","slxFacilityDot",handle);}catch(e1){}
try{m.on("click","slxFacilityText",handle);}catch(e2){}
}


/* ---------- MAIN ---------- */


function fiRun(){
var m=fiGetMap();
var d=fiGetDest();
var saved,i;


if(!d){fiToast("Set destination first");return false;}
if(!m){fiToast("Map not ready");return false;}


var tapNowV28=(new Date()).getTime();
if(tapNowV28-facilityLastTapV28<700 && facilityZoomedInV28 && facilityLastCameraV28){
facilityLastTapV28=0;
return fiRestoreCameraV28(m);
}
facilityLastTapV28=tapNowV28;


if(!fiMapReady(m)){
fiToast("Map still loading...");
setTimeout(fiRun,600);
return false;
}


if(!fiEnsureLayers(m)){
fiToast("Facility layers not ready");
return false;
}


facilityFeatures=fiBuildFeatures(d);


try{
saved=fiGetMemory(d);
if(saved&&saved.choice_name){
for(i=0;i<facilityFeatures.length;i++){
if(String(facilityFeatures[i].properties.name||"")===String(saved.choice_name||"")){
facilityFeatures[i].properties.selected=1;
selectedFacilityId=String(facilityFeatures[i].properties.id||"");
}
}
fiToast("Previously used: "+saved.choice_name);
}
}catch(e){}


fiDraw(m,facilityFeatures);
fiBind(m);


try{
var currentZoom=0;
try{currentZoom=m.getZoom();}catch(e){}
fiSaveCameraV28(m);


m.flyTo({
  center:[d.lng,d.lat],
  zoom: Math.max(currentZoom,13.8),
  pitch:45,
  bearing: m.getBearing ? m.getBearing() : 0,
  speed:0.8,
  curve:1.1,
  essential:true
});
facilityZoomedInV28=true;
setTimeout(fiWireButton,100);
}catch(e2){}


fiToast("Facility intel ready");
return false;
}


/* ---------- BUTTON ---------- */


function fiWireButton(){
var rail=document.querySelector(".rightRailBottom");
var btn=FI("btnPickEntrance");


if(!btn&&rail){
btn=document.createElement("button");
btn.id="btnPickEntrance";
btn.className="edgeBtn btn";
btn.type="button";
rail.insertBefore(btn,rail.firstChild);
}


if(!btn) return;


btn.textContent=facilityZoomedInV28?"RETURN VIEW":"FACILITY INTEL";
btn.style.display="block";
btn.style.visibility="visible";
btn.style.pointerEvents="auto";
btn.style.borderColor="rgba(80,230,255,.42)";
btn.style.color="#bdf7ff";
btn.style.boxShadow="0 0 18px rgba(80,230,255,.14)";


btn.onclick=function(e){
if(e&&e.preventDefault){e.preventDefault();}
if(e&&e.stopPropagation){e.stopPropagation();}
return fiRun();
};
}


setTimeout(fiWireButton,300);
setTimeout(fiWireButton,1000);
setTimeout(fiWireButton,1800);
setInterval(fiWireButton,2000);


setTimeout(fiUpdateArrivalBadge,800);
setTimeout(fiUpdateArrivalBadge,1800);
setInterval(fiUpdateArrivalBadge,2500);


window.slxPickEntranceScanV2=fiRun;
window.slxFacilityIntelRunV22=fiRun;
window.slxFacilityIntelRunV21=fiRun;
window.slxGetFacilityMemoryV1=fiGetMemory;
window.slxRememberFacilityChoiceV1=fiRemember;
window.slxUpdateArrivalConfidenceBadgeV1=fiUpdateArrivalBadge;


})();


/* =========================================================
SLX PICK ENTRANCE — ROUTE ENTRANCE CARD V1
Turns G/D/R/E pin taps into a clear Route Now card.
========================================================= */
(function(){
"use strict";


if(window.__SLX_ROUTE_ENTRANCE_CARD_V1__) return;
window.__SLX_ROUTE_ENTRANCE_CARD_V1__=true;


function $(id){return document.getElementById(id);}


function safeToast(msg){
  try{ if(typeof toast==="function"){toast(msg);return;} }catch(e){}
}


function ensureCard(){
  var card=$("slxRouteEntranceCard");


  if(card) return card;


  card=document.createElement("div");
  card.id="slxRouteEntranceCard";
  card.style.position="fixed";
  card.style.left="14px";
  card.style.right="150px";
  card.style.bottom="calc(255px + env(safe-area-inset-bottom,0px))";
  card.style.zIndex="340";
  card.style.borderRadius="18px";
  card.style.background="rgba(8,14,22,.94)";
  card.style.border="1px solid rgba(80,230,255,.30)";
  card.style.boxShadow="0 18px 42px rgba(0,0,0,.44),0 0 26px rgba(80,230,255,.14)";
  card.style.backdropFilter="blur(16px)";
  card.style.webkitBackdropFilter="blur(16px)";
  card.style.padding="12px";
  card.style.display="none";
  card.style.color="#fff";


  document.body.appendChild(card);
  return card;
}


function entranceMessage(type){
  type=String(type||"");


  if(type==="truck_gate") return "Best truck entry candidate. Verify facility signage.";
  if(type==="dock") return "Receiving dock candidate. Good for arrival planning.";
  if(type==="rear_access") return "Rear access candidate. Use caution and confirm signage.";
  if(type==="avoid") return "Likely office or employee entrance. Avoid unless instructed.";


  return "Entrance candidate ready.";
}


function saveEntrance(props,coords){
  try{
    localStorage.setItem("slx_selected_entrance_v1",JSON.stringify({
      updated_at:new Date().toISOString(),
      label:String(props.label||""),
      name:String(props.name||"Entrance"),
      type:String(props.type||""),
      score:Number(props.score||0),
      coordinates:coords||null
    }));


    localStorage.setItem("slx_driver_arrival_intel_v1",JSON.stringify({
      updated_at:new Date().toISOString(),
      label:String(props.label||""),
      name:String(props.name||"Entrance"),
      type:String(props.type||""),
      score:Number(props.score||0),
      coordinates:coords||null
    }));
  }catch(e){}
}


function openRouteEntranceCard(props,coords){
  var card=ensureCard();
  var name=String(props.name||"Entrance");
  var type=String(props.type||"");
  var score=Number(props.score||0);
  var msg=entranceMessage(type);


  saveEntrance(props,coords);


  card.innerHTML=
    '<div style="display:flex;justify-content:space-between;gap:10px;align-items:flex-start;">'+
      '<div style="min-width:0;">'+
        '<div style="font-size:10px;font-weight:1000;letter-spacing:.18em;color:#baffea;margin-bottom:6px;">PICK ENTRANCE</div>'+
        '<div style="font-size:18px;font-weight:1000;line-height:1.1;margin-bottom:7px;">'+name+'</div>'+
        '<div style="font-size:12px;font-weight:850;line-height:1.35;color:rgba(255,255,255,.78);">'+msg+'</div>'+
        '<div style="margin-top:9px;display:inline-flex;border:1px solid rgba(255,205,105,.34);border-radius:999px;padding:5px 9px;color:#ffe2a2;font-size:10px;font-weight:1000;">Confidence '+score+'</div>'+
      '</div>'+
      '<button id="slxRouteEntranceClose" type="button" style="width:34px;height:34px;border-radius:999px;border:1px solid rgba(255,255,255,.14);background:rgba(255,255,255,.08);color:#fff;font-size:20px;font-weight:1000;">×</button>'+
    '</div>'+
    '<button id="slxRouteEntranceNow" type="button" style="width:100%;height:42px;margin-top:12px;border-radius:15px;border:1px solid rgba(0,255,176,.50);background:linear-gradient(180deg,rgba(40,255,200,1),rgba(0,230,155,1));color:#041712;font-size:13px;font-weight:1000;letter-spacing:.08em;">ROUTE TO THIS ENTRANCE</button>';


  card.style.display="block";


  setTimeout(function(){
    var close=$("slxRouteEntranceClose");
    var route=$("slxRouteEntranceNow");


    if(close){
      close.onclick=function(){
        card.style.display="none";
      };
    }


    if(route){
      route.onclick=function(e){
        if(e&&e.preventDefault) e.preventDefault();


        saveEntrance(props,coords);


        try{
          if(typeof dest!=="undefined" && coords && coords.length>=2){
            dest.lng=Number(coords[0]);
            dest.lat=Number(coords[1]);
            dest.name=name;
          }
        }catch(x){}


        try{
          localStorage.setItem("slx_main_dest_v2",JSON.stringify({
            lng:Number(coords[0]),
            lat:Number(coords[1]),
            name:name,
            entrance:true,
            updated_at:new Date().toISOString()
          }));
        }catch(y){}


        card.style.display="none";
        safeToast("Entrance selected • tap ROUTE NOW");
        return false;
      };
    }
  },30);
}


function bindEntranceCardPins(){
  var m=null;


  try{m=window.__SLX_START_TRIP_MAP__||window.slxMap||window.SLX_MAP||window.map;}catch(e){}


  if(!m||!m.on||m.__slxRouteEntranceCardBoundV1) return;


  m.__slxRouteEntranceCardBoundV1=true;


  function handle(e){
    var f,props,coords;


    if(e&&e.preventDefault) e.preventDefault();
    if(e&&e.originalEvent&&e.originalEvent.stopPropagation){
      e.originalEvent.stopPropagation();
      e.originalEvent.cancelBubble=true;
    }


    if(!e||!e.features||!e.features.length) return false;


    f=e.features[0];
    props=f.properties||{};
    coords=f.geometry&&f.geometry.coordinates?f.geometry.coordinates:null;


    openRouteEntranceCard(props,coords);
    return false;
  }


  try{m.on("click","slxEntranceDot",handle);}catch(e1){}
  try{m.on("click","slxEntranceText",handle);}catch(e2){}
  try{m.on("touchstart","slxEntranceDot",handle);}catch(e3){}
  try{m.on("touchstart","slxEntranceText",handle);}catch(e4){}
}


setTimeout(bindEntranceCardPins,600);
setTimeout(bindEntranceCardPins,1600);
setTimeout(bindEntranceCardPins,3000);
setInterval(bindEntranceCardPins,2500);


window.slxOpenRouteEntranceCardV1=openRouteEntranceCard;


})();


/* =========================================================
SLX START TRIP — DESTINATION INPUT CLEAN PLACEHOLDER FIX
Removes forced default text like "Selected destination"
and converts it into a proper placeholder.
========================================================= */


(function(){


"use strict";


if(window.__SLX_DEST_INPUT_PLACEHOLDER_FIX__) return;
window.__SLX_DEST_INPUT_PLACEHOLDER_FIX__=true;




function findDestInput(){


  var el=
    document.querySelector("#destInput") ||
    document.querySelector("#destinationInput") ||
    document.querySelector(".destInput") ||
    document.querySelector("input[data-role='destination']");


  return el;
}




function cleanDestField(){


  var input=findDestInput();


  if(!input) return;


  var txt=(input.value||"").toLowerCase();


  if(
    txt==="selected destination" ||
    txt==="destination selected" ||
    txt==="select destination"
  ){
    input.value="";
  }


  input.placeholder="Search destination, warehouse, truck stop…";
}




function preventDefaultTextReturn(){


  var input=findDestInput();


  if(!input) return;


  input.addEventListener("focus",function(){


    var txt=(input.value||"").toLowerCase();


    if(
      txt==="selected destination" ||
      txt==="destination selected" ||
      txt==="select destination"
    ){
      input.value="";
    }


  });


}




setTimeout(cleanDestField,400);
setTimeout(cleanDestField,1200);
setTimeout(cleanDestField,2600);


setTimeout(preventDefaultTextReturn,900);




setInterval(cleanDestField,4000);




})();


/* =========================================================
SLX ARRIVAL CONFIDENCE LABEL + CARD POSITION PATCH V1
Adds human-readable confidence labels
Moves Arrival Confidence card slightly lower for better cockpit layout
Safe additive patch
========================================================= */


(function(){


"use strict";


if(window.__SLX_ARRIVAL_CONFIDENCE_PATCH_V1__) return;
window.__SLX_ARRIVAL_CONFIDENCE_PATCH_V1__=true;




/* =========================================================
CONFIDENCE LABEL INTERPRETER
========================================================= */


window.slxConfidenceLabel=function(score){


score=parseInt(score||0,10);


if(score>=90) return "VERIFIED ENTRANCE";
if(score>=70) return "HIGH CONFIDENCE";
if(score>=40) return "MEDIUM CONFIDENCE";


return "LOW CONFIDENCE";


};




/* =========================================================
AUTO APPLY POSITION FIX
========================================================= */


setTimeout(adjustArrivalConfidencePosition,300);
setTimeout(adjustArrivalConfidencePosition,1200);
setTimeout(adjustArrivalConfidencePosition,2500);




/* =========================================================
UPGRADE CONFIDENCE TEXT IF SCORE PRESENT
========================================================= */


function upgradeConfidenceText(){


var badge=document.getElementById("arrivalConfidenceScore") ||
document.querySelector(".arrivalConfidenceScore") ||
document.querySelector("[data-role='arrival-confidence-score']");


if(!badge) return;


var score=parseInt(badge.innerText||badge.textContent||"0",10);


if(!score) return;


var label=window.slxConfidenceLabel(score);


if(badge.__slxConfidenceUpgraded) return;


badge.__slxConfidenceUpgraded=true;


badge.innerText=score+" • "+label;


}


setTimeout(upgradeConfidenceText,400);
setTimeout(upgradeConfidenceText,1400);
setTimeout(upgradeConfidenceText,2600);




})();


/* =========================================================
SLX ENTRANCE CARD RISK COLOR ENGINE V1
Adds visual confidence glow to entrance cards
Safe additive patch
========================================================= */


(function(){


"use strict";


if(window.__SLX_ENTRANCE_CARD_RISK_COLOR_V1__) return;
window.__SLX_ENTRANCE_CARD_RISK_COLOR_V1__=true;




function safeJSON(k){
  try{return JSON.parse(localStorage.getItem(k)||"null");}catch(e){}
  return null;
}




function entranceData(){
  return safeJSON("slx_selected_entrance_v1") ||
         safeJSON("slx_driver_arrival_intel_v1");
}




function riskStyle(score,type){


  score=Number(score||0);


  if(type==="avoid" || score<40){
    return {
      border:"rgba(255,80,80,.48)",
      glow:"0 0 32px rgba(255,80,80,.22)"
    };
  }


  if(score>=90){
    return {
      border:"rgba(0,255,176,.48)",
      glow:"0 0 32px rgba(0,255,176,.22)"
    };
  }


  if(score>=70){
    return {
      border:"rgba(255,205,105,.44)",
      glow:"0 0 28px rgba(255,205,105,.18)"
    };
  }


  return {
    border:"rgba(255,165,0,.44)",
    glow:"0 0 26px rgba(255,165,0,.18)"
  };
}




function findEntranceCard(){


  return document.querySelector("#slxEntranceCard") ||
         document.querySelector(".slxEntranceCard") ||
         document.querySelector("[data-role='entrance-card']");


}




function applyEntranceRiskStyle(){


  var card=findEntranceCard();
  var data=entranceData();
  var style;


  if(!card || !data) return;


  style=riskStyle(data.score,data.type);


  card.style.borderColor=style.border;
  card.style.boxShadow=
    "0 18px 46px rgba(0,0,0,.45)," + style.glow;


}




setTimeout(applyEntranceRiskStyle,200);
setTimeout(applyEntranceRiskStyle,900);
setTimeout(applyEntranceRiskStyle,1600);


setInterval(applyEntranceRiskStyle,2000);




window.slxApplyEntranceRiskStyle=applyEntranceRiskStyle;


})();


/* =========================================================
SLX PICK ENTRANCE — AUTO ROUTE HIGH CONFIDENCE V1
If entrance confidence >= 90 and not avoid, promote it to destination.
Safe additive patch. ES5-safe.
========================================================= */


(function(){
"use strict";


if(window.__SLX_AUTO_ROUTE_HIGH_CONF_ENTRANCE_V1__) return;
window.__SLX_AUTO_ROUTE_HIGH_CONF_ENTRANCE_V1__=true;


var AUTO_SCORE=90;
var lastAutoKey="";


function $(id){return document.getElementById(id);}


function toastMsg(msg){
  try{if(typeof toast==="function"){toast(msg);return;}}catch(e){}
  var t=$("toast");
  if(t){
    t.textContent=msg;
    t.classList.add("on");
    setTimeout(function(){t.classList.remove("on");},1500);
  }
}


function safeJSON(k){
  try{return JSON.parse(localStorage.getItem(k)||"null");}catch(e){}
  return null;
}


function selectedEntrance(){
  return safeJSON("slx_selected_entrance_v1") || safeJSON("slx_driver_arrival_intel_v1");
}


function keyFor(e){
  if(!e) return "";
  return [
    String(e.label||""),
    String(e.name||""),
    String(e.type||""),
    String(e.score||""),
    String(e.coordinates&&e.coordinates[0]||""),
    String(e.coordinates&&e.coordinates[1]||"")
  ].join("|");
}


function canAutoRoute(e){
  if(!e) return false;
  if(String(e.type||"")==="avoid") return false;
  if(Number(e.score||0)<AUTO_SCORE) return false;
  if(!e.coordinates || e.coordinates.length<2) return false;
  if(!isFinite(Number(e.coordinates[0])) || !isFinite(Number(e.coordinates[1]))) return false;
  return true;
}


function promoteEntranceToDestination(e){
  var lng=Number(e.coordinates[0]);
  var lat=Number(e.coordinates[1]);
  var name=String(e.name||"Truck Entrance");


  try{
    if(typeof dest!=="undefined" && dest){
      dest.lng=lng;
      dest.lat=lat;
      dest.name=name;
    }
  }catch(x){}


  try{
    localStorage.setItem("slx_main_dest_v2",JSON.stringify({
      lng:lng,
      lat:lat,
      name:name,
      entrance:true,
      entrance_label:String(e.label||""),
      entrance_type:String(e.type||""),
      entrance_score:Number(e.score||0),
      updated_at:new Date().toISOString()
    }));
  }catch(y){}


  try{
    localStorage.setItem("slx_selected_dest_v1",JSON.stringify({
      lng:lng,
      lat:lat,
      name:name,
      entrance:true,
      updated_at:new Date().toISOString()
    }));
  }catch(z){}


  try{
    var input=$("destInput");
    if(input){input.value=name;}
  }catch(a){}
}


function triggerRouteRefresh(){
  try{
    if(typeof window.slxRouteNow==="function"){
      window.slxRouteNow();
      return true;
    }
  }catch(e){}


  try{
    if(typeof routeNow==="function"){
      routeNow();
      return true;
    }
  }catch(e2){}


  try{
    var btn=$("btnRouteNow");
    if(btn){
      btn.click();
      return true;
    }
  }catch(e3){}


  return false;
}


function autoRouteIfHighConfidence(){
  var e=selectedEntrance();
  var k=keyFor(e);


  if(!canAutoRoute(e)) return;
  if(k && k===lastAutoKey) return;


  lastAutoKey=k;


  promoteEntranceToDestination(e);


  setTimeout(function(){
    var routed=triggerRouteRefresh();


    if(routed){
      toastMsg("Route updated to truck entrance");
    }else{
      toastMsg("Truck entrance selected • tap ROUTE NOW");
    }
  },120);
}


/* Wrap known entrance card opener so high-confidence pins auto-promote */
function wrapEntranceCard(){
  if(typeof window.slxOpenRouteEntranceCardV1!=="function") return;
  if(window.slxOpenRouteEntranceCardV1.__slxAutoRouteHighConfV1) return;


  var old=window.slxOpenRouteEntranceCardV1;


  window.slxOpenRouteEntranceCardV1=function(props,coords){
    var r=old.apply(this,arguments);


    try{
      var e={
        label:String(props&&props.label||""),
        name:String(props&&props.name||"Truck Entrance"),
        type:String(props&&props.type||""),
        score:Number(props&&props.score||0),
        coordinates:coords||null
      };


      localStorage.setItem("slx_selected_entrance_v1",JSON.stringify({
        updated_at:new Date().toISOString(),
        label:e.label,
        name:e.name,
        type:e.type,
        score:e.score,
        coordinates:e.coordinates
      }));


      localStorage.setItem("slx_driver_arrival_intel_v1",JSON.stringify({
        updated_at:new Date().toISOString(),
        label:e.label,
        name:e.name,
        type:e.type,
        score:e.score,
        coordinates:e.coordinates
      }));


      setTimeout(autoRouteIfHighConfidence,160);
    }catch(x){}


    return r;
  };


  window.slxOpenRouteEntranceCardV1.__slxAutoRouteHighConfV1=true;
}


/* Also watch storage/select changes */
setTimeout(wrapEntranceCard,300);
setTimeout(wrapEntranceCard,1200);
setTimeout(autoRouteIfHighConfidence,1500);


setInterval(function(){
  wrapEntranceCard();
  autoRouteIfHighConfidence();
},1800);


window.slxAutoRouteHighConfidenceEntranceV1=autoRouteIfHighConfidence;


})();


/* =========================================================
SLX PICK ENTRANCE — APPROACH DIRECTION SCORING BOOST V1
Boosts entrance confidence based on route approach direction.
Safe additive patch. ES5-safe.
========================================================= */
(function(){
"use strict";


if(window.__SLX_APPROACH_DIRECTION_ENTRANCE_BOOST_V1__) return;
window.__SLX_APPROACH_DIRECTION_ENTRANCE_BOOST_V1__=true;


function safeJSON(k){
  try{return JSON.parse(localStorage.getItem(k)||"null");}catch(e){}
  return null;
}


function saveJSON(k,v){
  try{localStorage.setItem(k,JSON.stringify(v));}catch(e){}
}


function getRouteCoords(){
  var geo=safeJSON("slx_route_geo_v2") ||
          safeJSON("slx_route_geo_v1") ||
          safeJSON("slx_start_trip_route_v1") ||
          safeJSON("slx_route_geojson");


  var f,c;


  if(!geo||!geo.features||!geo.features.length) return null;


  f=geo.features[0];


  if(!f.geometry) return null;


  if(f.geometry.type==="LineString"){
    c=f.geometry.coordinates;
    if(c&&c.length>2) return c;
  }


  if(f.geometry.type==="MultiLineString"){
    c=f.geometry.coordinates&&f.geometry.coordinates[0];
    if(c&&c.length>2) return c;
  }


  return null;
}


function bearing(a,b){
  var lon1=a[0]*Math.PI/180;
  var lat1=a[1]*Math.PI/180;
  var lon2=b[0]*Math.PI/180;
  var lat2=b[1]*Math.PI/180;
  var y=Math.sin(lon2-lon1)*Math.cos(lat2);
  var x=Math.cos(lat1)*Math.sin(lat2)-Math.sin(lat1)*Math.cos(lat2)*Math.cos(lon2-lon1);
  var brng=Math.atan2(y,x)*180/Math.PI;
  return (brng+360)%360;
}


function angleDiff(a,b){
  var d=Math.abs(a-b)%360;
  return d>180?360-d:d;
}


function getApproachBearing(){
  var coords=getRouteCoords();
  var n;


  if(!coords||coords.length<3) return null;


  n=coords.length;


  return bearing(coords[Math.max(0,n-6)],coords[n-1]);
}


function entranceBearingFromDest(ent,dest){
  if(!ent||!ent.coordinates||!dest) return null;
  return bearing([dest.lng,dest.lat],ent.coordinates);
}


function getDest(){
  var d=safeJSON("slx_main_dest_v2") ||
        safeJSON("slx_selected_dest_v1") ||
        safeJSON("slx_dest");


  if(d&&isFinite(Number(d.lng))&&isFinite(Number(d.lat))){
    return {lng:Number(d.lng),lat:Number(d.lat)};
  }


  return null;
}


function boostScore(ent,approach,dest){
  var eb,diff,boost,score,type;


  if(!ent) return ent;


  type=String(ent.type||"");
  score=Number(ent.score||0);


  if(type==="avoid"){
    ent.approach_boost=0;
    ent.approach_note="No boost: avoid entrance";
    return ent;
  }


  eb=entranceBearingFromDest(ent,dest);


  if(eb===null||approach===null){
    ent.approach_boost=0;
    ent.approach_note="Approach not available";
    return ent;
  }


  diff=angleDiff(approach,eb);
  boost=0;


  if(diff<=35){boost=16;}
  else if(diff<=65){boost=10;}
  else if(diff<=95){boost=5;}
  else if(diff>=145){boost=-8;}


  if(type==="truck_gate"){boost+=4;}
  if(type==="dock"){boost+=2;}
  if(type==="rear_access"&&diff<=65){boost+=6;}


  ent.base_score=score;
  ent.approach_bearing=Math.round(approach);
  ent.entrance_bearing=Math.round(eb);
  ent.approach_diff=Math.round(diff);
  ent.approach_boost=boost;
  ent.score=Math.max(1,Math.min(99,Math.round(score+boost)));


  if(boost>0){
    ent.approach_note="Approach direction match +" + boost;
  }else if(boost<0){
    ent.approach_note="Wrong-side approach " + boost;
  }else{
    ent.approach_note="Neutral approach";
  }


  return ent;
}


function normalizeFeatureToEntrance(f){
  var p=f&&f.properties||{};
  var coords=f&&f.geometry&&f.geometry.coordinates;


  return {
    label:String(p.label||""),
    name:String(p.name||"Entrance"),
    type:String(p.type||""),
    score:Number(p.score||0),
    coordinates:coords||null
  };
}


function applyBoostToStoredCandidates(){
  var data=safeJSON("slx_pick_entrance_v1");
  var approach=getApproachBearing();
  var dest=getDest();
  var i,f,e;


  if(!data||!data.features||!data.features.length||!dest) return;


  for(i=0;i<data.features.length;i++){
    f=data.features[i];


    if(!f.properties){f.properties={};}


    e=normalizeFeatureToEntrance(f);
    e=boostScore(e,approach,dest);


    f.properties.score=e.score;
    f.properties.base_score=e.base_score;
    f.properties.approach_boost=e.approach_boost;
    f.properties.approach_note=e.approach_note;
    f.properties.approach_diff=e.approach_diff;
  }


  data.approach_boosted=true;
  data.approach_bearing=approach;
  data.updated_at=new Date().toISOString();


  saveJSON("slx_pick_entrance_v1",data);


  try{
    if(window.slxSetEntranceFeaturesV1){
      window.slxSetEntranceFeaturesV1(data.features);
    }
  }catch(x){}
}


function boostSelectedEntrance(){
  var selected=safeJSON("slx_selected_entrance_v1") ||
               safeJSON("slx_driver_arrival_intel_v1");
  var approach=getApproachBearing();
  var dest=getDest();


  if(!selected||!dest) return;


  selected=boostScore(selected,approach,dest);
  selected.updated_at=new Date().toISOString();
  selected.approach_boosted=true;


  saveJSON("slx_selected_entrance_v1",selected);
  saveJSON("slx_driver_arrival_intel_v1",selected);


  try{
    if(window.slxUpdateArrivalConfidenceBadgeV1){
      window.slxUpdateArrivalConfidenceBadgeV1();
    }
  }catch(e){}
}


/* Wrap entrance scan if available */
function wrapPickEntrance(){
  if(typeof window.slxPickEntranceScanV1!=="function") return;
  if(window.slxPickEntranceScanV1.__slxApproachBoostV1) return;


  var old=window.slxPickEntranceScanV1;


  window.slxPickEntranceScanV1=function(){
    var r=old.apply(this,arguments);


    setTimeout(applyBoostToStoredCandidates,180);
    setTimeout(applyBoostToStoredCandidates,700);
    setTimeout(applyBoostToStoredCandidates,1400);


    return r;
  };


  window.slxPickEntranceScanV1.__slxApproachBoostV1=true;
}


/* Wrap entrance card if available */
function wrapEntranceCard(){
  if(typeof window.slxOpenRouteEntranceCardV1!=="function") return;
  if(window.slxOpenRouteEntranceCardV1.__slxApproachBoostV1) return;


  var old=window.slxOpenRouteEntranceCardV1;


  window.slxOpenRouteEntranceCardV1=function(props,coords){
    var ent={
      label:String(props&&props.label||""),
      name:String(props&&props.name||"Entrance"),
      type:String(props&&props.type||""),
      score:Number(props&&props.score||0),
      coordinates:coords||null
    };
    var boosted=boostScore(ent,getApproachBearing(),getDest());


    if(props){
      props.score=boosted.score;
      props.approach_boost=boosted.approach_boost;
      props.approach_note=boosted.approach_note;
    }


    return old.apply(this,arguments);
  };


  window.slxOpenRouteEntranceCardV1.__slxApproachBoostV1=true;
}


setTimeout(function(){
  wrapPickEntrance();
  wrapEntranceCard();
  applyBoostToStoredCandidates();
  boostSelectedEntrance();
},500);


setInterval(function(){
  wrapPickEntrance();
  wrapEntranceCard();
},2000);


window.slxApplyApproachDirectionEntranceBoostV1=function(){
  applyBoostToStoredCandidates();
  boostSelectedEntrance();
};


})();


/* =========================================================
SLX CORRIDOR ENTRANCE AUTO-PRESELECT ENGINE V1
Automatically selects best entrance candidate after route loads
Uses approach-direction boosted confidence scoring
Safe additive patch
========================================================= */


(function(){


"use strict";


if(window.__SLX_CORRIDOR_AUTO_ENTRANCE_PRESELECT_V1__) return;
window.__SLX_CORRIDOR_AUTO_ENTRANCE_PRESELECT_V1__=true;




function safeJSON(k){
  try{return JSON.parse(localStorage.getItem(k)||"null");}catch(e){}
  return null;
}


function saveJSON(k,v){
  try{localStorage.setItem(k,JSON.stringify(v));}catch(e){}
}




function entranceCandidates(){


  var data=safeJSON("slx_pick_entrance_v1");


  if(!data||!data.features||!data.features.length){
    return [];
  }


  return data.features;
}




function bestEntranceCandidate(){


  var list=entranceCandidates();
  var best=null;
  var bestScore=-1;
  var i,f,p;


  for(i=0;i<list.length;i++){


    f=list[i];
    p=f.properties||{};


    if(!p) continue;


    if(String(p.type||"")==="avoid") continue;


    if(Number(p.score||0)>bestScore){


      bestScore=Number(p.score||0);
      best=f;


    }


  }


  return best;


}




function promoteEntrance(feature){


  if(!feature) return;


  var p=feature.properties||{};
  var coords=feature.geometry&&feature.geometry.coordinates;


  if(!coords||coords.length<2) return;


  var selected={
    updated_at:new Date().toISOString(),
    label:String(p.label||""),
    name:String(p.name||"Truck Entrance"),
    type:String(p.type||""),
    score:Number(p.score||0),
    coordinates:coords,
    auto_selected:true
  };


  saveJSON("slx_selected_entrance_v1",selected);
  saveJSON("slx_driver_arrival_intel_v1",selected);


  try{
    if(window.slxUpdateArrivalConfidenceBadgeV1){
      window.slxUpdateArrivalConfidenceBadgeV1();
    }
  }catch(e){}


}




function autoPromoteBestEntrance(){


  var best=bestEntranceCandidate();


  if(!best) return;


  promoteEntrance(best);


  if(Number(best.properties.score||0)>=90){


    try{
      if(window.slxAutoRouteHighConfidenceEntranceV1){
        window.slxAutoRouteHighConfidenceEntranceV1();
      }
    }catch(e){}


  }


}




function wrapRouteBuild(){


  if(typeof window.slxRouteNow!=="function") return;
  if(window.slxRouteNow.__slxCorridorEntranceHookV1) return;


  var old=window.slxRouteNow;


  window.slxRouteNow=function(){


    var r=old.apply(this,arguments);


    setTimeout(autoPromoteBestEntrance,250);
    setTimeout(autoPromoteBestEntrance,900);
    setTimeout(autoPromoteBestEntrance,1600);


    return r;
  };


  window.slxRouteNow.__slxCorridorEntranceHookV1=true;


}




function wrapEntranceScan(){


  if(typeof window.slxPickEntranceScanV1!=="function") return;
  if(window.slxPickEntranceScanV1.__slxCorridorEntranceHookV1) return;


  var old=window.slxPickEntranceScanV1;


  window.slxPickEntranceScanV1=function(){


    var r=old.apply(this,arguments);


    setTimeout(autoPromoteBestEntrance,220);
    setTimeout(autoPromoteBestEntrance,700);


    return r;


  };


  window.slxPickEntranceScanV1.__slxCorridorEntranceHookV1=true;


}




setTimeout(function(){


  wrapRouteBuild();
  wrapEntranceScan();
  autoPromoteBestEntrance();


},600);




setInterval(function(){


  wrapRouteBuild();
  wrapEntranceScan();


},2500);




window.slxAutoPreselectBestEntranceV1=autoPromoteBestEntrance;


})();


/* =========================================================
SLX DOCK-SIDE APPROACH PREDICTION ENGINE V1
Displays facility-side arrival guidance before trip begins
Safe additive patch
========================================================= */


(function(){


"use strict";


if(window.__SLX_DOCK_SIDE_APPROACH_PREDICT_V1__) return;
window.__SLX_DOCK_SIDE_APPROACH_PREDICT_V1__=true;




function safeJSON(k){
  try{return JSON.parse(localStorage.getItem(k)||"null");}catch(e){}
  return null;
}




function bearingToSide(b){


  if(b===null) return "";


  if(b>=315||b<45) return "north";
  if(b>=45&&b<135) return "east";
  if(b>=135&&b<225) return "south";


  return "west";
}




function approachText(ent){


  if(!ent) return "";


  var side=bearingToSide(ent.entrance_bearing);
  var type=String(ent.type||"");


  if(type==="dock"){
    return "Receiving dock likely on "+side+" perimeter";
  }


  if(type==="truck_gate"){
    return "Truck gate likely on "+side+" approach side";
  }


  if(type==="rear_access"){
    return "Rear yard access likely behind facility";
  }


  if(type==="service"){
    return "Service access likely on "+side+" perimeter";
  }


  return "Entrance likely on "+side+" perimeter";
}




function ensureDockIntelCard(){


  var card=document.getElementById("slxDockSideIntelCard");


  if(card) return card;


  card=document.createElement("div");
  card.id="slxDockSideIntelCard";


  card.style.position="fixed";
  card.style.left="14px";
  card.style.right="150px";
  card.style.bottom="calc(380px + env(safe-area-inset-bottom,0px))";
  card.style.zIndex="95";


  card.style.borderRadius="18px";
  card.style.padding="10px 12px";


  card.style.background="rgba(8,14,22,.90)";
  card.style.border="1px solid rgba(0,255,176,.28)";


  card.style.boxShadow="0 16px 36px rgba(0,0,0,.36),0 0 24px rgba(0,255,176,.14)";
  card.style.backdropFilter="blur(16px)";
  card.style.webkitBackdropFilter="blur(16px)";


  card.style.fontWeight="900";
  card.style.display="none";


  document.body.appendChild(card);


  return card;
}




function updateDockSideIntel(){


  var ent=safeJSON("slx_selected_entrance_v1") ||
          safeJSON("slx_driver_arrival_intel_v1");


  var card=ensureDockIntelCard();


  if(!ent){
    card.style.display="none";
    return;
  }


  if(!ent.entrance_bearing){
    card.style.display="none";
    return;
  }


  var msg=approachText(ent);


  card.innerHTML=
    '<div style="font-size:10px;letter-spacing:.14em;color:#9bffd7;margin-bottom:4px;">FACILITY APPROACH</div>'+
    '<div style="font-size:15px;font-weight:1000;color:#dfffff;">'+msg+'</div>';


  card.style.display="block";
}




function hideIfLoadoutOpen(){


  var sheet=document.getElementById("slxLoadoutSheet");
  var card=document.getElementById("slxDockSideIntelCard");


  if(!card) return;


  try{
    if(document.body.classList.contains("slx-loadout-open") ||
       (sheet&&sheet.classList.contains("on"))){


      card.style.display="none";
      return;


    }
  }catch(e){}


  updateDockSideIntel();
}




setTimeout(updateDockSideIntel,600);
setTimeout(updateDockSideIntel,1600);


setInterval(hideIfLoadoutOpen,1200);




window.slxUpdateDockSideIntelCardV1=updateDockSideIntel;


})();


/* =========================================================
SLX START TRIP — POI INFO CARD PLACE NAME + ADD STOP V1
Upgrades corridor POI cards with place name + add stop action.
Safe additive patch. ES5-safe.
========================================================= */


(function(){
"use strict";


if(window.__SLX_POI_CARD_ADD_STOP_V1__) return;
window.__SLX_POI_CARD_ADD_STOP_V1__=true;


function $(id){return document.getElementById(id);}


function toastMsg(msg){
  try{if(typeof toast==="function"){toast(msg);return;}}catch(e){}
  var t=$("toast");
  if(t){
    t.textContent=msg;
    t.classList.add("on");
    setTimeout(function(){t.classList.remove("on");},1500);
  }
}


function typeLabel(type){
  type=String(type||"").toLowerCase();


  if(type==="parking") return "Parking";
  if(type==="fuel") return "Fuel";
  if(type==="food") return "Food";
  if(type==="service") return "Service";
  if(type==="shopping") return "Store";
  if(type==="showers") return "Showers";
  if(type==="rest") return "Rest Area";


  return "Stop";
}


function getPoiName(props){
  return String(
    props.name ||
    props.label ||
    props.title ||
    props.place_name ||
    props.location_name ||
    typeLabel(props.type) + " window"
  );
}


function ensurePoiCard(){
  var card=$("slxPoiInfoCard");


  if(card) return card;


  card=document.createElement("div");
  card.id="slxPoiInfoCard";
  document.body.appendChild(card);


  card.style.position="fixed";
  card.style.left="14px";
  card.style.right="150px";
  card.style.bottom="calc(250px + env(safe-area-inset-bottom,0px))";
  card.style.zIndex="360";
  card.style.borderRadius="18px";
  card.style.background="rgba(8,14,22,.94)";
  card.style.border="1px solid rgba(80,230,255,.28)";
  card.style.boxShadow="0 18px 42px rgba(0,0,0,.44),0 0 26px rgba(80,230,255,.12)";
  card.style.backdropFilter="blur(16px)";
  card.style.webkitBackdropFilter="blur(16px)";
  card.style.padding="12px";
  card.style.color="#fff";
  card.style.display="none";


  return card;
}


function saveStop(props,coords){
  var stop={
    name:getPoiName(props),
    type:String(props.type||"stop"),
    lng:Number(coords&&coords[0]),
    lat:Number(coords&&coords[1]),
    source:"corridor_poi",
    updated_at:new Date().toISOString()
  };


  if(!isFinite(stop.lng)||!isFinite(stop.lat)){
    toastMsg("Stop location missing");
    return false;
  }


  try{
    localStorage.setItem("slx_stop1_v1",JSON.stringify(stop));
    localStorage.setItem("slx_optional_stop_v1",JSON.stringify(stop));
  }catch(e){}


  try{
    if(typeof stop1!=="undefined"){
      stop1={
        name:stop.name,
        type:stop.type,
        lng:stop.lng,
        lat:stop.lat
      };
    }
  }catch(e2){}


  try{
    var stopCard=$("stopCard");
    var stopMain=$("stopMain");
    var stopSub=$("stopSub");


    if(stopCard){stopCard.classList.add("on");}
    if(stopMain){stopMain.textContent=stop.name;}
    if(stopSub){stopSub.textContent=typeLabel(stop.type)+" • added to route";}
  }catch(e3){}


  toastMsg("Stop added • tap ROUTE NOW");
  return true;
}


function openPoiCard(props,coords){
  var card=ensurePoiCard();
  var name=getPoiName(props);
  var type=String(props.type||"stop");
  var pretty=typeLabel(type);
  var dist=String(props.distMiles||props.distance||props.miles||"");
  var context=String(props.reason||props.note||props.description||"Useful corridor stop option.");


  card.innerHTML=
    '<div style="display:flex;justify-content:space-between;gap:10px;align-items:flex-start;">'+
      '<div style="min-width:0;">'+
        '<div style="font-size:10px;font-weight:1000;letter-spacing:.18em;color:#baffea;margin-bottom:6px;">'+pretty.toUpperCase()+'</div>'+
        '<div style="font-size:20px;font-weight:1000;line-height:1.1;margin-bottom:7px;">'+name+'</div>'+
        '<div style="font-size:13px;font-weight:850;line-height:1.35;color:rgba(255,255,255,.78);">'+context+'</div>'+
        (dist ? '<div style="margin-top:9px;display:inline-flex;border:1px solid rgba(255,205,105,.34);border-radius:999px;padding:5px 9px;color:#ffe2a2;font-size:10px;font-weight:1000;">'+dist+' mi from corridor</div>' : '')+
      '</div>'+
      '<button id="slxPoiCardClose" type="button" style="width:34px;height:34px;border-radius:999px;border:1px solid rgba(255,255,255,.14);background:rgba(255,255,255,.08);color:#fff;font-size:20px;font-weight:1000;">×</button>'+
    '</div>'+
    '<button id="slxPoiAddStop" type="button" style="width:100%;height:42px;margin-top:12px;border-radius:15px;border:1px solid rgba(0,255,176,.50);background:linear-gradient(180deg,rgba(40,255,200,1),rgba(0,230,155,1));color:#041712;font-size:13px;font-weight:1000;letter-spacing:.08em;">ADD STOP TO ROUTE</button>';


  card.style.display="block";


  setTimeout(function(){
    var close=$("slxPoiCardClose");
    var add=$("slxPoiAddStop");


    if(close){
      close.onclick=function(){
        card.style.display="none";
      };
    }


    if(add){
      add.onclick=function(e){
        if(e&&e.preventDefault) e.preventDefault();
        saveStop(props,coords);
        card.style.display="none";
        return false;
      };
    }
  },30);
}


function bindPoiLayers(){
  var m=null;
  var layers=[
    "slxCorridorStopsText",
    "slxCorridorStopsDot",
    "slxCorridorStopsHalo",
    "slxPoiText",
    "slxPoiDot",
    "slxPoiHalo"
  ];
  var i;


  try{m=window.__SLX_START_TRIP_MAP__||window.slxMap||window.SLX_MAP||window.map;}catch(e){}


  if(!m||!m.on) return;


  for(i=0;i<layers.length;i++){
    (function(layer){
      try{
        if(m.getLayer && !m.getLayer(layer)) return;
        if(m["__slxPoiAddStopBound_"+layer]) return;


        m["__slxPoiAddStopBound_"+layer]=true;


        m.on("click",layer,function(e){
          var f,props,coords;


          if(e&&e.originalEvent&&e.originalEvent.stopPropagation){
            e.originalEvent.stopPropagation();
          }


          if(!e||!e.features||!e.features.length) return;


          f=e.features[0];
          props=f.properties||{};
          coords=f.geometry&&f.geometry.coordinates?f.geometry.coordinates:null;


          openPoiCard(props,coords);
          return false;
        });
      }catch(x){}
    })(layers[i]);
  }
}


setTimeout(bindPoiLayers,500);
setTimeout(bindPoiLayers,1600);
setTimeout(bindPoiLayers,3200);


setInterval(bindPoiLayers,2500);


window.slxOpenPoiCardAddStopV1=openPoiCard;


})();


/* =========================================================
SLX ENTRANCE AUTO-PROMOTION ENGINE V1
Auto-routes to selected truck entrance when confidence ≥ 80
Safe additive patch. ES5-safe.
========================================================= */


(function(){


"use strict";


if(window.__SLX_ENTRANCE_AUTOPROMOTE_V1__) return;
window.__SLX_ENTRANCE_AUTOPROMOTE_V1__=true;




function safeJSON(k){
  try{return JSON.parse(localStorage.getItem(k)||"null");}catch(e){}
  return null;
}




function promoteEntranceIfStrong(){


  var ent =
    safeJSON("slx_selected_entrance_v1") ||
    safeJSON("slx_driver_arrival_intel_v1");


  if(!ent) return;


  var score = Number(ent.score || 0);


  if(score < 80) return;




  if(!ent.lng || !ent.lat) return;




  try{


    if(window.__SLX_ENTRANCE_ALREADY_PROMOTED__) return;


    window.__SLX_ENTRANCE_ALREADY_PROMOTED__ = true;


  }catch(e){}




  var newDest = {
    name: ent.name || "Truck entrance",
    lng: Number(ent.lng),
    lat: Number(ent.lat),
    source: "auto_promoted_entrance",
    confidence: score,
    promoted_at: Date.now()
  };




  try{


    localStorage.setItem(
      "slx_main_dest_v2",
      JSON.stringify(newDest)
    );


  }catch(e){}




  try{


    if(typeof dest !== "undefined"){


      dest = {
        name: newDest.name,
        lng: newDest.lng,
        lat: newDest.lat
      };


    }


  }catch(e){}




  try{


    if(typeof window.slxBuildRoute === "function"){


      window.slxBuildRoute();


    }


  }catch(e){}




  try{


    if(typeof window.slxUpdateArrivalConfidenceBadgeV1 === "function"){


      window.slxUpdateArrivalConfidenceBadgeV1();


    }


  }catch(e){}




  try{


    if(typeof window.slxUpdateDockSideIntelCardV1 === "function"){


      window.slxUpdateDockSideIntelCardV1();


    }


  }catch(e){}


}




setTimeout(promoteEntranceIfStrong,900);
setTimeout(promoteEntranceIfStrong,2000);
setTimeout(promoteEntranceIfStrong,3500);




window.slxPromoteEntranceIfStrongV1 = promoteEntranceIfStrong;


})();


/* =========================================================
SLX START TRIP — FORWARD CORRIDOR SMART FILTER V1
Keeps Scan Stops useful: top forward stops instead of map explosion.
Safe additive patch. ES5-safe.
========================================================= */
(function(){
"use strict";


if(window.__SLX_FORWARD_CORRIDOR_SMART_FILTER_V1__) return;
window.__SLX_FORWARD_CORRIDOR_SMART_FILTER_V1__=true;


var MAX_TOTAL=12;
var MAX_PER_TYPE=3;


function safeJSON(k){
  try{return JSON.parse(localStorage.getItem(k)||"null");}catch(e){}
  return null;
}


function saveJSON(k,v){
  try{localStorage.setItem(k,JSON.stringify(v));}catch(e){}
}


function getRouteCoords(){
  var geo=safeJSON("slx_route_geo_v2") ||
          safeJSON("slx_route_geo_v1") ||
          safeJSON("slx_start_trip_route_v1") ||
          safeJSON("slx_route_geojson");
  var f,c;


  if(!geo||!geo.features||!geo.features.length) return null;
  f=geo.features[0];
  if(!f.geometry) return null;


  if(f.geometry.type==="LineString"){
    c=f.geometry.coordinates;
    if(c&&c.length>2) return c;
  }


  if(f.geometry.type==="MultiLineString"){
    c=f.geometry.coordinates&&f.geometry.coordinates[0];
    if(c&&c.length>2) return c;
  }


  return null;
}


function distMiles(a,b){
  var R=3959;
  var dLat=(b[1]-a[1])*Math.PI/180;
  var dLon=(b[0]-a[0])*Math.PI/180;
  var lat1=a[1]*Math.PI/180;
  var lat2=b[1]*Math.PI/180;
  var x=Math.sin(dLat/2)*Math.sin(dLat/2)+
        Math.sin(dLon/2)*Math.sin(dLon/2)*Math.cos(lat1)*Math.cos(lat2);
  return R*2*Math.atan2(Math.sqrt(x),Math.sqrt(1-x));
}


function nearestRouteIndex(pt,coords){
  var best=0,bestD=999999,i,d;
  for(i=0;i<coords.length;i++){
    d=distMiles(pt,coords[i]);
    if(d<bestD){
      bestD=d;
      best=i;
    }
  }
  return best;
}


function getCurrentPoint(coords){
  try{
    if(typeof lastFix!=="undefined"&&lastFix&&isFinite(Number(lastFix.lng))&&isFinite(Number(lastFix.lat))){
      return [Number(lastFix.lng),Number(lastFix.lat)];
    }
  }catch(e){}


  try{
    var gps=safeJSON("slx_last_gps_v1");
    if(gps&&isFinite(Number(gps.lng))&&isFinite(Number(gps.lat))){
      return [Number(gps.lng),Number(gps.lat)];
    }
  }catch(e2){}


  return coords&&coords.length?coords[0]:null;
}


function featureScore(f,currentIdx,coords){
  var p=f.properties||{};
  var type=String(p.type||"parking").toLowerCase();
  var pt=f.geometry&&f.geometry.coordinates;
  var idx,forward,d,score;


  if(!pt||pt.length<2) return -9999;


  idx=nearestRouteIndex(pt,coords);
  forward=idx-currentIdx;


  if(forward<0) return -9999;


  d=distMiles(coords[currentIdx],pt);


  score=100;


  score-=Math.min(45,d*1.2);
  score+=Math.min(30,forward/4);


  if(type==="parking") score+=18;
  if(type==="fuel") score+=16;
  if(type==="rest") score+=12;
  if(type==="showers") score+=10;
  if(type==="food") score+=7;
  if(type==="service") score+=6;
  if(type==="shopping") score+=3;


  if(p.confidence){
    score+=Number(p.confidence||0)/8;
  }


  if(p.pressure==="likely_open") score+=10;
  if(p.pressure==="tightening") score-=4;
  if(p.pressure==="likely_full") score-=16;


  f.properties=f.properties||{};
  f.properties.slx_smart_score=Math.round(score);
  f.properties.slx_forward_index=forward;
  f.properties.slx_route_distance_mi=Math.round(d*10)/10;


  return score;
}


function smartFilterFeatures(features){
  var coords=getRouteCoords();
  var current,currentIdx,ranked=[],kept=[],counts={},i,f,s,type;


  if(!features||!features.length) return features;
  if(!coords||coords.length<3) return features.slice(0,MAX_TOTAL);


  current=getCurrentPoint(coords);
  if(!current) return features.slice(0,MAX_TOTAL);


  currentIdx=nearestRouteIndex(current,coords);


  for(i=0;i<features.length;i++){
    f=features[i];
    s=featureScore(f,currentIdx,coords);
    if(s<=-9999) continue;
    ranked.push({feature:f,score:s});
  }


  ranked.sort(function(a,b){return b.score-a.score;});


  for(i=0;i<ranked.length;i++){
    f=ranked[i].feature;
    type=String(f.properties&&f.properties.type||"parking").toLowerCase();


    counts[type]=counts[type]||0;


    if(counts[type]>=MAX_PER_TYPE) continue;


    kept.push(f);
    counts[type]++;


    if(kept.length>=MAX_TOTAL) break;
  }


  return kept.length?kept:features.slice(0,MAX_TOTAL);
}


function refreshReadout(filtered){
  try{
    saveJSON("slx_corridor_stop_preview_v1",{
      updated_at:new Date().toISOString(),
      smart_filtered:true,
      features:filtered
    });
  }catch(e){}


  try{
    if(typeof window.slxUpdateCorridorReadoutV1==="function"){
      setTimeout(window.slxUpdateCorridorReadoutV1,80);
    }
  }catch(e2){}
}


function wrapSetPins(){
  if(typeof window.slxSetCorridorStopPins!=="function") return;
  if(window.slxSetCorridorStopPins.__slxSmartFilterV1) return;


  var old=window.slxSetCorridorStopPins;


  window.slxSetCorridorStopPins=function(features){
    var filtered=smartFilterFeatures(features||[]);
    refreshReadout(filtered);
    return old.call(this,filtered);
  };


  window.slxSetCorridorStopPins.__slxSmartFilterV1=true;
}


function filterStoredPreview(){
  var data=safeJSON("slx_corridor_stop_preview_v1");
  var filtered;


  if(!data||!data.features||!data.features.length) return;


  if(data.smart_filtered) return;


  filtered=smartFilterFeatures(data.features);


  refreshReadout(filtered);


  try{
    if(typeof window.slxSetCorridorStopPins==="function"){
      window.slxSetCorridorStopPins(filtered);
    }
  }catch(e){}
}


function toastMsg(msg){
  try{if(typeof toast==="function"){toast(msg);return;}}catch(e){}
}


function wrapScanButtons(){
  var btn=document.getElementById("btnScanStops");
  var cool=document.getElementById("btnCoolStops");


  if(btn&&!btn.__slxSmartFilterMsgV1){
    btn.__slxSmartFilterMsgV1=true;
    btn.addEventListener("click",function(){
      setTimeout(function(){
        wrapSetPins();
        filterStoredPreview();
        toastMsg("Showing best stops ahead");
      },700);
    },true);
  }


  if(cool&&!cool.__slxSmartFilterMsgV1){
    cool.__slxSmartFilterMsgV1=true;
    cool.addEventListener("click",function(){
      setTimeout(function(){
        wrapSetPins();
        filterStoredPreview();
      },700);
    },true);
  }
}


setTimeout(function(){
  wrapSetPins();
  wrapScanButtons();
  filterStoredPreview();
},500);


setInterval(function(){
  wrapSetPins();
  wrapScanButtons();
},1800);


window.slxForwardCorridorSmartFilterV1=smartFilterFeatures;
window.slxApplyForwardCorridorSmartFilterV1=filterStoredPreview;


})();


/* =========================================================
SLX START TRIP — CORRIDOR READOUT NEXT-BEST RADAR V1
Upgrades Corridor Readout to show next best stop by type.
Safe additive patch. ES5-safe.
========================================================= */
(function(){
"use strict";


if(window.__SLX_CORRIDOR_NEXT_BEST_RADAR_V1__) return;
window.__SLX_CORRIDOR_NEXT_BEST_RADAR_V1__=true;


function safeJSON(k){
  try{return JSON.parse(localStorage.getItem(k)||"null");}catch(e){}
  return null;
}


function typeMeta(type){
  var map={
    parking:{label:"P",name:"Parking",color:"#29dfff"},
    fuel:{label:"F",name:"Fuel",color:"#2e86ff"},
    food:{label:"E",name:"Food",color:"#27f08a"},
    service:{label:"S",name:"Service",color:"#ff8b2f"},
    shopping:{label:"M",name:"Store",color:"#8d55ff"},
    showers:{label:"W",name:"Shower",color:"#ff5087"},
    rest:{label:"R",name:"Rest",color:"#50e6ff"}
  };
  return map[String(type||"").toLowerCase()]||null;
}


function placeName(f,type){
  var p=f.properties||{};
  return String(
    p.name ||
    p.title ||
    p.place_name ||
    p.location_name ||
    typeMeta(type).name
  );
}


function milesLabel(f){
  var p=f.properties||{};
  var n=p.slx_route_distance_mi || p.distMiles || p.miles || p.distance;


  n=Number(n);


  if(!isFinite(n)||n<=0) return "ahead";


  return String(Math.round(n*10)/10)+" mi";
}


function bestByType(features){
  var out={},i,f,p,t,score;


  for(i=0;i<features.length;i++){
    f=features[i];
    p=f.properties||{};
    t=String(p.type||"parking").toLowerCase();


    if(!typeMeta(t)) continue;


    score=Number(p.slx_smart_score||p.score||0);


    if(!out[t]||score>out[t].score){
      out[t]={feature:f,score:score};
    }
  }


  return out;
}


function updateNextBestReadout(){
  var box=document.getElementById("slxCorridorReadoutV1") ||
          document.getElementById("slxCorridorReadout");


  var data=safeJSON("slx_corridor_stop_preview_v1");
  var features,best,order,items=[],i,t,meta,f;


  if(!box||!data||!data.features||!data.features.length) return;


  features=data.features;
  best=bestByType(features);
  order=["parking","fuel","showers","rest","food","service","shopping"];


  for(i=0;i<order.length;i++){
    t=order[i];
    if(!best[t]) continue;


    meta=typeMeta(t);
    f=best[t].feature;


    items.push(
      '<div style="display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:5px;">'+
        '<div style="min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">'+
          '<span style="color:'+meta.color+';font-weight:1000;margin-right:5px;">'+meta.label+'</span>'+
          '<span style="font-weight:1000;">'+meta.name+'</span>'+
          '<span style="opacity:.72;font-weight:850;"> • '+placeName(f,t)+'</span>'+
        '</div>'+
        '<div style="flex:0 0 auto;color:#ffe2a2;font-weight:1000;">'+milesLabel(f)+'</div>'+
      '</div>'
    );


    if(items.length>=4) break;
  }


  if(!items.length) return;


  box.innerHTML=
    '<div style="font-size:10px;letter-spacing:.12em;color:#9bffd7;margin-bottom:7px;">FORWARD RADAR • Best stops ahead</div>'+
    '<div style="font-size:10px;line-height:1.35;">'+items.join("")+'</div>';


  box.style.display="block";
}


function wrapReadout(){
  if(typeof window.slxUpdateCorridorReadoutV1!=="function") return;
  if(window.slxUpdateCorridorReadoutV1.__slxNextBestRadarV1) return;


  var old=window.slxUpdateCorridorReadoutV1;


  window.slxUpdateCorridorReadoutV1=function(){
    old.apply(this,arguments);
    setTimeout(updateNextBestReadout,40);
  };


  window.slxUpdateCorridorReadoutV1.__slxNextBestRadarV1=true;
}


setTimeout(function(){
  wrapReadout();
  updateNextBestReadout();
},400);


setTimeout(updateNextBestReadout,1400);


setInterval(function(){
  wrapReadout();
  updateNextBestReadout();
},1800);


window.slxUpdateCorridorNextBestRadarV1=updateNextBestReadout;


})();


/* =========================================================
SLX START TRIP — SEARCH AHEAD INTELLIGENCE V1
Ranks operational search results by what is ahead of driver/route.
Safe additive patch. ES5-safe.
========================================================= */


(function(){
"use strict";


if(window.__SLX_SEARCH_AHEAD_INTEL_V1__) return;
window.__SLX_SEARCH_AHEAD_INTEL_V1__=true;


function slxSAJson(k){
  try{return JSON.parse(localStorage.getItem(k)||"null");}catch(e){}
  return null;
}


function slxSAFinite(v){
  v=Number(v);
  return isFinite(v);
}


function slxSADist(a,b){
  var R=3959;
  var dLat=(b[1]-a[1])*Math.PI/180;
  var dLon=(b[0]-a[0])*Math.PI/180;
  var lat1=a[1]*Math.PI/180;
  var lat2=b[1]*Math.PI/180;
  var x=Math.sin(dLat/2)*Math.sin(dLat/2)+
        Math.sin(dLon/2)*Math.sin(dLon/2)*Math.cos(lat1)*Math.cos(lat2);
  return R*2*Math.atan2(Math.sqrt(x),Math.sqrt(1-x));
}


function slxSAGetRouteCoords(){
  var geo=slxSAJson("slx_route_geo_v2") ||
          slxSAJson("slx_route_geo_v1") ||
          slxSAJson("slx_route_geojson") ||
          slxSAJson("slx_route");


  var f,c;


  try{
    if(typeof routeGeo!=="undefined" && routeGeo && routeGeo.features && routeGeo.features[0]){
      geo=routeGeo;
    }
  }catch(e){}


  if(!geo||!geo.features||!geo.features.length) return null;


  f=geo.features[0];
  if(!f.geometry) return null;


  if(f.geometry.type==="LineString"){
    c=f.geometry.coordinates;
    if(c&&c.length>2) return c;
  }


  if(f.geometry.type==="MultiLineString"){
    c=f.geometry.coordinates&&f.geometry.coordinates[0];
    if(c&&c.length>2) return c;
  }


  return null;
}


function slxSAGetGpsPoint(coords){
  var gps=null;


  try{
    if(typeof getGPS==="function"){gps=getGPS();}
  }catch(e){}


  if(gps&&slxSAFinite(gps.lng)&&slxSAFinite(gps.lat)){
    return [Number(gps.lng),Number(gps.lat)];
  }


  gps=slxSAJson("slx_last_gps_v1");


  if(gps&&slxSAFinite(gps.lng)&&slxSAFinite(gps.lat)){
    return [Number(gps.lng),Number(gps.lat)];
  }


  return coords&&coords.length ? coords[0] : null;
}


function slxSANearestRouteIndex(pt,coords){
  var best=0,bestD=999999,i,d;


  if(!pt||!coords) return 0;


  for(i=0;i<coords.length;i++){
    d=slxSADist(pt,coords[i]);
    if(d<bestD){
      bestD=d;
      best=i;
    }
  }


  return best;
}


function slxSAScoreItem(item,currentIdx,coords){
  var pt,idx,forward,dist,score,type;


  if(!item||!slxSAFinite(item.lng)||!slxSAFinite(item.lat)){
    return 0;
  }


  pt=[Number(item.lng),Number(item.lat)];
  idx=slxSANearestRouteIndex(pt,coords);
  forward=idx-currentIdx;
  dist=Number(item.distanceMiles||0);


  score=Number(item.score||0);
  type=String(item.category||item.type||item.source||"").toLowerCase();


  if(forward>=0){
    score+=5000;
    item.aheadOfRoute=true;
    item.routeAheadIndex=forward;
  }else{
    score-=9000;
    item.aheadOfRoute=false;
    item.routeAheadIndex=forward;
  }


  if(forward>=0 && forward<20){score+=700;}
  if(forward>=20 && forward<80){score+=450;}
  if(forward>=80){score+=250;}


  if(dist>0){
    score-=Math.min(600,dist*8);
  }


  if(type.indexOf("fuel")>-1){score+=220;}
  if(type.indexOf("parking")>-1){score+=180;}
  if(type.indexOf("rest")>-1){score+=160;}
  if(type.indexOf("truck")>-1){score+=140;}


  item.searchAheadScore=Math.round(score);


  return score;
}


function slxSARankItems(items){
  var coords=slxSAGetRouteCoords();
  var current,currentIdx,i;


  if(!items||!items.length) return items;


  if(!coords||coords.length<3){
    items.sort(function(a,b){
      return Number(a.distanceMiles||9999)-Number(b.distanceMiles||9999);
    });
    return items;
  }


  current=slxSAGetGpsPoint(coords);
  currentIdx=slxSANearestRouteIndex(current,coords);


  for(i=0;i<items.length;i++){
    slxSAScoreItem(items[i],currentIdx,coords);
  }


  items.sort(function(a,b){
    return Number(b.searchAheadScore||0)-Number(a.searchAheadScore||0);
  });


  return items;
}


/* Wrap search results display so Search Ahead wins automatically */
if(typeof showResults==="function"&&!showResults.__slxSearchAheadV1){
  var oldShowResultsSA=showResults;


  showResults=function(items){
    return oldShowResultsSA(slxSARankItems(items||[]));
  };


  showResults.__slxSearchAheadV1=true;
}


/* Wrap result HTML builder too, in case code calls it directly */
if(typeof buildResultsHtml==="function"&&!buildResultsHtml.__slxSearchAheadV1){
  var oldBuildResultsSA=buildResultsHtml;


  buildResultsHtml=function(items,targetId){
    return oldBuildResultsSA(slxSARankItems(items||[]),targetId);
  };


  buildResultsHtml.__slxSearchAheadV1=true;
}


window.slxSearchAheadRankV1=slxSARankItems;


})();


/* =========================================================
SLX TRUE CORRIDOR SEARCH FILTER V1.1
BOTTOM PATCH — paste AFTER final })();
========================================================= */


(function () {
"use strict";


if (window.__SLX_TRUE_CORRIDOR_SEARCH_FILTER_V11__) { return; }
window.__SLX_TRUE_CORRIDOR_SEARCH_FILTER_V11__ = true;


function okNum(v) {
  v = Number(v);
  return isFinite(v);
}


function miles(a, b) {
  var R = 3958.8;
  var dLat = (Number(b[1]) - Number(a[1])) * Math.PI / 180;
  var dLng = (Number(b[0]) - Number(a[0])) * Math.PI / 180;
  var lat1 = Number(a[1]) * Math.PI / 180;
  var lat2 = Number(b[1]) * Math.PI / 180;
  var x =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(lat1) * Math.cos(lat2);
  return R * (2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x)));
}


function readRoute() {
  var keys = [
    "slx_route_geo_v2",
    "slx_route_geo_v1",
    "slx_route_geojson",
    "slx_route",
    "slx_active_route",
    "slx_trip_route"
  ];
  var i, geo, f;


  for (i = 0; i < keys.length; i += 1) {
    try {
      geo = JSON.parse(localStorage.getItem(keys[i]) || "null");
      if (geo && geo.features && geo.features[0]) {
        f = geo.features[0];
        if (f.geometry && f.geometry.coordinates && f.geometry.coordinates.length) {
          return f.geometry.coordinates;
        }
      }
    } catch (e) {}
  }


  return null;
}


function readGps(coords) {
  var gps;


  try {
    gps = JSON.parse(localStorage.getItem("slx_last_gps_v1") || "null");
    if (gps && okNum(gps.lng) && okNum(gps.lat)) {
      return [Number(gps.lng), Number(gps.lat)];
    }
  } catch (e) {}


  return coords && coords.length ? coords[0] : null;
}


function nearestIndex(pt, coords) {
  var best = 0;
  var bestD = 999999;
  var step = Math.max(1, Math.floor(coords.length / 180));
  var i, d;


  for (i = 0; i < coords.length; i += step) {
    d = miles(pt, coords[i]);
    if (d < bestD) {
      bestD = d;
      best = i;
    }
  }


  return best;
}


function distanceToRoute(item, coords) {
  var pt, bestD, bestI, step, i, d;


  if (!item || !okNum(item.lng) || !okNum(item.lat)) { return null; }


  pt = [Number(item.lng), Number(item.lat)];
  bestD = 999999;
  bestI = 0;
  step = Math.max(1, Math.floor(coords.length / 220));


  for (i = 0; i < coords.length; i += step) {
    d = miles(pt, coords[i]);
    if (d < bestD) {
      bestD = d;
      bestI = i;
    }
  }


  return { miles: bestD, index: bestI };
}


function isTruckResult(item) {
  var text = String(
    (item && item.main || "") + " " +
    (item && item.label || "") + " " +
    (item && item.full || "") + " " +
    (item && item.sub || "") + " " +
    (item && item.category || "") + " " +
    (item && item.type || "") + " " +
    (item && item.source || "")
  ).toLowerCase();


  return !!(
    item &&
    (item.truckRelevant || item.operationalPoi ||
    text.indexOf("truck") > -1 ||
    text.indexOf("pilot") > -1 ||
    text.indexOf("flying j") > -1 ||
    text.indexOf("loves") > -1 ||
    text.indexOf("love's") > -1 ||
    text.indexOf("diesel") > -1 ||
    text.indexOf("fuel") > -1 ||
    text.indexOf("rest area") > -1 ||
    text.indexOf("rest stop") > -1 ||
    text.indexOf("parking") > -1)
  );
}


function filter(items) {
  var coords = readRoute();
  var current, currentIdx, out, i, item, hit, forward;


  if (!items || !items.length) { return items; }
  if (!coords || coords.length < 3) { return items; }


  current = readGps(coords);
  currentIdx = nearestIndex(current, coords);
  out = [];


  for (i = 0; i < items.length; i += 1) {
    item = items[i];


    if (!isTruckResult(item)) {
      out.push(item);
      continue;
    }


    hit = distanceToRoute(item, coords);
    if (!hit) { continue; }


    forward = hit.index - currentIdx;


    if (forward >= -8 && hit.miles <= 28) {
      item.score = Number(item.score || 0) + 5000 - (hit.miles * 90) + (forward * 0.8);
      item.corridorMiles = hit.miles;
      out.push(item);
    }
  }


  out.sort(function (a, b) {
    return Number(b.score || 0) - Number(a.score || 0);
  });


  return out.length ? out.slice(0, 8) : items.slice(0, 6);
}


function install() {
  if (typeof window.showResults !== "function") { return false; }
  if (window.showResults.__slxCorridorFilterV11) { return true; }


  var old = window.showResults;


  window.showResults = function (items) {
    return old(filter(items));
  };


  window.showResults.__slxCorridorFilterV11 = true;
  return true;
}


setTimeout(install, 300);
setTimeout(install, 1200);
setTimeout(install, 2500);


window.slxTrueCorridorFilterV11 = filter;


})();


/* =========================================================
SLX SEARCH RESULTS — ON ROUTE / OFF ROUTE TRUST LABEL V1
Shows route-aware trust copy on each result row.
Safe bottom patch. ES5-safe.
========================================================= */
(function(){
"use strict";


if(window.__SLX_SEARCH_ROUTE_TRUST_LABEL_V1__) return;
window.__SLX_SEARCH_ROUTE_TRUST_LABEL_V1__=true;


function slxSRGetRouteCoords(){
  var geo=null;


  try{
    geo = window.routeGeo || null;
  }catch(e){}


  if(!geo){
    try{ geo = JSON.parse(localStorage.getItem("slx_route_geo_v2") || localStorage.getItem("slx_route_geo_v1") || "null"); }catch(e2){}
  }


  try{
    if(geo && geo.features && geo.features[0] && geo.features[0].geometry && geo.features[0].geometry.coordinates){
      return geo.features[0].geometry.coordinates;
    }
  }catch(e3){}


  return null;
}


function slxSRMiles(a,b){
  var R=3959;
  var dLat=(b[1]-a[1])*Math.PI/180;
  var dLon=(b[0]-a[0])*Math.PI/180;
  var lat1=a[1]*Math.PI/180;
  var lat2=b[1]*Math.PI/180;
  var x=Math.sin(dLat/2)*Math.sin(dLat/2)+Math.sin(dLon/2)*Math.sin(dLon/2)*Math.cos(lat1)*Math.cos(lat2);
  return R*2*Math.atan2(Math.sqrt(x),Math.sqrt(1-x));
}


function slxSRDistanceToRouteMiles(lng,lat){
  var coords=slxSRGetRouteCoords();
  var best=999999;
  var step,i,d;


  if(!coords || coords.length<2) return null;


  step=Math.max(1,Math.floor(coords.length/140));


  for(i=0;i<coords.length;i+=step){
    d=slxSRMiles([Number(lng),Number(lat)],coords[i]);
    if(d<best) best=d;
  }


  return best;
}


function slxSRTrustLabel(item){
  var d=null;


  if(!item) return "";


  if(item.operationalPoi || item.truckRelevant){
    d=slxSRDistanceToRouteMiles(item.lng,item.lat);


    if(d!==null){
      if(d<=1.5) return "ON ROUTE";
      if(d<=5) return String(Math.round(d*10)/10)+" MI OFF ROUTE";
      return String(Math.round(d))+" MI OFF ROUTE";
    }


    if(item.distanceMiles){
      return String(Math.round(Number(item.distanceMiles)*10)/10)+" MI AWAY";
    }


    return "TRUCK VERIFIED";
  }


  return "";
}


if(typeof buildResultsHtml==="function" && !buildResultsHtml.__slxRouteTrustLabelV1){
  var oldBuildResultsHtml=buildResultsHtml;


  buildResultsHtml=function(items,targetId){
    var i,label;


    if(items && items.length){
      for(i=0;i<items.length;i++){
        label=slxSRTrustLabel(items[i]);


        if(label){
          items[i].sub = label + " • " + String(items[i].sub || "");
        }
      }
    }


    return oldBuildResultsHtml(items,targetId);
  };


  buildResultsHtml.__slxRouteTrustLabelV1=true;
}


})();


/* =========================================================
SLX WHY THIS STOP CARD V1
Shows compact stop-intelligence card after tapping search result.
Safe bottom patch. ES5-safe.
========================================================= */
(function () {
"use strict";


if (window.__SLX_WHY_THIS_STOP_CARD_V1__) { return; }
window.__SLX_WHY_THIS_STOP_CARD_V1__ = true;


var lastWhyItem = null;


function slxWhyText(item) {
  var text = String(
    (item && item.main || "") + " " +
    (item && item.sub || "") + " " +
    (item && item.category || "") + " " +
    (item && item.type || "")
  ).toLowerCase();


  if (text.indexOf("rest") > -1) {
    return "Good break candidate near your route. Useful for reset, parking, or quick stop planning.";
  }


  if (text.indexOf("parking") > -1) {
    return "Parking-aware stop candidate. Prioritized because it appears useful for driver planning.";
  }


  if (text.indexOf("pilot") > -1 || text.indexOf("flying j") > -1 || text.indexOf("love") > -1 || text.indexOf("ta ") > -1 || text.indexOf("petro") > -1) {
    return "Truck-fuel stop candidate. Ranked for brand relevance, route usefulness, and low wasted miles.";
  }


  if (text.indexOf("diesel") > -1 || text.indexOf("fuel") > -1) {
    return "Fuel candidate. Useful for route-cost planning and avoiding unnecessary detours.";
  }


  return "Operational stop candidate. Ranked for trucking relevance and route usefulness.";
}


function slxWhyRouteLabel(item) {
  if (!item) { return ""; }


  if (item.corridorMiles !== undefined && item.corridorMiles !== null) {
    if (Number(item.corridorMiles) <= 1.5) { return "ON ROUTE"; }
    return String(Math.round(Number(item.corridorMiles) * 10) / 10) + " MI OFF ROUTE";
  }


  if (item.distanceMiles) {
    return String(Math.round(Number(item.distanceMiles) * 10) / 10) + " MI AWAY";
  }


  return "TRUCK INTEL";
}


function slxEnsureWhyCard() {
  var card = document.getElementById("slxWhyStopCardV1");


  if (card) { return card; }


  card = document.createElement("div");
  card.id = "slxWhyStopCardV1";


  card.style.position = "fixed";
  card.style.left = "14px";
  card.style.right = "150px";
  card.style.bottom = "calc(186px + env(safe-area-inset-bottom,0px))";
  card.style.zIndex = "360";
  card.style.display = "none";
  card.style.borderRadius = "18px";
  card.style.background = "rgba(8,14,22,.94)";
  card.style.border = "1px solid rgba(0,255,176,.28)";
  card.style.boxShadow = "0 18px 42px rgba(0,0,0,.42),0 0 24px rgba(0,255,176,.12)";
  card.style.backdropFilter = "blur(16px)";
  card.style.webkitBackdropFilter = "blur(16px)";
  card.style.padding = "11px 12px";
  card.style.color = "#fff";
  card.style.pointerEvents = "auto";
  card.style.maxHeight = "132px";
  card.style.overflow = "hidden";


  document.body.appendChild(card);
  return card;
}


function slxShowWhyCard(item) {
  var card = slxEnsureWhyCard();
  var title = item && (item.main || item.label || item.name) ? String(item.main || item.label || item.name) : "Selected stop";
  var routeLabel = slxWhyRouteLabel(item);
  var why = slxWhyText(item);


  lastWhyItem = item;


  card.innerHTML =
    '<div style="display:flex;justify-content:space-between;gap:8px;align-items:flex-start;">' +
      '<div style="min-width:0;flex:1;">' +
        '<div style="font-size:9px;font-weight:1000;letter-spacing:.15em;color:#9bffd7;margin-bottom:5px;">WHY THIS STOP • ' + routeLabel + '</div>' +
        '<div style="font-size:14px;font-weight:1000;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-bottom:6px;">' + title + '</div>' +
        '<div style="font-size:11px;font-weight:850;line-height:1.3;color:rgba(255,255,255,.78);">' + why + '</div>' +
      '</div>' +
      '<button id="slxWhyStopCloseV1" type="button" style="width:30px;height:30px;border-radius:999px;border:1px solid rgba(255,255,255,.14);background:rgba(255,255,255,.08);color:#fff;font-size:18px;font-weight:1000;">×</button>' +
    '</div>';


  card.style.display = "block";


  setTimeout(function () {
    var close = document.getElementById("slxWhyStopCloseV1");
    if (close) {
      close.onclick = function () {
        card.style.display = "none";
        return false;
      };
    }
  }, 30);


  clearTimeout(window.__slxWhyStopTimerV1);
  window.__slxWhyStopTimerV1 = setTimeout(function () {
    if (card) { card.style.display = "none"; }
  }, 6500);
}


/* Hook result selection without changing routing behavior */
if (typeof chooseSearchResult === "function" && !chooseSearchResult.__slxWhyStopCardV1) {
  var oldChooseSearchResultWhyV1 = chooseSearchResult;


  chooseSearchResult = function (item) {
    var r = oldChooseSearchResultWhyV1(item);


    try {
      if (item && (item.truckRelevant || item.operationalPoi)) {
        setTimeout(function () {
          slxShowWhyCard(item);
        }, 120);
      }
    } catch (e) {}


    return r;
  };


  chooseSearchResult.__slxWhyStopCardV1 = true;
}


window.slxShowWhyStopCardV1 = slxShowWhyCard;


})();


/* =========================================================
SLX WHY THIS STOP CARD — DIRECT RESULT TAP HOOK V2
========================================================= */
(function(){
"use strict";


if(window.__SLX_WHY_STOP_DIRECT_HOOK_V2__) return;
window.__SLX_WHY_STOP_DIRECT_HOOK_V2__=true;


function slxFindResultItemFromCard(card){
  var titleEl, title, cards, i, txt;


  if(!card) return null;


  titleEl = card.querySelector(
    ".slx-result-title,.result-title,.title,h3,strong"
  );


  if(!titleEl){
    titleEl = card.querySelector("div");
  }


  if(!titleEl) return null;


  title = String(titleEl.textContent || "").trim().toLowerCase();


  if(!title) return null;


  cards = window.__lastSearchResults || [];


  for(i=0;i<cards.length;i++){
    txt = String(
      cards[i].main ||
      cards[i].label ||
      cards[i].name ||
      ""
    ).trim().toLowerCase();


    if(txt === title){
      return cards[i];
    }
  }


  return null;
}


function slxInstallWhyTapHook(){
  var cards, i;


  cards = document.querySelectorAll(
    ".slx-search-result,.slx-result-card,.search-result,.result-card"
  );


  if(!cards || !cards.length) return;


  for(i=0;i<cards.length;i++){


    if(cards[i].__slxWhyHookedV2) continue;
    cards[i].__slxWhyHookedV2 = true;


    cards[i].addEventListener("click",function(){


      var item = slxFindResultItemFromCard(this);


      if(item && typeof window.slxShowWhyStopCardV1==="function"){
        setTimeout(function(){
          window.slxShowWhyStopCardV1(item);
        },180);
      }


    },true);
  }
}


/* capture latest search results */
if(typeof window.showResults==="function" &&
   !window.showResults.__slxWhyCaptureV2){


  var oldShowResultsWhyV2 = window.showResults;


  window.showResults=function(items){


    window.__lastSearchResults = items || [];


    var r = oldShowResultsWhyV2(items);


    setTimeout(slxInstallWhyTapHook,120);
    setTimeout(slxInstallWhyTapHook,600);


    return r;
  };


  window.showResults.__slxWhyCaptureV2=true;
}


setInterval(slxInstallWhyTapHook,2000);


/* =========================================================
SLX START TRIP — FORWARD-ONLY STOP RANKING ENGINE V1
Ranks search results by stops ahead on the active route.
Prevents fuel/rest searches from sending driver backward.
ES5-safe. Add near bottom of Start Trip JS.
========================================================= */


if (!window.__SLX_FORWARD_ONLY_STOP_RANKING_V1__) {
window.__SLX_FORWARD_ONLY_STOP_RANKING_V1__ = true;


function slxForwardMilesV1(a, b) {
  var R = 3958.8;
  var dLat, dLng, lat1, lat2, x;


  if (!a || !b) { return 999999; }


  dLat = (Number(b[1]) - Number(a[1])) * Math.PI / 180;
  dLng = (Number(b[0]) - Number(a[0])) * Math.PI / 180;
  lat1 = Number(a[1]) * Math.PI / 180;
  lat2 = Number(b[1]) * Math.PI / 180;


  x =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLng / 2) * Math.sin(dLng / 2) *
    Math.cos(lat1) * Math.cos(lat2);


  return R * (2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x)));
}


function slxForwardRouteCoordsV1() {
  try {
    if (routeGeo && routeGeo.features && routeGeo.features[0] &&
        routeGeo.features[0].geometry && routeGeo.features[0].geometry.coordinates) {
      return routeGeo.features[0].geometry.coordinates;
    }
  } catch (e) {}


  return null;
}


function slxForwardCurrentPointV1(coords) {
  var gps = null;


  try {
    if (typeof getGPS === "function") {
      gps = getGPS();
    }
  } catch (e) {}


  if (gps && isFiniteNum(Number(gps.lng)) && isFiniteNum(Number(gps.lat))) {
    return [Number(gps.lng), Number(gps.lat)];
  }


  try {
    if (lastFix && isFiniteNum(Number(lastFix.lng)) && isFiniteNum(Number(lastFix.lat))) {
      return [Number(lastFix.lng), Number(lastFix.lat)];
    }
  } catch (e2) {}


  return coords && coords.length ? coords[0] : null;
}


function slxNearestRouteIndexV1(pt, coords) {
  var best = 0;
  var bestD = 999999;
  var i, d;


  if (!pt || !coords || !coords.length) { return 0; }


  for (i = 0; i < coords.length; i += 1) {
    d = slxForwardMilesV1(pt, coords[i]);
    if (d < bestD) {
      bestD = d;
      best = i;
    }
  }


  return best;
}


function slxForwardRankItemV1(item, currentIdx, currentPt, coords) {
  var stopPt, stopIdx, forwardIdx, directMiles, detourMiles, baseScore, category, name;


  if (!item || !isFiniteNum(Number(item.lng)) || !isFiniteNum(Number(item.lat))) {
    return -999999;
  }


  stopPt = [Number(item.lng), Number(item.lat)];
  stopIdx = slxNearestRouteIndexV1(stopPt, coords);
  forwardIdx = stopIdx - currentIdx;
  directMiles = slxForwardMilesV1(currentPt, stopPt);
  detourMiles = slxForwardMilesV1(stopPt, coords[stopIdx]);


  category = String(item.category || item.type || "").toLowerCase();
  name = String(item.main || item.label || item.name || "").toLowerCase();


  if (forwardIdx < -2) {
    item.forwardRejected = true;
    item.forwardReason = "behind_route";
    return -999999;
  }


  baseScore = 10000;


  baseScore += Math.min(3500, forwardIdx * 18);
  baseScore -= Math.min(2200, directMiles * 18);
  baseScore -= Math.min(4200, detourMiles * 900);


  if (forwardIdx >= 0) { baseScore += 2500; }
  if (forwardIdx > 2) { baseScore += 900; }
  if (detourMiles <= 1.5) { baseScore += 1200; }
  if (detourMiles <= 0.6) { baseScore += 1700; }


  if (category.indexOf("truck") > -1) { baseScore += 1200; }
  if (category.indexOf("fuel") > -1) { baseScore += 800; }
  if (category.indexOf("rest") > -1) { baseScore += 650; }


  if (name.indexOf("pilot") > -1 || name.indexOf("flying j") > -1 || name.indexOf("love") > -1 || name.indexOf("ta") > -1 || name.indexOf("petro") > -1) {
    baseScore += 600;
  }


  item.forwardRouteIndex = stopIdx;
  item.forwardIndexDelta = forwardIdx;
  item.forwardDirectMiles = directMiles;
  item.forwardDetourMiles = detourMiles;
  item.forwardRanked = true;
  item.score = baseScore;


  return baseScore;
}


function slxForwardRankSearchItemsV1(items) {
  var coords, currentPt, currentIdx, out, i, item, score;


  if (!items || !items.length) { return items || []; }


  coords = slxForwardRouteCoordsV1();


  if (!coords || coords.length < 3) {
    return items;
  }


  currentPt = slxForwardCurrentPointV1(coords);
  if (!currentPt) { return items; }


  currentIdx = slxNearestRouteIndexV1(currentPt, coords);
  out = [];


  for (i = 0; i < items.length; i += 1) {
    item = items[i];
    score = slxForwardRankItemV1(item, currentIdx, currentPt, coords);


    if (score <= -999999) { continue; }


    out.push(item);
  }


  if (!out.length) {
    return items;
  }


  out.sort(function (a, b) {
    return Number(b.score || 0) - Number(a.score || 0);
  });


  return out.slice(0, 8);
}


/* Wrap search results so active-route searches prefer forward stops */
if (typeof showResults === "function" && !showResults.__slxForwardOnlyWrappedV1) {
  var __oldShowResultsForwardOnlyV1 = showResults;


  showResults = function (items) {
    var ranked = slxForwardRankSearchItemsV1(items || []);
    return __oldShowResultsForwardOnlyV1(ranked);
  };


  showResults.__slxForwardOnlyWrappedV1 = true;
}


/* Wrap buildResultsHtml too, in case anything bypasses showResults */
if (typeof buildResultsHtml === "function" && !buildResultsHtml.__slxForwardOnlyWrappedV1) {
  var __oldBuildResultsHtmlForwardOnlyV1 = buildResultsHtml;


  buildResultsHtml = function (items, targetId) {
    var ranked = slxForwardRankSearchItemsV1(items || []);
    return __oldBuildResultsHtmlForwardOnlyV1(ranked, targetId);
  };


  buildResultsHtml.__slxForwardOnlyWrappedV1 = true;
}


window.slxForwardRankSearchItemsV1 = slxForwardRankSearchItemsV1;


}


})();


/* =========================================================
SEMI LOCATOR — DISPATCH LINK AUTO ROUTE PATCH V1
Paste at very bottom of Start Trip page/code.
Goal: when a dispatch link opens with destination already loaded,
automatically draw the route so driver does not have to tap Route Now.
ES5-safe.
========================================================= */
(function () {
"use strict";


if (window.__SLX_DISPATCH_AUTO_ROUTE_PATCH_V1__) { return; }
window.__SLX_DISPATCH_AUTO_ROUTE_PATCH_V1__ = true;


var KEY_DONE = "slx_dispatch_auto_route_done_v1";
var tries = 0;
var maxTries = 40;
var delayMs = 500;


function safeGet(key) {
try { return localStorage.getItem(key); } catch (e) { return null; }
}


function safeSet(key, val) {
try { localStorage.setItem(key, val); } catch (e) {}
}


function hasDispatchPayload() {
var qs = String(window.location.search || "");
var hash = String(window.location.hash || "");


if (qs.indexOf("dispatch") >= 0) { return true; }
if (qs.indexOf("trip") >= 0) { return true; }
if (qs.indexOf("dest") >= 0) { return true; }
if (hash.indexOf("dispatch") >= 0) { return true; }


if (safeGet("slx_dispatch_payload_v1")) { return true; }
if (safeGet("slx_start_trip_payload")) { return true; }
if (safeGet("slx_native_trip_payload_v1")) { return true; }


return false;
}


function hasDestination() {
if (window.dest) { return true; }
if (window.SLX_DEST) { return true; }
if (safeGet("slx_main_dest_v2")) { return true; }
if (safeGet("slx_dest")) { return true; }
return false;
}


function routeAlreadyReady() {
if (window.routeReady === true) { return true; }
if (window.routeGeo) { return true; }
if (safeGet("slx_route_geo_v2")) { return true; }
if (safeGet("slx_route_geo_v1")) { return true; }
return false;
}


function clickRouteButton() {
var selectors = [
"#routeNow",
"#routeNowBtn",
"#slxRouteNow",
"[data-route-now]",
"[data-action='route-now']",
".route-now",
".slx-route-now"
];


var i, btn;
for (i = 0; i < selectors.length; i += 1) {
btn = document.querySelector(selectors[i]);
if (btn && typeof btn.click === "function") {
btn.click();
return true;
}
}


return false;
}


function callRouteFunction() {
var fns = [
"routeNow",
"slxRouteNow",
"buildRoute",
"requestRoute",
"drawRoute",
"SLX_routeNow"
];


var i, fn;
for (i = 0; i < fns.length; i += 1) {
fn = window[fns[i]];
if (typeof fn === "function") {
try {
fn();
return true;
} catch (e) {}
}
}


return false;
}


function attemptAutoRoute() {
tries += 1;


if (!hasDispatchPayload()) { return; }


if (routeAlreadyReady()) {
safeSet(KEY_DONE, "1");
return;
}


if (!hasDestination()) {
if (tries < maxTries) {
setTimeout(attemptAutoRoute, delayMs);
}
return;
}


if (safeGet(KEY_DONE) === "1") { return; }


if (clickRouteButton() || callRouteFunction()) {
safeSet(KEY_DONE, "1");
return;
}


if (tries < maxTries) {
setTimeout(attemptAutoRoute, delayMs);
}
}


function resetForNewDispatchLink() {
var urlKey = "slx_dispatch_auto_route_url_v1";
var current = String(window.location.href || "");
var previous = safeGet(urlKey);


if (previous !== current) {
try {
localStorage.removeItem(KEY_DONE);
localStorage.setItem(urlKey, current);
} catch (e) {}
}
}


resetForNewDispatchLink();


if (document.readyState === "loading") {
document.addEventListener("DOMContentLoaded", function () {
setTimeout(attemptAutoRoute, 900);
});
} else {
setTimeout(attemptAutoRoute, 900);
}


/* =========================================================
SLX START TRIP - ROUTE CONFIDENCE ENGINE V1
Additive decision layer for Start Trip.
No API changes. No new route calls. ES5 safe.
========================================================= */


if(!window.__SLX_ROUTE_CONFIDENCE_ENGINE_V1__){
window.__SLX_ROUTE_CONFIDENCE_ENGINE_V1__=true;


function slxClampConfidenceScore(v){
  v=Number(v);
  if(!isFinite(v)){v=0;}
  if(v<0){v=0;}
  if(v>100){v=100;}
  return Math.round(v);
}


function slxConfidenceLabel(score){
  score=slxClampConfidenceScore(score);
  if(score>=86){return "HIGH";}
  if(score>=72){return "GOOD";}
  if(score>=58){return "WATCH";}
  return "RISKY";
}


function slxDecisionLabel(type, score){
  type=String(type || activeChipType || "profit");
  if(type==="parking"){return "BEST FOR PARKING";}
  if(type==="weather"){return "LOWEST RISK";}
  if(type==="tolls"){return "LOW TOLLS";}
  if(type==="fastest"){return "FASTEST";}
  if(type==="loadshift"){return "LOAD SAFE";}
  if(type==="crosswind"){return "WIND SAFE";}
  if(score>=88){return "BEST PROFIT";}
  return "BEST PROFIT";
}


function slxTrafficConfidenceScore(route){
  var miles, hours, avg;
  if(!route){return 74;}
  miles=Number(route.distanceMeters || 0)*0.000621371;
  hours=Number(route.durationSeconds || 0)/3600;
  if(!miles || !hours || !isFinite(miles) || !isFinite(hours)){return 74;}
  avg=miles/hours;
  if(avg>=58){return 92;}
  if(avg>=50){return 84;}
  if(avg>=42){return 73;}
  if(avg>=34){return 61;}
  return 48;
}


function slxRouteFuelConfidenceScore(route){
  var money, miles, fuelPerMile;
  if(!route){return 72;}
  money=route.money || calcTripMoney(route.distanceMeters, route.durationSeconds);
  miles=Number(money.miles || 0);
  if(!miles){return 72;}
  fuelPerMile=Number(money.fuel || 0)/miles;
  if(fuelPerMile<=0.62){return 90;}
  if(fuelPerMile<=0.74){return 80;}
  if(fuelPerMile<=0.86){return 68;}
  return 56;
}


function slxRouteConfidenceData(route, type){
  var park, weather, traffic, toll, load, wind, signal, fuel, score, label, badge, reasons, money;
  if(!route){return null;}


  money=route.money || calcTripMoney(route.distanceMeters, route.durationSeconds);
  park=slxClampConfidenceScore(isFiniteNum(route.parkingScore) ? route.parkingScore : estimateParkingConfidenceScore(route.distanceMeters));
  weather=slxClampConfidenceScore(isFiniteNum(route.weatherScore) ? route.weatherScore : weatherImpactScore(route.distanceMeters, route.geometry));
  toll=slxClampConfidenceScore(isFiniteNum(route.tollScore) ? route.tollScore : tollRiskScore(route.distanceMeters));
  load=slxClampConfidenceScore(isFiniteNum(route.loadShiftScore) ? route.loadShiftScore : loadShiftRiskScore(route.distanceMeters));
  wind=slxClampConfidenceScore(isFiniteNum(route.crosswindScore) ? route.crosswindScore : crosswindExposureScore(route.distanceMeters));
  signal=slxClampConfidenceScore(isFiniteNum(route.signalScore) ? route.signalScore : signalRiskScore(route.distanceMeters));
  traffic=slxClampConfidenceScore(slxTrafficConfidenceScore(route));
  fuel=slxClampConfidenceScore(slxRouteFuelConfidenceScore(route));


  score=slxClampConfidenceScore(
    (park*0.25)+
    (weather*0.19)+
    (traffic*0.14)+
    (toll*0.10)+
    (fuel*0.10)+
    (load*0.11)+
    (wind*0.11)
  );


  label=slxConfidenceLabel(score);
  badge=slxDecisionLabel(type,score);
  reasons=[];


  if(type==="profit"){reasons.push("Best net estimate for this trip");}
  if(type==="parking"){reasons.push("Stronger parking confidence");}
  if(type==="weather"){reasons.push("Lower weather exposure");}
  if(type==="fastest"){reasons.push("Fastest ETA option");}
  if(type==="tolls"){reasons.push("Lower toll risk");}
  if(type==="loadshift"){reasons.push("Better load stability");}
  if(type==="crosswind"){reasons.push("Lower crosswind exposure");}


  if(park>=80){reasons.push("Strong parking outlook");}
  else if(park<60){reasons.push("Parking may tighten later");}


  if(weather>=80){reasons.push("Cleaner weather corridor");}
  else if(weather<60){reasons.push("Weather risk needs attention");}


  if(wind<60){reasons.push("Crosswind exposure elevated");}
  else if(wind>=80){reasons.push("Low crosswind exposure");}


  if(traffic>=82){reasons.push("Good travel pace expected");}
  if(toll>=82){reasons.push("Low toll pressure");}
  if(load>=82){reasons.push("Load stability looks good");}


  while(reasons.length>3){reasons.pop();}


  return {
    score:score,
    label:label,
    badge:badge,
    reasons:reasons,
    parking:park,
    weather:weather,
    traffic:traffic,
    toll:toll,
    fuel:fuel,
    loadShift:load,
    crosswind:wind,
    signal:signal,
    net:Math.round(Number(money.net || 0)),
    miles:Math.round(Number(money.miles || 0)),
    minutes:Math.round(Number(route.durationSeconds || 0)/60)
  };
}


function slxApplyConfidenceToRoute(index,type){
  var route, data, props;
  if(!altRoutes || !altRoutes.length){return null;}
  if(!isFiniteNum(index)){index=selectedRouteIndex || 0;}
  if(index<0 || index>=altRoutes.length){index=0;}


  route=altRoutes[index];
  if(!route){return null;}


  data=slxRouteConfidenceData(route,type || activeChipType || "profit");
  if(!data){return null;}


  route.confidenceData=data;
  route.routeConfidenceScore=data.score;
  route.routeConfidenceLabel=data.label;
  route.tripDecisionLabel=data.badge;
  route.routeReasons=data.reasons;


  try{
    if(routeGeo && routeGeo.features && routeGeo.features[0]){
      props=routeGeo.features[0].properties || {};
      props.routeConfidenceScore=data.score;
      props.routeConfidenceLabel=data.label;
      props.tripDecisionLabel=data.badge;
      props.routeReasons=data.reasons.join(" | ");
      props.parkingScore=data.parking;
      props.weatherScore=data.weather;
      props.trafficScore=data.traffic;
      props.tollScore=data.toll;
      props.fuelScore=data.fuel;
      props.loadShiftScore=data.loadShift;
      props.crosswindScore=data.crosswind;
      routeGeo.features[0].properties=props;
    }
  }catch(e){}


  try{
    localStorage.setItem("slx_route_confidence_v1",JSON.stringify(data));
    localStorage.setItem("slx_route_decision_label_v1",String(data.badge || ""));
    localStorage.setItem("slx_route_decision_reasons_v1",JSON.stringify(data.reasons || []));
  }catch(e2){}


  return data;
}


function slxConfidenceColor(score){
  score=slxClampConfidenceScore(score);
  if(score>=86){return "rgba(0,255,176,.98)";}
  if(score>=72){return "rgba(94,197,255,.98)";}
  if(score>=58){return "rgba(255,205,105,.98)";}
  return "rgba(255,100,100,.98)";
}


function slxHtmlText(v){
  return String(v || "")
    .replace(/&/g,"&amp;")
    .replace(/</g,"&lt;")
    .replace(/>/g,"&gt;")
    .replace(/"/g,"&quot;")
    .replace(/'/g,"&#39;");
}


function slxRouteTypeLabel(type){
  type=String(type || activeChipType || "profit");
  if(type==="profit"){return "Best Profit";}
  if(type==="fastest"){return "Fastest";}
  if(type==="tolls"){return "Low Tolls";}
  if(type==="parking"){return "Best Parking";}
  if(type==="weather"){return "Low Weather Impact";}
  if(type==="loadshift"){return "Load Shift Safe";}
  if(type==="crosswind"){return "Crosswind Safe";}
  return "Route Intelligence";
}


function slxBuildTripIntelSpeech(data,eta,intel){
  var parts=[];
  var reasons=[];
  var routeLabel=slxRouteTypeLabel(activeChipType);
  var money=safeJSONParse(lsGet(LS.MONEY_PREVIEW));


  parts.push(routeLabel + " route selected.");


  if(money && isFiniteNum(Number(money.net))){
    parts.push("Estimated net is " + String(Math.round(Number(money.net))) + " dollars.");
  }


  if(eta && eta.real_minutes){
    parts.push("Real ETA is " + slxMinutesLabel(eta.real_minutes) + ".");
    if(eta.buffer_minutes && Number(eta.buffer_minutes)>0){
      parts.push("That includes a " + String(Math.round(Number(eta.buffer_minutes))) + " minute trip buffer.");
    }
  }


  if(data && data.parking){
    parts.push("Parking confidence is " + parkingConfidenceLabel(data.parking).toLowerCase() + ".");
  }


  if(data && data.weather){
    parts.push("Weather impact is " + weatherImpactLabel(data.weather).toLowerCase() + ".");
  }


  if(intel && intel.reasons && intel.reasons.length){
    reasons=intel.reasons;
  }else if(data && data.reasons && data.reasons.length){
    reasons=data.reasons;
  }


  if(reasons && reasons.length){
    parts.push("Why this route: " + String(reasons.slice(0,3).join(", ")) + ".");
  }


  return parts.join(" ");
}


function slxSpeakTripIntel(){
  var data, eta, intel, text, u, voices, i, chosen;


  try{
    if(!window.speechSynthesis || !window.SpeechSynthesisUtterance){
      toast("Voice not available on this device");
      return;
    }


    data=safeJSONParse(localStorage.getItem("slx_route_confidence_v1"));
    eta=safeJSONParse(lsGet(LS.ROUTE_ETA));
    intel=safeJSONParse(lsGet(LS.ROUTE_INTEL));
    text=slxBuildTripIntelSpeech(data,eta,intel);


    if(!text){
      toast("Route intelligence not ready yet");
      return;
    }


    try{window.speechSynthesis.cancel();}catch(e0){}


    u=new SpeechSynthesisUtterance(text);
    u.rate=0.96;
    u.pitch=0.98;
    u.volume=1;


    try{
      voices=window.speechSynthesis.getVoices ? window.speechSynthesis.getVoices() : [];
      for(i=0;i<voices.length;i++){
        if(String(voices[i].lang || "").toLowerCase().indexOf("en")===0){
          chosen=voices[i];
          if(String(voices[i].name || "").toLowerCase().indexOf("samantha")>-1){break;}
        }
      }
      if(chosen){u.voice=chosen;}
    }catch(e1){}


    lsSet("slx_trip_intel_voice_enabled_v1","1");
    window.speechSynthesis.speak(u);
    toast("Reading trip intel");
  }catch(e2){
    toast("Voice readout failed");
  }
}


function slxInstallRouteConfidenceStyles(){
  var st=$("slxRouteConfidenceStylesV1");
  if(st){return;}
  st=document.createElement("style");
  st.id="slxRouteConfidenceStylesV1";
  st.textContent=
    "#slxRouteConfidencePanel{position:fixed;left:12px;right:12px;bottom:calc(134px + env(safe-area-inset-bottom,0px));z-index:119;border:1px solid rgba(255,255,255,.13);border-radius:18px;background:linear-gradient(135deg,rgba(5,13,22,.90),rgba(7,22,34,.82));box-shadow:0 16px 38px rgba(0,0,0,.38),0 0 34px rgba(0,255,176,.10);backdrop-filter:blur(16px);-webkit-backdrop-filter:blur(16px);padding:10px 11px;color:#fff;font-family:inherit;max-height:156px;overflow:hidden;}"+
    "#slxRouteConfidencePanel .rcTop{display:flex;align-items:center;justify-content:space-between;gap:10px;}"+
    "#slxRouteConfidencePanel .rcBadge{font-size:10px;font-weight:950;letter-spacing:.08em;color:#071018;background:linear-gradient(90deg,#86e8ff,#00ffb0);border-radius:999px;padding:6px 8px;white-space:nowrap;}"+
    "#slxRouteConfidencePanel .rcScore{font-size:26px;line-height:1;font-weight:950;text-shadow:0 0 22px rgba(0,255,176,.18);}"+
    "#slxRouteConfidencePanel .rcLabel{font-size:9px;font-weight:900;letter-spacing:.12em;opacity:.78;margin-top:2px;text-align:right;}"+
    "#slxRouteConfidencePanel .rcReasons{display:flex;gap:6px;margin-top:8px;overflow:hidden;}"+
    "#slxRouteConfidencePanel .rcEta{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-top:8px;border-radius:13px;background:rgba(0,255,176,.07);border:1px solid rgba(0,255,176,.14);padding:7px 8px;}"+
    "#slxRouteConfidencePanel .rcEta b{font-size:12px;font-weight:1000;color:#9bffd7;}"+
    "#slxRouteConfidencePanel .rcEta span{font-size:10px;font-weight:900;color:rgba(255,255,255,.74);text-align:right;}"+
    "#slxRouteConfidencePanel .rcReason{font-size:10px;font-weight:850;line-height:1.1;white-space:nowrap;border:1px solid rgba(255,255,255,.10);background:rgba(255,255,255,.06);border-radius:999px;padding:6px 8px;max-width:33%;overflow:hidden;text-overflow:ellipsis;}"+
    "#slxRouteConfidencePanel .rcMeters{display:grid;grid-template-columns:repeat(4,1fr);gap:5px;margin-top:8px;}"+
    "#slxRouteConfidencePanel .rcMeter{border-radius:10px;background:rgba(255,255,255,.055);border:1px solid rgba(255,255,255,.075);padding:5px 5px 4px;}"+
    "#slxRouteConfidencePanel .rcMeter b{display:block;font-size:10px;line-height:1;font-weight:950;}"+
    "#slxRouteConfidencePanel .rcMeter span{display:block;font-size:7px;line-height:1;margin-top:3px;opacity:.70;font-weight:900;letter-spacing:.08em;}"+
    "#slxRouteConfidencePanel .rcIntel{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-top:8px;border-radius:13px;background:rgba(94,197,255,.07);border:1px solid rgba(94,197,255,.13);padding:7px 8px;}"+
    "#slxRouteConfidencePanel .rcIntel b{font-size:11px;font-weight:1000;color:#b9f2ff;letter-spacing:.06em;}"+
    "#slxRouteConfidencePanel .rcIntel span{font-size:9px;font-weight:850;color:rgba(255,255,255,.72);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}"+
    "#slxRouteConfidencePanel .rcListen{appearance:none;border:0;border-radius:999px;background:linear-gradient(90deg,#86e8ff,#00ffb0);color:#061713;font-size:10px;font-weight:1000;letter-spacing:.08em;padding:7px 9px;white-space:nowrap;box-shadow:0 0 18px rgba(0,255,176,.14);}"+
    "@media(max-height:720px){#slxRouteConfidencePanel{bottom:calc(126px + env(safe-area-inset-bottom,0px));max-height:132px;padding:8px 9px;}#slxRouteConfidencePanel .rcMeters{display:none;}#slxRouteConfidencePanel .rcScore{font-size:23px;}#slxRouteConfidencePanel .rcReason{font-size:9px;padding:5px 7px;}#slxRouteConfidencePanel .rcIntel span{display:none;}}";
  document.head.appendChild(st);
}


function slxEnsureRouteConfidencePanel(){
  var el=$("slxRouteConfidencePanel");
  slxInstallRouteConfidenceStyles();
  if(el){return el;}
  el=document.createElement("div");
  el.id="slxRouteConfidencePanel";
  el.style.display="none";
  document.body.appendChild(el);
  return el;
}


function slxRenderRouteConfidence(){
  var el, data, reasons, html, color, eta, etaHtml, intel, intelHtml, listenBtn;
  el=slxEnsureRouteConfidencePanel();


  if(!routeReady || !routeGeo){
    el.style.display="none";
    return;
  }


  data=slxApplyConfidenceToRoute(selectedRouteIndex || 0,activeChipType || "profit");
  if(!data){
    el.style.display="none";
    return;
  }


  reasons=data.reasons || [];
  while(reasons.length<3){reasons.push("Route intelligence active");}
  color=slxConfidenceColor(data.score);
  eta=safeJSONParse(lsGet(LS.ROUTE_ETA));
  intel=safeJSONParse(lsGet(LS.ROUTE_INTEL));
  etaHtml="";
  if(eta && eta.real_minutes){
    etaHtml='<div class="rcEta"><b>REAL ETA '+slxMinutesLabel(eta.real_minutes)+'</b><span>Drive '+slxMinutesLabel(eta.base_minutes)+' • '+slxHtmlText(String(eta.buffer_label||("+"+eta.buffer_minutes+"m buffer")))+'</span></div>';
  }


  intelHtml='<div class="rcIntel"><div><b>TRIP INTEL</b><span>'+slxHtmlText(String(reasons[0]||"Route intelligence active"))+' • '+slxHtmlText(String(reasons[1]||"Real ETA ready"))+'</span></div><button id="slxTripIntelListenBtn" class="rcListen" type="button">LISTEN</button></div>';


  html=
    '<div class="rcTop">'+
      '<div>'+
        '<div class="rcBadge">'+String(data.badge || "ROUTE INTELLIGENCE")+'</div>'+
      '</div>'+
      '<div style="text-align:right;">'+
        '<div class="rcScore" style="color:'+color+';">'+String(data.score)+'</div>'+
        '<div class="rcLabel">CONFIDENCE '+String(data.label || "GOOD")+'</div>'+
      '</div>'+
    '</div>'+
    '<div class="rcReasons">'+
      '<div class="rcReason">'+String(reasons[0])+'</div>'+
      '<div class="rcReason">'+String(reasons[1])+'</div>'+
      '<div class="rcReason">'+String(reasons[2])+'</div>'+
    '</div>'+
    etaHtml+
    intelHtml+
    '<div class="rcMeters">'+
      '<div class="rcMeter"><b>'+String(data.parking)+'</b><span>PARK</span></div>'+
      '<div class="rcMeter"><b>'+String(data.weather)+'</b><span>WEATHER</span></div>'+
      '<div class="rcMeter"><b>'+String(data.traffic)+'</b><span>PACE</span></div>'+
      '<div class="rcMeter"><b>'+String(data.crosswind)+'</b><span>WIND</span></div>'+
    '</div>';


  el.innerHTML=html;
  el.style.display="block";


  listenBtn=$("slxTripIntelListenBtn");
  if(listenBtn && !listenBtn.__slxBound){
    listenBtn.__slxBound=true;
    listenBtn.onclick=function(ev){
      try{if(ev && ev.stopPropagation){ev.stopPropagation();}}catch(e0){}
      slxSpeakTripIntel();
    };
  }
}


function slxRankBestConfidenceRoute(){
  var i, data, bestIndex, bestScore;
  if(!altRoutes || !altRoutes.length){return 0;}
  bestIndex=0;
  bestScore=-1;
  for(i=0;i<altRoutes.length;i++){
    data=slxRouteConfidenceData(altRoutes[i],"confidence");
    if(data && data.score>bestScore){
      bestScore=data.score;
      bestIndex=i;
    }
  }
  return bestIndex;
}


var __oldBuildRouteMetaConfidenceV1=buildRouteMeta;
buildRouteMeta=function(){
  var meta, bestConfidenceIndex, bestData;
  meta=__oldBuildRouteMetaConfidenceV1();
  if(!meta){return meta;}


  bestConfidenceIndex=slxRankBestConfidenceRoute();
  bestData=slxRouteConfidenceData(altRoutes[bestConfidenceIndex],"confidence");


  meta.bestConfidenceIndex=bestConfidenceIndex;
  meta.bestConfidenceScore=bestData ? bestData.score : 0;
  meta.bestConfidenceLabel=bestData ? bestData.label : "";
  meta.bestConfidenceReasons=bestData ? bestData.reasons : [];


  try{
    localStorage.setItem("slx_alt_route_meta_v1",JSON.stringify(meta));
  }catch(e){}


  return meta;
};


var __oldRenderChipLabelsConfidenceV1=renderChipLabels;
renderChipLabels=function(meta){
  __oldRenderChipLabelsConfidenceV1(meta);


  try{
    if(meta && meta.bestConfidenceScore && $("subline") && routeReady){
      $("subline").textContent="Route intelligence ready - confidence "+String(meta.bestConfidenceScore)+" - compare before Start Trip";
    }
  }catch(e){}
};


var __oldSelectAltRouteConfidenceV1=selectAltRoute;
selectAltRoute=function(index,label){
  __oldSelectAltRouteConfidenceV1(index,label);
  slxApplyConfidenceToRoute(index,label || activeChipType || "profit");
  try{
    if(routeGeo && dest){
      lsSet(LS.ROUTE_GEO,JSON.stringify(routeGeo));
      lsSet(LS.ROUTE_GEO_V2,JSON.stringify(routeGeo));
      lsSet(LS.ROUTE_1,JSON.stringify(routeGeo));
      lsSet(LS.ROUTE_2,JSON.stringify(routeGeo));
      lsSet(LS.ROUTE_3,JSON.stringify(routeGeo));
      lsSet(LS.ROUTE_4,JSON.stringify(routeGeo));
    }
  }catch(e){}
  slxRenderRouteConfidence();
  saveDriverHandoffPayload();
};


var __oldSaveDriverHandoffPayloadConfidenceV1=saveDriverHandoffPayload;
saveDriverHandoffPayload=function(){
  var data;
  __oldSaveDriverHandoffPayloadConfidenceV1();


  try{
    data=safeJSONParse(localStorage.getItem("slx_route_confidence_v1"));
    if(data){
      localStorage.setItem("slx_trip_intelligence_v1",JSON.stringify({
        trip_id:TRIP_ID,
        route_confidence:data,
        route_eta:safeJSONParse(lsGet(LS.ROUTE_ETA)),
        route_intel:safeJSONParse(lsGet(LS.ROUTE_INTEL)),
        corridor_vision:safeJSONParse(lsGet(LS.CORRIDOR_VISION)),
        selected_route_index:selectedRouteIndex || 0,
        selected_route_type:activeChipType || "profit",
        destination:dest,
        updated_at:new Date().toISOString()
      }));
    }
  }catch(e){}
};


var __oldSyncUiFromStateConfidenceV1=syncUiFromState;
syncUiFromState=function(){
  __oldSyncUiFromStateConfidenceV1();
  slxRenderRouteConfidence();
};


var __oldClearRouteStateOnlyConfidenceV1=clearRouteStateOnly;
clearRouteStateOnly=function(){
  __oldClearRouteStateOnlyConfidenceV1();
  try{
    localStorage.removeItem("slx_route_confidence_v1");
    localStorage.removeItem("slx_route_decision_label_v1");
    localStorage.removeItem("slx_route_decision_reasons_v1");
    localStorage.removeItem("slx_trip_intelligence_v1");
    localStorage.removeItem("slx_route_eta_v1");
    localStorage.removeItem("slx_route_intel_v1");
    localStorage.removeItem("slx_corridor_vision_v1");
  }catch(e){}
  slxRenderRouteConfidence();
};


window.setTimeout(slxRenderRouteConfidence,700);
window.setTimeout(slxRenderRouteConfidence,1800);
window.setTimeout(slxRenderRouteConfidence,3200);


}


})();


/* =========================================================
SLX V42 — MANUAL DEV UNLOCK ONLY
Production-safe replacement for the old always-on hard unlock.
Nothing is unlocked automatically at boot.

For explicit local testing only:
window.SLXEnableManualDevPro()
========================================================= */
(function(){
"use strict";

if(window.__SLX_MANUAL_DEV_UNLOCK_V42__) return;
window.__SLX_MANUAL_DEV_UNLOCK_V42__ = true;

window.SLXEnableManualDevPro = function(){
  try{
    localStorage.setItem("slx_dev_pro_unlocked_v1","1");
    localStorage.setItem("slx_founding_driver_number_v1","DEV");
    localStorage.setItem("slx_paywall_bypass_v1","1");
    localStorage.setItem("slx_pro_unlocked_v1","1");
    localStorage.setItem("slx_subscription_active_v1","1");
    localStorage.setItem("slx_entitlement_pro_v1","1");
    if(typeof slxHidePaywallOverlay === "function"){ slxHidePaywallOverlay(); }
    if(typeof slxHidePressureOverlay === "function"){ slxHidePressureOverlay(); }
    if(typeof slxRenderFoundingDriverBadge === "function"){ slxRenderFoundingDriverBadge(); }
    if(typeof setStatus === "function"){ setStatus("Dev Pro unlocked","green"); }
    if(typeof toast === "function"){ toast("Dev Pro unlocked"); }
  }catch(e){}
  return true;
};

})();



/* =========================================================
SLX FOUNDING DRIVER BADGE FORCE MOVE V3
Moves badge out of lower Trip Money panel.
Bottom patch. UI only.
========================================================= */
(function(){
"use strict";


if(window.__SLX_FOUNDING_BADGE_FORCE_MOVE_V3__) return;
window.__SLX_FOUNDING_BADGE_FORCE_MOVE_V3__ = true;


function isBadge(el){
  var txt;


  if(!el || !el.style) return false;


  if(
    el.id === "slxFounderBadge" ||
    el.id === "slxFoundingBadge" ||
    el.id === "slxFoundingDriverBadge" ||
    el.id === "slxFounderDriverBadge"
  ){
    return true;
  }


  txt = String(el.textContent || el.innerText || "").toUpperCase();


  return txt.indexOf("FOUNDING DRIVER") > -1;
}


function findBadge(){
  var all = document.querySelectorAll("div,span,button");
  var i;


  for(i=0;i<all.length;i++){
    if(isBadge(all[i])) return all[i];
  }


  return null;
}


function moveBadge(){
  var badge = findBadge();


  if(!badge) return;


  badge.id = "slxFounderBadge";


  /*
  Important: detach it from any lower panel parent.
  */
  if(badge.parentNode !== document.body){
    try{ document.body.appendChild(badge); }catch(e){}
  }


  badge.style.setProperty("position","fixed","important");


  /*
  NEW LOCATION:
  Under the route chips, above Arrival Confidence.
  */
  badge.style.setProperty("top","calc(545px + env(safe-area-inset-top,0px))","important");
  badge.style.setProperty("left","calc(28px + env(safe-area-inset-left,0px))","important");
  badge.style.setProperty("right","auto","important");
  badge.style.setProperty("bottom","auto","important");


  badge.style.setProperty("z-index","999999","important");
  badge.style.setProperty("transform","none","important");


  badge.style.setProperty("width","auto","important");
  badge.style.setProperty("max-width","215px","important");
  badge.style.setProperty("height","30px","important");
  badge.style.setProperty("padding","0 14px","important");
  badge.style.setProperty("border-radius","999px","important");


  badge.style.setProperty("display","flex","important");
  badge.style.setProperty("align-items","center","important");
  badge.style.setProperty("justify-content","center","important");


  badge.style.setProperty("background","rgba(5,16,22,.90)","important");
  badge.style.setProperty("border","1px solid rgba(130,255,220,.38)","important");
  badge.style.setProperty("box-shadow","0 10px 26px rgba(0,0,0,.42),0 0 22px rgba(0,255,176,.13)","important");


  badge.style.setProperty("color","#c9ffee","important");
  badge.style.setProperty("font-size","9px","important");
  badge.style.setProperty("font-weight","1000","important");
  badge.style.setProperty("letter-spacing","3px","important");
  badge.style.setProperty("line-height","1","important");
  badge.style.setProperty("white-space","nowrap","important");
  badge.style.setProperty("pointer-events","none","important");
}


moveBadge();


setTimeout(moveBadge,100);
setTimeout(moveBadge,400);
setTimeout(moveBadge,900);
setTimeout(moveBadge,1800);
setInterval(moveBadge,700);


try{
  var obs = new MutationObserver(function(){
    moveBadge();
  });


  obs.observe(document.body,{
    childList:true,
    subtree:true,
    attributes:true,
    attributeFilter:["style","class","id"]
  });
}catch(e){}


})();



/* =========================================================
   SEMI START DRIVE V30 — MANEUVER HANDOFF COMMIT LOCK
   ---------------------------------------------------------
   Read-only/commit helper layered over V29:
   - selected route's provider steps are the canonical maneuver payload
   - slx_route_steps_v2 is primary
   - compatibility aliases mirror the same exact array
   - route geometry + maneuver steps are committed together
   ========================================================= */
(function(){
"use strict";
if(window.__SLX_START_DRIVE_MANEUVER_HANDOFF_V30__){return;}
window.__SLX_START_DRIVE_MANEUVER_HANDOFF_V30__=true;

function parse(v){try{return JSON.parse(String(v||""));}catch(e){}return null;}
function set(k,v){try{localStorage.setItem(k,String(v));}catch(e){}}
function get(k){try{return localStorage.getItem(k);}catch(e){}return null;}

function commit(){
  var payload=parse(get("slx_start_trip_payload"))||{};
  var steps =
    (payload.route_steps && payload.route_steps.length) ? payload.route_steps :
    (payload.maneuver_steps && payload.maneuver_steps.length) ? payload.maneuver_steps :
    parse(get("slx_route_steps_v2")) ||
    parse(get("slx_maneuver_steps_v1")) ||
    [];

  if(!steps || !steps.length){return false;}

  set("slx_route_steps_v2",JSON.stringify(steps));
  set("slx_maneuver_steps_v1",JSON.stringify(steps));
  set("slx_route_steps_v1",JSON.stringify(steps));
  set("slx_trip_steps_v1",JSON.stringify(steps));
  set("slx_nav_steps_v1",JSON.stringify(steps));

  try{
    payload.route_steps=steps;
    payload.maneuver_steps=steps;
    payload.maneuver_step_count=steps.length;
    payload.maneuver_handoff_version="V30";
    set("slx_start_trip_payload",JSON.stringify(payload));
  }catch(e0){}

  try{console.log("✅ Start Drive V30 maneuver handoff committed:",steps.length,"steps");}catch(e1){}
  return true;
}

window.SLXStartDriveManeuverHandoffV30={commit:commit};
setTimeout(commit,300);
setTimeout(commit,1000);
})();

